(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
"use strict";

let jscore = require("jscore");

jscore.config(function (core) {
  // Check which version of the skin we want?
  core.config.api.base = "https://api.exploretalent.com/v1";
  if (/(.*)auditions\.net$/.test(window.location.hostname)) {
    core.config.api.base = "https://api.auditions.net/v1";
  }
  core.config.gapi.key = "AIzaSyDrPvalUo7Qc6hGNU9jpyyXhZOvSOf6ock";

  core.config.api.type = "/cd";
  core.config.api.client_id = "1397ef61d42ee4b09f89349b2613a92bda90a1e4";
  core.config.api.client_secret = "61c9b2b17db77a27841bbeeabff923448b0f6388";
});

function withTimeout (promise, ms) {
  return new Promise(function (resolve, reject) {
    var timer = setTimeout(function () {
      reject(new Error('bootstrap timed out'))
    }, ms)

    Promise.resolve(promise).then(function (result) {
      clearTimeout(timer)
      resolve(result)
    }).catch(function (err) {
      clearTimeout(timer)
      reject(err)
    })
  })
}

jscore.run(function (core) {
  let qs = core.service.query_string();
  var bootTimer

  function clearAuthSession() {
    try {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("expires_on");
      sessionStorage.clear();
    } catch (err) {}

    if (core.service && core.service.rest && core.service.rest.settings) {
      core.service.rest.settings.headers = {};
    }
  }

  if (qs.logged_out === "1" || qs.logout === "1") {
    clearAuthSession();
    init({ id: 0, bam_cd_user_id: 0 });
    return;
  } else if (qs.access_token) {
    localStorage.setItem("access_token", qs.access_token);
    localStorage.setItem("refresh_token", qs.refresh_token || "");
    var tokenExpiresIn = parseInt(qs.expires_in, 10);
    if (!tokenExpiresIn && qs.expires_at) {
      tokenExpiresIn = Math.max(
        0,
        Math.round((new Date(qs.expires_at).getTime() - Date.now()) / 1000)
      );
    }
    if (!tokenExpiresIn) {
      tokenExpiresIn = 31536000;
    }
    localStorage.setItem(
      "expires_on",
      Math.round(new Date().getTime() / 1000) + tokenExpiresIn
    );
    core.service.rest.settings.headers = {
      Authorization: "Bearer " + qs.access_token,
    };
  } else {
    var storedToken = localStorage.getItem("access_token");
    if (storedToken) {
      core.service.rest.settings.headers = {
        Authorization: "Bearer " + storedToken,
      };
    }
  }

  bootTimer = setTimeout(function () {
    if (!window.__cdAppInitialized) {
      console.warn('CD portal bootstrap timed out; continuing with minimal session')
      init({ id: 0, bam_cd_user_id: 0, user_apps: [] })
    }
  }, 15000)

  withTimeout(core.resource.user.get({
    userId: "me",
    withs: [
      "bam_cd_user",
      "user_apps",
      "user_apps.app",
      "user_apps.app.app_xorigins",
    ],
  }), 15000).then(init, init)

  function init(user) {
    if (window.__cdAppInitialized) {
      return
    }
    window.__cdAppInitialized = true
    clearTimeout(bootTimer)

    if (!user || !user.id) {
      user = { id: 0, bam_cd_user_id: 0, user_apps: [] };
    }

    if (!user.user_apps) {
      user.user_apps = []
    }

    core.service.rest.settings.statusCode = {
      401: function () {
        if (
          window.location.pathname !== "/" &&
          window.location.pathname !== "/login" &&
          window.location.pathname !== "/logout" &&
          window.location.pathname !== "/register" &&
          window.location.pathname !== "/forgot-password" &&
          window.location.pathname !== "/reset-password" &&
          window.location.pathname !== "/verify-email" &&
          window.location.pathname !== "/error"
        ) {
          window.location.href =
            "/login?redirect=" + encodeURIComponent(window.location);
        }
      },
    };

    // run all components
    var components = {'add-note': require('./components/add-note.js'),'alerts': require('./components/alerts.js'),'date-picker': require('./components/date-picker.js'),'dropdown': require('./components/dropdown.js'),'edit-note': require('./components/edit-note.js'),'email-verification': require('./components/email-verification.js'),'favorite-button': require('./components/favorite-button.js'),'go-to-top': require('./components/go-to-top.js'),'layout': require('./components/layout.js'),'like-it-list': require('./components/like-it-list.js'),'location-filter': require('./components/location-filter.js'),'logout': require('./components/logout.js'),'new-window': require('./components/new-window.js'),'popover': require('./components/popover.js'),'rangeslider': require('./components/rangeslider.js'),'select2': require('./components/select2.js'),'talent-photo-modal': require('./components/talent-photo-modal.js'),'talent-resume-modal': require('./components/talent-resume-modal.js')};

    _.each(components, function (component) {
      try {
        component(core, user);
      } catch (err) {
        console.error('CD component failed to initialize', err)
      }
    });

    // registers all controllers for the router to recognize
    core.service.router.$$controllers = {'alternate-emails': require('./controllers/alternate-emails.js'),'error': require('./controllers/error.js'),'feedback': require('./controllers/feedback.js'),'ghost-onboarding': require('./controllers/ghost-onboarding.js'),'login': require('./controllers/login.js'),'message': require('./controllers/message.js'),'password.forgot': require('./controllers/password.forgot.js'),'password.reset': require('./controllers/password.reset.js'),'project.create': require('./controllers/project.create.js'),'project.edit': require('./controllers/project.edit.js'),'project.index': require('./controllers/project.index.js'),'project.quickpost': require('./controllers/project.quickpost.js'),'project.show': require('./controllers/project.show.js'),'project.worksheet': require('./controllers/project.worksheet.js'),'register': require('./controllers/register.js'),'role.booked': require('./controllers/role.booked.js'),'role.callbacks': require('./controllers/role.callbacks.js'),'role.create': require('./controllers/role.create.js'),'role.edit': require('./controllers/role.edit.js'),'role.find-talents': require('./controllers/role.find-talents.js'),'role.landing': require('./controllers/role.landing.js'),'role.like-it-list': require('./controllers/role.like-it-list.js'),'role.publiclikeitlist': require('./controllers/role.publiclikeitlist.js'),'role.scheduled': require('./controllers/role.scheduled.js'),'role.submissions': require('./controllers/role.submissions.js'),'role.worksheet': require('./controllers/role.worksheet.js'),'settings': require('./controllers/settings.js'),'talent.favorite': require('./controllers/talent.favorite.js'),'talent.index': require('./controllers/talent.index.js'),'talent.resume': require('./controllers/talent.resume.js'),'unsubscribe': require('./controllers/unsubscribe.js'),'verify-email': require('./controllers/verify-email.js'),'welcome': require('./controllers/welcome.js')};

    var cd = {
      email: "cd@exploretalent.com",
      title: "CD Exploretalent",
      homeLogo: "/images/logo-home-et.png",
      slogan: "Casting Director Module",
      loggedInLogo: "/images/logo-home-et-cd.png",
      bodyClass: "cd",
      favicon: "/images/favicon.ico",
      phoneNumber: "424-688-1722",
    };

    var auditions = {
      email: "cd@auditions.com",
      title: "CD Auditions",
      homeLogo: "/images/Auditions-net/logo.png",
      slogan: "Casting Director Module",
      loggedInLogo: "/images/Auditions-net/logo-loggedin.png",
      bodyClass: "auditions",
      favicon: "/images/Auditions-net/favicon.ico",
      phoneNumber: "424-781-1200",
    };

    // create deep nested property for skins to avoid variable override in templates
    core.vars = {
      skins: {},
      getFullName: function () {
        if (user && user.bam_cd_user) {
          var cd = user.bam_cd_user;
          return [cd.fname, cd.lname].filter(Boolean).join(' ') || 'Casting Director';
        }
        return "Loading...";
      },
    };

    // Check which version of the skin we want?
    if (/(.*)auditions\.com$/.test(window.location.hostname)) {
      core.vars.skins = auditions;
    } else {
      core.vars.skins = cd;
    }

    core.service.databind("head", core.vars);
    core.service.databind(".skins", core.vars);

    // default parameters for all controllers
    core.service.router.$$params = [core, user];

    core.service.router

      // add routes here
      .add("/", "login")
      .add("/login", "login")
      .add("/register", "register")
      .add("/settings", "settings")
      .add("/alternate-emails", "alternate-emails")
      .add("/welcome", "welcome")
      .add("/reset-password", "password.reset")
      .add("/forgot-password", "password.forgot")
      .add("/verify-email", "verify-email")

      // talents
      .add("/talents", "talent.index")
      .add("/talents/favorite", "talent.favorite")
      .add("/talents/{talentId}", "talent.resume")

      // landing
      .add("/landing", "landing.index")

      // project pages
      .add("/projects", "project.index")
      .add("/projects/create", "project.create")
      .add("/projects/quickpost", "project.quickpost")
      .add("/projects/{projectId}/edit", "project.edit")
      .add("/projects/{projectId}/worksheet", "project.worksheet")
      .add("/projects/{projectId}", "project.show")

      // roles pages
      .add("/projects/{projectId}/roles/create", "role.create")
      .add("/projects/{projectId}/roles/{roleId}/worksheet", "role.worksheet")
      .add(
        "/projects/{projectId}/roles/{roleId}/like-it-list",
        "role.like-it-list"
      )
      .add(
        "/projects/{projectId}/roles/{roleId}/find-talents",
        "role.find-talents"
      )
      .add(
        "/projects/{projectId}/roles/{roleId}/submissions",
        "role.submissions"
      )
      .add("/projects/{projectId}/roles/{roleId}/callbacks", "role.callbacks")
      .add("/projects/{projectId}/roles/{roleId}/booked", "role.booked")
      .add("/projects/{projectId}/roles/{roleId}/landing", "role.landing")
      .add(
        "/projects/{projectId}/roles/{roleId}/public-like-it-list",
        "role.publiclikeitlist"
      )
      .add(
        "/projects/{projectId}/roles/{roleId}/public-like-it-list/{accessToken}",
        "role.publiclikeitlist"
      )
      .add("/projects/{projectId}/roles/{roleId}/edit", "role.edit")

      .add("/audition-worksheet/{campaignId}", "worksheet.show")
      .add("/audition-worksheet", "worksheet")
      .add("/messages/{projectId}/{roleId}", "message")
      .add("/messages/{projectId}", "message")
      .add("/messages", "message")
      .add("/feedback", "feedback")
      .add("/error", "error")
      .add("/unsubscribe", "unsubscribe")

      .finalize();
  }
});

jscore.initialize();

},{"./components/add-note.js":438,"./components/alerts.js":439,"./components/date-picker.js":440,"./components/dropdown.js":441,"./components/edit-note.js":442,"./components/email-verification.js":443,"./components/favorite-button.js":444,"./components/go-to-top.js":445,"./components/layout.js":446,"./components/like-it-list.js":447,"./components/location-filter.js":448,"./components/logout.js":449,"./components/new-window.js":450,"./components/popover.js":451,"./components/rangeslider.js":452,"./components/select2.js":453,"./components/talent-photo-modal.js":454,"./components/talent-resume-modal.js":455,"./controllers/alternate-emails.js":456,"./controllers/error.js":457,"./controllers/feedback.js":458,"./controllers/ghost-onboarding.js":459,"./controllers/login.js":460,"./controllers/message.js":461,"./controllers/password.forgot.js":462,"./controllers/password.reset.js":463,"./controllers/project.create.js":464,"./controllers/project.edit.js":465,"./controllers/project.index.js":466,"./controllers/project.quickpost.js":467,"./controllers/project.show.js":468,"./controllers/project.worksheet.js":469,"./controllers/register.js":470,"./controllers/role.booked.js":471,"./controllers/role.callbacks.js":472,"./controllers/role.create.js":473,"./controllers/role.edit.js":474,"./controllers/role.find-talents.js":475,"./controllers/role.landing.js":476,"./controllers/role.like-it-list.js":477,"./controllers/role.publiclikeitlist.js":478,"./controllers/role.scheduled.js":479,"./controllers/role.submissions.js":480,"./controllers/role.worksheet.js":481,"./controllers/settings.js":482,"./controllers/talent.favorite.js":483,"./controllers/talent.index.js":484,"./controllers/talent.resume.js":485,"./controllers/unsubscribe.js":486,"./controllers/verify-email.js":487,"./controllers/welcome.js":488,"jscore":9}],2:[function(require,module,exports){
(function (process){

// Use the fastest possible means to execute a task in a future turn
// of the event loop.

// linked list of tasks (single, with head node)
var head = {task: void 0, next: null};
var tail = head;
var flushing = false;
var requestFlush = void 0;
var isNodeJS = false;

function flush() {
    /* jshint loopfunc: true */

    while (head.next) {
        head = head.next;
        var task = head.task;
        head.task = void 0;
        var domain = head.domain;

        if (domain) {
            head.domain = void 0;
            domain.enter();
        }

        try {
            task();

        } catch (e) {
            if (isNodeJS) {
                // In node, uncaught exceptions are considered fatal errors.
                // Re-throw them synchronously to interrupt flushing!

                // Ensure continuation if the uncaught exception is suppressed
                // listening "uncaughtException" events (as domains does).
                // Continue in next event to avoid tick recursion.
                if (domain) {
                    domain.exit();
                }
                setTimeout(flush, 0);
                if (domain) {
                    domain.enter();
                }

                throw e;

            } else {
                // In browsers, uncaught exceptions are not fatal.
                // Re-throw them asynchronously to avoid slow-downs.
                setTimeout(function() {
                   throw e;
                }, 0);
            }
        }

        if (domain) {
            domain.exit();
        }
    }

    flushing = false;
}

if (typeof process !== "undefined" && process.nextTick) {
    // Node.js before 0.9. Note that some fake-Node environments, like the
    // Mocha test runner, introduce a `process` global without a `nextTick`.
    isNodeJS = true;

    requestFlush = function () {
        process.nextTick(flush);
    };

} else if (typeof setImmediate === "function") {
    // In IE10, Node.js 0.9+, or https://github.com/NobleJS/setImmediate
    if (typeof window !== "undefined") {
        requestFlush = setImmediate.bind(window, flush);
    } else {
        requestFlush = function () {
            setImmediate(flush);
        };
    }

} else if (typeof MessageChannel !== "undefined") {
    // modern browsers
    // http://www.nonblocking.io/2011/06/windownexttick.html
    var channel = new MessageChannel();
    channel.port1.onmessage = flush;
    requestFlush = function () {
        channel.port2.postMessage(0);
    };

} else {
    // old browsers
    requestFlush = function () {
        setTimeout(flush, 0);
    };
}

function asap(task) {
    tail = tail.next = {
        task: task,
        domain: isNodeJS && process.domain,
        next: null
    };

    if (!flushing) {
        flushing = true;
        requestFlush();
    }
};

module.exports = asap;


}).call(this,require('_process'))
},{"_process":430}],3:[function(require,module,exports){
/** @license
 * crossroads <http://millermedeiros.github.com/crossroads.js/>
 * Author: Miller Medeiros | MIT License
 * v0.12.2 (2015/07/31 18:37)
 */

(function () {
var factory = function (signals) {

    var crossroads,
        _hasOptionalGroupBug,
        UNDEF;

    // Helpers -----------
    //====================

    // IE 7-8 capture optional groups as empty strings while other browsers
    // capture as `undefined`
    _hasOptionalGroupBug = (/t(.+)?/).exec('t')[1] === '';

    function arrayIndexOf(arr, val) {
        if (arr.indexOf) {
            return arr.indexOf(val);
        } else {
            //Array.indexOf doesn't work on IE 6-7
            var n = arr.length;
            while (n--) {
                if (arr[n] === val) {
                    return n;
                }
            }
            return -1;
        }
    }

    function arrayRemove(arr, item) {
        var i = arrayIndexOf(arr, item);
        if (i !== -1) {
            arr.splice(i, 1);
        }
    }

    function isKind(val, kind) {
        return '[object '+ kind +']' === Object.prototype.toString.call(val);
    }

    function isRegExp(val) {
        return isKind(val, 'RegExp');
    }

    function isArray(val) {
        return isKind(val, 'Array');
    }

    function isFunction(val) {
        return typeof val === 'function';
    }

    //borrowed from AMD-utils
    function typecastValue(val) {
        var r;
        if (val === null || val === 'null') {
            r = null;
        } else if (val === 'true') {
            r = true;
        } else if (val === 'false') {
            r = false;
        } else if (val === UNDEF || val === 'undefined') {
            r = UNDEF;
        } else if (val === '' || isNaN(val)) {
            //isNaN('') returns false
            r = val;
        } else {
            //parseFloat(null || '') returns NaN
            r = parseFloat(val);
        }
        return r;
    }

    function typecastArrayValues(values) {
        var n = values.length,
            result = [];
        while (n--) {
            result[n] = typecastValue(values[n]);
        }
        return result;
    }

    // borrowed from MOUT
    function decodeQueryString(queryStr, shouldTypecast) {
        var queryArr = (queryStr || '').replace('?', '').split('&'),
            reg = /([^=]+)=(.+)/,
            i = -1,
            obj = {},
            equalIndex, cur, pValue, pName;

        while ((cur = queryArr[++i])) {
            equalIndex = cur.indexOf('=');
            pName = cur.substring(0, equalIndex);
            pValue = decodeURIComponent(cur.substring(equalIndex + 1));
            if (shouldTypecast !== false) {
                pValue = typecastValue(pValue);
            }
            if (pName in obj){
                if(isArray(obj[pName])){
                    obj[pName].push(pValue);
                } else {
                    obj[pName] = [obj[pName], pValue];
                }
            } else {
                obj[pName] = pValue;
           }
        }
        return obj;
    }


    // Crossroads --------
    //====================

    /**
     * @constructor
     */
    function Crossroads() {
        this.bypassed = new signals.Signal();
        this.routed = new signals.Signal();
        this._routes = [];
        this._prevRoutes = [];
        this._piped = [];
        this.resetState();
    }

    Crossroads.prototype = {

        greedy : false,

        greedyEnabled : true,

        ignoreCase : true,

        ignoreState : false,

        shouldTypecast : false,

        normalizeFn : null,

        resetState : function(){
            this._prevRoutes.length = 0;
            this._prevMatchedRequest = null;
            this._prevBypassedRequest = null;
        },

        create : function () {
            return new Crossroads();
        },

        addRoute : function (pattern, callback, priority) {
            var route = new Route(pattern, callback, priority, this);
            this._sortedInsert(route);
            return route;
        },

        removeRoute : function (route) {
            arrayRemove(this._routes, route);
            route._destroy();
        },

        removeAllRoutes : function () {
            var n = this.getNumRoutes();
            while (n--) {
                this._routes[n]._destroy();
            }
            this._routes.length = 0;
        },

        parse : function (request, defaultArgs) {
            request = request || '';
            defaultArgs = defaultArgs || [];

            // should only care about different requests if ignoreState isn't true
            if ( !this.ignoreState &&
                (request === this._prevMatchedRequest ||
                 request === this._prevBypassedRequest) ) {
                return;
            }

            var routes = this._getMatchedRoutes(request),
                i = 0,
                n = routes.length,
                cur;

            if (n) {
                this._prevMatchedRequest = request;

                this._notifyPrevRoutes(routes, request);
                this._prevRoutes = routes;
                //should be incremental loop, execute routes in order
                while (i < n) {
                    cur = routes[i];
                    cur.route.matched.dispatch.apply(cur.route.matched, defaultArgs.concat(cur.params));
                    cur.isFirst = !i;
                    this.routed.dispatch.apply(this.routed, defaultArgs.concat([request, cur]));
                    i += 1;
                }
            } else {
                this._prevBypassedRequest = request;
                this.bypassed.dispatch.apply(this.bypassed, defaultArgs.concat([request]));
            }

            this._pipeParse(request, defaultArgs);
        },

        _notifyPrevRoutes : function(matchedRoutes, request) {
            var i = 0, prev;
            while (prev = this._prevRoutes[i++]) {
                //check if switched exist since route may be disposed
                if(prev.route.switched && this._didSwitch(prev.route, matchedRoutes)) {
                    prev.route.switched.dispatch(request);
                }
            }
        },

        _didSwitch : function (route, matchedRoutes){
            var matched,
                i = 0;
            while (matched = matchedRoutes[i++]) {
                // only dispatch switched if it is going to a different route
                if (matched.route === route) {
                    return false;
                }
            }
            return true;
        },

        _pipeParse : function(request, defaultArgs) {
            var i = 0, route;
            while (route = this._piped[i++]) {
                route.parse(request, defaultArgs);
            }
        },

        getNumRoutes : function () {
            return this._routes.length;
        },

        _sortedInsert : function (route) {
            //simplified insertion sort
            var routes = this._routes,
                n = routes.length;
            do { --n; } while (routes[n] && route._priority <= routes[n]._priority);
            routes.splice(n+1, 0, route);
        },

        _getMatchedRoutes : function (request) {
            var res = [],
                routes = this._routes,
                n = routes.length,
                route;
            //should be decrement loop since higher priorities are added at the end of array
            while (route = routes[--n]) {
                if ((!res.length || this.greedy || route.greedy) && route.match(request)) {
                    res.push({
                        route : route,
                        params : route._getParamsArray(request)
                    });
                }
                if (!this.greedyEnabled && res.length) {
                    break;
                }
            }
            return res;
        },

        pipe : function (otherRouter) {
            this._piped.push(otherRouter);
        },

        unpipe : function (otherRouter) {
            arrayRemove(this._piped, otherRouter);
        },

        toString : function () {
            return '[crossroads numRoutes:'+ this.getNumRoutes() +']';
        }
    };

    //"static" instance
    crossroads = new Crossroads();
    crossroads.VERSION = '0.12.2';

    crossroads.NORM_AS_ARRAY = function (req, vals) {
        return [vals.vals_];
    };

    crossroads.NORM_AS_OBJECT = function (req, vals) {
        return [vals];
    };


    // Route --------------
    //=====================

    /**
     * @constructor
     */
    function Route(pattern, callback, priority, router) {
        var isRegexPattern = isRegExp(pattern),
            patternLexer = router.patternLexer;
        this._router = router;
        this._pattern = pattern;
        this._paramsIds = isRegexPattern? null : patternLexer.getParamIds(pattern);
        this._optionalParamsIds = isRegexPattern? null : patternLexer.getOptionalParamsIds(pattern);
        this._matchRegexp = isRegexPattern? pattern : patternLexer.compilePattern(pattern, router.ignoreCase);
        this.matched = new signals.Signal();
        this.switched = new signals.Signal();
        if (callback) {
            this.matched.add(callback);
        }
        this._priority = priority || 0;
    }

    Route.prototype = {

        greedy : false,

        rules : void(0),

        match : function (request) {
            request = request || '';
            return this._matchRegexp.test(request) && this._validateParams(request); //validate params even if regexp because of `request_` rule.
        },

        _validateParams : function (request) {
            var rules = this.rules,
                values = this._getParamsObject(request),
                key;
            for (key in rules) {
                // normalize_ isn't a validation rule... (#39)
                if(key !== 'normalize_' && rules.hasOwnProperty(key) && ! this._isValidParam(request, key, values)){
                    return false;
                }
            }
            return true;
        },

        _isValidParam : function (request, prop, values) {
            var validationRule = this.rules[prop],
                val = values[prop],
                isValid = false,
                isQuery = (prop.indexOf('?') === 0);

            if (val == null && this._optionalParamsIds && arrayIndexOf(this._optionalParamsIds, prop) !== -1) {
                isValid = true;
            }
            else if (isRegExp(validationRule)) {
                if (isQuery) {
                    val = values[prop +'_']; //use raw string
                }
                isValid = validationRule.test(val);
            }
            else if (isArray(validationRule)) {
                if (isQuery) {
                    val = values[prop +'_']; //use raw string
                }
                isValid = this._isValidArrayRule(validationRule, val);
            }
            else if (isFunction(validationRule)) {
                isValid = validationRule(val, request, values);
            }

            return isValid; //fail silently if validationRule is from an unsupported type
        },

        _isValidArrayRule : function (arr, val) {
            if (! this._router.ignoreCase) {
                return arrayIndexOf(arr, val) !== -1;
            }

            if (typeof val === 'string') {
                val = val.toLowerCase();
            }

            var n = arr.length,
                item,
                compareVal;

            while (n--) {
                item = arr[n];
                compareVal = (typeof item === 'string')? item.toLowerCase() : item;
                if (compareVal === val) {
                    return true;
                }
            }
            return false;
        },

        _getParamsObject : function (request) {
            var shouldTypecast = this._router.shouldTypecast,
                values = this._router.patternLexer.getParamValues(request, this._matchRegexp, shouldTypecast),
                o = {},
                n = values.length,
                param, val;
            while (n--) {
                val = values[n];
                if (this._paramsIds) {
                    param = this._paramsIds[n];
                    if (param.indexOf('?') === 0 && val) {
                        //make a copy of the original string so array and
                        //RegExp validation can be applied properly
                        o[param +'_'] = val;
                        //update vals_ array as well since it will be used
                        //during dispatch
                        val = decodeQueryString(val, shouldTypecast);
                        values[n] = val;
                    }
                    // IE will capture optional groups as empty strings while other
                    // browsers will capture `undefined` so normalize behavior.
                    // see: #gh-58, #gh-59, #gh-60
                    if ( _hasOptionalGroupBug && val === '' && arrayIndexOf(this._optionalParamsIds, param) !== -1 ) {
                        val = void(0);
                        values[n] = val;
                    }
                    o[param] = val;
                }
                //alias to paths and for RegExp pattern
                o[n] = val;
            }
            o.request_ = shouldTypecast? typecastValue(request) : request;
            o.vals_ = values;
            return o;
        },

        _getParamsArray : function (request) {
            var norm = this.rules? this.rules.normalize_ : null,
                params;
            norm = norm || this._router.normalizeFn; // default normalize
            if (norm && isFunction(norm)) {
                params = norm(request, this._getParamsObject(request));
            } else {
                params = this._getParamsObject(request).vals_;
            }
            return params;
        },

        interpolate : function(replacements) {
            var str = this._router.patternLexer.interpolate(this._pattern, replacements);
            if (! this._validateParams(str) ) {
                throw new Error('Generated string doesn\'t validate against `Route.rules`.');
            }
            return str;
        },

        dispose : function () {
            this._router.removeRoute(this);
        },

        _destroy : function () {
            this.matched.dispose();
            this.switched.dispose();
            this.matched = this.switched = this._pattern = this._matchRegexp = null;
        },

        toString : function () {
            return '[Route pattern:"'+ this._pattern +'", numListeners:'+ this.matched.getNumListeners() +']';
        }

    };



    // Pattern Lexer ------
    //=====================

    Crossroads.prototype.patternLexer = (function () {

        var
            //match chars that should be escaped on string regexp
            ESCAPE_CHARS_REGEXP = /[\\.+*?\^$\[\](){}\/'#]/g,

            //trailing slashes (begin/end of string)
            LOOSE_SLASHES_REGEXP = /^\/|\/$/g,
            LEGACY_SLASHES_REGEXP = /\/$/g,

            //params - everything between `{ }` or `: :`
            PARAMS_REGEXP = /(?:\{|:)([^}:]+)(?:\}|:)/g,

            //used to save params during compile (avoid escaping things that
            //shouldn't be escaped).
            TOKENS = {
                'OS' : {
                    //optional slashes
                    //slash between `::` or `}:` or `\w:` or `:{?` or `}{?` or `\w{?`
                    rgx : /([:}]|\w(?=\/))\/?(:|(?:\{\?))/g,
                    save : '$1{{id}}$2',
                    res : '\\/?'
                },
                'RS' : {
                    //required slashes
                    //used to insert slash between `:{` and `}{`
                    rgx : /([:}])\/?(\{)/g,
                    save : '$1{{id}}$2',
                    res : '\\/'
                },
                'RQ' : {
                    //required query string - everything in between `{? }`
                    rgx : /\{\?([^}]+)\}/g,
                    //everything from `?` till `#` or end of string
                    res : '\\?([^#]+)'
                },
                'OQ' : {
                    //optional query string - everything in between `:? :`
                    rgx : /:\?([^:]+):/g,
                    //everything from `?` till `#` or end of string
                    res : '(?:\\?([^#]*))?'
                },
                'OR' : {
                    //optional rest - everything in between `: *:`
                    rgx : /:([^:]+)\*:/g,
                    res : '(.*)?' // optional group to avoid passing empty string as captured
                },
                'RR' : {
                    //rest param - everything in between `{ *}`
                    rgx : /\{([^}]+)\*\}/g,
                    res : '(.+)'
                },
                // required/optional params should come after rest segments
                'RP' : {
                    //required params - everything between `{ }`
                    rgx : /\{([^}]+)\}/g,
                    res : '([^\\/?]+)'
                },
                'OP' : {
                    //optional params - everything between `: :`
                    rgx : /:([^:]+):/g,
                    res : '([^\\/?]+)?\/?'
                }
            },

            LOOSE_SLASH = 1,
            STRICT_SLASH = 2,
            LEGACY_SLASH = 3,

            _slashMode = LOOSE_SLASH;


        function precompileTokens(){
            var key, cur;
            for (key in TOKENS) {
                if (TOKENS.hasOwnProperty(key)) {
                    cur = TOKENS[key];
                    cur.id = '__CR_'+ key +'__';
                    cur.save = ('save' in cur)? cur.save.replace('{{id}}', cur.id) : cur.id;
                    cur.rRestore = new RegExp(cur.id, 'g');
                }
            }
        }
        precompileTokens();


        function captureVals(regex, pattern) {
            var vals = [], match;
            // very important to reset lastIndex since RegExp can have "g" flag
            // and multiple runs might affect the result, specially if matching
            // same string multiple times on IE 7-8
            regex.lastIndex = 0;
            while (match = regex.exec(pattern)) {
                vals.push(match[1]);
            }
            return vals;
        }

        function getParamIds(pattern) {
            return captureVals(PARAMS_REGEXP, pattern);
        }

        function getOptionalParamsIds(pattern) {
            return captureVals(TOKENS.OP.rgx, pattern);
        }

        function compilePattern(pattern, ignoreCase) {
            pattern = pattern || '';

            if(pattern){
                if (_slashMode === LOOSE_SLASH) {
                    pattern = pattern.replace(LOOSE_SLASHES_REGEXP, '');
                }
                else if (_slashMode === LEGACY_SLASH) {
                    pattern = pattern.replace(LEGACY_SLASHES_REGEXP, '');
                }

                //save tokens
                pattern = replaceTokens(pattern, 'rgx', 'save');
                //regexp escape
                pattern = pattern.replace(ESCAPE_CHARS_REGEXP, '\\$&');
                //restore tokens
                pattern = replaceTokens(pattern, 'rRestore', 'res');

                if (_slashMode === LOOSE_SLASH) {
                    pattern = '\\/?'+ pattern;
                }
            }

            if (_slashMode !== STRICT_SLASH) {
                //single slash is treated as empty and end slash is optional
                pattern += '\\/?';
            }
            return new RegExp('^'+ pattern + '$', ignoreCase? 'i' : '');
        }

        function replaceTokens(pattern, regexpName, replaceName) {
            var cur, key;
            for (key in TOKENS) {
                if (TOKENS.hasOwnProperty(key)) {
                    cur = TOKENS[key];
                    pattern = pattern.replace(cur[regexpName], cur[replaceName]);
                }
            }
            return pattern;
        }

        function getParamValues(request, regexp, shouldTypecast) {
            var vals = regexp.exec(request);
            if (vals) {
                vals.shift();
                if (shouldTypecast) {
                    vals = typecastArrayValues(vals);
                }
            }
            return vals;
        }

        function interpolate(pattern, replacements) {
            // default to an empty object because pattern might have just
            // optional arguments
            replacements = replacements || {};
            if (typeof pattern !== 'string') {
                throw new Error('Route pattern should be a string.');
            }

            var replaceFn = function(match, prop){
                    var val;
                    prop = (prop.substr(0, 1) === '?')? prop.substr(1) : prop;
                    if (replacements[prop] != null) {
                        if (typeof replacements[prop] === 'object') {
                            var queryParts = [], rep;
                            for(var key in replacements[prop]) {
                                rep = replacements[prop][key];
                                if (isArray(rep)) {
                                    for (var k in rep) {
                                        if ( key.slice(-2) == '[]' ) {
                                            queryParts.push(encodeURI(key.slice(0, -2)) + '[]=' + encodeURI(rep[k]));
                                        } else {
                                            queryParts.push(encodeURI(key + '=' + rep[k]));
                                        }
                                    }
                                }
                                else {
                                    queryParts.push(encodeURI(key + '=' + rep));
                                }
                            }
                            val = '?' + queryParts.join('&');
                        } else {
                            // make sure value is a string see #gh-54
                            val = String(replacements[prop]);
                        }

                        if (match.indexOf('*') === -1 && val.indexOf('/') !== -1) {
                            throw new Error('Invalid value "'+ val +'" for segment "'+ match +'".');
                        }
                    }
                    else if (match.indexOf('{') !== -1) {
                        throw new Error('The segment '+ match +' is required.');
                    }
                    else {
                        val = '';
                    }
                    return val;
                };

            if (! TOKENS.OS.trail) {
                TOKENS.OS.trail = new RegExp('(?:'+ TOKENS.OS.id +')+$');
            }

            return pattern
                        .replace(TOKENS.OS.rgx, TOKENS.OS.save)
                        .replace(PARAMS_REGEXP, replaceFn)
                        .replace(TOKENS.OS.trail, '') // remove trailing
                        .replace(TOKENS.OS.rRestore, '/'); // add slash between segments
        }

        //API
        return {
            strict : function(){
                _slashMode = STRICT_SLASH;
            },
            loose : function(){
                _slashMode = LOOSE_SLASH;
            },
            legacy : function(){
                _slashMode = LEGACY_SLASH;
            },
            getParamIds : getParamIds,
            getOptionalParamsIds : getOptionalParamsIds,
            getParamValues : getParamValues,
            compilePattern : compilePattern,
            interpolate : interpolate
        };

    }());


    return crossroads;
};

if (typeof define === 'function' && define.amd) {
    define(['signals'], factory);
} else if (typeof module !== 'undefined' && module.exports) { //Node
    module.exports = factory(require('signals'));
} else {
    /*jshint sub:true */
    window['crossroads'] = factory(window['signals']);
}

}());


},{"signals":437}],4:[function(require,module,exports){
 /**
  * Represents a point on the surface of the Earth.
  *
  * This library is derived from the Java code originally published at
  * http://JanMatuschek.de/LatitudeLongitudeBoundingCoordinates
  * 
  * @author Jan Philip Matuschek
  * @version 22 September 2010
  */
(function () {

  var toString = Object.prototype.toString,
      DEG2RAD = Math.PI / 180, // degrees to radian conversion
      RAD2DEG = 180 / Math.PI, // radians to degrees conversion
      MI2KM = 1.6093439999999999, // miles to kilometers conversion
      KM2MI = 0.621371192237334, // kilometers to miles conversion
      EARTH_RADIUS_KM = 6371.01, // Earth's radius in km
      EARTH_RADIUS_MI = 3958.762079, // Earth's radius in miles
      MAX_LAT = Math.PI / 2, // 90 degrees
      MIN_LAT = -MAX_LAT, // -90 degrees
      MAX_LON = Math.PI, // 180 degrees
      MIN_LON = -MAX_LON, // -180 degrees
      FULL_CIRCLE_RAD = Math.PI * 2; // Full cirle (360 degrees) in radians

  /**
   * Check if an object is a valid number
   *
   * @param   {Number}    value   Value to check
   * @return  {Boolean}   true if a number and not NaN
   */
  function isNumber(value) {
    return toString.call(value) === '[object Number]' && value === +value;
  }

  /**
   * Constructor
   *
   * @param   {Number}    lat         Latitude
   * @param   {Number}    long        Longitude
   * @param   {Boolean}   inRadians   true if latitude and longitude are in radians
   */
  function GeoPoint(lat, lon, inRadians) {
    if (!isNumber(lat)) {
      throw new Error('Invalid latitude');
    }
    if (!isNumber(lon)) {
      throw new Error('Invalid longitude');
    }
    if (inRadians === true) {
      this._degLat = GeoPoint.radiansToDegrees(lat);
      this._degLon = GeoPoint.radiansToDegrees(lon);
      this._radLat = lat;
      this._radLon = lon;
    } else {
      this._degLat = lat;
      this._degLon = lon;
      this._radLat = GeoPoint.degreesToRadians(lat);
      this._radLon = GeoPoint.degreesToRadians(lon);
    }
    if (this._radLat < MIN_LAT || this._radLat > MAX_LAT) {
      throw new Error('Latitude out of bounds');
    } else if (this._radLon < MIN_LON || this._radLon > MAX_LON) {
      throw new Error('Longitude out of bounds');
    }
  }

  /**
   * Return the latitude
   *
   * @param   {Boolean}   inRadians   true to return the latitude in radians
   * @param   {Number}    latitude
   */
  GeoPoint.prototype.latitude = function(inRadians) {
    if (inRadians === true) {
      return this._radLat;
    }
    return this._degLat;
  };

  /**
   * Return the longitude
   *
   * @param   {Boolean}   inRadians   true to return the longitude in radians
   * @param   {Number}    longitude
   */
  GeoPoint.prototype.longitude = function(inRadians) {
    if (inRadians === true) {
      return this._radLon;
    }
    return this._degLon;
  };

  /**
   * Calculates the distance between two points
   *
   * @param   {Object}    point         GeoPoint instance
   * @param   {Boolean}   inKilometers  true to return the distance in kilometers
   * @return  {Number}    distance between points
   */
  GeoPoint.prototype.distanceTo = function(point, inKilometers) {
    if (!(point instanceof GeoPoint)) {
      throw new Error('Invalid GeoPoint');
    }
    var radius = inKilometers === true ? EARTH_RADIUS_KM : EARTH_RADIUS_MI,
        lat1 = this.latitude(true),
        lat2 = point.latitude(true),
        lon1 = this.longitude(true),
        lon2 = point.longitude(true);
    return Math.acos(
            Math.sin(lat1) * Math.sin(lat2) +
            Math.cos(lat1) * Math.cos(lat2) *
            Math.cos(lon1 - lon2)) * radius;
  };

  /**
   * Calculate the bouding coordinates
   *
   * @param   {Number}    distance      distance from the point
   * @param   {Number}    radius        optional sphere radius to use
   * @param   {Boolean}   inKilometers  true to return the distance in kilometers
   * @return  {Array}     array containing SW and NE points of bounding box
   */
  GeoPoint.prototype.boundingCoordinates = function(distance, radius, inKilometers) {
    if (!isNumber(distance) || distance <= 0) {
      throw new Error('Invalid distance');
    }
    if (radius === true || radius === false) {
      inKilometers = radius;
      radius = null;
    }
    if (!isNumber(radius) || radius <= 0) {
      radius = inKilometers === true ? EARTH_RADIUS_KM : EARTH_RADIUS_MI;
    }
    var lat = this.latitude(true),
        lon = this.longitude(true),
        radDist = distance / radius,
        minLat = lat - radDist,
        maxLat = lat + radDist,
        minLon,
        maxLon,
        deltaLon;
    if (minLat > MIN_LAT && maxLat < MAX_LAT) {
      deltaLon = Math.asin(Math.sin(radDist) / Math.cos(lat));
      minLon = lon - deltaLon;
      if (minLon < MIN_LON) {
        minLon += FULL_CIRCLE_RAD;
      }
			maxLon = lon + deltaLon;
			if (maxLon > MAX_LON) {
        maxLon -= FULL_CIRCLE_RAD;
      }
    } else {
      minLat = Math.max(minLat, MIN_LAT);
			maxLat = Math.min(maxLat, MAX_LAT);
			minLon = MIN_LON;
			maxLon = MAX_LON;
    }
    return [new GeoPoint(minLat, minLon, true), new GeoPoint(maxLat, maxLon, true)];
  };

  /**
   * Convert degrees to radians
   *
   * @param   {Number}    value   degree value
   * @return  {Number}    radian value
   */
  GeoPoint.degreesToRadians = function(value) {
    if (!isNumber(value)) {
      throw new Error('Invalid degree value');
    }
    return value * DEG2RAD;
  };

  /**
   * Convert radians to degrees
   *
   * @param   {Number}    value   radian value
   * @return  {Number}    degree value
   */
  GeoPoint.radiansToDegrees = function(value) {
    if (!isNumber(value)) {
      throw new Error('Invalid radian value');
    }
    return value * RAD2DEG;
  };

  /**
   * Cnvert miles to kilometers
   *
   * @param   {Number}    value   miles value
   * @return  {Number}    kilometers value
   */
  GeoPoint.milesToKilometers = function(value) {
    if (!isNumber(value)) {
      throw new Error('Invalid mile value');
    }
    return value * MI2KM;
  };

  /**
   * Convert kilometers to miles
   *
   * @param   {Number}    value   kilometer value
   * @return  {Number}    miles value
   */
  GeoPoint.kilometersToMiles = function(value) {
    if (!isNumber(value)) {
      throw new Error('Invalid kilometer value');
    }
    return value * KM2MI;
  };

  // Export
  if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = GeoPoint;
  } else {
    this.GeoPoint = GeoPoint;
  }

}).call(this);

},{}],5:[function(require,module,exports){
/** @module google-maps-api */

var script = require( 'scriptjs' ),
  promise = require( 'promise' );

var maps = null,
  callBacks = [],
  key;

window.$$mapsCB = function() {

  maps = google.maps;

  for( var i = 0, len = callBacks.length; i < len; i++ ) {

    resolve.apply( undefined, callBacks[ i ] );
  }
};

function resolve( onOk, onErr, onComplete, err ) {

  if( !err ) {

    onOk( maps );

    if( onComplete )
      onComplete( undefined, maps );
  } else {

    onErr( err );

    if( onComplete )
      onComplete( err );
  }
}


/**
 * Load a Google Maps API Object asynchronously. This module will return a Promise.
 * Which will on resolved will return the "google.maps" object.
 *
 * Or if you prefer you can simply use the callback instead.
 *
 * @param  {String} apikey Your Google Maps API Key
 * @param  {Function} [onComplete] A callback which will return the google.maps object
 * @return {Promise} When this promise resolves it will return the google.maps object
 *
 * @example using via promise
 *
 * ```javascript
 * var mapsapi = require( 'google-maps-api' )( 'your api key' );
 *
 * mapsapi().then( function( maps ) {
 *
 *  //use the google.maps object as you please
 * });
 * ```
 *
 * @example using via callback
 * ```javascript
 * require( 'google-maps-api' )( 'your api key', function( maps ) {
 *
 *  //use the google.maps object as you please
 * })
 * ```
 */
module.exports = function( apikey, libraries, onComplete ) {

  key = apikey || key;
  if (typeof libraries == 'function') {
    onComplete = libraries;
    libraries = [];
  }

  return function() {

    return new promise( function( onOk, onErr ) {

      if( !key ) {

        resolve( onOk, onErr, onComplete, new Error( 'No API key passed to require(\'google-maps-api\')' ) );
      } else {

        if( maps ) {

          resolve( onOk, onErr, onComplete );
        } else {

          callBacks.push( [ onOk, onErr, onComplete ] );

          if (callBacks.length == 1) {
            var auth = '';
            if (typeof key == 'string') {

              auth = '&key=' + key;
            } else if (typeof key == 'object') {

              auth = '&' + Object.keys(key).map(function (k) {
                return k + '=' + encodeURIComponent(key[k]);
              }).join('&');
            }

            var url = 'https://maps.googleapis.com/maps/api/js?v=3&callback=$$mapsCB' + auth;
            if (Array.isArray(libraries) && libraries.length > 0) {
              url+='&libraries='+libraries.join(',');
            }
            script( url );
          }
        }
      }
    });
  };
};

},{"promise":431,"scriptjs":436}],6:[function(require,module,exports){
/*!
 * jQuery JavaScript Library v2.2.4
 * http://jquery.com/
 *
 * Includes Sizzle.js
 * http://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-05-20T17:23Z
 */

(function( global, factory ) {

	if ( typeof module === "object" && typeof module.exports === "object" ) {
		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Support: Firefox 18+
// Can't be in strict mode, several libs including ASP.NET trace
// the stack via arguments.caller.callee and Firefox dies if
// you try to trace through "use strict" call chains. (#13335)
//"use strict";
var arr = [];

var document = window.document;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var support = {};



var
	version = "2.2.4",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android<4.1
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([\da-z])/gi,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// Start with an empty selector
	selector: "",

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {
		return num != null ?

			// Return just the one element from the set
			( num < 0 ? this[ num + this.length ] : this[ num ] ) :

			// Return all the elements in a clean array
			slice.call( this );
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;
		ret.context = this.context;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = jQuery.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && jQuery.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isFunction: function( obj ) {
		return jQuery.type( obj ) === "function";
	},

	isArray: Array.isArray,

	isWindow: function( obj ) {
		return obj != null && obj === obj.window;
	},

	isNumeric: function( obj ) {

		// parseFloat NaNs numeric-cast false positives (null|true|false|"")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		// adding 1 corrects loss of precision from parseFloat (#15100)
		var realStringObj = obj && obj.toString();
		return !jQuery.isArray( obj ) && ( realStringObj - parseFloat( realStringObj ) + 1 ) >= 0;
	},

	isPlainObject: function( obj ) {
		var key;

		// Not plain objects:
		// - Any object or value whose internal [[Class]] property is not "[object Object]"
		// - DOM nodes
		// - window
		if ( jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
			return false;
		}

		// Not own constructor property must be Object
		if ( obj.constructor &&
				!hasOwn.call( obj, "constructor" ) &&
				!hasOwn.call( obj.constructor.prototype || {}, "isPrototypeOf" ) ) {
			return false;
		}

		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own
		for ( key in obj ) {}

		return key === undefined || hasOwn.call( obj, key );
	},

	isEmptyObject: function( obj ) {
		var name;
		for ( name in obj ) {
			return false;
		}
		return true;
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}

		// Support: Android<4.0, iOS<6 (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		var script,
			indirect = eval;

		code = jQuery.trim( code );

		if ( code ) {

			// If the code includes a valid, prologue position
			// strict mode pragma, execute code by injecting a
			// script tag into the document.
			if ( code.indexOf( "use strict" ) === 1 ) {
				script = document.createElement( "script" );
				script.text = code;
				document.head.appendChild( script ).parentNode.removeChild( script );
			} else {

				// Otherwise, avoid the DOM node creation, insertion
				// and removal by using an indirect global eval

				indirect( code );
			}
		}
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE9-11+
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	nodeName: function( elem, name ) {
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android<4.1
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: Date.now,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

// JSHint would error on this code due to the Symbol not being defined in ES5.
// Defining this global in .jshintrc would create a danger of using the global
// unguarded in another place, it seems safer to just disable JSHint for these
// three lines.
/* jshint ignore: start */
if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}
/* jshint ignore: end */

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: iOS 8.2 (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.2.1
 * http://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2015-10-17
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// General-purpose constants
	MAX_NEGATIVE = 1 << 31,

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// http://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,
	rescape = /'|\\/g,

	// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	};

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, nidselect, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rescape, "\\$&" );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					nidselect = ridentifier.test( nid ) ? "#" + nid : "[id='" + nid + "']";
					while ( i-- ) {
						groups[i] = nidselect + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created div and expects a boolean result
 */
function assert( fn ) {
	var div = document.createElement("div");

	try {
		return !!fn( div );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( div.parentNode ) {
			div.parentNode.removeChild( div );
		}
		// release memory in IE
		div = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			( ~b.sourceIndex || MAX_NEGATIVE ) -
			( ~a.sourceIndex || MAX_NEGATIVE );

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, parent,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( (parent = document.defaultView) && parent.top !== parent ) {
		// Support: IE 11
		if ( parent.addEventListener ) {
			parent.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( parent.attachEvent ) {
			parent.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( div ) {
		div.className = "i";
		return !div.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( div ) {
		div.appendChild( document.createComment("") );
		return !div.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( div ) {
		docElem.appendChild( div ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID find and filter
	if ( support.getById ) {
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var m = context.getElementById( id );
				return m ? [ m ] : [];
			}
		};
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
	} else {
		// Support: IE6/7
		// getElementById is not reliable as a find shortcut
		delete Expr.find["ID"];

		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See http://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( div ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// http://bugs.jquery.com/ticket/12359
			docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( div.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !div.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibing-combinator selector` fails
			if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( div ) {
			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			div.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( div.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":enabled").length ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			div.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( div ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( div, "div" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( div, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": function( elem ) {
			return elem.disabled === false;
		},

		"disabled": function( elem ) {
			return elem.disabled === true;
		},

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		checkNonElements = base && dir === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( (oldCache = uniqueCache[ dir ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ dir ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				support.getById && context.nodeType === 9 && documentIsHTML &&
				Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( div1 ) {
	// Should return 1, but returns 4 (following)
	return div1.compareDocumentPosition( document.createElement("div") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( div ) {
	div.innerHTML = "<a href='#'></a>";
	return div.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( div ) {
	div.innerHTML = "<input/>";
	div.firstChild.setAttribute( "value", "" );
	return div.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( div ) {
	return div.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;



var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = ( /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/ );



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			/* jshint -W018 */
			return !!qualifier.call( elem, i, elem ) !== not;
		} );

	}

	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );

	}

	if ( typeof qualifier === "string" ) {
		if ( risSimple.test( qualifier ) ) {
			return jQuery.filter( qualifier, elements, not );
		}

		qualifier = jQuery.filter( qualifier, elements );
	}

	return jQuery.grep( elements, function( elem ) {
		return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
	} );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	return elems.length === 1 && elem.nodeType === 1 ?
		jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
		jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i,
			len = this.length,
			ret = [],
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		// Needed because $( selector, context ) becomes $( context ).find( selector )
		ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
		ret.selector = this.selector ? this.selector + " " + selector : selector;
		return ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					// Support: Blackberry 4.6
					// gEBID returns nodes no longer in the document (#6963)
					if ( elem && elem.parentNode ) {

						// Inject the element directly into the jQuery object
						this.length = 1;
						this[ 0 ] = elem;
					}

					this.context = document;
					this.selector = selector;
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this.context = this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		if ( selector.selector !== undefined ) {
			this.selector = selector.selector;
			this.context = selector.context;
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
				jQuery( selectors, context || this.context ) :
				0;

		for ( ; i < l; i++ ) {
			for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

				// Always skip document fragments
				if ( cur.nodeType < 11 && ( pos ?
					pos.index( cur ) > -1 :

					// Don't pass non-elements to Sizzle
					cur.nodeType === 1 &&
						jQuery.find.matchesSelector( cur, selectors ) ) ) {

					matched.push( cur );
					break;
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		return elem.contentDocument || jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnotwhite = ( /\S+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( jQuery.isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, listener list, final state
				[ "resolve", "done", jQuery.Callbacks( "once memory" ), "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ), "rejected" ],
				[ "notify", "progress", jQuery.Callbacks( "memory" ) ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				then: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;
					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {
							var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];

							// deferred[ done | fail | progress ] for forwarding actions to newDefer
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this === promise ? newDefer.promise() : this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Keep pipe for back-compat
		promise.pipe = promise.then;

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 3 ];

			// promise[ done | fail | progress ] = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add( function() {

					// state = [ resolved | rejected ]
					state = stateString;

				// [ reject_list | resolve_list ].disable; progress_list.lock
				}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
			}

			// deferred[ resolve | reject | notify ]
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? promise : this, arguments );
				return this;
			};
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( subordinate /* , ..., subordinateN */ ) {
		var i = 0,
			resolveValues = slice.call( arguments ),
			length = resolveValues.length,

			// the count of uncompleted subordinates
			remaining = length !== 1 ||
				( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,

			// the master Deferred.
			// If resolveValues consist of only a single Deferred, just use that.
			deferred = remaining === 1 ? subordinate : jQuery.Deferred(),

			// Update function for both resolve and progress values
			updateFunc = function( i, contexts, values ) {
				return function( value ) {
					contexts[ i ] = this;
					values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( values === progressValues ) {
						deferred.notifyWith( contexts, values );
					} else if ( !( --remaining ) ) {
						deferred.resolveWith( contexts, values );
					}
				};
			},

			progressValues, progressContexts, resolveContexts;

		// Add listeners to Deferred subordinates; treat others as resolved
		if ( length > 1 ) {
			progressValues = new Array( length );
			progressContexts = new Array( length );
			resolveContexts = new Array( length );
			for ( ; i < length; i++ ) {
				if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
					resolveValues[ i ].promise()
						.progress( updateFunc( i, progressContexts, progressValues ) )
						.done( updateFunc( i, resolveContexts, resolveValues ) )
						.fail( deferred.reject );
				} else {
					--remaining;
				}
			}
		}

		// If we're not waiting on anything, resolve the master
		if ( !remaining ) {
			deferred.resolveWith( resolveContexts, resolveValues );
		}

		return deferred.promise();
	}
} );


// The deferred used on DOM ready
var readyList;

jQuery.fn.ready = function( fn ) {

	// Add the callback
	jQuery.ready.promise().done( fn );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Hold (or release) the ready event
	holdReady: function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	},

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );

		// Trigger any bound ready events
		if ( jQuery.fn.triggerHandler ) {
			jQuery( document ).triggerHandler( "ready" );
			jQuery( document ).off( "ready" );
		}
	}
} );

/**
 * The ready event handler and self cleanup method
 */
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

jQuery.ready.promise = function( obj ) {
	if ( !readyList ) {

		readyList = jQuery.Deferred();

		// Catch cases where $(document).ready() is called
		// after the browser event has already occurred.
		// Support: IE9-10 only
		// Older IE sometimes signals "interactive" too soon
		if ( document.readyState === "complete" ||
			( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

			// Handle it asynchronously to allow scripts the opportunity to delay ready
			window.setTimeout( jQuery.ready );

		} else {

			// Use the handy event callback
			document.addEventListener( "DOMContentLoaded", completed );

			// A fallback to window.onload, that will always work
			window.addEventListener( "load", completed );
		}
	}
	return readyList.promise( obj );
};

// Kick off the DOM ready check even if the user does not
jQuery.ready.promise();




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	return chainable ?
		elems :

		// Gets
		bulk ?
			fn.call( elems ) :
			len ? fn( elems[ 0 ], key ) : emptyGet;
};
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	/* jshint -W018 */
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	register: function( owner, initial ) {
		var value = initial || {};

		// If it is a node unlikely to be stringify-ed or looped over
		// use plain assignment
		if ( owner.nodeType ) {
			owner[ this.expando ] = value;

		// Otherwise secure it in a non-enumerable, non-writable property
		// configurability must be true to allow the property to be
		// deleted with the delete operator
		} else {
			Object.defineProperty( owner, this.expando, {
				value: value,
				writable: true,
				configurable: true
			} );
		}
		return owner[ this.expando ];
	},
	cache: function( owner ) {

		// We can accept data for non-element nodes in modern browsers,
		// but we should not, see #8335.
		// Always return an empty object.
		if ( !acceptData( owner ) ) {
			return {};
		}

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		if ( typeof data === "string" ) {
			cache[ data ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ prop ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :
			owner[ this.expando ] && owner[ this.expando ][ key ];
	},
	access: function( owner, key, value ) {
		var stored;

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			stored = this.get( owner, key );

			return stored !== undefined ?
				stored : this.get( owner, jQuery.camelCase( key ) );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i, name, camel,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key === undefined ) {
			this.register( owner );

		} else {

			// Support array or space separated string of keys
			if ( jQuery.isArray( key ) ) {

				// If "name" is an array of keys...
				// When data is initially created, via ("key", "val") signature,
				// keys will be converted to camelCase.
				// Since there is no way to tell _how_ a key was added, remove
				// both plain key and camelCase key. #12786
				// This will only penalize the array argument path.
				name = key.concat( key.map( jQuery.camelCase ) );
			} else {
				camel = jQuery.camelCase( key );

				// Try the string as a key before any manipulation
				if ( key in cache ) {
					name = [ key, camel ];
				} else {

					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					name = camel;
					name = name in cache ?
						[ name ] : ( name.match( rnotwhite ) || [] );
				}
			}

			i = name.length;

			while ( i-- ) {
				delete cache[ name[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <= 35-45+
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://code.google.com/p/chromium/issues/detail?id=378607
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = data === "true" ? true :
					data === "false" ? false :
					data === "null" ? null :

					// Only convert to a number if it doesn't change the string
					+data + "" === data ? +data :
					rbrace.test( data ) ? jQuery.parseJSON( data ) :
					data;
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE11+
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data, camelKey;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// with the key as-is
				data = dataUser.get( elem, key ) ||

					// Try to find dashed key if it exists (gh-2779)
					// This is for 2.2.x only
					dataUser.get( elem, key.replace( rmultiDash, "-$&" ).toLowerCase() );

				if ( data !== undefined ) {
					return data;
				}

				camelKey = jQuery.camelCase( key );

				// Attempt to get data from the cache
				// with the key camelized
				data = dataUser.get( elem, camelKey );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, camelKey, undefined );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			camelKey = jQuery.camelCase( key );
			this.each( function() {

				// First, attempt to store a copy or reference of any
				// data that might've been store with a camelCased key.
				var data = dataUser.get( this, camelKey );

				// For HTML5 data-* attribute interop, we have to
				// store property names with dashes in a camelCase form.
				// This might not apply to all properties...*
				dataUser.set( this, camelKey, value );

				// *... In the case of properties that might _actually_
				// have dashes, we need to also store a copy of that
				// unchanged property.
				if ( key.indexOf( "-" ) > -1 && data !== undefined ) {
					dataUser.set( this, key, value );
				}
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || jQuery.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHidden = function( elem, el ) {

		// isHidden might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;
		return jQuery.css( elem, "display" ) === "none" ||
			!jQuery.contains( elem.ownerDocument, elem );
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted,
		scale = 1,
		maxIterations = 20,
		currentValue = tween ?
			function() { return tween.cur(); } :
			function() { return jQuery.css( elem, prop, "" ); },
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		do {

			// If previous iteration zeroed out, double until we get *something*.
			// Use string for doubling so we don't accidentally see scale as unchanged below
			scale = scale || ".5";

			// Adjust and apply
			initialInUnit = initialInUnit / scale;
			jQuery.style( elem, prop, initialInUnit + unit );

		// Update scale, tolerating zero or NaN from tween.cur()
		// Break the loop if scale is unchanged or perfect, or if we've just had enough.
		} while (
			scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
		);
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([\w:-]+)/ );

var rscriptType = ( /^$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE9
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE9
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE9-11+
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret = typeof context.getElementsByTagName !== "undefined" ?
			context.getElementsByTagName( tag || "*" ) :
			typeof context.querySelectorAll !== "undefined" ?
				context.querySelectorAll( tag || "*" ) :
			[];

	return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
		jQuery.merge( [ context ], ret ) :
		ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( jQuery.type( elem ) === "object" ) {

				// Support: Android<4.1, PhantomJS<2
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android<4.1, PhantomJS<2
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0-4.3, Safari<=5.1
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Safari<=5.1, Android<4.2
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE<=11+
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();


var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE9
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( event ) {

		// Make a writable jQuery.Event from the native event object
		event = jQuery.event.fix( event );

		var i, j, ret, matched, handleObj,
			handlerQueue = [],
			args = slice.call( arguments ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;
		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, matches, sel, handleObj,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Support (at least): Chrome, IE9
		// Find delegate handlers
		// Black-hole SVG <use> instance trees (#13180)
		//
		// Support: Firefox<=42+
		// Avoid non-left-click in FF but don't block IE radio events (#3861, gh-2343)
		if ( delegateCount && cur.nodeType &&
			( event.type !== "click" || isNaN( event.button ) || event.button < 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && ( cur.disabled !== true || event.type !== "click" ) ) {
					matches = [];
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matches[ sel ] === undefined ) {
							matches[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matches[ sel ] ) {
							matches.push( handleObj );
						}
					}
					if ( matches.length ) {
						handlerQueue.push( { elem: cur, handlers: matches } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: this, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	// Includes some event props shared by KeyEvent and MouseEvent
	props: ( "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase " +
		"metaKey relatedTarget shiftKey target timeStamp view which" ).split( " " ),

	fixHooks: {},

	keyHooks: {
		props: "char charCode key keyCode".split( " " ),
		filter: function( event, original ) {

			// Add which for key events
			if ( event.which == null ) {
				event.which = original.charCode != null ? original.charCode : original.keyCode;
			}

			return event;
		}
	},

	mouseHooks: {
		props: ( "button buttons clientX clientY offsetX offsetY pageX pageY " +
			"screenX screenY toElement" ).split( " " ),
		filter: function( event, original ) {
			var eventDoc, doc, body,
				button = original.button;

			// Calculate pageX/Y if missing and clientX/Y available
			if ( event.pageX == null && original.clientX != null ) {
				eventDoc = event.target.ownerDocument || document;
				doc = eventDoc.documentElement;
				body = eventDoc.body;

				event.pageX = original.clientX +
					( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) -
					( doc && doc.clientLeft || body && body.clientLeft || 0 );
				event.pageY = original.clientY +
					( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) -
					( doc && doc.clientTop  || body && body.clientTop  || 0 );
			}

			// Add which for click: 1 === left; 2 === middle; 3 === right
			// Note: button is not normalized, so don't use it
			if ( !event.which && button !== undefined ) {
				event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
			}

			return event;
		}
	},

	fix: function( event ) {
		if ( event[ jQuery.expando ] ) {
			return event;
		}

		// Create a writable copy of the event object and normalize some properties
		var i, prop, copy,
			type = event.type,
			originalEvent = event,
			fixHook = this.fixHooks[ type ];

		if ( !fixHook ) {
			this.fixHooks[ type ] = fixHook =
				rmouseEvent.test( type ) ? this.mouseHooks :
				rkeyEvent.test( type ) ? this.keyHooks :
				{};
		}
		copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;

		event = new jQuery.Event( originalEvent );

		i = copy.length;
		while ( i-- ) {
			prop = copy[ i ];
			event[ prop ] = originalEvent[ prop ];
		}

		// Support: Cordova 2.5 (WebKit) (#13255)
		// All events should have a target; Cordova deviceready doesn't
		if ( !event.target ) {
			event.target = document;
		}

		// Support: Safari 6.0+, Chrome<28
		// Target should not be a text node (#504, #13143)
		if ( event.target.nodeType === 3 ) {
			event.target = event.target.parentNode;
		}

		return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return jQuery.nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android<4.0
				src.returnValue === false ?
			returnTrue :
			returnFalse;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://code.google.com/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {
	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,

	// Support: IE 10-11, Edge 10240+
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Manipulating tables requires a tbody
function manipulationTarget( elem, content ) {
	return jQuery.nodeName( elem, "table" ) &&
		jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?

		elem.getElementsByTagName( "tbody" )[ 0 ] ||
			elem.appendChild( elem.ownerDocument.createElement( "tbody" ) ) :
		elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );

	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		isFunction = jQuery.isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( isFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( isFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android<4.1, PhantomJS<2
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							jQuery.globalEval( node.textContent.replace( rcleanScript, "" ) );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <= 35-45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <= 35-45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {

	// Keep domManip exposed until 3.0 (gh-2225)
	domManip: domManip,

	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: QtWebKit
			// .get() because push.apply(_, arraylike) throws
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );


var iframe,
	elemdisplay = {

		// Support: Firefox
		// We have to pre-define these values for FF (#10227)
		HTML: "block",
		BODY: "block"
	};

/**
 * Retrieve the actual display of a element
 * @param {String} name nodeName of the element
 * @param {Object} doc Document object
 */

// Called only from within defaultDisplay
function actualDisplay( name, doc ) {
	var elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),

		display = jQuery.css( elem[ 0 ], "display" );

	// We don't have any data stored on the element,
	// so use "detach" method as fast way to get rid of the element
	elem.detach();

	return display;
}

/**
 * Try to determine the default display value of an element
 * @param {String} nodeName
 */
function defaultDisplay( nodeName ) {
	var doc = document,
		display = elemdisplay[ nodeName ];

	if ( !display ) {
		display = actualDisplay( nodeName, doc );

		// If the simple way fails, read from inside an iframe
		if ( display === "none" || !display ) {

			// Use the already-created iframe if possible
			iframe = ( iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" ) )
				.appendTo( doc.documentElement );

			// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
			doc = iframe[ 0 ].contentDocument;

			// Support: IE
			doc.write();
			doc.close();

			display = actualDisplay( nodeName, doc );
			iframe.detach();
		}

		// Store the correct default display
		elemdisplay[ nodeName ] = display;
	}

	return display;
}
var rmargin = ( /^margin/ );

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var documentElement = document.documentElement;



( function() {
	var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE9-11+
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
		"padding:0;margin-top:1px;position:absolute";
	container.appendChild( div );

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {
		div.style.cssText =

			// Support: Firefox<29, Android 2.3
			// Vendor-prefix box-sizing
			"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;" +
			"position:relative;display:block;" +
			"margin:auto;border:1px;padding:1px;" +
			"top:1%;width:50%";
		div.innerHTML = "";
		documentElement.appendChild( container );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";
		reliableMarginLeftVal = divStyle.marginLeft === "2px";
		boxSizingReliableVal = divStyle.width === "4px";

		// Support: Android 4.0 - 4.3 only
		// Some styles come back with percentage values, even though they shouldn't
		div.style.marginRight = "50%";
		pixelMarginRightVal = divStyle.marginRight === "4px";

		documentElement.removeChild( container );
	}

	jQuery.extend( support, {
		pixelPosition: function() {

			// This test is executed only once but we still do memoizing
			// since we can use the boxSizingReliable pre-computing.
			// No need to check if the test was already performed, though.
			computeStyleTests();
			return pixelPositionVal;
		},
		boxSizingReliable: function() {
			if ( boxSizingReliableVal == null ) {
				computeStyleTests();
			}
			return boxSizingReliableVal;
		},
		pixelMarginRight: function() {

			// Support: Android 4.0-4.3
			// We're checking for boxSizingReliableVal here instead of pixelMarginRightVal
			// since that compresses better and they're computed together anyway.
			if ( boxSizingReliableVal == null ) {
				computeStyleTests();
			}
			return pixelMarginRightVal;
		},
		reliableMarginLeft: function() {

			// Support: IE <=8 only, Android 4.0 - 4.3 only, Firefox <=3 - 37
			if ( boxSizingReliableVal == null ) {
				computeStyleTests();
			}
			return reliableMarginLeftVal;
		},
		reliableMarginRight: function() {

			// Support: Android 2.3
			// Check if div with explicit width and no margin-right incorrectly
			// gets computed margin-right based on width of container. (#3333)
			// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
			// This support function is only executed once so no memoizing is needed.
			var ret,
				marginDiv = div.appendChild( document.createElement( "div" ) );

			// Reset CSS: box-sizing; display; margin; border; padding
			marginDiv.style.cssText = div.style.cssText =

				// Support: Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:content-box;box-sizing:content-box;" +
				"display:block;margin:0;border:0;padding:0";
			marginDiv.style.marginRight = marginDiv.style.width = "0";
			div.style.width = "1px";
			documentElement.appendChild( container );

			ret = !parseFloat( window.getComputedStyle( marginDiv ).marginRight );

			documentElement.removeChild( container );
			div.removeChild( marginDiv );

			return ret;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		style = elem.style;

	computed = computed || getStyles( elem );
	ret = computed ? computed.getPropertyValue( name ) || computed[ name ] : undefined;

	// Support: Opera 12.1x only
	// Fall back to style even without computed
	// computed is undefined for elems on document fragments
	if ( ( ret === "" || ret === undefined ) && !jQuery.contains( elem.ownerDocument, elem ) ) {
		ret = jQuery.style( elem, name );
	}

	// Support: IE9
	// getPropertyValue is only needed for .css('filter') (#12537)
	if ( computed ) {

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// http://dev.w3.org/csswg/cssom/#resolved-values
		if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE9-11+
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,

	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "O", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i = extra === ( isBorderBox ? "border" : "content" ) ?

		// If we already have the right measurement, avoid augmentation
		4 :

		// Otherwise initialize for horizontal or vertical properties
		name === "width" ? 1 : 0,

		val = 0;

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {

			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// At this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {

			// At this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// At this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with offset property, which is equivalent to the border-box value
	var valueIsBorderBox = true,
		val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
		styles = getStyles( elem ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// Some non-html elements return undefined for offsetWidth, so check for null/undefined
	// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
	// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
	if ( val <= 0 || val == null ) {

		// Fall back to computed then uncomputed css if necessary
		val = curCSS( elem, name, styles );
		if ( val < 0 || val == null ) {
			val = elem.style[ name ];
		}

		// Computed unit is not pixels. Stop here and return.
		if ( rnumnonpx.test( val ) ) {
			return val;
		}

		// Check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = isBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ name ] );

		// Normalize "", auto, and prepare for extra
		val = parseFloat( val ) || 0;
	}

	// Use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

function showHide( elements, show ) {
	var display, elem, hidden,
		values = [],
		index = 0,
		length = elements.length;

	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		values[ index ] = dataPriv.get( elem, "olddisplay" );
		display = elem.style.display;
		if ( show ) {

			// Reset the inline display of this element to learn if it is
			// being hidden by cascaded rules or not
			if ( !values[ index ] && display === "none" ) {
				elem.style.display = "";
			}

			// Set elements which have been overridden with display: none
			// in a stylesheet to whatever the default browser style is
			// for such an element
			if ( elem.style.display === "" && isHidden( elem ) ) {
				values[ index ] = dataPriv.access(
					elem,
					"olddisplay",
					defaultDisplay( elem.nodeName )
				);
			}
		} else {
			hidden = isHidden( elem );

			if ( display !== "none" || !hidden ) {
				dataPriv.set(
					elem,
					"olddisplay",
					hidden ? display : jQuery.css( elem, "display" )
				);
			}
		}
	}

	// Set the display of most of the elements in a second loop
	// to avoid the constant reflow
	for ( index = 0; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}
		if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
			elem.style.display = show ? values[ index ] || "" : "none";
		}
	}

	return elements;
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {
		"float": "cssFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			style = elem.style;

		name = jQuery.cssProps[ origName ] ||
			( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// Support: IE9-11+
			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				style[ name ] = value;
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = jQuery.camelCase( name );

		// Make sure that we're working with the right name
		name = jQuery.cssProps[ origName ] ||
			( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}
		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
					elem.offsetWidth === 0 ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						} ) :
						getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = extra && getStyles( elem ),
				subtract = extra && augmentWidthOrHeight(
					elem,
					name,
					extra,
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				);

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ name ] = value;
				value = jQuery.css( elem, name );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// Support: Android 2.3
jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
	function( elem, computed ) {
		if ( computed ) {
			return swap( elem, { "display": "inline-block" },
				curCSS, [ elem, "marginRight" ] );
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( jQuery.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	},
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHidden( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE9
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back Compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, timerId,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4 ; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	/* jshint validthis: true */
	var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHidden( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Handle queue: false promises
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Height/width overflow pass
	if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {

		// Make sure that nothing sneaks out
		// Record all 3 overflow attributes because IE9-10 do not
		// change the overflow attribute when overflowX and
		// overflowY are set to the same value
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Set display property to inline-block for height/width
		// animations on inline elements that are having width/height animated
		display = jQuery.css( elem, "display" );

		// Test default display if display is currently "none"
		checkDisplay = display === "none" ?
			dataPriv.get( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;

		if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
			style.display = "inline-block";
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// show/hide pass
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.exec( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// If there is dataShow left over from a stopped hide or show
				// and we are going to proceed with show, we should pretend to be hidden
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );

		// Any non-fx value stops us from restoring the original display value
		} else {
			display = undefined;
		}
	}

	if ( !jQuery.isEmptyObject( orig ) ) {
		if ( dataShow ) {
			if ( "hidden" in dataShow ) {
				hidden = dataShow.hidden;
			}
		} else {
			dataShow = dataPriv.access( elem, "fxshow", {} );
		}

		// Store state if its toggle - enables .stop().toggle() to "reverse"
		if ( toggle ) {
			dataShow.hidden = !hidden;
		}
		if ( hidden ) {
			jQuery( elem ).show();
		} else {
			anim.done( function() {
				jQuery( elem ).hide();
			} );
		}
		anim.done( function() {
			var prop;

			dataPriv.remove( elem, "fxshow" );
			for ( prop in orig ) {
				jQuery.style( elem, prop, orig[ prop ] );
			}
		} );
		for ( prop in orig ) {
			tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );

			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = tween.start;
				if ( hidden ) {
					tween.end = tween.start;
					tween.start = prop === "width" || prop === "height" ? 1 : 0;
				}
			}
		}

	// If this is a noop like .hide().hide(), restore an overwritten display value
	} else if ( ( display === "none" ? defaultDisplay( elem.nodeName ) : display ) === "inline" ) {
		style.display = display;
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( jQuery.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length ; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			if ( percent < 1 && length ) {
				return remaining;
			} else {
				deferred.resolveWith( elem, [ animation ] );
				return false;
			}
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length ; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( jQuery.isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					jQuery.proxy( result.stop, result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	// attach callbacks from options
	return animation.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );
}

jQuery.Animation = jQuery.extend( Animation, {
	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnotwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length ; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ?
		opt.duration : opt.duration in jQuery.fx.speeds ?
			jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHidden ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Checks the timer has not already been removed
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	if ( timer() ) {
		jQuery.fx.start();
	} else {
		jQuery.timers.pop();
	}
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( !timerId ) {
		timerId = window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
	}
};

jQuery.fx.stop = function() {
	window.clearInterval( timerId );

	timerId = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// http://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: iOS<=5.1, Android<=4.2+
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE<=11+
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: Android<=2.3
	// Options inside disabled selects are incorrectly marked as disabled
	select.disabled = true;
	support.optDisabled = !opt.disabled;

	// Support: IE<=11+
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// All attributes are lowercase
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			name = name.toLowerCase();
			hooks = jQuery.attrHooks[ name ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					jQuery.nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name, propName,
			i = 0,
			attrNames = value && value.match( rnotwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				propName = jQuery.propFix[ name ] || name;

				// Boolean attributes get special treatment (#10870)
				if ( jQuery.expr.match.bool.test( name ) ) {

					// Set corresponding property to false
					elem[ propName ] = false;
				}

				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};
jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle;
		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ name ];
			attrHandle[ name ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				name.toLowerCase() :
				null;
			attrHandle[ name ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				return tabindex ?
					parseInt( tabindex, 10 ) :
					rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) && elem.href ?
							0 :
							-1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {
			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {
			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




var rclass = /[\t\r\n\f]/g;

function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnotwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 &&
					( " " + curValue + " " ).replace( rclass, " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = jQuery.trim( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnotwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 &&
					( " " + curValue + " " ).replace( rclass, " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = jQuery.trim( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( type === "string" ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = value.match( rnotwhite ) || [];

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + getClass( elem ) + " " ).replace( rclass, " " )
					.indexOf( className ) > -1
			) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g,
	rspaces = /[\x20\t\r\n\f]+/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				return typeof ret === "string" ?

					// Handle most common string cases
					ret.replace( rreturn, "" ) :

					// Handle cases where value is null/undef or number
					ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( jQuery.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE10-11+
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					jQuery.trim( jQuery.text( elem ) ).replace( rspaces, " " );
			}
		},
		select: {
			get: function( elem ) {
				var value, option,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one" || index < 0,
					values = one ? null : [],
					max = one ? index + 1 : options.length,
					i = index < 0 ?
						max :
						one ? index : 0;

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							( support.optDisabled ?
								!option.disabled : option.getAttribute( "disabled" ) === null ) &&
							( !option.parentNode.disabled ||
								!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];
					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( jQuery.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					elem[ type ]();
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


jQuery.each( ( "blur focus focusin focusout load resize scroll unload click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup error contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




support.focusin = "onfocusin" in window;


// Support: Firefox
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome, Safari
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://code.google.com/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = jQuery.now();

var rquery = ( /\?/ );



// Support: Android 2.3
// Workaround failure to string-cast null input
jQuery.parseJSON = function( data ) {
	return JSON.parse( data + "" );
};


// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE9
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rhash = /#.*$/,
	rts = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];

		if ( jQuery.isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

		// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",
		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": jQuery.parseJSON,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// The jqXHR state
			state = 0,

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( state === 2 ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return state === 2 ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					var lname = name.toLowerCase();
					if ( !state ) {
						name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( !state ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( state < 2 ) {
							for ( code in map ) {

								// Lazy-add the new callback in a way that preserves old ones
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						} else {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR ).complete = completeDeferred.add;
		jqXHR.success = jqXHR.done;
		jqXHR.error = jqXHR.fail;

		// Remove hash character (#7531: and string promotion)
		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" ).replace( rhash, "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE8-11+
			// IE throws exception if url is malformed, e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE8-11+
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( state === 2 ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		cacheURL = s.url;

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add anti-cache in url if needed
			if ( s.cache === false ) {
				s.url = rts.test( cacheURL ) ?

					// If there is already a '_' parameter, set its value
					cacheURL.replace( rts, "$1_=" + nonce++ ) :

					// Otherwise add one to the end
					cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
			}
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		for ( i in { success: 1, error: 1, complete: 1 } ) {
			jqXHR[ i ]( s[ i ] );
		}

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( state === 2 ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				state = 1;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Propagate exception as error if not done
				if ( state < 2 ) {
					done( -1, e );

				// Simply rethrow otherwise
				} else {
					throw e;
				}
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Called once
			if ( state === 2 ) {
				return;
			}

			// State is "done" now
			state = 2;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapAll( html.call( this, i ) );
			} );
		}

		if ( this[ 0 ] ) {

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function() {
		return this.parent().each( function() {
			if ( !jQuery.nodeName( this, "body" ) ) {
				jQuery( this ).replaceWith( this.childNodes );
			}
		} ).end();
	}
} );


jQuery.expr.filters.hidden = function( elem ) {
	return !jQuery.expr.filters.visible( elem );
};
jQuery.expr.filters.visible = function( elem ) {

	// Support: Opera <= 12.12
	// Opera reports offsetWidths and offsetHeights less than zero on some elements
	// Use OR instead of AND as the element is not visible if either is true
	// See tickets #10406 and #13132
	return elem.offsetWidth > 0 || elem.offsetHeight > 0 || elem.getClientRects().length > 0;
};




var r20 = /%20/g,
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( jQuery.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, value ) {

			// If value is a function, invoke it and return its value
			value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
			s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
		};

	// Set traditional to true for jQuery <= 1.3.2 behavior.
	if ( traditional === undefined ) {
		traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" ).replace( r20, "+" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			return val == null ?
				null :
				jQuery.isArray( val ) ?
					jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} ) :
					{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE9
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE9
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = callback( "error" );

				// Support: IE9
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( !data || typeof data !== "string" ) {
		return null;
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}
	context = context || document;

	var parsed = rsingleTag.exec( data ),
		scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


// Keep a copy of the old load method
var _load = jQuery.fn.load;

/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	if ( typeof url !== "string" && _load ) {
		return _load.apply( this, arguments );
	}

	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = jQuery.trim( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.filters.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




/**
 * Gets a window from an element
 */
function getWindow( elem ) {
	return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
}

jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {
	offset: function( options ) {
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var docElem, win,
			elem = this[ 0 ],
			box = { top: 0, left: 0 },
			doc = elem && elem.ownerDocument;

		if ( !doc ) {
			return;
		}

		docElem = doc.documentElement;

		// Make sure it's not a disconnected DOM node
		if ( !jQuery.contains( docElem, elem ) ) {
			return box;
		}

		box = elem.getBoundingClientRect();
		win = getWindow( doc );
		return {
			top: box.top + win.pageYOffset - docElem.clientTop,
			left: box.left + win.pageXOffset - docElem.clientLeft
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
		// because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume getBoundingClientRect is there when computed position is fixed
			offset = elem.getBoundingClientRect();

		} else {

			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
			parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {
			var win = getWindow( elem );

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari<7-8+, Chrome<37-44+
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://code.google.com/p/chromium/issues/detail?id=229280
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {

					// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
					// isn't a whole lot we can do. See pull request at this URL for discussion:
					// https://github.com/jquery/jquery/pull/764
					return elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable, null );
		};
	} );
} );


jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},
	size: function() {
		return this.length;
	}
} );

jQuery.fn.andSelf = jQuery.fn.addBack;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( typeof define === "function" && define.amd ) {
	define( "jquery", [], function() {
		return jQuery;
	} );
}



var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}

return jQuery;
}));

},{}],7:[function(require,module,exports){
module.exports = {
  base: '',
  baseV2: '',
  type: '/talent'
}

},{}],8:[function(require,module,exports){
module.exports = {
  key: ''
}

},{}],9:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function Core () {
  this.$$configs = []
  this.$$runs = []
}

Core.prototype.config = function (callback) {
  this.$$configs.push(callback)
}

Core.prototype.run = function (callback) {
  this.$$runs.push(callback)
}

Core.prototype.initialize = function () {
  let configs = {'api': require('./config/api.js'),'gapi': require('./config/gapi.js')}
  let values = {'builds': require('./values/builds.json'),'ethnicities': require('./values/ethnicities.json'),'markets': require('./values/markets.json'),'music_types': require('./values/music_types.json'),'project_category': require('./values/project_category.json'),'project_union': require('./values/project_union.json'),'resume_experience': require('./values/resume_experience.json'),'resume_performance': require('./values/resume_performance.json'),'resume_types': require('./values/resume_types.json'),'talent_media_types': require('./values/talent_media_types.json')}

  while (this.$$configs.length > 0) {
    this.$$configs.shift()({
      config: configs,
      value: values
    })
  }

  let services = {'converter': require('./services/converter.js'),'cron': require('./services/cron.js'),'databind': require('./services/databind.js'),'date': require('./services/date.js'),'form': require('./services/form.js'),'model': require('./services/model.js'),'paginate': require('./services/paginate.js'),'phone': require('./services/phone.js'),'query_string': require('./services/query_string.js'),'resource': require('./services/resource.js'),'rest': require('./services/rest.js'),'router': require('./services/router.js'),'talent': require('./services/talent.js')}
  let resources = {'admin_alert': require('./resources/admin_alert.js'),'agent_leads': require('./resources/agent_leads.js'),'alert': require('./resources/alert.js'),'app': require('./resources/app.js'),'app_xorigins': require('./resources/app_xorigins.js'),'bad_accounts': require('./resources/bad_accounts.js'),'banned_email': require('./resources/banned_email.js'),'callback': require('./resources/callback.js'),'campaign': require('./resources/campaign.js'),'campaign_app': require('./resources/campaign_app.js'),'campaign_app_log': require('./resources/campaign_app_log.js'),'campaign_app_queue': require('./resources/campaign_app_queue.js'),'campaign_sender': require('./resources/campaign_sender.js'),'campaign_sender_address': require('./resources/campaign_sender_address.js'),'campaign_sender_did': require('./resources/campaign_sender_did.js'),'campaign_sender_type': require('./resources/campaign_sender_type.js'),'campaign_type': require('./resources/campaign_type.js'),'casting_app': require('./resources/casting_app.js'),'casting_category': require('./resources/casting_category.js'),'castings_call_logs': require('./resources/castings_call_logs.js'),'castings_evil': require('./resources/castings_evil.js'),'cd_claim_sales': require('./resources/cd_claim_sales.js'),'cd_log': require('./resources/cd_log.js'),'cd_user': require('./resources/cd_user.js'),'cd_user_campaign_subscription': require('./resources/cd_user_campaign_subscription.js'),'cd_user_subscription': require('./resources/cd_user_subscription.js'),'col_recurring': require('./resources/col_recurring.js'),'contest_link': require('./resources/contest_link.js'),'contest_media': require('./resources/contest_media.js'),'contests': require('./resources/contests.js'),'conversation': require('./resources/conversation.js'),'data': require('./resources/data.js'),'did_log': require('./resources/did_log.js'),'email_template': require('./resources/email_template.js'),'et_leads': require('./resources/et_leads.js'),'et_online': require('./resources/et_online.js'),'favorite_projects': require('./resources/favorite_projects.js'),'favorite_talent': require('./resources/favorite_talent.js'),'featured_castings': require('./resources/featured_castings.js'),'featured_castings_admin': require('./resources/featured_castings_admin.js'),'feedback': require('./resources/feedback.js'),'friend': require('./resources/friend.js'),'future_recurring': require('./resources/future_recurring.js'),'inbound_did': require('./resources/inbound_did.js'),'job': require('./resources/job.js'),'job_match': require('./resources/job_match.js'),'job_orders': require('./resources/job_orders.js'),'job_schedule': require('./resources/job_schedule.js'),'knowledge_base': require('./resources/knowledge_base.js'),'lead_assignment': require('./resources/lead_assignment.js'),'legacy_packages': require('./resources/legacy_packages.js'),'link_campaign': require('./resources/link_campaign.js'),'liveagent_contact': require('./resources/liveagent_contact.js'),'liveagent_sync_to_liveagent': require('./resources/liveagent_sync_to_liveagent.js'),'liveagent_ticket': require('./resources/liveagent_ticket.js'),'location': require('./resources/location.js'),'market': require('./resources/market.js'),'media': require('./resources/media.js'),'media_review': require('./resources/media_review.js'),'media_review_pictures_for_approval': require('./resources/media_review_pictures_for_approval.js'),'message': require('./resources/message.js'),'message_template': require('./resources/message_template.js'),'message_template_category': require('./resources/message_template_category.js'),'oauth_access_token': require('./resources/oauth_access_token.js'),'payment': require('./resources/payment.js'),'poster_stat': require('./resources/poster_stat.js'),'project': require('./resources/project.js'),'project_app': require('./resources/project_app.js'),'project_stats': require('./resources/project_stats.js'),'promocode': require('./resources/promocode.js'),'qa_answer': require('./resources/qa_answer.js'),'qa_choice': require('./resources/qa_choice.js'),'qa_question': require('./resources/qa_question.js'),'qa_section': require('./resources/qa_section.js'),'quickpost': require('./resources/quickpost.js'),'recording_logs': require('./resources/recording_logs.js'),'reminder': require('./resources/reminder.js'),'report_abuse': require('./resources/report_abuse.js'),'report_abuse_reasons': require('./resources/report_abuse_reasons.js'),'sale_sources_tls': require('./resources/sale_sources_tls.js'),'sales': require('./resources/sales.js'),'sales_source': require('./resources/sales_source.js'),'schedule': require('./resources/schedule.js'),'schedule_cd_status': require('./resources/schedule_cd_status.js'),'schedule_import': require('./resources/schedule_import.js'),'schedule_note': require('./resources/schedule_note.js'),'schedule_status': require('./resources/schedule_status.js'),'search_project': require('./resources/search_project.js'),'search_talent': require('./resources/search_talent.js'),'sender_option': require('./resources/sender_option.js'),'sms_message': require('./resources/sms_message.js'),'sms_stat': require('./resources/sms_stat.js'),'sms_thread': require('./resources/sms_thread.js'),'sound_board': require('./resources/sound_board.js'),'staff_notes': require('./resources/staff_notes.js'),'star_talent': require('./resources/star_talent.js'),'tag': require('./resources/tag.js'),'tag_type': require('./resources/tag_type.js'),'talent': require('./resources/talent.js'),'talent_autosubs': require('./resources/talent_autosubs.js'),'talent_general': require('./resources/talent_general.js'),'talent_media2': require('./resources/talent_media2.js'),'talent_payment_options': require('./resources/talent_payment_options.js'),'talent_sales': require('./resources/talent_sales.js'),'talent_social': require('./resources/talent_social.js'),'talent_songs': require('./resources/talent_songs.js'),'talent_videos': require('./resources/talent_videos.js'),'talentinfo1': require('./resources/talentinfo1.js'),'talentinfo2': require('./resources/talentinfo2.js'),'talentorder': require('./resources/talentorder.js'),'talentordertracking': require('./resources/talentordertracking.js'),'talentrecurring': require('./resources/talentrecurring.js'),'talenttracking': require('./resources/talenttracking.js'),'team': require('./resources/team.js'),'transactions_store': require('./resources/transactions_store.js'),'trm_banners': require('./resources/trm_banners.js'),'trm_call_log': require('./resources/trm_call_log.js'),'trm_category': require('./resources/trm_category.js'),'trm_feedback': require('./resources/trm_feedback.js'),'trm_location': require('./resources/trm_location.js'),'trm_schedule_note': require('./resources/trm_schedule_note.js'),'trm_script': require('./resources/trm_script.js'),'trm_script_category': require('./resources/trm_script_category.js'),'trm_user': require('./resources/trm_user.js'),'trm_user_email': require('./resources/trm_user_email.js'),'trm_user_option': require('./resources/trm_user_option.js'),'trollbox': require('./resources/trollbox.js'),'user': require('./resources/user.js'),'user_app': require('./resources/user_app.js'),'user_email': require('./resources/user_email.js'),'user_option': require('./resources/user_option.js'),'verified_contact': require('./resources/verified_contact.js'),'vicidial': require('./resources/vicidial.js'),'vicidial_agent_logs': require('./resources/vicidial_agent_logs.js'),'vicidial_closer_log': require('./resources/vicidial_closer_log.js'),'vicidial_live_agents': require('./resources/vicidial_live_agents.js'),'vicidial_log': require('./resources/vicidial_log.js'),'vicidial_recs': require('./resources/vicidial_recs.js'),'vicidial_reports': require('./resources/vicidial_reports.js'),'vicidial_scorecard_reports': require('./resources/vicidial_scorecard_reports.js'),'vicidial_users': require('./resources/vicidial_users.js'),'zip': require('./resources/zip.js')}

  while (this.$$runs.length > 0) {
    this.$$runs.shift()({
      service: services,
      resource: resources,
      value: values,
      config: configs
    })
  }
}

module.exports = new Core()

},{"./config/api.js":7,"./config/gapi.js":8,"./resources/admin_alert.js":264,"./resources/agent_leads.js":265,"./resources/alert.js":266,"./resources/app.js":267,"./resources/app_xorigins.js":268,"./resources/bad_accounts.js":269,"./resources/banned_email.js":270,"./resources/callback.js":271,"./resources/campaign.js":272,"./resources/campaign_app.js":273,"./resources/campaign_app_log.js":274,"./resources/campaign_app_queue.js":275,"./resources/campaign_sender.js":276,"./resources/campaign_sender_address.js":277,"./resources/campaign_sender_did.js":278,"./resources/campaign_sender_type.js":279,"./resources/campaign_type.js":280,"./resources/casting_app.js":281,"./resources/casting_category.js":282,"./resources/castings_call_logs.js":283,"./resources/castings_evil.js":284,"./resources/cd_claim_sales.js":285,"./resources/cd_log.js":286,"./resources/cd_user.js":287,"./resources/cd_user_campaign_subscription.js":288,"./resources/cd_user_subscription.js":289,"./resources/col_recurring.js":290,"./resources/contest_link.js":291,"./resources/contest_media.js":292,"./resources/contests.js":293,"./resources/conversation.js":294,"./resources/data.js":295,"./resources/did_log.js":296,"./resources/email_template.js":297,"./resources/et_leads.js":298,"./resources/et_online.js":299,"./resources/favorite_projects.js":300,"./resources/favorite_talent.js":301,"./resources/featured_castings.js":302,"./resources/featured_castings_admin.js":303,"./resources/feedback.js":304,"./resources/friend.js":305,"./resources/future_recurring.js":306,"./resources/inbound_did.js":307,"./resources/job.js":308,"./resources/job_match.js":309,"./resources/job_orders.js":310,"./resources/job_schedule.js":311,"./resources/knowledge_base.js":312,"./resources/lead_assignment.js":313,"./resources/legacy_packages.js":314,"./resources/link_campaign.js":315,"./resources/liveagent_contact.js":316,"./resources/liveagent_sync_to_liveagent.js":317,"./resources/liveagent_ticket.js":318,"./resources/location.js":319,"./resources/market.js":320,"./resources/media.js":321,"./resources/media_review.js":322,"./resources/media_review_pictures_for_approval.js":323,"./resources/message.js":324,"./resources/message_template.js":325,"./resources/message_template_category.js":326,"./resources/oauth_access_token.js":327,"./resources/payment.js":328,"./resources/poster_stat.js":329,"./resources/project.js":330,"./resources/project_app.js":331,"./resources/project_stats.js":332,"./resources/promocode.js":333,"./resources/qa_answer.js":334,"./resources/qa_choice.js":335,"./resources/qa_question.js":336,"./resources/qa_section.js":337,"./resources/quickpost.js":338,"./resources/recording_logs.js":339,"./resources/reminder.js":340,"./resources/report_abuse.js":341,"./resources/report_abuse_reasons.js":342,"./resources/sale_sources_tls.js":343,"./resources/sales.js":344,"./resources/sales_source.js":345,"./resources/schedule.js":346,"./resources/schedule_cd_status.js":347,"./resources/schedule_import.js":348,"./resources/schedule_note.js":349,"./resources/schedule_status.js":350,"./resources/search_project.js":351,"./resources/search_talent.js":352,"./resources/sender_option.js":353,"./resources/sms_message.js":354,"./resources/sms_stat.js":355,"./resources/sms_thread.js":356,"./resources/sound_board.js":357,"./resources/staff_notes.js":358,"./resources/star_talent.js":359,"./resources/tag.js":360,"./resources/tag_type.js":361,"./resources/talent.js":362,"./resources/talent_autosubs.js":363,"./resources/talent_general.js":364,"./resources/talent_media2.js":365,"./resources/talent_payment_options.js":366,"./resources/talent_sales.js":367,"./resources/talent_social.js":368,"./resources/talent_songs.js":369,"./resources/talent_videos.js":370,"./resources/talentinfo1.js":371,"./resources/talentinfo2.js":372,"./resources/talentorder.js":373,"./resources/talentordertracking.js":374,"./resources/talentrecurring.js":375,"./resources/talenttracking.js":376,"./resources/team.js":377,"./resources/transactions_store.js":378,"./resources/trm_banners.js":379,"./resources/trm_call_log.js":380,"./resources/trm_category.js":381,"./resources/trm_feedback.js":382,"./resources/trm_location.js":383,"./resources/trm_schedule_note.js":384,"./resources/trm_script.js":385,"./resources/trm_script_category.js":386,"./resources/trm_user.js":387,"./resources/trm_user_email.js":388,"./resources/trm_user_option.js":389,"./resources/trollbox.js":390,"./resources/user.js":391,"./resources/user_app.js":392,"./resources/user_email.js":393,"./resources/user_option.js":394,"./resources/verified_contact.js":395,"./resources/vicidial.js":396,"./resources/vicidial_agent_logs.js":397,"./resources/vicidial_closer_log.js":398,"./resources/vicidial_live_agents.js":399,"./resources/vicidial_log.js":400,"./resources/vicidial_recs.js":401,"./resources/vicidial_reports.js":402,"./resources/vicidial_scorecard_reports.js":403,"./resources/vicidial_users.js":404,"./resources/zip.js":405,"./services/converter.js":406,"./services/cron.js":407,"./services/databind.js":408,"./services/date.js":409,"./services/form.js":410,"./services/model.js":411,"./services/paginate.js":412,"./services/phone.js":413,"./services/query_string.js":414,"./services/resource.js":415,"./services/rest.js":416,"./services/router.js":417,"./services/talent.js":418,"./values/builds.json":419,"./values/ethnicities.json":420,"./values/markets.json":421,"./values/music_types.json":422,"./values/project_category.json":423,"./values/project_union.json":424,"./values/resume_experience.json":425,"./values/resume_performance.json":426,"./values/resume_types.json":427,"./values/talent_media_types.json":428,"lodash":429}],10:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function AccessToken (data) {
  _.extend(this, data || {})
}

module.exports = AccessToken

},{"lodash":429}],11:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  access_tokens = {}

access_tokens.create = function (array) {
  let model = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return model('access_token', item)
  })
}

module.exports = access_tokens

},{"./../services/model.js":411,"lodash":429}],12:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function AdminAlert (data) {
  _.extend(this, data || {})
}

AdminAlert.relationship = [
  'data:admin_alerts'
]

module.exports = AdminAlert

},{"lodash":429}],13:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  admin_alerts = {}

admin_alerts.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('admin_alert', item)
  })
}

module.exports = admin_alerts

},{"./../services/model.js":411,"lodash":429}],14:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function AgentLead (data) {
  _.extend(this, data || {})
}

module.exports = AgentLead

},{"lodash":429}],15:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  AgentLeads = {},
  AgentLead = require('./agent_lead.js')

AgentLeads.relationship = AgentLead.relationship

AgentLeads.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('agent_lead', item)
  })
}

module.exports = AgentLeads

},{"./../services/model.js":411,"./agent_lead.js":14,"lodash":429}],16:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function Alert (data) {
  _.extend(this, data || {})
}

Alert.relationship = [
  'data:alerts'
]

module.exports = Alert

},{"lodash":429}],17:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  alerts = {},
  Alert = require('./alert.js')

alerts.relationship = Alert.relationship

alerts.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('alert', item)
  })
}

module.exports = alerts

},{"./../services/model.js":411,"./alert.js":16,"lodash":429}],18:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function App (data) {
  _.extend(this, data || {})
}

App.relationship = [
  'data:apps'
]

module.exports = App

},{"lodash":429}],19:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function AppXorigins (data) {
  _.extend(this, data || {})
}

AppXorigins.relationship = [
  'data:app_xorigins'
]

module.exports = AppXorigins

},{"lodash":429}],20:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  app_xorigins = {}

app_xorigins.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('app_xorigin', item)
  })
}

module.exports = app_xorigins

},{"./../services/model.js":411,"lodash":429}],21:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  apps = {},
  App = require('./app.js')

apps.relationship = App.relationship

apps.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('app', item)
  })
}

module.exports = apps

},{"./../services/model.js":411,"./app.js":18,"lodash":429}],22:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function BadAccounts (data) {
  _.extend(this, data || {})
}

BadAccounts.relationship = [
  'data:bad_accounts'
]

module.exports = BadAccounts

},{"lodash":429}],23:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  bad_accountss = {}

bad_accountss.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('bad_account', item)
  })
}

module.exports = bad_accountss

},{"./../services/model.js":411,"lodash":429}],24:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  converter = require('./../services/converter.js'),
  date = require('./../services/date.js')

function CastCat (data) {
  _.extend(this, data)
}

CastCat.relationship = [
  'bam_talentci'
]

module.exports = CastCat

},{"./../services/converter.js":406,"./../services/date.js":409,"lodash":429}],25:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  date = require('./../services/date.js')

function Casting (data) {
  _.extend(this, data)
}

Casting.prototype.getRate = function () {
  let rates = [
    'N/A' ,
    'Per Event',
    'Per Hour',
    'Per Day',
    'Per Week',
    'Per Month',
    'Negotiable'
  ]

  return rates[this.rate_des]
}

Casting.prototype.getRateText = function () {
  if (this.rate_des == 0 || this.rate_des == 6) {
    return this.getRate()
  }

  return this.rate + ' ' + this.getRate()
}

Casting.prototype.getCategory = function () {
  let categories = {
    0: '',
    1: 'Commercials',
    10: 'Feature Film - Non-SAG',
    11: 'Feature Film - Student Films',
    12: 'Feature Film - Short Film',
    13: 'Feature Film - Documentaries',
    14: 'Feature Film - Inde/Low Budget',
    15: 'Infomercials',
    16: 'Crew - Assistants & Entry Level',
    17: 'Industrial/Training Films',
    18: 'Modeling - Runway',
    19: 'Modeling - Hair/Cosmetics',
    20: 'Modeling - Print',
    21: 'Music Videos',
    22: 'Theatre - Equity (Union)',
    23: 'Theatre - Non-Equity',
    24: 'Trade Shows/Live Events/Promo Model',
    25: 'Crew - Marketing/PR',
    26: 'Voice Over',
    27: 'Internet',
    28: 'Music - Vocals',
    29: 'Music - Strings',
    3: 'Dance - Ballet/Classic',
    30: 'Music - Horns',
    31: 'Music - Keyboards',
    32: 'Music - Drums',
    33: 'Music - Other',
    34: 'Crew - Ligthing/Sound',
    35: 'Crew - Camera/Editor',
    36: 'Crew - Producer/Director',
    37: 'Crew - Make Up/Stylist',
    38: 'Crew - Other',
    39: 'Crew - Writing/Script/Edit',
    4: 'Dance - Modern/Jazz',
    40: 'Crew - Showbiz Internship',
    41: 'Acting - Comedy/Clown',
    42: 'Variety - Variety Acts',
    43: 'Acting - Acrobatics/Stunts',
    44: 'Music - Band',
    45: 'Music - DJ/Sound',
    46: 'Music - Teacher',
    47: 'Crew - TV/Radio',
    48: 'Crew - Graphic/Web/Animate',
    49: 'Crew - Accounting/Payroll/HR',
    5: 'Episodic TV - Pilots',
    50: 'Crew - Technology/MIS',
    51: 'Crew - Management',
    52: 'Crew - Talent/Casting Mgmt',
    53: 'Dance - HipHop',
    54: 'Dance - Club/Gogo',
    55: 'Dance - Traditonal/Latin',
    56: 'Dance - Choreography',
    57: 'Dance - Teacher',
    58: 'Dance - Other/General',
    59: 'Reality TV',
    6: 'Episodic TV - SAG',
    60: 'Extras',
    61: 'Acting - Other',
    7: 'Episodic TV - AFTRA',
    8: 'Episodic TV - Non-Union',
    9: 'Feature Film - SAG'
  }

  return categories[this.cat]
}

Casting.prototype.getProjectType = function () {
  let projectTypes = {
    0: 'Commercials',
    1: 'Print',
    2: 'Music Video',
    3: 'Feature Film',
    4: 'SAG Experm',
    5: 'Episodic',
    6: 'Pilots',
    7: 'Voice Over',
    8: 'Live Event',
    9: 'Infomercial',
    10: 'Doc. Short Film',
    11: 'TV Show',
    12: 'Music',
    13: 'Crew',
    14: 'Dance'
  }

  return projectTypes[this.project_type]
}

Casting.prototype.convertToFullDate = function (timestamp) {
  return date.formatYMD(parseInt(timestamp))
}

Casting.prototype.getUrl = function () {
  if (this.zip) {
    return 'https://www.exploretalent.com/auditions/' + this.normalize(this.getCategory()) + '-' +
      this.normalize(this.name) + '-' +
      this.normalize(this.location) + '-' +
      this.normalize(this.zip) + '_' +
      this.normalize(this.casting_id)
  } else {
    return 'https://www.exploretalent.com/auditions/' + this.normalize(this.getCategory()) + '-' +
      this.normalize(this.name) + '-' +
      this.normalize(this.location) + '-' +
      this.normalize(this.casting_id)
  }
}

Casting.prototype.normalize = function (url) {
  url = url + ''
  let str = url.replace(/[^a-zA-Z0-9-_ ]/, '')
  let strs = str.toLowerCase().split(' ')

  _.remove(strs, function (s) {
    return s.trim() == ''
  })

  str = strs.join('-')
  strs = str.toLowerCase().split('-')

  _.remove(strs, function (s) {
    return (s.trim() == '' || s.trim() == '-')
  })

  str = strs.join('_')
  strs = str.toLowerCase().split('_')

  _.remove(strs, function (s) {
    return (s.trim() == '' || s.trim() == '_')
  })

  return strs.join('-')
}

Casting.relationship = [
  'data:bam_castings',
  'bam_cd_user',
  'bam_roles'
]

module.exports = Casting

},{"./../services/date.js":409,"lodash":429}],26:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  castings = {},
  Casting = require('./bam_casting.js')

castings.relationship = Casting.relationship

castings.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('bam_casting', item)
  })
}

module.exports = castings

},{"./../services/model.js":411,"./bam_casting.js":25,"lodash":429}],27:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  talentHelper = require('./../services/talent.js')

function CdUser (data) {
  _.extend(this, data || {})
}

CdUser.prototype.getCallStat = function () {
  if (this.call_status == 0) {
    return 'Not Set'
  }
  if (this.call_status == 1) {
    return 'Left Massage'
  }
  if (this.call_status == 2) {
    return 'Incomplete Review'
  }
  if (this.call_status == 3) {
    return 'Need to Re-Review'
  }
  if (this.call_status == 4) {
    return 'Missing Contact Info'
  }
  if (this.call_status == 5) {
    return 'Bad Contact Info'
  }
  if (this.call_status == 6) {
    return 'Suspicious'
  }
  if (this.call_status == 7) {
    return 'Happy CD/Reference'
  }
  if (this.call_status == 8) {
    return 'They Hate Us/No call'
  }
  if (this.call_status == 9) {
    return 'Data Ok - need call'
  } else {
    return 'Good Reference'
  }
}

CdUser.prototype.getFullName = function () {
  return talentHelper.getFullName(this.fname, this.lname)
}

CdUser.relationship = [
  'user',
  'data:bam_cd_users'
]

module.exports = CdUser

},{"./../services/talent.js":418,"lodash":429}],28:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  cd_users = {},
  CdUser = require('./bam_cd_user.js')

cd_users.relationship = CdUser.relationship

cd_users.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('bam_cd_user', item)
  })
}

module.exports = cd_users

},{"./../services/model.js":411,"./bam_cd_user.js":27,"lodash":429}],29:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function FavoriteCastings (data) {
  _.extend(this, data)
}

module.exports = FavoriteCastings

},{"lodash":429}],30:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  converter = require('./../services/converter.js')

function Friend (data) {
  _.extend(this, data)
}

Friend.prototype.getOtherUser = function () {
  if (this.owner) {
    let owner = this.owner

    if (this.talentnum1 == owner.bam_talentci.talentnum) {
      return this.bam_talentci2
    } else {
      return this.bam_talentci1
    }
  } else {
    return null
  }
}

Friend.relationship = [
  'bam_talentci1:bam_talentci',
  'bam_talentci2:bam_talentci',
  'data:bam_friends'
]

module.exports = Friend

},{"./../services/converter.js":406,"lodash":429}],31:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  friends = {},
  Friend = require('./bam_friend.js')

friends.relationship = Friend.relationship

friends.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('bam_friend', item)
  })
}

module.exports = friends

},{"./../services/model.js":411,"./bam_friend.js":30,"lodash":429}],32:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  talentService = require('./../services/talent.js'),
  restService = require('./../services/rest.js'),
  scheduleResource = require('./../resources/schedule.js'),
  scheduleImportResource = require('./../resources/schedule_import.js'),
  searchTalentResource = require('./../resources/search_talent.js')

function Role (data) {
  _.extend(this, data)
}

Role.prototype.getHeightMinText = function () {
  if (parseInt(this.height_min)) {
    return talentService.getHeight(this.height_min)
  } else {
    return 'Any'
  }
}

Role.prototype.getHeightMaxText = function () {
  if (parseInt(this.height_max)) {
    return talentService.getHeight(this.height_max)
  } else {
    return 'Any'
  }
}

Role.prototype.getLikeItList = function (options, app_filter) {
  options = options || {}

  let data = {
    per_page: options.per_page,
    query: [
      [ 'with', 'user' ],
      [ 'with', 'bam_talentinfo1' ],
      [ 'with', 'bam_talentinfo2' ],
      [ 'with', 'bam_talent_music' ],
      [ 'with', 'bam_talent_dance' ],
      [ 'with', 'bam_talent_media2' ],
      [ 'join', 'laret_users', 'laret_users.bam_talentnum', '=', 'talentci.talentnum' ],
      [ 'leftJoin', 'laret_schedules', 'laret_schedules.invitee_id', '=', 'laret_users.id' ],
      [ 'where', 'laret_schedules.rating', '<>', 0 ],
      [ 'where', 'laret_schedules.bam_role_id', '=', this.role_id ]
    ]
  }

  options = options || {}

  data.page = options.page

  if (app_filter) {
    data.query.push(['whereIn', 'x_origin', app_filter])
  }

  if (options.filter == 'free') {
    data.query.push([ 'where', 'join_status', '<', 5 ])
  }

  if (options.filter == 'pro') {
    data.query.push([ 'where', 'join_status', '=', 5 ])
  }

  return self.core.resource.talent.get(data)
}

Role.prototype.getLikeItListCount = function (xorigins) {
  let deferred = $.Deferred()

  let data = {
    per_page: 1,
    query: [
      [ 'join', 'bam.laret_users', 'bam.laret_users.bam_talentnum', '=', 'search.talents.talentnum' ],
      [ 'leftJoin', 'bam.laret_schedules', 'bam.laret_schedules.invitee_id', '=', 'bam.laret_users.id' ],
      [ 'where', 'bam.laret_schedules.rating', '<>', 0 ],
      [ 'where', 'bam.laret_schedules.bam_role_id', '=', this.role_id ]
    ]
  }

  if (xorigins instanceof Array) {
    data.query.push([ 'whereIn', 'x_origin', xorigins ])
  }

  self.core.resource.search_talent.get(data)
    .then(function (res) {
      deferred.resolve(res.total)
    })

  return deferred.promise()
}

Role.prototype.getSubmissionsCount = function (xorigins) {
  let deferred = $.Deferred()

  let data = {
    per_page: 1,
    page: self.page,
    query: [
      [ 'join', 'bam.laret_users', 'bam.laret_users.bam_talentnum', '=', 'search.talents.talentnum' ],
      [ 'leftJoin', 'bam.laret_schedules', 'bam.laret_schedules.invitee_id', '=', 'bam.laret_users.id' ],
      [ 'where', 'bam.laret_schedules.submission', '>', 0 ],
      [ 'where', 'bam.laret_schedules.bam_role_id', '=', this.role_id ]
    ]
  }

  if (xorigins instanceof Array) {
    data.query.push([ 'whereIn', 'x_origin', xorigins ])
  }

  self.core.resource.search_talent.get(data)
    .then(function (res) {
      deferred.resolve(res.total)
    })

  return deferred.promise()
}

Role.prototype.getSchedulesCount = function (status) {
  let deferred = $.Deferred()

  let data = {
    per_page: 1,
    page: self.page,
    query: [
      [ 'join', 'bam.laret_users', 'bam.laret_users.bam_talentnum', '=', 'search.talents.talentnum' ],
      [ 'leftJoin', 'bam.laret_schedules', 'bam.laret_schedules.invitee_id', '=', 'bam.laret_users.id' ],
      [ 'where', 'bam.laret_schedules.status', '=', status ],
      [ 'where', 'bam.laret_schedules.bam_role_id', '=', this.role_id ]
    ]
  }

  self.core.resource.search_talent.get(data)
    .then(function (res) {
      deferred.resolve(res.total)
    })

  return deferred.promise()
}

Role.prototype.deleteLikeItList = function () {
  let data = {
    query: [
      [ 'where', 'rating', '<>', 0 ],
      [ 'where', 'bam_role_id', '=', this.role_id ]
    ],
    fields: {
      rating: 0
    },
    paginate: false
  }

  return scheduleResource.patch(data)
}

Role.prototype.copyToLikeItList = function () {
  let data = {
    query: [
      [ 'where',
        [ 'where', 'rating', '=', 0 ],
        [ 'orWhereNull', 'rating' ]
      ],
      [ 'where', 'submission', '>', 0 ],
      [ 'where', 'bam_role_id', '=', this.role_id ]
    ],
    fields: {
      rating: 3
    },
    per_page: 1000
  }

  return scheduleResource.patch(data)
}

Role.prototype.deleteSelfSubmissions = function () {
  let data = {
    with_trashed: 1,
    query: [
      [ 'where', 'submission', '>', 0 ],
      [ 'where', 'bam_role_id', '=', this.role_id ]
    ],
    per_page: 1000000
  }

  return scheduleResource.delete(data)
}

Role.prototype.getSelfSubmissions = function (options, app_filter) {
  let data = {

    query:
    [
      [ 'with', 'user' ],
      [ 'with', 'bam_talentinfo1' ],
      [ 'with', 'bam_talentinfo2' ],
      [ 'with', 'bam_talent_media2' ],
      [ 'with', 'bam_talent_music' ],
      [ 'with', 'bam_talent_dance' ],
      [ 'join', 'laret_users', 'laret_users.bam_talentnum', '=', 'talentci.talentnum' ],
      [ 'leftJoin', 'laret_schedules', 'laret_schedules.invitee_id', '=', 'laret_users.id' ],
      [ 'where', 'laret_schedules.submission', '>', 0 ],
      [ 'where', 'laret_schedules.bam_role_id', '=', this.role_id ]
    ]
  }

  if (options) {
    data = _.merge(data, options)
  }

  if (app_filter) {
    data.query.push(['whereIn', 'x_origin', app_filter])
  }

  return self.core.resource.talent.get(data)
}

Role.prototype.copyMatchesToLikeItList = function (pro, user_id) {
  let data = {
    query: this.getMatchesFilter(pro).query,
    bam_role_id: this.role_id,
    bam_user_id: user_id,
    bam_cd_user_id: this.bam_casting.user_id
  }

  return scheduleImportResource.post(data)
}

Role.prototype.copyMatchesToLikeItListwParam = function (pro, param, user_id) {
  let data = {
    query: this.getMatchesFilter(pro, param).query,
    bam_role_id: this.role_id,
    bam_user_id: user_id,
    bam_cd_user_id: this.bam_casting.user_id
  }

  return scheduleImportResource.post(data)
}

Role.prototype.getMatches = function (pro, options, app_filter) {
  let data = this.getMatchesFilter(pro, options, app_filter)
  data.q = JSON.stringify(data.query)
  delete data.query

  return searchTalentResource.get(data)
}

Role.prototype.getMatchesFilter = function (pro, options, app_filter) {
  let data = {
    query: [
      [ 'where', 'is_pro', '=', pro ? 1 : 0 ]
    ]
  }

  if (options) {
    data = _.merge(data, options)

    if (options.has_photos) {
      if (options.has_photos == 1) {
        data.query.push(['where', 'has_photos', '=', 1 ])
      } else {
        data.query.push(['where', 'has_photos', '=', 0 ])
      }
    }

    if (options.regdate_from && options.regdate_to) {
      data.query.push(['where', 'date_entered', '<=', options.regdate_to])
      data.query.push(['where', 'date_entered', '>=', options.regdate_from])
    }
  }

  if (app_filter) {
    data.query.push([ 'whereIn', 'x_origin', app_filter ])
  }

  if (parseInt(this.age_min)) {
    data.query.push([ 'where', 'dobyyyy', '<=', new Date().getFullYear() - parseInt(this.age_min) ])
  }

  if (parseInt(this.age_max)) {
    data.query.push([ 'where', 'dobyyyy', '>=', new Date().getFullYear() - parseInt(this.age_max) ])
  }

  if (parseInt(this.height_min)) {
    data.query.push([ 'where', 'heightinches', '>=', this.height_min ])
  }

  if (parseInt(this.height_max)) {
    data.query.push([ 'where', 'heightinches', '<=', this.height_max ])
  }

  let subquery = []

  // markets
  let markets = self.project.market.split('>')

  let nationwide = _.find(markets, function (market) {
    return market == 'N/A'
  })

  if (markets.length && !nationwide) {
    subquery = []

    _.each(markets, function (market) {
      if (subquery.length == 0) {
        subquery.push([ 'where', 'city', 'like', '%' + market + '%' ])
      } else {
        subquery.push([ 'orWhere', 'city', 'like', '%' + market + '%' ])
      }

      subquery.push([ 'orWhere', 'city1', 'like', '%' + market + '%' ])
      subquery.push([ 'orWhere', 'city2', 'like', '%' + market + '%' ])
      subquery.push([ 'orWhere', 'city3', 'like', '%' + market + '%' ])
    })

    data.query.push([ 'where', subquery ])
  }

  // gender
  let genders = this.getGenders()

  if (genders.length) {
    subquery = []

    _.each(genders, function (gender) {
      if (subquery.length == 0) {
        subquery.push([ 'where', 'sex', '=', gender ])
      } else {
        subquery.push([ 'orWhere', 'sex', '=', gender ])
      }
    })

    data.query.push([ 'where', subquery ])
  }

  // ethnicity
  let ethnicities = this.getEthnicities()

  if (ethnicities.length) {
    subquery = []

    _.each(ethnicities, function (ethnicity) {
      if (subquery.length == 0) {
        subquery.push([ 'where', 'ethnicity', '=', ethnicity ])
      } else {
        subquery.push([ 'orWhere', 'ethnicity', '=', ethnicity ])
      }
    })

    data.query.push([ 'where', subquery ])
  }

  // body type/build
  let builds = this.getBuilds()

  if (builds.length) {
    subquery = []

    _.each(builds, function (build) {
      if (subquery.length == 0) {
        subquery.push([ 'where', 'build', '=', build ])
      } else {
        subquery.push([ 'orWhere', 'build', '=', build ])
      }
    })

    data.query.push([ 'where', subquery ])
  }

  // hair color
  let haircolors = this.getHairColors()

  if (haircolors.length) {
    subquery = []

    _.each(haircolors, function (haircolor) {
      if (subquery.length == 0) {
        subquery.push([ 'where', 'haircolor', '=', haircolor ])
      } else {
        subquery.push([ 'orWhere', 'haircolor', '=', haircolor ])
      }
    })

    data.query.push([ 'where', subquery ])
  }

  // hair style
  let hairstyles = this.getHairStyles()

  if (hairstyles.length) {
    subquery = []

    _.each(hairstyles, function (hairstyle) {
      if (subquery.length == 0) {
        subquery.push([ 'where', 'hairstyle', '=', hairstyle ])
      } else {
        subquery.push([ 'orWhere', 'hairstyle', '=', hairstyle ])
      }
    })

    data.query.push([ 'where', subquery ])
  }

  // eye color
  let eyecolors = this.getEyeColors()

  if (eyecolors.length) {
    subquery = []

    _.each(eyecolors, function (eyecolor) {
      if (subquery.length == 0) {
        subquery.push([ 'where', 'eyecolor', '=', eyecolor ])
      } else {
        subquery.push([ 'orWhere', 'eyecolor', '=', eyecolor ])
      }
    })

    data.query.push([ 'where', subquery ])
  }

  return data
}

Role.prototype.getGenders = function () {
  let array = []

  if (this.gender_male == 1) {
    array.push('Male')
  }

  if (this.gender_female == 1) {
    array.push('Female')
  }

  if (array.length > 1) {
    return []
  }

  return array
}

Role.prototype.getEthnicities = function () {
  let array = []

  let ethnicities = {
    african: 'African',
    african_am: 'African American',
    asian: 'Asian',
    carribian: 'Caribbean',
    caucasian: 'Caucasian',
    hispanic: 'Hispanic',
    mediterranean: 'Mediterranean',
    middle_est: 'Middle Eastern',
    mixed: 'Mixed',
    native_am: 'American',
    american_in: 'American Indian',
    east_indian: 'East Indian'
  }

  if (this.ethnicity_any == 1) {
    return []
  }

  for (let e in ethnicities) {
    if (this['ethnicity_' + e] == 1) {
      array.push(ethnicities[e])
    }
  }

  return array
}

Role.prototype.getHairColors = function () {
  let array = []

  let haircolors = {
    auburn: 'Auburn',
    black: 'Black',
    blonde: 'Blonde',
    brown: 'Brown',
    chestnut: 'Chestnut',
    dark_brown: 'Dark Brown',
    grey: 'Grey',
    red: 'Red',
    white: 'White',
    salt_pepper: 'Salt&Peppe'
  }

  if (this.hair_any == 1) {
    return []
  }

  for (let color in haircolors) {
    if (this['hair_' + color] == 1) {
      array.push(haircolors[color])
    }
  }

  return array
}

Role.prototype.getHairStyles = function () {
  let array = []

  let hairstyles = {
    afro: 'Afro',
    bald: 'Bald',
    buzz: '',
    cons: 'Conservati',
    dread: 'Dreadlocks',
    long: 'Long',
    medium: 'Medium',
    shaved: 'Shaved',
    short: 'Short'
  }

  if (this.hairstyle_any == 1) {
    return []
  }

  for (let style in hairstyles) {
    if (this['hairstyle_' + style] == 1) {
      array.push(hairstyles[style])
    }
  }

  return array
}

Role.prototype.getEyeColors = function () {
  let array = []

  let eyecolors = {
    blue: 'Blue',
    b_g: 'Blue-Green',
    brown: 'Brown',
    green: 'Green',
    grey: 'Grey',
    g_b: 'Grey-Blue',
    g_g: 'Grey-Green',
    hazel: 'Hazel'
  }

  if (this.eye_any == 1) {
    return []
  }

  for (let color in eyecolors) {
    if (this['eye_' + color] == 1) {
      array.push(eyecolors[color])
    }
  }

  return array
}

Role.prototype.getBuilds = function () {
  let array = []

  let builds = {
    medium: 'Medium',
    athletic: 'Athletic',
    bb: 'Muscular',
    xlarge: 'Extra Large',
    large: 'Large',
    petite: 'Petite',
    thin: 'Slim',
    lm: 'Lean Muscle',
    average: 'Average'
  }

  if (this.built_any == 1) {
    return []
  }

  for (let b in builds) {
    if (this['built_' + b] == 1) {
      array.push(builds[b])
    }
  }

  return array
}

Role.prototype.bulkAddToLikeitlist = function (filters) {
  let data = {
    bam_cd_user_id: this.bam_casting.user_id,
    bam_role_id: this.role_id,
    query: JSON.stringify(filters),
    status: 0
  }

  return scheduleImportResource.post(data)
}

Role.prototype.stopBulkAddToLikeitlist = function () {
  let data = {
    query: [
      ['where', 'bam_role_id', '=', this.role_id]
    ]
  }

  return scheduleImportResource.get(data)
    .then(function (result) {
      let promises = result.data.map(function (schedule_import) {
        return scheduleImportResource.delete({scheduleId: schedule_import.id})
      })

      return $.when.apply($.when, promises)
    })
}

function getValues (obj) {
  return Object.keys(obj).map(function (key) {
    return obj[key]
  })
}

Role.relationship = [
  'data:bam_roles',
  'schedules',
  'bam_casting'
]

module.exports = Role

},{"./../resources/schedule.js":346,"./../resources/schedule_import.js":348,"./../resources/search_talent.js":352,"./../services/rest.js":416,"./../services/talent.js":418,"lodash":429}],33:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  roles = {},
  Role = require('./bam_role.js')

roles.relationship = Role.relationship

roles.create = function (array) {
  let modelify = require('./../services/model.js')
  return _.map(array || [], function (item) {
    return modelify('bam_role', item)
  })
}

module.exports = roles

},{"./../services/model.js":411,"./bam_role.js":32,"lodash":429}],34:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  talentHelper = require('./../services/talent.js')

function TalentDance (data) {
  _.extend(this, data)
}

TalentDance.prototype.getExperience = function () {
  return talentHelper.getExperience(this.experience)
}

TalentDance.prototype.getPerformance = function () {
  return talentHelper.getPerformance(this.num_of_perform)
}

module.exports = TalentDance

},{"./../services/talent.js":418,"lodash":429}],35:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function TalentMedia2 (data) {
  _.extend(this, data)
}

module.exports = TalentMedia2

},{"lodash":429}],36:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  talent = require('./../services/talent.js')

TalentMusic.$$musicTypes = require('./../values/resume_types')

function TalentMusic (data) {
  _.extend(this, data)
}

TalentMusic.prototype.getMusicType = function (index) {
  let genre = this['music_type' + (index || '')]
  return TalentMusic.$$musicTypes[genre]
}

TalentMusic.prototype.getGenres = function () {
  let self = this
  return _(['', 2, 3, 4]).map(function (item) {
    return self['genre' + item] || ''
  }).compact().value().join(', ')
}

TalentMusic.prototype.getExperience = function () {
  return talent.getExperience(this.experience)
}

TalentMusic.prototype.getPerformance = function () {
  return talent.getPerformance(this.number_of_gigs)
}

module.exports = TalentMusic

},{"./../services/talent.js":418,"./../values/resume_types":427,"lodash":429}],37:[function(require,module,exports){
'use strict'

let _ = require('lodash')

TalentResume.$$resumeTypes = require('./../values/resume_types')

function TalentResume (data) {
  let resumeTypes = TalentResume.$$resumeTypes

  let object = _.reduce(data, function (object, value, key) {
    object[resumeTypes[value.type]] = value
    return object
  }, {})

  _.each(resumeTypes, function (value, key) {
    object[value] = object[value] || {}
  })

  _.extend(this, object)
}

module.exports = TalentResume

},{"./../values/resume_types":427,"lodash":429}],38:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function TalentSocial (data) {
  _.extend(this, data || {})
}

TalentSocial.prototype.getByType = function (type) {
  if (this.data) {
    let social = _.first(_.where(this.data, { sm_type: type }))
    return social
  }
}

TalentSocial.relationship = [
  'talentnum:bam_talentci',
  'data:bam_talent_socials'
]

module.exports = TalentSocial

},{"lodash":429}],39:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  talent_socials = {},
  TalentSocial = require('./bam_talent_social.js')

talent_socials.relationship = TalentSocial.relationship

talent_socials.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('bam_talent_social', item)
  })
}

module.exports = talent_socials

},{"./../services/model.js":411,"./bam_talent_social.js":38,"lodash":429}],40:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  talent = require('./../services/talent.js'),
  scheduleResource = require('./../resources/schedule.js'),
  campaignResource = require('./../resources/campaign.js'),
  jobResource = require('./../resources/job.js'),
  accessTokenResource = require('./../resources/oauth_access_token.js'),
  date = require('./../services/date.js')

function Talent(data) {
  _.extend(this, data || {})
} Talent.prototype.getFullName = function() {
  return talent.getFullName(this.fname, this.lname)
}

Talent.prototype.getAge = function() {
  return date.calculateAge(this.bam_talentinfo1.dobyyyy, this.bam_talentinfo1.dobmm, this.bam_talentinfo1.dobdd)
}

Talent.prototype.getXOrigin = function(){
  if(this.x_origin == 8){
    return "auditions.com"
  }
  if(this.x_origin == 7){
    return "cebumodeling.com"
  }
  if(this.x_origin == 9){
    return "talent.ph"
  }
  if(this.x_origin == 0 || this.x_origin == 1 || this.x_origin == 2 || this.x_origin == 3 || this.x_origin == 4 || this.x_origin == 5 || this.x_origin == 6){
    return "exploretalent.com"
  }
}

Talent.prototype.getHeight = function() {
  let feet = Math.floor(this.heightinches / 12)
  let inches = this.heightinches % 12
  return feet + "'" + inches + '"'
}

Talent.prototype.isPaying = function() {
  return this.bam_talentrecurring ? true : false
}

Talent.prototype.loginAsTalent = function(redirect_url) {
  let deferred = $.Deferred()

  // Default has no redirect_url
  redirect_url = redirect_url || this.talentlogin

  // The beginning of the end (SUBLIME SUCKS)
  let login_url = 'http://'

  // Add the domain
  login_url += this.getXOrigin()

  // Create the access token
  accessTokenResource.post({ user_id: this.user.id, app_id: 4 })
    .then(function(res) {
      // Add the redirect URL to the PARAMS if available
      if (redirect_url.length > 0) {
        res.redirect_url = encodeURIComponent(redirect_url)
      }

      // Add the login syntax
      login_url += '/verify?'

      // Encode the values and add to the URL
      login_url += jQuery.param(res)

      // Open the new window/tab
      window.open(login_url,'_blank')

      // Resolve the deferred promise
      deferred.resolve(login_url)
    })

  // Defer the promise
  return deferred.promise()
}

Talent.prototype.getPrimaryPhoto = function() {
  let media_path =
    _.first(
      _.pluck(
        _.uniq(([]).concat(
          _.where(this.bam_talent_media2, { type : 2 }),
          _.where(this.bam_talent_media2, { type : '2' })
        )),
        'bam_media_path_full'
      )
    )

  let gender = this.bam_talentinfo1 ? this.bam_talentinfo1.sex : 'Male'

  if (media_path) {
    return 'https://talentmedia.blob.core.windows.net/etdownload/' + media_path
  }
  else {
    if(gender == "Male") {
      let imgsrc = $('.profile-pic-primary').attr('src')
      if(imgsrc == '/images/filler.jpg') {
        $('a.fancybox').addClass('show-upload-primary-photo-btn')
        $('a.fancybox').removeClass('fancybox')
      }
      return '/images/filler.jpg'
    }

    else {
      let imgsrc = $('.profile-pic-primary').attr('src')
      if(imgsrc == '/images/filler_women.jpg') {
        $('a.fancybox').addClass('show-upload-primary-photo-btn')
        $('a.fancybox').removeClass('fancybox')
      }
      return '/images/filler_women.jpg'
    }
  }
}

Talent.prototype.getPrimaryPhotoId = function() {
  let id =
    _.first(
      _.pluck(
        _.uniq(([]).concat(
          _.where(this.bam_talent_media2, { type : 2 }),
          _.where(this.bam_talent_media2, { type : '2' })
        )),
        'id'
      )
    )
   return id
}

Talent.prototype.getPrimaryPhotoComplete = function() {
  let complete =
    _.first(
      _.pluck(
        _.uniq(([]).concat(
          _.where(this.bam_talent_media2, { type : 2 }),
          _.where(this.bam_talent_media2, { type : '2' })
        )),
        'complete'
      )
    )
   return complete
}

Talent.prototype.getSocialAccount = function(type) {
  let social = _.first(_.pluck(_.where(this.bam_talent_social, { sm_type : type }), 'sm_url'))

  return social
}

Talent.prototype.getLocation = function() {
  let parts = []

  if(this.city && this.city.length > 0) {
    parts.push(this.city)
  }

  if(this.state && this.state.length > 0) {
    parts.push(this.state)
  }

  if (parts.length  >= 2) {
    return parts.join(', ')
  }

  if (this.bam_talentinfo2) {
    if (this.bam_talentinfo2.city1) {
      return this.bam_talentinfo2.city1
    }

    if (this.bam_talentinfo2.city2) {
      return this.bam_talentinfo2.city2
    }

    if (this.bam_talentinfo2.city3) {
      return this.bam_talentinfo2.city3
    }
  }

  if (parts.length  >= 1) {
    return parts.join(', ')
  }

  return 'Unknown'
}

Talent.prototype.heightText = function() {
  let feet = Math.floor(this.bam_talentinfo1.heightinches / 12.00)
  let inches = this.bam_talentinfo1.heightinches % 12
  return feet + "'" + inches + '"'
}

Talent.prototype.stateText = function() {
  let states = {
    'AL' : 'Alabama',
    'AK' : 'Alaska',
    'AZ' : 'Arizona',
    'AR' : 'Arkansas',
    'CA' : 'California',
    'CO' : 'Colorado',
    'CT' : 'Connecticut',
    'DE' : 'Delaware',
    'FL' : 'Florida',
    'GA' : 'Georgia',
    'HI' : 'Hawaii',
    'ID' : 'Idaho',
    'IL' : 'Illinois',
    'IN' : 'Indiana',
    'IA' : 'Iowa',
    'KS' : 'Kansas',
    'KY' : 'Kentucky',
    'LA' : 'Louisiana',
    'ME' : 'Maine',
    'MD' : 'Maryland',
    'MA' : 'Massachusetts',
    'MI' : 'Michigan',
    'MN' : 'Minnesota',
    'MS' : 'Mississippi',
    'MO' : 'Missouri',
    'MT' : 'Montana',
    'NE' : 'Nebraska',
    'NV' : 'Nevada',
    'NH' : 'New Hampshire',
    'NJ' : 'New Jersey',
    'NM' : 'New Mexico',
    'NY' : 'New York',
    'NC' : 'North Carolina',
    'ND' : 'North Dakota',
    'OH' : 'Ohio',
    'OK' : 'Oklahoma',
    'OR' : 'Oregon',
    'PA' : 'Pennsylvania',
    'RI' : 'Rhode Island',
    'SC' : 'South Carolina',
    'SD' : 'South Dakota',
    'TN' : 'Tennessee',
    'TX' : 'Texas',
    'UT' : 'Utah',
    'VT' : 'Vermont',
    'VA' : 'Virginia',
    'WA' : 'Washington',
    'WV' : 'West Virginia',
    'WI' : 'Wisconsin',
    'WY' : 'Wyoming'
  }

  return states[this.state]
}

Talent.prototype.getSelfSubmissions = function () {
  let deferred = $.Deferred()
  let qs = self.core.service.query_string()

  let data = {
    page: qs.self_submissions || 1,
    query : [
      [ 'join', 'laret_schedules', 'laret_schedules.bam_role_id', '=', 'roles.role_id' ],
      [ 'where', 'laret_schedules.submission', '>', 0 ],
      [ 'where', 'laret_schedules.invitee_id', '=', this.user.id ],
      [ 'select', 'laret_schedules.id as schedule_id' ],
      [ 'orderBy', 'laret_schedules.created_at', 'DESC' ]
    ]
  }

  let roles

  jobResource.get(data)
    .then(function(res) {
      roles = res
      let scheduleIds = _.map(res.data, function(schedule) {
        return schedule.schedule_id
      })

      scheduleIds.push(0)

      let data2 = {
        query : [
          [ 'whereIn', 'id', scheduleIds ],
          [ 'with', 'bam_role.bam_casting' ],
          [ 'orderBy', 'created_at', 'DESC' ]
        ]
      }

      return scheduleResource.get(data2)
    })
    .then(function(res) {
      res.total = roles.total

      deferred.resolve(res)
    })

  return deferred.promise()

}

Talent.prototype.getCDInvites = function () {
  let qs = self.core.service.query_string()
  let deferred = $.Deferred()

  let data = {
    page: qs.cd_invites || 1,
    per_page : 10,
    query : [
      [ 'join', 'laret_schedules', 'laret_schedules.bam_role_id', '=', 'roles.role_id' ],
      [ 'join', 'laret_campaigns', 'laret_campaigns.bam_role_id', '=', 'roles.role_id' ],
      [ 'where', 'laret_schedules.rating', '<>', 0 ],
      [ 'where', 'laret_schedules.invitee_id', '=', this.user.id ],
      [ 'select', 'laret_campaigns.id AS campaign_id', 'laret_schedules.id AS schedule_id' ],
      [ 'orderBy', 'laret_campaigns.created_at', 'DESC' ],
      [ 'groupBy', 'laret_campaigns.bam_role_id' ]
    ]
  }


  let campaignIds,
    scheduleIds,
    invites

  jobResource.get(data)
    .then(function(res) {
      invites = res

      campaignIds = _.map(res.data, 'campaign_id')
      campaignIds.push(0)

      scheduleIds = _.map(res.data, 'schedule_id')
      scheduleIds.push(0)

      data = {
        query : [
          [ 'whereIn', 'id', campaignIds ],
          [ 'with', 'bam_role.bam_casting' ],
          [ 'orderBy', 'created_at', 'DESC' ]
        ]
      }

      return campaignResource.get(data)
    })
    .then(function(res) {
      invites.data = res.data

      data = {
        query : [
        [ 'whereIn', 'id', scheduleIds ],
        [ 'with', 'conversation.messages.user.bam_talentci' ],
        [ 'with', 'conversation.messages.user.bam_cd_user' ]
        ]
      }

      return scheduleResource.get(data)
    })
    .then(function(res) {
      for(let i = 0; i < invites.data.length; i++) {
        for(let j = 0; j < res.data.length; j++) {
          if (invites.data[i].bam_role_id == res.data[j].bam_role_id) {
            invites.data[i].schedule = res.data[j]
          }
        }
      }

      deferred.resolve(invites)
    })

  return deferred.promise()
}

Talent.relationship = [
  'user',
  'bam_talentrecurring',
  'bam_talenttracking',
  'bam_talentinfo1',
  'bam_talentinfo2',
  'bam_talentinfo3',
  'bam_talent_resume',
  'bam_talent_music',
  'bam_talent_dance',
  'bam_talent_general',
  'bam_talent_social:bam_talent_socials',
  //if using GET from api, result is in the data property, set model to array of bam_talentcis
  'data:bam_talentcis'
]

module.exports = Talent

},{"./../resources/campaign.js":272,"./../resources/job.js":308,"./../resources/oauth_access_token.js":327,"./../resources/schedule.js":346,"./../services/date.js":409,"./../services/talent.js":418,"lodash":429}],41:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  talents = {},
  Talent = require('./bam_talentci.js')

talents.relationship = Talent.relationship

talents.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('bam_talentci', item)
  })
}

module.exports = talents

},{"./../services/model.js":411,"./bam_talentci.js":40,"lodash":429}],42:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  converter = require('./../services/converter.js'),
  date = require('./../services/date.js')

function TalentInfo1 (data) {
  _.extend(this, data)
}

TalentInfo1.relationship = [
  'bam_talentci'
]

module.exports = TalentInfo1

},{"./../services/converter.js":406,"./../services/date.js":409,"lodash":429}],43:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function TalentInfo2 (data) {
  _.extend(this, data)
}

module.exports = TalentInfo2

},{"lodash":429}],44:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function TalentInfo3 (data) {
  _.extend(this, data)
}

module.exports = TalentInfo3

},{"lodash":429}],45:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function TalentRecurring (data) {
  _.extend(this, data)
}

module.exports = TalentRecurring

},{"lodash":429}],46:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function Talenttracking (data) {
  _.extend(this, data || {})
}

Talenttracking.relationship = [
  'data:bam_talenttrackings'
]

module.exports = Talenttracking

},{"lodash":429}],47:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  talenttrackings = {}

talenttrackings.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('bam_talenttracking', item)
  })
}

module.exports = talenttrackings

},{"./../services/model.js":411,"lodash":429}],48:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function User (data) {
  _.extend(this, data)
}

User.relationship = [
  'user'
]

module.exports = User

},{"lodash":429}],49:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function Zip (data) {
  _.extend(this, data)
}

module.exports = Zip

},{"lodash":429}],50:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function BannedEmail (data) {
  _.extend(this, data || {})
}

BannedEmail.relationship = [
  'data:banned_emails'
]

module.exports = BannedEmail

},{"lodash":429}],51:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  banned_emails = {}

banned_emails.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('banned_email', item)
  })
}

module.exports = banned_emails

},{"./../services/model.js":411,"lodash":429}],52:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function CallBack (data) {
  _.extend(this, data)
}

CallBack.prototype.formatToDateTime = function (timestamp) {
  return moment.unix(timestamp).format('DD/MM/YY hh:mm A')
}

CallBack.relationship = [
  'data:callbacks'
]

module.exports = CallBack

},{"lodash":429}],53:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  callbacks = {},
  Callback = require('./callback.js')

callbacks.relationship = Callback.relationship

callbacks.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('callback', item)
  })
}

module.exports = callbacks

},{"./../services/model.js":411,"./callback.js":52,"lodash":429}],54:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function Campaign (data) {
  _.extend(this, data || {})
}

Campaign.prototype.queryObject = function (key, operator) {
  let query = JSON.parse(this.query)

  let obj = {}

  _.each(query, function (q) {
    // check what type of query
    if (q[0] == 'where') {
      // its a subquery!
      if (q[1] instanceof Array) {
        _.each(q[1], function (subq) {
          let name = subq[1].split('.')
          name = name[name.length - 1]

          let value = subq[3]

          if (subq[2] == '>=') {
            value = { gt: subq[3] }
          } else if (subq[2] == '<=') {
            value = { lt: subq[3] }
          }

          // if already assigned, convert to array
          if (obj[name]) {
            if (value instanceof Object) {
              if (value.gt != null) {
                obj[name]['gt'] = value.gt
              } else {
                obj[name]['lt'] = value.lt
              }
            } else {
              let arr = []
              arr.push(obj[name])
              arr.push(value)
              obj[name] = arr
            }
          }
          // if not, assign directly
          else {
            obj[name] = value
          }
        })
      } else {
        // get only last name
        let name = q[1].split('.')
        name = name[name.length - 1]

        let value = q[3]

        if (q[2] == '>=') {
          value = { gt: q[3] }
        } else if (q[2] == '<=') {
          value = { lt: q[3] }
        }

        // if already assigned, convert to array
        if (obj[name]) {
          if (value instanceof Object) {
            if (value.gt != null) {
              obj[name]['gt'] = value.gt
            } else {
              obj[name]['lt'] = value.lt
            }
          } else {
            let arr = []
            arr.push(obj[name])
            arr.push(value)
            obj[name] = arr
          }
        }
        // if not, assign directly
        else {
          obj[name] = value
        }
      }
    }
  })

  return obj
}

Campaign.relationship = [
  'data:campaigns',
  'bam_role',
  'bam_cd_user'
]

module.exports = Campaign

},{"lodash":429}],55:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function CampaignAppLog (data) {
  _.extend(this, data || {})
}

CampaignAppLog.relationship = [
  'data:campaign_app_logs'
]

module.exports = CampaignAppLog

},{"lodash":429}],56:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  campaign_app_logs = {}

campaign_app_logs.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('campaign_app_log', item)
  })
}

module.exports = campaign_app_logs

},{"./../services/model.js":411,"lodash":429}],57:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function CampaignAppQueue (data) {
  _.extend(this, data || {})
}

CampaignAppQueue.relationship = [
  'data:campaign_app_queues',
  'bam_talentci'
]

module.exports = CampaignAppQueue

},{"lodash":429}],58:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  campaign_app_queues = {}

campaign_app_queues.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('campaign_app_queue', item)
  })
}

module.exports = campaign_app_queues

},{"./../services/model.js":411,"lodash":429}],59:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function CampaignSender (data) {
  _.extend(this, data || {})
}

CampaignSender.relationship = [
  'data:campaign_senders'
]

module.exports = CampaignSender

},{"lodash":429}],60:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function CampaignSenderAddress (data) {
  _.extend(this, data || {})
}

CampaignSenderAddress.relationship = [
  'data:campaign_sender_addresses'
]

module.exports = CampaignSenderAddress

},{"lodash":429}],61:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  campaign_sender_addresses = {},
  CampaignSenderAddress = require('./campaign_sender_address.js')

campaign_sender_addresses.relationship = CampaignSenderAddress.relationship

campaign_sender_addresses.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('campaign_sender_address', item)
  })
}

module.exports = campaign_sender_addresses

},{"./../services/model.js":411,"./campaign_sender_address.js":60,"lodash":429}],62:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function CampaignSenderDid (data) {
  _.extend(this, data || {})
}

CampaignSenderDid.relationship = [
  'data:campaign_sender_dids'
]

module.exports = CampaignSenderDid

},{"lodash":429}],63:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  campaign_sender_dids = {},
  CampaignSenderDid = require('./campaign_sender_did.js')

campaign_sender_dids.relationship = CampaignSenderDid.relationship

campaign_sender_dids.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('campaign_sender_did', item)
  })
}

module.exports = campaign_sender_dids

},{"./../services/model.js":411,"./campaign_sender_did.js":62,"lodash":429}],64:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function CampaignSenderType (data) {
  _.extend(this, data || {})
}

CampaignSenderType.relationship = [
  'data:campaign_sender_types'
]

module.exports = CampaignSenderType

},{"lodash":429}],65:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  campaign_sender_types = {},
  CampaignSenderType = require('./campaign_sender_type.js')

campaign_sender_types.relationship = CampaignSenderType.relationship

campaign_sender_types.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('campaign_sender_type', item)
  })
}

module.exports = campaign_sender_types

},{"./../services/model.js":411,"./campaign_sender_type.js":64,"lodash":429}],66:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  campaign_senders = {},
  CampaignSender = require('./campaign_sender.js')

campaign_senders.relationship = CampaignSender.relationship

campaign_senders.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('campaign_sender', item)
  })
}

module.exports = campaign_senders

},{"./../services/model.js":411,"./campaign_sender.js":59,"lodash":429}],67:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  campaigns = {},
  Campaign = require('./campaign.js')

campaigns.relationship = Campaign.relationship

campaigns.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('campaign', item)
  })
}

module.exports = campaigns

},{"./../services/model.js":411,"./campaign.js":54,"lodash":429}],68:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function CastingApp (data) {
  _.extend(this, data)
}

module.exports = CastingApp

},{"lodash":429}],69:[function(require,module,exports){
let _ = require('lodash'),
  casting_apps = {},
  CastingApp = require('./casting_app.js')

casting_apps.relationship = CastingApp.relationship

casting_apps.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('casting_app', item)
  })
}

module.exports = casting_apps

},{"./../services/model.js":411,"./casting_app.js":68,"lodash":429}],70:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function CastingCallLogs (data) {
  _.extend(this, data)
}

CastingCallLogs.relationship = [
  'data:castings_call_logs'
]
module.exports = CastingCallLogs

},{"lodash":429}],71:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  callLogs = {}

callLogs.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('castings_call_log', item)
  })
}

module.exports = callLogs

},{"./../services/model.js":411,"lodash":429}],72:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function CastingsEvil (data) {
  _.extend(this, data || {})
}

module.exports = CastingsEvil

},{"lodash":429}],73:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  castings_evils = {}

castings_evils.create = function(array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function(item) {
    return modelify('castings_evil', item)
  })
}

module.exports = castings_evils

},{"./../services/model.js":411,"lodash":429}],74:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function CdClaimSale (data) {
  _.extend(this, data || {})
}

CdClaimSale.relationship = [
  'data:cd_claim_sales'
]

module.exports = CdClaimSale

},{"lodash":429}],75:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  cd_claim_sales = {}

cd_claim_sales.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('cd_claim_sale', item)
  })
}

module.exports = cd_claim_sales

},{"./../services/model.js":411,"lodash":429}],76:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function CDLogs (data) {
  _.extend(this, data)
}

CDLogs.relationship = [
  'data:cd_logs'
]
module.exports = CDLogs

},{"lodash":429}],77:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  cdLogs = {}

cdLogs.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('cd_log', item)
  })
}

module.exports = cdLogs

},{"./../services/model.js":411,"lodash":429}],78:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function Subscription (data) {
  _.extend(this, data)
}

Subscription.relationship = [
  'data:cd_user_campaign_subscriptions'
]

module.exports = Subscription

},{"lodash":429}],79:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  subscriptions = {}

subscriptions.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('cd_user_campaign_subscription', item)
  })
}

module.exports = subscriptions

},{"./../services/model.js":411,"lodash":429}],80:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function Subscription (data) {
  _.extend(this, data)
}

Subscription.relationship = [
  'data:cd_user_subscriptions'
]
module.exports = Subscription

},{"lodash":429}],81:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  subscriptions = {}

subscriptions.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('cd_user_subscription', item)
  })
}

module.exports = subscriptions

},{"./../services/model.js":411,"lodash":429}],82:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function ColRecurring (data) {
  _.extend(this, data || {})
}

ColRecurring.relationship = [
  'data:col_recurrings'
]

module.exports = ColRecurring

},{"lodash":429}],83:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  col_recurrings = {}

col_recurrings.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('col_recurring', item)
  })
}

module.exports = col_recurrings

},{"./../services/model.js":411,"lodash":429}],84:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function Contest (data) {
  _.extend(this, data || {})
}

Contest.relationship = [
  'data:contests'
]

module.exports = Contest

},{"lodash":429}],85:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function ContestLink (data) {
  _.extend(this, data || {})
}

ContestLink.relationship = [
  'data:contest_links'
]

module.exports = ContestLink

},{"lodash":429}],86:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  contest_links = {},
  ContestLink = require('./contest_link.js')

contest_links.relationship = ContestLink.relationship

contest_links.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('contest_link', item)
  })
}

module.exports = contest_links

},{"./../services/model.js":411,"./contest_link.js":85,"lodash":429}],87:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function ContestMedia (data) {
  _.extend(this, data || {})
}

ContestMedia.relationship = [
  'data:contest_medias'
]

module.exports = ContestMedia

},{"lodash":429}],88:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  contest_medias = {},
  ContestMedia = require('./contest_media.js')

contest_medias.relationship = ContestMedia.relationship

contest_medias.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('contest_media', item)
  })
}

module.exports = contest_medias

},{"./../services/model.js":411,"./contest_media.js":87,"lodash":429}],89:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  contests = {},
  Contest = require('./contest.js')

contests.relationship = Contest.relationship

contests.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('contest', item)
  })
}

module.exports = contests

},{"./../services/model.js":411,"./contest.js":84,"lodash":429}],90:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function Conversation (data) {
  _.extend(this, data || {})
}

Conversation.prototype.from = function () {
  return _.first(_.where(this.users, { id: this.user_id }))
}

Conversation.prototype.to = function () {
  let user_id = this.user_id
  return _.first(_.filter(this.users, function (n) { return n.id != user_id }))
}

Conversation.prototype.getOtherUser = function () {
  if (this.owner) {
    let owner = this.owner
    return _.first(_.filter(this.users, function (n) { return n.id != owner.id }))
  }
}

Conversation.prototype.getUnreadCount = function () {
  if (this.messages) {
    return _.where(this.messages, { read: 0 }).length
  }
}

Conversation.relationship = [
  'user',
  'users',
  'messages',
  'schedule',
  'data:conversations'
]

module.exports = Conversation

},{"lodash":429}],91:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  conversations = {},
  Conversation = require('./conversation.js')

conversations.relationship = Conversation.relationship

conversations.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('conversation', item)
  })
}

module.exports = conversations

},{"./../services/model.js":411,"./conversation.js":90,"lodash":429}],92:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  data = {},
  Datum = require('./datum.js')

data.relationship = Datum.relationship

data.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('datum', item)
  })
}

module.exports = data

},{"./../services/model.js":411,"./datum.js":93,"lodash":429}],93:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function Datum (data) {
  _.extend(this, data || {})
}

Datum.relationship = [
  'data:data'
]

module.exports = Datum

},{"lodash":429}],94:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function DidLog (data) {
  _.extend(this, data)
}

module.exports = DidLog

},{"lodash":429}],95:[function(require,module,exports){
let _ = require('lodash'),
  DidLogs = {},
  DidLog = require('./did_log.js')

DidLogs.relationship = DidLog.relationship

DidLogs.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('did_log', item)
  })
}

module.exports = DidLogs

},{"./../services/model.js":411,"./did_log.js":94,"lodash":429}],96:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function EmailTemplate (data) {
  _.extend(this, data || {})
}

EmailTemplate.relationship = [
  'data:email_templates'
]

module.exports = EmailTemplate

},{"lodash":429}],97:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  email_templates = {}

email_templates.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('email_template', item)
  })
}

module.exports = email_templates

},{"./../services/model.js":411,"lodash":429}],98:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function ETLeads (data) {
  _.extend(this, data)
}

module.exports = ETLeads

},{"lodash":429}],99:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function EtOnline (data) {
  _.extend(this, data || {})
}

module.exports = EtOnline

},{"lodash":429}],100:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  et_onlines = {}

et_onlines.create = function (array) {
  let model = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return model('et_online', item)
  })
}

module.exports = et_onlines

},{"./../services/model.js":411,"lodash":429}],101:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  date = require('./../services/date.js')

function FavoriteTalent (data) {
  _.extend(this, data)
}

FavoriteTalent.relationship = [
  'user',
  'bam_talentci',
  'bam_talentrecurring',
  'bam_talenttracking',
  'bam_talentinfo1',
  'bam_talentinfo2',
  'bam_talentinfo3',
  'bam_talent_resume',
  'bam_talent_music',
  'bam_talent_dance',
  'bam_talent_general',
  'bam_talent_social:bam_talent_socials',
  // if using GET from api, result is in the data property, set model to array of bam_talentcis
  'data:favorite_talents'
]

module.exports = FavoriteTalent

},{"./../services/date.js":409,"lodash":429}],102:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  favoriteTalents = {},
  FavoriteTalent = require('./favorite_talent.js')

favoriteTalents.relationship = FavoriteTalent.relationship

favoriteTalents.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('favorite_talent', item)
  })
}

module.exports = favoriteTalents

},{"./../services/model.js":411,"./favorite_talent.js":101,"lodash":429}],103:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function FeaturedCasting (data) {
  _.extend(this, data || {})
}

FeaturedCasting.relationship = [
  'data:featured_castings'
]

module.exports = FeaturedCasting

},{"lodash":429}],104:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function FeaturedCastingAdmin (data) {
  _.extend(this, data || {})
}

FeaturedCastingAdmin.relationship = [
  'data:featured_casting_admins'
]

module.exports = FeaturedCastingAdmin

},{"lodash":429}],105:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  featured_casting_admins = {},
  FeaturedCastingAdmin = require('./featured_casting_admin.js')

featured_casting_admins.relationship = FeaturedCastingAdmin.relationship

featured_casting_admins.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('featured_casting', item)
  })
}

module.exports = featured_casting_admins

},{"./../services/model.js":411,"./featured_casting_admin.js":104,"lodash":429}],106:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  featured_castings = {},
  FeaturedCasting = require('./featured_casting.js')

featured_castings.relationship = FeaturedCasting.relationship

featured_castings.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('featured_casting', item)
  })
}

module.exports = featured_castings

},{"./../services/model.js":411,"./featured_casting.js":103,"lodash":429}],107:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function Feedback (data) {
  _.extend(this, data || {})
}

Feedback.relationship = [
  'data:feedbacks'
]

module.exports = Feedback

},{"lodash":429}],108:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  feedbacks = {}

feedbacks.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('feedback', item)
  })
}

module.exports = feedbacks

},{"./../services/model.js":411,"lodash":429}],109:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function FutureRecurring (data) {
  _.extend(this, data || {})
}

FutureRecurring.relationship = [
  'data:future_recurrings'
]

module.exports = FutureRecurring

},{"lodash":429}],110:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  future_recurrings = {}

future_recurrings.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('future_recurring', item)
  })
}

module.exports = future_recurrings

},{"./../services/model.js":411,"lodash":429}],111:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function InboundDid (data) {
  _.extend(this, data || {})
}

module.exports = InboundDid

},{"lodash":429}],112:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  InboundDids = {},
  InboundDid = require('./inbound_did.js')

InboundDids.relationship = InboundDid.relationship

InboundDids.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('inbound_did', item)
  })
}

module.exports = InboundDids

},{"./../services/model.js":411,"./inbound_did.js":111,"lodash":429}],113:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function JobOrder (data) {
  _.extend(this, data)
}

module.exports = JobOrder

//

},{"lodash":429}],114:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function KnowledgeBase (data) {
  _.extend(this, data)
}

module.exports = KnowledgeBase

},{"lodash":429}],115:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function LeadAssignment (data) {
  _.extend(this, data || {})
}

LeadAssignment.relationship = [
  'data:lead_assignments'
]

module.exports = LeadAssignment

},{"lodash":429}],116:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  lead_assignments = {}

lead_assignments.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('lead_assignment', item)
  })
}

module.exports = lead_assignments

},{"./../services/model.js":411,"lodash":429}],117:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function LegacyPackages (data) {
  _.extend(this, data || {})
}

LegacyPackages.relationship = [
  'data:legacy_packages'
]

module.exports = LegacyPackages

},{"lodash":429}],118:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  legacy_packagess = {}

legacy_packagess.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('legacy_package', item)
  })
}

module.exports = legacy_packagess

},{"./../services/model.js":411,"lodash":429}],119:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function LinkCampaign (data) {
  _.extend(this, data || {})
}

LinkCampaign.relationship = [
  'data:link_campaigns'
]

module.exports = LinkCampaign

},{"lodash":429}],120:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  link_campaigns = {}

link_campaigns.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('link_campaign', item)
  })
}

module.exports = link_campaigns

},{"./../services/model.js":411,"lodash":429}],121:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function LiveagentContact (data) {
  _.extend(this, data || {})
}

module.exports = LiveagentContact

},{"lodash":429}],122:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  liveagent_contacts = {}

liveagent_contacts.create = function (array) {
  let model = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return model('liveagent_contact', item)
  })
}

module.exports = liveagent_contacts

},{"./../services/model.js":411,"lodash":429}],123:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function LiveagnetSyncToLiveagent (data) {
  _.extend(this, data || {})
}

module.exports = LiveagnetSyncToLiveagent

},{"lodash":429}],124:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  liveagent_sync_to_liveagents = {}

liveagent_sync_to_liveagents.create = function (array) {
  let model = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return model('liveagent_sync_to_liveagent', item)
  })
}

module.exports = liveagent_sync_to_liveagents

},{"./../services/model.js":411,"lodash":429}],125:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function LiveagentTicket (data) {
  _.extend(this, data || {})
}

module.exports = LiveagentTicket

},{"lodash":429}],126:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  liveagent_tickets = {}

liveagent_tickets.create = function (array) {
  let model = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return model('liveagent_ticket', item)
  })
}

module.exports = liveagent_tickets

},{"./../services/model.js":411,"lodash":429}],127:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function Location (data) {
  _.extend(this, data)
}

Location.relationship = [
  'data:locations'
]

module.exports = Location

},{"lodash":429}],128:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  locations = {}

locations.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('location', item)
  })
}

module.exports = locations

},{"./../services/model.js":411,"lodash":429}],129:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function Market (data) {
  _.extend(this, data)
}

module.exports = Market

},{"lodash":429}],130:[function(require,module,exports){
let _ = require('lodash'),
  markets = {},
  Market = require('./market.js')

markets.relationship = Market.relationship

markets.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('market', item)
  })
}

module.exports = markets

},{"./../services/model.js":411,"./market.js":129,"lodash":429}],131:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function Media (data) {
  _.extend(this, data)
}

module.exports = Media

},{"lodash":429}],132:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  medias = {},
  Media = require('./media.js')

medias.relationship = Media.relationship

medias.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('media', item)
  })
}

module.exports = medias

},{"./../services/model.js":411,"./media.js":131,"lodash":429}],133:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function Message (data) {
  _.extend(this, data)
}

Message.prototype.from = function () {
  return _.first(_.where(this.users, { id: this.user_id }))
}

Message.prototype.to = function () {
  let user_id = this.user_id
  return _.first(_.filter(this.users, function (n) { return n.id != user_id }))
}

Message.prototype.getOtherUser = function () {
  if (this.owner) {
    let owner = this.owner
    return _.first(_.filter(this.users, function (n) { return n.id != owner.id }))
  }
}

Message.relationship = [
  'user',
  'users',
  'data:messages'
]

module.exports = Message

},{"lodash":429}],134:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function MessageTemplate (data) {
  _.extend(this, data || {})
}

MessageTemplate.relationship = [
  'data:message_templates'
]

module.exports = MessageTemplate

},{"lodash":429}],135:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  message_template_categories = {}

message_template_categories.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('message_template_category', item)
  })
}

module.exports = message_template_categories

},{"./../services/model.js":411,"lodash":429}],136:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function MessageTemplateCategory (data) {
  _.extend(this, data || {})
}

MessageTemplateCategory.relationship = [
  'data:message_template_categories'
]

module.exports = MessageTemplateCategory

},{"lodash":429}],137:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  message_templates = {}

message_templates.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('message_template', item)
  })
}

module.exports = message_templates

},{"./../services/model.js":411,"lodash":429}],138:[function(require,module,exports){
let _ = require('lodash'),
  messages = {},
  Message = require('./message.js')

messages.relationship = Message.relationship

messages.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('message', item)
  })
}

module.exports = messages

},{"./../services/model.js":411,"./message.js":133,"lodash":429}],139:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function Payments (data) {
  _.extend(this, data || {})
}

Payments.relationship = [
  'data:payments'
]

module.exports = Payments

},{"lodash":429}],140:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  payments = {},
  Payments = require('./payment.js')

payments.relationship = Payments.relationship

payments.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('payment', item)
  })
}

module.exports = payments

},{"./../services/model.js":411,"./payment.js":139,"lodash":429}],141:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function PosterStat (data) {
  _.extend(this, data)
}

module.exports = PosterStat

},{"lodash":429}],142:[function(require,module,exports){
let _ = require('lodash'),
  poster_stats = {},
  PosterStat = require('./poster_stat.js')

poster_stats.relationship = PosterStat.relationship

poster_stats.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('poster_stat', item)
  })
}

module.exports = poster_stats

},{"./../services/model.js":411,"./poster_stat.js":141,"lodash":429}],143:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  date = require('./../services/date.js')

function Project (data) {
  _.extend(this, data)
}

Project.prototype.convertAsapToFullDate = function () {
  return date.formatYMD(parseInt(this.asap))
}

Project.prototype.convertAudToFullDate = function () {
  return date.formatYMD(parseInt(this.aud_timestamp))
}

Project.prototype.convertSubToFullDate = function () {
  return date.formatYMD(parseInt(this.sub_timestamp))
}

Project.prototype.convertShootToFullDate = function () {
  return date.formatYMD(parseInt(this.shoot_timestamp))
}

module.exports = Project

},{"./../services/date.js":409,"lodash":429}],144:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function ProjectApp (data) {
  _.extend(this, data)
}

ProjectApp.relationship = [
  'data:project_apps'
]
module.exports = ProjectApp

},{"lodash":429}],145:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  project_apps = {}

project_apps.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('project_app', item)
  })
}

module.exports = project_apps

},{"./../services/model.js":411,"lodash":429}],146:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function ProjectStat (data) {
  _.extend(this, data || {})
}

module.exports = ProjectStat

},{"lodash":429}],147:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  project_stats = {}

project_stats.create = function (array) {
  let model = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return model('project_stat', item)
  })
}

module.exports = project_stats

},{"./../services/model.js":411,"lodash":429}],148:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  projects = {},
  Project = require('./project.js')

projects.relationship = Project.relationship

projects.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('project', item)
  })
}

module.exports = projects

},{"./../services/model.js":411,"./project.js":143,"lodash":429}],149:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function Promocode (data) {
  _.extend(this, data || {})
}

Promocode.relationship = [
  'data:promocodes'
]

module.exports = Promocode

},{"lodash":429}],150:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  promocodes = {}

promocodes.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('promocode', item)
  })
}

module.exports = promocodes

},{"./../services/model.js":411,"lodash":429}],151:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function QaAnswer (data) {
  _.extend(this, data || {})
}

QaAnswer.relationship = [
  'data:qa_answers'
]

module.exports = QaAnswer

},{"lodash":429}],152:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  qa_answers = {}

qa_answers.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('qa_answer', item)
  })
}

module.exports = qa_answers

},{"./../services/model.js":411,"lodash":429}],153:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function QaChoice (data) {
  _.extend(this, data || {})
}

QaChoice.relationship = [
  'data:qa_choices'
]

module.exports = QaChoice

},{"lodash":429}],154:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  qa_choices = {}

qa_choices.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('qa_choice', item)
  })
}

module.exports = qa_choices

},{"./../services/model.js":411,"lodash":429}],155:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function QaQuestion (data) {
  _.extend(this, data || {})
}

QaQuestion.relationship = [
  'data:qa_questions'
]

module.exports = QaQuestion

},{"lodash":429}],156:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  qa_questions = {}

qa_questions.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('qa_question', item)
  })
}

module.exports = qa_questions

},{"./../services/model.js":411,"lodash":429}],157:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function QaSection (data) {
  _.extend(this, data || {})
}

QaSection.relationship = [
  'data:qa_sections'
]

module.exports = QaSection

},{"lodash":429}],158:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  qa_sections = {}

qa_sections.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('qa_section', item)
  })
}

module.exports = qa_sections

},{"./../services/model.js":411,"lodash":429}],159:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function Quickpost (data) {
  _.extend(this, data || {})
}

Quickpost.relationship = [
  'data:quickposts'
]

module.exports = Quickpost

},{"lodash":429}],160:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  quickposts = {}

quickposts.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('quickpost', item)
  })
}

module.exports = quickposts

},{"./../services/model.js":411,"lodash":429}],161:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function RecordingLogs (data) {
  _.extend(this, data || {})
}

RecordingLogs.relationship = [
  'data:recording_logs'
]

module.exports = RecordingLogs

},{"lodash":429}],162:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  recording_logs = {}

recording_logs.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('recording_log', item)
  })
}

module.exports = recording_logs

},{"./../services/model.js":411,"lodash":429}],163:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function Reminder (data) {
  _.extend(this, data || {})
}

Reminder.relationship = [
  'data:reminders'
]

module.exports = Reminder

},{"lodash":429}],164:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  reminders = {}

reminders.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('reminder', item)
  })
}

module.exports = reminders

},{"./../services/model.js":411,"lodash":429}],165:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function ReportAbuse (data) {
  _.extend(this, data)
}

module.exports = ReportAbuse

},{"lodash":429}],166:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function ReportAbuseReason (data) {
  _.extend(this, data)
}

module.exports = ReportAbuseReason

},{"lodash":429}],167:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  models = {}

models.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('report_abuse_reason', item)
  })
}

module.exports = models

},{"./../services/model.js":411,"lodash":429}],168:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  models = {}

models.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('report_abuse', item)
  })
}

module.exports = models

},{"./../services/model.js":411,"lodash":429}],169:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function Sales (data) {
  _.extend(this, data || {})
}

Sales.prototype.commaSeparateNumber = function (val) {
  if (val) {
    while (/(\d+)(\d{3})/.test(val.toString())) {
      val = val.toString().replace(/(\d+)(\d{3})/, '$1' + ',' + '$2')
    }
    return val
  } else {
    return ''
  }
}

Sales.prototype.currencyWithDecimal = function (val) {
  if (val) {
    return parseFloat(val).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  } else {
    return ''
  }
}

Sales.prototype.formatToYMDT = function (timestamp, canceled) {
  let date = new Date(timestamp * 1000)

  let month = date.getUTCMonth()
  let day = date.getUTCDate()
  let year = date.getUTCFullYear()

  year = year.toString().substr(2, 2)

  month = month + 1
  month = month + ''

  if (month.length == 1) {
    month = '0' + month
  }

  day = day + ''

  if (day.length == 1) {
    day = '0' + day
  }

  let formattedDate = month + '/' + day + '/' + year

  let hours = date.getHours()
  hours = hours + 8
  let minutes = date.getMinutes()
  let seconds = date.getSeconds()

  // let ampm = hours >= 12 ? 'pm' : 'am'

  hours = hours % 12
  hours = hours || 12
  minutes = minutes < 10 ? '0' + minutes : minutes
  seconds = seconds < 10 ? '0' + seconds : seconds

  let formattedTime = hours + ':' + minutes + ':' + seconds
  let formatFull = formattedDate + ' ' + formattedTime

  // if canceled date, return just date with no time
  if (canceled) {
    formatFull = formattedDate
  }

  return formatFull
}

Sales.relationship = [
  'data:sales'
]

module.exports = Sales

},{"lodash":429}],170:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function SaleSourcesTls (data) {
  _.extend(this, data || {})
}

SaleSourcesTls.relationship = [
  'data:sale_sources_tlss'
]

module.exports = SaleSourcesTls

},{"lodash":429}],171:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  sale_sources_tlss = {}

sale_sources_tlss.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('sale_sources_tls', item)
  })
}

module.exports = sale_sources_tlss

},{"./../services/model.js":411,"lodash":429}],172:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  sales = {},
  Sales = require('./sale.js')

sales.relationship = Sales.relationship

sales.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('sale', item)
  })
}

module.exports = sales

},{"./../services/model.js":411,"./sale.js":169,"lodash":429}],173:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function SalesSource (data) {
  _.extend(this, data || {})
}

SalesSource.relationship = [
  'data:sales_sources'
]

module.exports = SalesSource

},{"lodash":429}],174:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  sales_sources = {}

sales_sources.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('sales_source', item)
  })
}

module.exports = sales_sources

},{"./../services/model.js":411,"lodash":429}],175:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  date = require('../services/date.js')

function Schedule (data) {
  _.extend(this, data)
}

Schedule.prototype.convertToFullDate = function (timestamp) {
  return date.formatYMD(parseInt(timestamp))
}

Schedule.prototype.getTalent = function () {
  return this.invitee && parseInt(this.invitee.bam_talentnum) ? this.invitee : this.inviter
}

Schedule.relationship = [
  'invitee:user',
  'inviter:user',
  'bam_role',
  'schedule_notes',
  'conversation',
  'data:schedules'
]

module.exports = Schedule

},{"../services/date.js":409,"lodash":429}],176:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  date = require('../services/date.js')

function ScheduleImport (data) {
  _.extend(this, data)
}

module.exports = ScheduleImport

},{"../services/date.js":409,"lodash":429}],177:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function ScheduleNote (data) {
  _.extend(this, data)
}

ScheduleNote.relationship = [
  'user',
  'data:schedule_notes'
]

module.exports = ScheduleNote

},{"lodash":429}],178:[function(require,module,exports){
let _ = require('lodash'),
  schedule_notes = {},
  ScheduleNote = require('./schedule_note.js')

schedule_notes.relationship = ScheduleNote.relationship

schedule_notes.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('schedule_note', item)
  })
}

module.exports = schedule_notes

},{"./../services/model.js":411,"./schedule_note.js":177,"lodash":429}],179:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  schedules = {},
  Schedule = require('./schedule.js')

schedules.relationship = Schedule.relationship

schedules.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('schedule', item)
  })
}

module.exports = schedules

},{"./../services/model.js":411,"./schedule.js":175,"lodash":429}],180:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  talent = require('./../services/talent.js'),
  date = require('./../services/date.js')

function Talent (data) {
  _.extend(this, data || {})
}

Talent.prototype.getXOrigin = function () {
  if (this.x_origin == 8) {
    return 'auditions.com'
  }
  if (this.x_origin == 7) {
    return 'cebumodeling.com'
  }
  if (this.x_origin == 9) {
    return 'talent.ph'
  }
  if (this.x_origin == 0 || this.x_origin == 1 || this.x_origin == 2 || this.x_origin == 3 || this.x_origin == 4 || this.x_origin == 5 || this.x_origin == 6) {
    return 'exploretalent.com'
  }
}

Talent.prototype.getFullName = function () {
  return talent.getFullName(this.fname, this.lname)
}

Talent.prototype.getAge = function () {
  return date.calculateAge(this.dobyyyy, this.dobmm, this.dobdd)
}

Talent.prototype.getPrimaryPhoto = function () {
  let media_path =
    _.first(
      _.pluck(
        _.uniq(([]).concat(
          _.where(this.bam_talent_media2, { type: 2 }),
          _.where(this.bam_talent_media2, { type: '2' })
        )),
        'bam_media_path_full'
      )
    )

  let gender = this.bam_talentinfo1 ? this.bam_talentinfo1.sex : 'Male'

  if (media_path) {
    return 'https://talentmedia.blob.core.windows.net/etdownload/' + media_path
  } else {
    if (gender == 'Male') {
      let imgsrc = $('.profile-pic-primary').attr('src')
      if (imgsrc == '/images/filler.jpg') {
        $('a.fancybox').addClass('show-upload-primary-photo-btn')
        $('a.fancybox').removeClass('fancybox')
      }
      return '/images/filler.jpg'
    } else {
      let imgsrc = $('.profile-pic-primary').attr('src')
      if (imgsrc == '/images/filler_women.jpg') {
        $('a.fancybox').addClass('show-upload-primary-photo-btn')
        $('a.fancybox').removeClass('fancybox')
      }
      return '/images/filler_women.jpg'
    }
  }
}

Talent.prototype.getLocation = function () {
  if (this.city1) {
    return this.city1
  } else if (this.city && this.state && this.state.length > 2) {
    return this.city + ', ' + this.state
  } else if (this.state && this.state.length > 2) {
    return this.city
  } else {
    return 'Not Set'
  }
}

Talent.prototype.getHeight = function () {
  let feet = Math.floor(this.heightinches / 12)
  let inches = this.heightinches % 12
  return feet + "'" + inches + '"'
}

Talent.prototype.getState = function () {
  let states = {
    'AL': 'Alabama',
    'AK': 'Alaska',
    'AZ': 'Arizona',
    'AR': 'Arkansas',
    'CA': 'California',
    'CO': 'Colorado',
    'CT': 'Connecticut',
    'DE': 'Delaware',
    'FL': 'Florida',
    'GA': 'Georgia',
    'HI': 'Hawaii',
    'ID': 'Idaho',
    'IL': 'Illinois',
    'IN': 'Indiana',
    'IA': 'Iowa',
    'KS': 'Kansas',
    'KY': 'Kentucky',
    'LA': 'Louisiana',
    'ME': 'Maine',
    'MD': 'Maryland',
    'MA': 'Massachusetts',
    'MI': 'Michigan',
    'MN': 'Minnesota',
    'MS': 'Mississippi',
    'MO': 'Missouri',
    'MT': 'Montana',
    'NE': 'Nebraska',
    'NV': 'Nevada',
    'NH': 'New Hampshire',
    'NJ': 'New Jersey',
    'NM': 'New Mexico',
    'NY': 'New York',
    'NC': 'North Carolina',
    'ND': 'North Dakota',
    'OH': 'Ohio',
    'OK': 'Oklahoma',
    'OR': 'Oregon',
    'PA': 'Pennsylvania',
    'RI': 'Rhode Island',
    'SC': 'South Carolina',
    'SD': 'South Dakota',
    'TN': 'Tennessee',
    'TX': 'Texas',
    'UT': 'Utah',
    'VT': 'Vermont',
    'VA': 'Virginia',
    'WA': 'Washington',
    'WV': 'West Virginia',
    'WI': 'Wisconsin',
    'WY': 'Wyoming'
  }

  return states[this.state]
}

Talent.relationship = [
  'bam_talentci',
  'bam_talent_media2',
  'bam_talent_music',
  'bam_talent_dance',
  'data:search_talents'
]

module.exports = Talent

},{"./../services/date.js":409,"./../services/talent.js":418,"lodash":429}],181:[function(require,module,exports){
let _ = require('lodash'),
  talents = {}

talents.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('search_talent', item)
  })
}

module.exports = talents

},{"./../services/model.js":411,"lodash":429}],182:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function SenderOption (data) {
  _.extend(this, data || {})
}

SenderOption.relationship = [
  'data:sender_options'
]

module.exports = SenderOption

},{"lodash":429}],183:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  sender_options = {}

sender_options.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('sender_option', item)
  })
}

module.exports = sender_options

},{"./../services/model.js":411,"lodash":429}],184:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  date = require('./../services/date.js')

function SmsMessage (data) {
  _.extend(this, data || {})
}

SmsMessage.prototype.getDateTime = function () {
  return date.formatDateTime(parseInt(this.timestamp))
}

SmsMessage.relationship = [
  'bam_talentci',
  'bam_user',
  'data:sms_messages'
]

module.exports = SmsMessage

},{"./../services/date.js":409,"lodash":429}],185:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  sms_messages = {}

sms_messages.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('sms_message', item)
  })
}

module.exports = sms_messages

},{"./../services/model.js":411,"lodash":429}],186:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function SmsStat (data) {
  _.extend(this, data || {})
}

module.exports = SmsStat

},{"lodash":429}],187:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  sms_stats = {}

sms_stats.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('sms_stat', item)
  })
}

module.exports = sms_stats

},{"./../services/model.js":411,"lodash":429}],188:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  date = require('./../services/date.js')

function SmsThread (data) {
  _.extend(this, data || {})
}

SmsThread.relationship = [
  'data:sms_threads'
]

module.exports = SmsThread

},{"./../services/date.js":409,"lodash":429}],189:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  sms_threads = {}

sms_threads.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('sms_thread', item)
  })
}

module.exports = sms_threads

},{"./../services/model.js":411,"lodash":429}],190:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function SoundBoard (data) {
  _.extend(this, data)
}

module.exports = SoundBoard

},{"lodash":429}],191:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function StaffNote (data) {
  _.extend(this, data)
}

module.exports = StaffNote

},{"lodash":429}],192:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function StarTalent (data) {
  _.extend(this, data || {})
}

StarTalent.relationship = [
  'data:star_talents'
]

module.exports = StarTalent

},{"lodash":429}],193:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  star_talents = {},
  StarTalent = require('./star_talent.js')

star_talents.relationship = StarTalent.relationship

star_talents.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('star_talent', item)
  })
}

module.exports = star_talents

},{"./../services/model.js":411,"./star_talent.js":192,"lodash":429}],194:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function Tags (data) {
  _.extend(this, data)
}

module.exports = Tags

},{"lodash":429}],195:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function TagTypes (data) {
  _.extend(this, data)
}

module.exports = TagTypes

},{"lodash":429}],196:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  tag_types = {}

tag_types.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('tag_type', item)
  })
}

module.exports = tag_types

},{"./../services/model.js":411,"lodash":429}],197:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  tags = {}

tags.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('tag', item)
  })
}

module.exports = tags

},{"./../services/model.js":411,"lodash":429}],198:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function TalentAutosubs (data) {
  _.extend(this, data || {})
}

module.exports = TalentAutosubs

},{"lodash":429}],199:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function TalentGeneral (data) {
  _.extend(this, data || {})
}

TalentGeneral.relationship = [
  'data:talent_generals'
]

module.exports = TalentGeneral

},{"lodash":429}],200:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  talent_generals = {}

talent_generals.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('talent_general', item)
  })
}

module.exports = talent_generals

},{"./../services/model.js":411,"lodash":429}],201:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function TalentPaymentOptions (data) {
  _.extend(this, data || {})
}

TalentPaymentOptions.relationship = [
  'data:talent_payment_options'
]

module.exports = TalentPaymentOptions

},{"lodash":429}],202:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  talent_payment_optionss = {}

talent_payment_optionss.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('talent_payment_option', item)
  })
}

module.exports = talent_payment_optionss

},{"./../services/model.js":411,"lodash":429}],203:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function TalentSales (data) {
  _.extend(this, data || {})
}

TalentSales.relationship = [
  'data:talent_sales'
]

module.exports = TalentSales

},{"lodash":429}],204:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  talent_saless = {}

talent_saless.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('talent_sale', item)
  })
}

module.exports = talent_saless

},{"./../services/model.js":411,"lodash":429}],205:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function TalentSong (data) {
  _.extend(this, data || {})
}

TalentSong.relationship = [
  'data:talent_songs'
]

module.exports = TalentSong

},{"lodash":429}],206:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  talent_songs = {},
  TalentSong = require('./talent_song.js')

talent_songs.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('talent_song', item)
  })
}

module.exports = talent_songs

},{"./../services/model.js":411,"./talent_song.js":205,"lodash":429}],207:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function TalentVideo (data) {
  _.extend(this, data || {})
}

TalentVideo.relationship = [
  'data:talent_videos'
]

module.exports = TalentVideo

},{"lodash":429}],208:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  talent_videos = {},
  TalentVideo = require('./talent_video.js')

talent_videos.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('talent_video', item)
  })
}

module.exports = talent_videos

},{"./../services/model.js":411,"./talent_video.js":207,"lodash":429}],209:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function TalentOrder (data) {
  _.extend(this, data || {})
}

TalentOrder.relationship = [
  'data:talentorders'
]

module.exports = TalentOrder

},{"lodash":429}],210:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  talentorders = {},
  TalentOrder = require('./talentorder.js')

talentorders.relationship = TalentOrder.relationship

talentorders.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('talentorder', item)
  })
}

module.exports = talentorders

},{"./../services/model.js":411,"./talentorder.js":209,"lodash":429}],211:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function Talentordertracking (data) {
  _.extend(this, data || {})
}

Talentordertracking.relationship = [
  'data:talentordertrackings'
]

module.exports = Talentordertracking

},{"lodash":429}],212:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  talentordertrackings = {}

talentordertrackings.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('talentordertracking', item)
  })
}

module.exports = talentordertrackings

},{"./../services/model.js":411,"lodash":429}],213:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function Talentrecurring (data) {
  _.extend(this, data || {})
}

Talentrecurring.relationship = [
  'data:talentrecurrings'
]

module.exports = Talentrecurring

},{"lodash":429}],214:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  talentrecurrings = {}

talentrecurrings.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('talentrecurring', item)
  })
}

module.exports = talentrecurrings

},{"./../services/model.js":411,"lodash":429}],215:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function Team (data) {
  _.extend(this, data || {})
}

module.exports = Team

},{"lodash":429}],216:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  Teams = {},
  Team = require('./team.js')

Teams.relationship = Team.relationship

Teams.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('team', item)
  })
}

module.exports = Teams

},{"./../services/model.js":411,"./team.js":215,"lodash":429}],217:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function TransactionsStore (data) {
  _.extend(this, data || {})
}

TransactionsStore.relationship = [
  'data:transactions_stores'
]

module.exports = TransactionsStore

},{"lodash":429}],218:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  transactions_stores = {}

transactions_stores.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('transactions_store', item)
  })
}

module.exports = transactions_stores

},{"./../services/model.js":411,"lodash":429}],219:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function Banners (data) {
  _.extend(this, data || {})
}

module.exports = Banners

},{"lodash":429}],220:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function TrmCallLog (data) {
  _.extend(this, data || {})
}

TrmCallLog.prototype.formatToDateTime = function (timestamp) {
  let date = new Date(timestamp * 1000)

  let month = date.getMonth()
  let day = date.getDate()
  let year = date.getFullYear()

  year = year.toString().substr(2, 2)

  month = month + 1
  month = month + ''

  if (month.length == 1) {
    month = '0' + month
  }

  day = day + ''

  if (day.length == 1) {
    day = '0' + day
  }

  let formattedDate = month + '-' + day + '-' + year

  let hours = date.getHours()
  let minutes = date.getMinutes()

  let ampm = hours >= 12 ? 'pm' : 'am'

  hours = hours % 12
  hours = hours || 12
  minutes = minutes < 10 ? '0' + minutes : minutes

  let formattedTime = hours + ':' + minutes + ' ' + ampm

  let formatFull = formattedDate + ' ' + formattedTime

  return formatFull
}

TrmCallLog.relationship = [
  'data:trm_call_logs'
]

module.exports = TrmCallLog

},{"lodash":429}],221:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  trm_call_logs = {},
  TrmCallLog = require('./trm_call_log.js')

trm_call_logs.relationship = TrmCallLog.relationship

trm_call_logs.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('trm_call_log', item)
  })
}

module.exports = trm_call_logs

},{"./../services/model.js":411,"./trm_call_log.js":220,"lodash":429}],222:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  trm_categories = {},
  TrmCategory = require('./trm_category.js')

trm_categories.relationship = TrmCategory.relationship

trm_categories.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('trm_category', item)
  })
}

module.exports = trm_categories

},{"./../services/model.js":411,"./trm_category.js":223,"lodash":429}],223:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function TrmCategory (data) {
  _.extend(this, data || {})
}

TrmCategory.relationship = [
  'data:trm_categories'
]

module.exports = TrmCategory

},{"lodash":429}],224:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function TrmFeedback (data) {
  _.extend(this, data || {})
}

TrmFeedback.relationship = [
  'data:trm_feedbacks'
]

module.exports = TrmFeedback

},{"lodash":429}],225:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  trm_feedbacks = {}

trm_feedbacks.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('trm_feedback', item)
  })
}

module.exports = trm_feedbacks

},{"./../services/model.js":411,"lodash":429}],226:[function(require,module,exports){

'use strict'

let _ = require('lodash')

function Locations (data) {
  _.extend(this, data || {})
}

module.exports = Locations

},{"lodash":429}],227:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function TrmScript (data) {
  _.extend(this, data || {})
}

TrmScript.relationship = [
  'data:trm_scripts'
]

module.exports = TrmScript

},{"lodash":429}],228:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  trm_script_categories = {},
  TrmScriptCategory = require('./trm_script_category.js')

trm_script_categories.relationship = TrmScriptCategory.relationship

trm_script_categories.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('trm_script_category', item)
  })
}

module.exports = trm_script_categories

},{"./../services/model.js":411,"./trm_script_category.js":229,"lodash":429}],229:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function TrmScriptCategory (data) {
  _.extend(this, data || {})
}

TrmScriptCategory.relationship = [
  'data:trm_script_categories'
]

module.exports = TrmScriptCategory

},{"lodash":429}],230:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  trm_scripts = {},
  TrmScript = require('./trm_script.js')

trm_scripts.relationship = TrmScript.relationship

trm_scripts.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('trm_script', item)
  })
}

module.exports = trm_scripts

},{"./../services/model.js":411,"./trm_script.js":227,"lodash":429}],231:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function TrmUser (data) {
  _.extend(this, data)
}

module.exports = TrmUser

},{"lodash":429}],232:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function TrmUserEmail (data) {
  _.extend(this, data)
}

TrmUserEmail.relationship = [
  'data:trm_user_emails'
]
module.exports = TrmUserEmail

},{"lodash":429}],233:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  trm_user_emails = {}

trm_user_emails.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('trm_user_email', item)
  })
}

module.exports = trm_user_emails

},{"./../services/model.js":411,"lodash":429}],234:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function TrmUserOption (data) {
  _.extend(this, data)
}

module.exports = TrmUserOption

},{"lodash":429}],235:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function Trollbox (data) {
  _.extend(this, data || {})
}

module.exports = Trollbox

},{"lodash":429}],236:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  trollboxes = {}

trollboxes.create = function (array) {
  let model = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return model('trollbox', item)
  })
}

module.exports = trollboxes

},{"./../services/model.js":411,"lodash":429}],237:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function User (data) {
  _.extend(this, data)
}

User.prototype.getMediaByType = function (t) {
  return _.where(this.media, { media_type_id: t })
}

User.relationship = [
  'bam_talentci',
  'bam_cd_user',
  'bam_user',
  'schedules',
  'invitations:schedules',
  'media:medias'
]

module.exports = User

},{"lodash":429}],238:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function UserApp (data) {
  _.extend(this, data)
}

UserApp.relationship = [
  'data:user_apps'
]
module.exports = UserApp

},{"lodash":429}],239:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  user_apps = {}

user_apps.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('user_app', item)
  })
}

module.exports = user_apps

},{"./../services/model.js":411,"lodash":429}],240:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function UserEmail (data) {
  _.extend(this, data)
}

UserEmail.relationship = [
  'data:user_emails'
]
module.exports = UserEmail

},{"lodash":429}],241:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  user_emails = {}

user_emails.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('user_email', item)
  })
}

module.exports = user_emails

},{"./../services/model.js":411,"lodash":429}],242:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function UserOption (data) {
  _.extend(this, data)
}

UserOption.relationship = [
  'data:user_options'
]
module.exports = UserOption

},{"lodash":429}],243:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  user_options = {}

user_options.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('user_option', item)
  })
}

module.exports = user_options

},{"./../services/model.js":411,"lodash":429}],244:[function(require,module,exports){
let _ = require('lodash'),
  users = {},
  User = require('./user.js')

users.relationship = User.relationship

users.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('user', item)
  })
}

module.exports = users

},{"./../services/model.js":411,"./user.js":237,"lodash":429}],245:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function VerifiedContact (data) {
  _.extend(this, data || {})
}

VerifiedContact.relationship = [
  'data:verified_contacts'
]

module.exports = VerifiedContact

},{"lodash":429}],246:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  verified_contacts = {}

verified_contacts.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('verified_contact', item)
  })
}

module.exports = verified_contacts

},{"./../services/model.js":411,"lodash":429}],247:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function Vicidial (data) {
  _.extend(this, data || {})
}

Vicidial.relationship = [
  'data:vicidials'
]

module.exports = Vicidial

},{"lodash":429}],248:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function VicidialAgentLogs (data) {
  _.extend(this, data || {})
}

VicidialAgentLogs.relationship = [
  'data:vicidial_agent_logs'
]

module.exports = VicidialAgentLogs

},{"lodash":429}],249:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  vicidial_agent_logss = {}

vicidial_agent_logss.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('vicidial_agent_log', item)
  })
}

module.exports = vicidial_agent_logss

},{"./../services/model.js":411,"lodash":429}],250:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function CloserLog (data) {
  _.extend(this, data || {})
}

CloserLog.relationship = [
  'data:vicidial_closer_logs'
]

module.exports = CloserLog

},{"lodash":429}],251:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  vicidial_closer_logs = {}

vicidial_closer_logs.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('vicidial_closer_log', item)
  })
}

module.exports = vicidial_closer_logs

},{"./../services/model.js":411,"lodash":429}],252:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function VicidialLiveAgents (data) {
  _.extend(this, data || {})
}

VicidialLiveAgents.relationship = [
  'data:vicidial_live_agents'
]

module.exports = VicidialLiveAgents

},{"lodash":429}],253:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  vicidial_live_agentss = {}

vicidial_live_agentss.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('vicidial_live_agent', item)
  })
}

module.exports = vicidial_live_agentss

},{"./../services/model.js":411,"lodash":429}],254:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function ViciLogs (data) {
  _.extend(this, data || {})
}

ViciLogs.relationship = [
  'data:vicidial_logs'
]

module.exports = ViciLogs

},{"lodash":429}],255:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  vicidial_logs = {}

vicidial_logs.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('vicidial_log', item)
  })
}

module.exports = vicidial_logs

},{"./../services/model.js":411,"lodash":429}],256:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function VicidialRecsReports (data) {
  _.extend(this, data || {})
}

module.exports = VicidialRecsReports

},{"lodash":429}],257:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function VicidialReports (data) {
  _.extend(this, data || {})
}

VicidialReports.relationship = [
  'data:vicidial_reports'
]

module.exports = VicidialReports

},{"lodash":429}],258:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  vicidial_reports = {}

vicidial_reports.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('vicidial_report', item)
  })
}

module.exports = vicidial_reports

},{"./../services/model.js":411,"lodash":429}],259:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function VicidialScoreCardReports (data) {
  _.extend(this, data || {})
}

VicidialScoreCardReports.relationship = [
  'data:vicidial_scorecard_reports'
]

module.exports = VicidialScoreCardReports

},{"lodash":429}],260:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  vicidial_scorecard_reports = {}

vicidial_scorecard_reports.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('vicidial_scorecard_report', item)
  })
}

module.exports = vicidial_scorecard_reports

},{"./../services/model.js":411,"lodash":429}],261:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function VicidialUsers (data) {
  _.extend(this, data || {})
}

VicidialUsers.relationship = [
  'data:vicidial_users'
]

module.exports = VicidialUsers

},{"lodash":429}],262:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  vicidial_userss = {}

vicidial_userss.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('vicidial_user', item)
  })
}

module.exports = vicidial_userss

},{"./../services/model.js":411,"lodash":429}],263:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  vicidials = {}

vicidials.create = function (array) {
  let modelify = require('./../services/model.js')

  return _.map(array || [], function (item) {
    return modelify('vicidial', item)
  })
}

module.exports = vicidials

},{"./../services/model.js":411,"lodash":429}],264:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/alerts/:alertId', {
  model: 'admin_alert'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],265:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + '/admin/reports/agent_leads/:id', {
  model: 'agent_lead'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],266:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + '/alerts/:alertId', {
  model: 'alert'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],267:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/apps/:appId', {
  model: 'app'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],268:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/app_xorigins/:appId', {
  model: 'app_xorigin'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],269:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/bad_accounts/:talentnum', {
  model: 'bad_account'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],270:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/banned_contacts/:bannedEmailId', {
  model: 'banned_email'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],271:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/call_backs/:callbackId', {
  model: 'callback'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],272:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/campaigns/:campaignId', {
  model: 'campaign'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],273:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/campaign_apps/:campaignAppId', {
  model: 'campaign_app'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],274:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/campaign_app_logs', {
  model: 'campaign_app_log'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],275:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/campaign_apps/:campaignAppId/queues/:type', {
  model: 'campaign_app_queue'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],276:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/campaign_senders/:senderId', {
  model: 'campaign_sender'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],277:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/campaign_sender_addresses/:id', {
  model: 'campaign_sender_address'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],278:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/campaign_sender_dids/:id', {
  model: 'campaign_sender_did'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],279:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/campaign_sender_types/:senderId', {
  model: 'campaign_sender_type'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],280:[function(require,module,exports){
'use strict'

module.exports = {
  NORMAL: 1, // normal campaigns
  CD_INVITE: 2, // cd invites
  TRM: 3, // triggered / transactional
  CAST_MATCH: 4, // cast match
  DYN: 5, // dynamic campaign
  VICI: 6   // Vicidial Rec
}

},{}],281:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/project_apps/:id', {
  model: 'casting_apps'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],282:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/casting_categories/:castingCategoryId', {
  model: 'bam_cast_cat'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],283:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/castings_call_logs/:castingId', {
  model: 'castings_call_log'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],284:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/castings_evils/:id', {
  model: 'castings_evil'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],285:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/cd_claim_sales/:ccsId', {
  model: 'cd_claim_sale'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],286:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/cd_logs/:cdLogId', {
  model: 'cd_log'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],287:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/cd_users/:cdUserId', {
  model: 'bam_cd_user'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],288:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/user_campaign_subscriptions/:id', {
  model: 'cd_user_campaign_subscription'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],289:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/cd_user_subscriptions/:subscriptionId', {
  model: 'cd_user_subscription'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],290:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/col_recurring/:colId', {
  model: 'col_recurring'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],291:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/et_contest/contest_links/:linkId', {
  model: 'contest_link'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],292:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/et_contest/contest_media/:mediaId', {
  model: 'contest_media'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],293:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/et_contest/contests/:contestId', {
  model: 'contest'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],294:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + '/conversations/:conversationId', {
  model: 'conversation'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],295:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + '/data/:type', {
  model: 'datum'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],296:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/vicidial/did_logs/:id', {
  model: 'did_logs'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],297:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/email_templates/:emailTemplateId', {
  model: 'email_template'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],298:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/et_leads/:leadId', {
  model: 'et_leads'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],299:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/et_online/:id', {
  model: 'et_online'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],300:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/favorite_projects/:projectId', {
  model: 'bam_favorite_castings'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],301:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/favorite_talents/:favoriteId', {
  model: 'favorite_talent'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],302:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + '/featured_castings/:castingId', {
  model: 'featured_casting'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],303:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/featured_castings/:castingId', {
  model: 'featured_casting'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],304:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + '/feedbacks/:feedbackId', {
  model: 'feedback'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],305:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/friends/:friendId', {
  model: 'bam_friend'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],306:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/future_recurring/:talentnum', {
  model: 'future_recurring'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],307:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/vicidial/inbound_dids/:id', {
  model: 'inbound_did'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],308:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

if (api.type == '/cd') { module.exports = new Resource(api.base + api.type + '/projects/:projectId/jobs/:jobId', { model: 'bam_role' }) } else { module.exports = new Resource(api.base + api.type + '/jobs/:jobId', { model: 'bam_role' }) }

},{"./../config/api.js":7,"./../services/resource.js":415}],309:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + '/cd/jobs/:jobId/matches')

},{"./../config/api.js":7,"./../services/resource.js":415}],310:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/job_orders/:jobId', {
  model: 'job_order'
})

/// /

},{"./../config/api.js":7,"./../services/resource.js":415}],311:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + '/cd/jobs/:jobId/schedules/:scheduleId')

},{"./../config/api.js":7,"./../services/resource.js":415}],312:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/trm_knowhows/:knowHowsId', {
  model: 'knowledge_base'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],313:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/lead_assignments/:leadAssignmentId', {
  model: 'lead_assignment'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],314:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/legacy_packages/:packageId', {
  model: 'legacy_package'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],315:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/link_campaigns/:id', {
  model: 'link_campaign'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],316:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/liveagent/contacts/:id', {
  model: 'liveagent_contact'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],317:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/liveagent/sync_to_liveagent/:talentnum', {
  model: 'liveagent_sync_to_liveagent'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],318:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/liveagent/tickets/:talentnum', {
  model: 'liveagent_ticket'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],319:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + '/locations/:locationId', {
  model: 'location'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],320:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + '/markets/:zip', {
  model: 'markets'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],321:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/media/:id', {
  model: 'media'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],322:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.baseV2 + api.type + '/pictures_for_approval', {
  model: 'campaign_app'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],323:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.baseV2 + api.type + '/pictures_for_approval/rate_pictures')


},{"./../config/api.js":7,"./../services/resource.js":415}],324:[function(require,module,exports){
'use strict'

let conversation = require('./conversation.js')

module.exports = conversation.child('/messages/:messageId')

},{"./conversation.js":294}],325:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/message_templates/:templateId', {
  model: 'message_template'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],326:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/message_template_categories/:categoryId', {
  model: 'message_template_category'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],327:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/oauth/access_token/:tokenId', {
  model: 'access_token'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],328:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/sale/:talentId', {
  model: 'payment'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],329:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/poster_stats/:id', {
  model: 'poster_stats'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],330:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/projects/:projectId', {
  model: 'bam_casting'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],331:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/project_apps/:id', {
  model: 'project_app'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],332:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/project_stats', {
  model: 'project_stat'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],333:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/promo_codes/:promoId', {
  model: 'promocode'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],334:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/qa_answers/:id', {
  model: 'qa_answer'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],335:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/qa_choices/:id', {
  model: 'qa_choice'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],336:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/qa_questions/:id', {
  model: 'qa_question'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],337:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/qa_sections/:id', {
  model: 'qa_section'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],338:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/lazy_projects/:quickpostId', {
  model: 'quickpost'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],339:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/asterisk/recording_logs/:uniqueid', {
  model: 'recording_log'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],340:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + '/reminders', {
  model: 'reminder'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],341:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/report_abuses/:id', {
  model: 'report_abuse'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],342:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/report_abuse_reasons/:id', {
  model: 'report_abuse_reason'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],343:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/sale_sources_tls/:id', {
  model: 'sale_sources_tls'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],344:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/reports/sales', {
  model: 'sale'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],345:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/sale_sources/:sourceId', {
  model: 'sales_source'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],346:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/schedules/:scheduleId', {
  model: 'schedule'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],347:[function(require,module,exports){
'use strict'

module.exports = {
  PENDING: 1,
  CALLBACK: 2,
  HIRED: 3
}

},{}],348:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/schedule_imports/:scheduleId', {
  model: 'schedule_import'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],349:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/schedules/:scheduleId/schedule_notes/:noteId', {
  model: 'schedule_note'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],350:[function(require,module,exports){
'use strict'

module.exports = {
  PENDING: 1,
  ACCEPTED: 2,
  DECLINED: 3,
  RESCHEDULED: 4
}

},{}],351:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + '/search/projects/:id', {
  model: 'bam_casting'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],352:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + '/search/talents', {
  model: 'search_talent'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],353:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/sender_options/:senderId', {
  model: 'sender_option'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],354:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/sms_messages/:smsId', {
  model: 'sms_message'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],355:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/sms_stats/:id', {
  model: 'sms_stat'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],356:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/sms_threads/:smsId', {
  model: 'sms_thread'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],357:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/sb_transfers/:sbId', {
  model: 'sound_board'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],358:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/staff_notes/:noteId', {
  model: 'staff_notes'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],359:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/star_talents/:id', {
  model: 'star_talent'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],360:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/tags/:id', {
  model: 'tag'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],361:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/tag_types/:id', {
  model: 'tag_type'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],362:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

let resource = new Resource(api.base + api.type + '/talentci/:talentId', {
  model: 'bam_talentci'
})

resource.search = function (data, options) {
  let deferred = $.Deferred()
  let talents, talentnums, users

  // search talent from search/talents
  self.core.resource.search_talent.get(data)
    .then(function (res) {
      // assign to a letiable
      talents = res

      // get all talentnums
      talentnums = _.map(talents.data, function (talent) {
        return talent.talentnum
      })

      // add 0 so we dont have an empty array
      talentnums.push(0)

      // get user and bam_talent_media2 objects using talentci resource
      data = {
        query: [
          [ 'whereIn', 'talentci.talentnum', talentnums ],
          [ 'with', 'bam_talent_media2' ],
          [ 'with', 'user' ]
        ]
      }

      return self.core.resource.talent.get(data)
    })
    .then(function (res) {
      // loop through talents and find talent_media2 object
      _.each(talents.data, function (talent) {
        // find talentci object
        let talentci = _.find(res.data, function (t) {
          return talent.talentnum == t.talentnum
        })

        // if we have talentci object, assign its talent_media2 and user object to the talent
        if (talentci) {
          talent.bam_talent_media2 = talentci.bam_talent_media2
          talent.user = talentci.user
        }
      })

      // get all user.id
      users = _.map(talents.data, function (talent) {
        if (talent.user) {
          return talent.user.id
        }
      })

      // add 0 so we dont have an empty array
      users.push(0)

      // get favorite talents
      data = {
        q: [
          [ 'whereIn', 'bam_talentnum', talentnums ]
        ]
      }

      return self.core.resource.favorite_talent.get(data)
    })
    .then(function (res) {
      // assign favorite talents to talent
      _.each(talents.data, function (talent) {
        // find favorite object and assign it
        talent.favorite = _.find(res.data, function (favorite) {
          return talent.talentnum == favorite.bam_talentnum
        })
      })

      // if bam_role_id is given, search if talent has schedule for it
      if (options && options.bam_role_id) {
        data = {
          q: [
            [ 'whereIn', 'invitee_id', users ],
            [ 'where', 'bam_role_id', '=', options.bam_role_id ],
            [ 'with', 'schedule_notes.user.bam_cd_user' ]
          ]
        }

        return self.core.resource.schedule.get(data)
      } else {
        return $.when({ data: [] })
      }
    })
    .then(function (res) {
      _.each(talents.data, function (talent) {
        talent.schedule = _.find(res.data, function (schedule) {
          return talent.user && talent.user.id == schedule.invitee_id
        })

        if (!talent.schedule) {
          talent.schedule = {
            schedule_notes: []
          }
        }
      })

      data = {
        query: [
          [ 'whereIn', 'talentnum', talentnums ],
          [ 'where', 'type', '=', '6' ]
        ]
      }

      return self.core.resource.talent_videos.get(data)
    })
    .then(function (res) {
      _.each(talents.data, function (talent) {
        let video = _.find(res.data, function (v) {
          return talent.talentnum == v.talentnum
        })

        if (video) {
          talent.video_id = video.video_id
        } else {
          talent.video_id = ''
        }
      })

      deferred.resolve(talents)
    })

  return deferred.promise()
}

module.exports = resource

},{"./../config/api.js":7,"./../services/resource.js":415}],363:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/talent_autosubs/:subId', {
  model: 'talent_autosub'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],364:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/talent_general/:talentGeneralId', {
  model: 'talent_general'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],365:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/talent_media2/:id', {
  model: 'bam_talent_media2'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],366:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/talent_payment_options/:optionId', {
  model: 'talent_payment_option'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],367:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/sales/:saleId', {
  model: 'talent_sale'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],368:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/talent_social/:talentSocialId', {
  model: 'bam_talent_social'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],369:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/songs/:songId', {
  model: 'talent_song'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],370:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/videos/:videoId', {
  model: 'talent_video'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],371:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/talentinfo1/:talentId', {
  model: 'bam_talentinfo1'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],372:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/talentinfo2/:talentId', {
  model: 'bam_talentinfo2'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],373:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/talentorders/:orderId', {
  model: 'talentorder'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],374:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/talentordertracking/:orderId', {
  model: 'talentordertracking'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],375:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/talentrecurring/:talentnum', {
  model: 'talentrecurring'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],376:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/talent_trackings/:trackingId', {
  model: 'bam_talenttracking'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],377:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/teams/:id', {
  model: 'team'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],378:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/transactions_stores/:trId', {
  model: 'transactions_store'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],379:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/banners/:bannerId', {
  model: 'trm_banner'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],380:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/talentci/:talentci/call_logs/:id', {
  model: 'trm_call_log'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],381:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/trm_categories/:categoryId', {
  model: 'trm_category'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],382:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/feedbacks/:feedbackId', {
  model: 'trm_feedback'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],383:[function(require,module,exports){

'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/locations/:locationId', {
  model: 'trm_location'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],384:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/schedule_notes/:noteId', {
  model: 'schedule_note'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],385:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/trm_scripts/:scriptId', {
  model: 'trm_script'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],386:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/trm_script_categories/:scriptCategoryId', {
  model: 'trm_script_category'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],387:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/users/:userId', {
  model: 'trm_user'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],388:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/user_emails/:id', {
  model: 'trm_user_email'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],389:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/user_options/:id', {
  model: 'trm_user_option'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],390:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/trollbox/:trollboxId', {
  model: 'trollbox'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],391:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + '/users/:userId', {
  model: 'user'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],392:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/user_apps/:id', {
  model: 'user_app'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],393:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + '/user_emails/:id', {
  model: 'user_email'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],394:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + '/user_options/:id', {
  model: 'user_option'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],395:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/verified_contacts/:id', {
  model: 'verified_contact'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],396:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/vicidial/agent_api', {
  model: 'vicidial'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],397:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/vicidial/agent_logs/:agentLogId', {
  model: 'vicidial_agent_log'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],398:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/vicidial/closer_logs', {
  model: 'vicidial_closer_log'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],399:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/vicidial/live_agents', {
  model: 'vicidial_live_agent'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],400:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/vicidial/logs', {
  model: 'vicidial_log'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],401:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/et/vicidial_recs/:vdId', {
  model: 'vicidial_recs'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],402:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/vicidial/reports/calls/:vicidialId', {
  model: 'vicidial_report'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],403:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/vicidial/reports/scorecard/:vicidialId', {
  model: 'vicidial_scorecard_report'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],404:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + api.type + '/vicidial/users', {
  model: 'vicidial_user'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],405:[function(require,module,exports){
'use strict'

let api = require('./../config/api.js'),
  Resource = require('./../services/resource.js')

module.exports = new Resource(api.base + '/zips/:zip', {
  model: 'bam_zip'
})

},{"./../config/api.js":7,"./../services/resource.js":415}],406:[function(require,module,exports){
'use strict'

function Converter () {
}

Converter.prototype.inchToCm = function (inch) {
  return inch * 2.54
}

Converter.prototype.cmToInch = function (cm) {
  return cm * 0.393701
}

Converter.prototype.lbToKg = function (lb) {
  return lb * 0.453592
}

Converter.prototype.kgToLb = function (kg) {
  return kg * 2.20462
}

Converter.prototype.convert = function (value, from, to, round) {
  from = from.toLowerCase()
  to = to.charAt(0).toUpperCase() + to.substr(1).toLowerCase()

  if (round) { return Math.round(this[from + 'To' + to](value)) } else { return this[from + 'To' + to](value) }
}

module.exports = new Converter()

},{}],407:[function(require,module,exports){
'use strict'

let Cron = {
  default: '* * * * *',
  parse: (cron) => {
    // Default data is RUN ALL THE TIME
    let data = {}

    if (typeof cron !== 'string') {
      // Reset the CRON
      cron = Cron.default
    }

    // Split the CRON
    cron = cron.split(' ')

    if (cron.length !== 5) {
      // Reset the CRON
      cron = Cron.default.split(' ')
    }

    // Check if we have hours
    cron[1] = cron[1].split('-')
    if (cron[1] == '*') {
      cron[1][0] = '0'
      cron[1][1] = '23'
    }
    if (cron[1].length == 1) {
      cron[1][1] = cron[1][0]
    }
    data.cron_hours_from = cron[1][0]
    data.cron_hours_to = cron[1][1]

    // Check if we have dates
    cron[2] = cron[2].split('-')
    if (cron[2] == '*') {
      cron[2][0] = '1'
      cron[2][1] = '31'
    }
    if (cron[2].length == 1) {
      cron[2][1] = cron[2][0]
    }
    data.cron_days_from = cron[2][0]
    data.cron_days_to = cron[2][1]

    // Check if we have months of the year
    cron[3] = cron[3].split(',')
    if (cron[3][0] === '*') {
      cron[3] = [1,2,3,4,5,6,7,8,9,10,11,12]
    }
    data.cron_months = cron[3]

    // Check if we have days of the week
    cron[4] = cron[4].split(',')
    if (cron[4][0] === '*') {
      cron[4] = [0,1,2,3,4,5,6]
    }
    data.cron_days = cron[4]

    return data
  },
  create: (data) => {
    // Default cron is RUN ALL THE TIME
    let cron = Cron.default.split(' ')

    // Check if we have hours
    if (data.cron_hours_from != 0 || data.cron_hours_to != 23) {
      cron[1] = data.cron_hours_from
      if (data.cron_hours_from != data.cron_hours_to) {
        cron[1] = data.cron_hours_from + '-' + data.cron_hours_to
      }
    }

    // Check if we have dates
    if (data.cron_days_from != 1 || data.cron_days_to != 31) {
      cron[2] = data.cron_days_from
      if (data.cron_days_from != data.cron_days_to) {
        cron[2] = data.cron_days_from + '-' + data.cron_days_to
      }
    }

    // Check if we have months of the year
    if (data.cron_months && data.cron_months.length != 12) {
      if (data.cron_months.length == 1) {
        data.cron_months = [data.cron_months]
      }
      cron[3] = data.cron_months.join(',')
    }

    // Check if we have days of the week
    if (data.cron_days && data.cron_days.length != 7) {
      if (data.cron_days.length == 1) {
        data.cron_days = [data.cron_days]
      }
      cron[4] = data.cron_days.join(',')
    }

    return cron.join(' ')
  }
}

module.exports = Cron

},{}],408:[function(require,module,exports){
'use strict'

function databind (element, data, append) {
  let self = $(element)

  // remove elements of parent element which are not templates if append flag is not true
  if (!append) {
    _.forEach(self.find('[data-bind-template]'), function (e) {
      _.forEach($($(e).attr('data-bind-template')).children(), function (el) {
        if (!$(el).attr('data-bind-template')) {
          $(el).remove()
        }
      })
    })
  }

  _.each(self.find('[data-bind]:not([data-bind-template])').addBack('[data-bind]'), function (_element) {
    let element = $(_element)

    // if child of a template, skip it since it will be databind later
    if (element.parents('[data-bind-template]').length) { return }

    // set element value
    setValue(element, _.template(element.attr('data-bind'))(data))
  })

  _.each(self.find('[data-bind-template]'), function (_element) {
    if (typeof _element === 'undefined') { return }

    element = $(_element)

    // get only templates not within a template
    if (element.parents('[data-bind-template]').length) { return }

    // get new data from data-bind-value
    let new_data = eval('data.' + element.attr('data-bind-value'))

    // iterate throught the data
    _.each(new_data, function (data) {
      // create clone of the template
      let clone = element.clone()
      // assign data-bind-template attr to another let before removing
      let appendTo = clone.attr('data-bind-template')
      // remove hide class
      clone.removeClass('hide')
      // clone.find('.hide').removeClass('hide')
      // remove data-bind-template so we can use it on databind
      clone.removeAttr('data-bind-template')
      clone.removeAttr('data-bind-value')
      // call databind on the cloned element
      databind(clone, data)
      // remove all data-bind attributes so it wont affect on next databind call
      clone.removeAttr('data-bind')
      clone.find('[data-bind]').removeAttr('data-bind')
      // add cloned element to the target
      self.find(appendTo).addBack(appendTo).append(clone)
    })
  })

  // sets the value of the element
  function setValue (element, _value) {
    let attr = element.attr('data-bind-target')
    let value = _value || ''

    // if data-bind-target is not set, set default value depending on what type of element it is
    if (!attr) {
      if ($(element).is('[data-summernote]')) {
        attr = 'summernote'
      } else if ($(element).is('[data-slider]')) {
        attr = 'slider'
      } else if ($(element).is('input[type="checkbox"]') || $(element).is('input[type="radio"]')) {
        attr = 'checked'
        _value = false
        if (value == 1 || value == 'true') {
          _value = true
        }
        value = _value
      } else if ($(element).is('[data-multiselect]')) {
        attr = 'multiselect'
      } else if ($(element).is('[data-select]')) {
        attr = 'select'
      } else if ($(element).is('input') || $(element).is('select') || $(element).is('textarea')) {
        attr = 'val'
      } else if ($(element).is('a')) {
        attr = 'href'
      } else if (
        $(element).is('p') ||
        $(element).is('span') ||
        $(element).is('b') ||
        $(element).is('td') ||
        $(element).is('h1') ||
        $(element).is('h2') ||
        $(element).is('h3') ||
        $(element).is('h4') ||
        $(element).is('h5') ||
        $(element).is('h6') ||
        $(element).is('div') ||
        $(element).is('strong')
      ) {
        attr = 'text'
      } else if ($(element).is('img') || $(element).is('iframe')) {
        attr = 'src'
      } else if ($(element).is('option')) {
        attr = 'option'
      }
    }

    // set value depending on the attr
    switch (attr) {
      case 'val':
        if ($(element).is('select')) {
          if (typeof value === 'string') {
            let delimiter = '|'
            if (/,/.test(value)) {
              delimiter = ','
            }

            value = value.split(delimiter)
          }
        }
        $(element).val(value)
        break
      case 'text':
        $(element).text(value)
        break
      case 'title':
      case 'title-suf':
        $(element).text($(element).text() + ' - ' +  value)
        break
      case 'title-pre':
        $(element).text(value + ' - ' +  $(element).text())
        break
      case 'html':
        if ($(element).is('iframe')) {
          $(element).contents().find('html').html(value)
        } else {
          $(element).html(value)
        }
        break
      case 'checked':
        $(element).prop('checked', value)
        break
      case 'slider':
        value = eval(value)
        $(element).slider({ values: value })
        break
      case 'summernote':
        $(element).text(value)
        $(element).next().find('.note-editable').html(value)
        break
      case 'select':
        if (typeof value === 'string') {
          let delimiter = '|'
          if (/,/.test(value)) {
            delimiter = ','
          }

          value = value.split(delimiter)
        }
        $(element).val(value).select2()
        break
      case 'multiselect':
        if (typeof value === 'string') {
          let delimiter = '|'
          if (/,/.test(value)) {
            delimiter = ','
          }

          value = value.split(delimiter)
        }
        $(element).val(value).multiselect('refresh')
        break
      case 'visibility':
        if (parseInt(value)) {
          $(element).show()
        } else {
          $(element).hide()
        }
        break
      case 'option':
        value = JSON.parse(value)
        $(element).attr('value', value.key)
        $(element).text(value.value)
        if (value.selected && value.selected.length > 0) {
          $(element).attr('selected', 'selected')
        }
        break
      case 'class':
        $(element).addClass(value)
        break
      case 'title-attr':
        $(element).attr('title', value)
        break
      default:
        $(element).attr(attr, value)
        break
    }
  }
}

module.exports = databind

},{}],409:[function(require,module,exports){
'use strict'

let _ = require('lodash')

function toUnixTimeStamp (date) {
  return new Date(date) / 1000
}

function formatYMD (value) {
  let date
  if (isNaN(value)) {
    date = new Date(value)
  } else {
    date = new Date((value || 0) * 1000 - (7 * 60 * 60)) // set timezone to dev-la (GMT -7)
  }

  if (typeof date == 'undefined' || date == 'Invalid Date') {
    return 'Invalid Date'
  }

  return date.getUTCFullYear() + '-' + _.padLeft(date.getUTCMonth() + 1, 2, 0) + '-' + _.padLeft(date.getUTCDate(), 2, 0)
}

function formatFYMD (value) {
  let date
  if (isNaN(value)) {
    date = new Date(value)
  } else {
    date = new Date((value || 0) * 1000 - (7 * 60 * 60)) // set timezone to dev-la (GMT -7)
  }

  if (typeof date == 'undefined' || date == 'Invalid Date') {
    return 'Invalid Date'
  }

  return moment(date).format('MMMM DD, YYYY')
}

function formatMDY (value, seperator = '-') {
  let date
  if (isNaN(value)) {
    date = new Date(value)
  } else {
    date = new Date((value || 0) * 1000 - (7 * 60 * 60)) // set timezone to dev-la (GMT -7)
  }

  if (typeof date == 'undefined' || date == 'Invalid Date') {
    return 'Invalid Date'
  }

  return date.getUTCMonth() + 1 + seperator + _.padLeft(date.getUTCDate(), 2, 0) + seperator + _.padLeft(date.getUTCFullYear(), 2, 0)
}

function calculateAge (year, month, day) {
  let difference = Date.now() - new Date(year, month - 1, day).getTime()
  let fromEpoch = new Date(difference)
  return fromEpoch.getUTCFullYear() - 1970
}

function now () {
  let date = new Date(Date.now())
  return {
    year: date.getUTCFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate()
  }
}

function formatDateTime (value) {
  let date
  if (isNaN(value)) {
    date = new Date(value)
  } else {
    date = new Date((value || 0) * 1000 - (7 * 60 * 60)) // set timezone to dev-la (GMT -7)
  }

  if (typeof date == 'undefined' || date == 'Invalid Date') {
    return 'Invalid Date'
  }

  return date.getUTCFullYear() + '-' +
    _.padLeft(date.getUTCMonth() + 1, 2, 0) + '-' +
    _.padLeft(date.getUTCDate(), 2, 0) + ' ' +
    _.padLeft((date.getUTCHours() > 12 ? date.getUTCHours() - 12 : (date.getUTCHours() == '00') ? '12' : date.getUTCHours()), 2, 0) + ':' +
    _.padLeft(date.getUTCMinutes(), 2, 0) + ' ' +
    (date.getUTCHours() < 12 ? 'AM' : 'PM')
}

function sql(date) {
  return moment(+(date || moment())).format('YYYY-MM-DD HH:mm:ss')
}

module.exports = {
  toUnixTimeStamp: toUnixTimeStamp,
  formatYMD: formatYMD,
  formatMDY: formatMDY,
  formatDateTime: formatDateTime,
  calculateAge: calculateAge,
  now: now,
  formatFYMD: formatFYMD,
  sql: sql
}

},{"lodash":429}],410:[function(require,module,exports){
'use strict'

module.exports = {
  serializeObject: serializeObject,
  validate: validate
}

function serializeObject (form) {
  let str = $(form).serialize()
  return (str).replace(/(^\?)/, '').split('&').map(
    function (n) {
      n = n.split('=')
      n[1] = decodeURIComponent(n[1])
      n[1] = n[1].replace(/\+/g, ' ')

      if (this[n[0]] != null) {
        if (this[n[0]] instanceof Array) {
          this[n[0]] = this[n[0]].concat(n[1])
        } else {
          this[n[0]] = [ this[n[0]], n[1] ]
        }
      } else {
        this[n[0]] = n[1]
      }

      return this
    }.bind({}))[0]
}

function validate (form) {
  let $form = $(form)
  let allOk = true

  _.forEach($form.find('[data-validate]'), function (e) {
    let $e = $(e)
    let ok = true
    switch ($e.attr('data-validate')) {
      case 'phone':
      case 'number':
        ok = /^\d+$/.test($e.val())
        break
      case 'text':
        ok = /^[A-Za-z\s]+$/.test($e.val())
        break
      case 'email':
        ok = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}\b/.test($e.val())
        break
      case 'email-not-required':
        ok = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}|^$|^\s$\b/.test($e.val())
        break
      case 'phone-not-required':
        ok = /^[0-9]+$|^$|^\s$/.test($e.val())
        break
      case 'required':
        ok = !!$e.val().trim()
        break
      case 'zip':
        ok = /^[0-9]+$|^$|^\s$/.test($e.val())
        let okNum = /^[0-9]+$/.test($e.val())
        if (ok == okNum) { ok = parseInt($e.val()) <= 99999 }
      default:
        break
    }

    let $parent = $e.parent()
    let $help = $parent.find('.help-block')

    if (ok) {
      $parent.removeClass('has-error')
      $help.remove()
    } else {
      allOk = false
      $parent.addClass('has-error')

      if ($help.length) {
        $help.show()
      } else {
        $parent.append('<p class="help-block">' + $e.attr('data-validate-error') + '</p>')
      }
    }
  })

  return allOk
}

},{}],411:[function(require,module,exports){
'use strict'

let _ = require('lodash')

modelify.$$hashRelation = hashRelation

function modelify (name, data) {
  let models = {'access_token': require('../models/access_token.js'),'access_tokens': require('../models/access_tokens.js'),'admin_alert': require('../models/admin_alert.js'),'admin_alerts': require('../models/admin_alerts.js'),'agent_lead': require('../models/agent_lead.js'),'agent_leads': require('../models/agent_leads.js'),'alert': require('../models/alert.js'),'alerts': require('../models/alerts.js'),'app': require('../models/app.js'),'app_xorigin': require('../models/app_xorigin.js'),'app_xorigins': require('../models/app_xorigins.js'),'apps': require('../models/apps.js'),'bad_account': require('../models/bad_account.js'),'bad_accounts': require('../models/bad_accounts.js'),'bam_cast_cat': require('../models/bam_cast_cat.js'),'bam_casting': require('../models/bam_casting.js'),'bam_castings': require('../models/bam_castings.js'),'bam_cd_user': require('../models/bam_cd_user.js'),'bam_cd_users': require('../models/bam_cd_users.js'),'bam_favorite_castings': require('../models/bam_favorite_castings.js'),'bam_friend': require('../models/bam_friend.js'),'bam_friends': require('../models/bam_friends.js'),'bam_role': require('../models/bam_role.js'),'bam_roles': require('../models/bam_roles.js'),'bam_talent_dance': require('../models/bam_talent_dance.js'),'bam_talent_media2': require('../models/bam_talent_media2.js'),'bam_talent_music': require('../models/bam_talent_music.js'),'bam_talent_resume': require('../models/bam_talent_resume.js'),'bam_talent_social': require('../models/bam_talent_social.js'),'bam_talent_socials': require('../models/bam_talent_socials.js'),'bam_talentci': require('../models/bam_talentci.js'),'bam_talentcis': require('../models/bam_talentcis.js'),'bam_talentinfo1': require('../models/bam_talentinfo1.js'),'bam_talentinfo2': require('../models/bam_talentinfo2.js'),'bam_talentinfo3': require('../models/bam_talentinfo3.js'),'bam_talentrecurring': require('../models/bam_talentrecurring.js'),'bam_talenttracking': require('../models/bam_talenttracking.js'),'bam_talenttrackings': require('../models/bam_talenttrackings.js'),'bam_user': require('../models/bam_user.js'),'bam_zip': require('../models/bam_zip.js'),'banned_email': require('../models/banned_email.js'),'banned_emails': require('../models/banned_emails.js'),'callback': require('../models/callback.js'),'callbacks': require('../models/callbacks.js'),'campaign': require('../models/campaign.js'),'campaign_app_log': require('../models/campaign_app_log.js'),'campaign_app_logs': require('../models/campaign_app_logs.js'),'campaign_app_queue': require('../models/campaign_app_queue.js'),'campaign_app_queues': require('../models/campaign_app_queues.js'),'campaign_sender': require('../models/campaign_sender.js'),'campaign_sender_address': require('../models/campaign_sender_address.js'),'campaign_sender_addresses': require('../models/campaign_sender_addresses.js'),'campaign_sender_did': require('../models/campaign_sender_did.js'),'campaign_sender_dids': require('../models/campaign_sender_dids.js'),'campaign_sender_type': require('../models/campaign_sender_type.js'),'campaign_sender_types': require('../models/campaign_sender_types.js'),'campaign_senders': require('../models/campaign_senders.js'),'campaigns': require('../models/campaigns.js'),'casting_app': require('../models/casting_app.js'),'casting_apps': require('../models/casting_apps.js'),'castings_call_log': require('../models/castings_call_log.js'),'castings_call_logs': require('../models/castings_call_logs.js'),'castings_evil': require('../models/castings_evil.js'),'castings_evils': require('../models/castings_evils.js'),'cd_claim_sale': require('../models/cd_claim_sale.js'),'cd_claim_sales': require('../models/cd_claim_sales.js'),'cd_log': require('../models/cd_log.js'),'cd_logs': require('../models/cd_logs.js'),'cd_user_campaign_subscription': require('../models/cd_user_campaign_subscription.js'),'cd_user_campaign_subscriptions': require('../models/cd_user_campaign_subscriptions.js'),'cd_user_subscription': require('../models/cd_user_subscription.js'),'cd_user_subscriptions': require('../models/cd_user_subscriptions.js'),'col_recurring': require('../models/col_recurring.js'),'col_recurrings': require('../models/col_recurrings.js'),'contest': require('../models/contest.js'),'contest_link': require('../models/contest_link.js'),'contest_links': require('../models/contest_links.js'),'contest_media': require('../models/contest_media.js'),'contest_medias': require('../models/contest_medias.js'),'contests': require('../models/contests.js'),'conversation': require('../models/conversation.js'),'conversations': require('../models/conversations.js'),'data': require('../models/data.js'),'datum': require('../models/datum.js'),'did_log': require('../models/did_log.js'),'did_logs': require('../models/did_logs.js'),'email_template': require('../models/email_template.js'),'email_templates': require('../models/email_templates.js'),'et_leads': require('../models/et_leads.js'),'et_online': require('../models/et_online.js'),'et_onlines': require('../models/et_onlines.js'),'favorite_talent': require('../models/favorite_talent.js'),'favorite_talents': require('../models/favorite_talents.js'),'featured_casting': require('../models/featured_casting.js'),'featured_casting_admin': require('../models/featured_casting_admin.js'),'featured_casting_admins': require('../models/featured_casting_admins.js'),'featured_castings': require('../models/featured_castings.js'),'feedback': require('../models/feedback.js'),'feedbacks': require('../models/feedbacks.js'),'future_recurring': require('../models/future_recurring.js'),'future_recurrings': require('../models/future_recurrings.js'),'inbound_did': require('../models/inbound_did.js'),'inbound_dids': require('../models/inbound_dids.js'),'job_order': require('../models/job_order.js'),'knowledge_base': require('../models/knowledge_base.js'),'lead_assignment': require('../models/lead_assignment.js'),'lead_assignments': require('../models/lead_assignments.js'),'legacy_package': require('../models/legacy_package.js'),'legacy_packages': require('../models/legacy_packages.js'),'link_campaign': require('../models/link_campaign.js'),'link_campaigns': require('../models/link_campaigns.js'),'liveagent_contact': require('../models/liveagent_contact.js'),'liveagent_contacts': require('../models/liveagent_contacts.js'),'liveagent_sync_to_liveagent': require('../models/liveagent_sync_to_liveagent.js'),'liveagent_sync_to_liveagents': require('../models/liveagent_sync_to_liveagents.js'),'liveagent_ticket': require('../models/liveagent_ticket.js'),'liveagent_tickets': require('../models/liveagent_tickets.js'),'location': require('../models/location.js'),'locations': require('../models/locations.js'),'market': require('../models/market.js'),'markets': require('../models/markets.js'),'media': require('../models/media.js'),'medias': require('../models/medias.js'),'message': require('../models/message.js'),'message_template': require('../models/message_template.js'),'message_template_categories': require('../models/message_template_categories.js'),'message_template_category': require('../models/message_template_category.js'),'message_templates': require('../models/message_templates.js'),'messages': require('../models/messages.js'),'payment': require('../models/payment.js'),'payments': require('../models/payments.js'),'poster_stat': require('../models/poster_stat.js'),'poster_stats': require('../models/poster_stats.js'),'project': require('../models/project.js'),'project_app': require('../models/project_app.js'),'project_apps': require('../models/project_apps.js'),'project_stat': require('../models/project_stat.js'),'project_stats': require('../models/project_stats.js'),'projects': require('../models/projects.js'),'promocode': require('../models/promocode.js'),'promocodes': require('../models/promocodes.js'),'qa_answer': require('../models/qa_answer.js'),'qa_answers': require('../models/qa_answers.js'),'qa_choice': require('../models/qa_choice.js'),'qa_choices': require('../models/qa_choices.js'),'qa_question': require('../models/qa_question.js'),'qa_questions': require('../models/qa_questions.js'),'qa_section': require('../models/qa_section.js'),'qa_sections': require('../models/qa_sections.js'),'quickpost': require('../models/quickpost.js'),'quickposts': require('../models/quickposts.js'),'recording_log': require('../models/recording_log.js'),'recording_logs': require('../models/recording_logs.js'),'reminder': require('../models/reminder.js'),'reminders': require('../models/reminders.js'),'report_abuse': require('../models/report_abuse.js'),'report_abuse_reason': require('../models/report_abuse_reason.js'),'report_abuse_reasons': require('../models/report_abuse_reasons.js'),'report_abuses': require('../models/report_abuses.js'),'sale': require('../models/sale.js'),'sale_sources_tls': require('../models/sale_sources_tls.js'),'sale_sources_tlss': require('../models/sale_sources_tlss.js'),'sales': require('../models/sales.js'),'sales_source': require('../models/sales_source.js'),'sales_sources': require('../models/sales_sources.js'),'schedule': require('../models/schedule.js'),'schedule_import': require('../models/schedule_import.js'),'schedule_note': require('../models/schedule_note.js'),'schedule_notes': require('../models/schedule_notes.js'),'schedules': require('../models/schedules.js'),'search_talent': require('../models/search_talent.js'),'search_talents': require('../models/search_talents.js'),'sender_option': require('../models/sender_option.js'),'sender_options': require('../models/sender_options.js'),'sms_message': require('../models/sms_message.js'),'sms_messages': require('../models/sms_messages.js'),'sms_stat': require('../models/sms_stat.js'),'sms_stats': require('../models/sms_stats.js'),'sms_thread': require('../models/sms_thread.js'),'sms_threads': require('../models/sms_threads.js'),'sound_board': require('../models/sound_board.js'),'staff_notes': require('../models/staff_notes.js'),'star_talent': require('../models/star_talent.js'),'star_talents': require('../models/star_talents.js'),'tag': require('../models/tag.js'),'tag_type': require('../models/tag_type.js'),'tag_types': require('../models/tag_types.js'),'tags': require('../models/tags.js'),'talent_autosub': require('../models/talent_autosub.js'),'talent_general': require('../models/talent_general.js'),'talent_generals': require('../models/talent_generals.js'),'talent_payment_option': require('../models/talent_payment_option.js'),'talent_payment_options': require('../models/talent_payment_options.js'),'talent_sale': require('../models/talent_sale.js'),'talent_sales': require('../models/talent_sales.js'),'talent_song': require('../models/talent_song.js'),'talent_songs': require('../models/talent_songs.js'),'talent_video': require('../models/talent_video.js'),'talent_videos': require('../models/talent_videos.js'),'talentorder': require('../models/talentorder.js'),'talentorders': require('../models/talentorders.js'),'talentordertracking': require('../models/talentordertracking.js'),'talentordertrackings': require('../models/talentordertrackings.js'),'talentrecurring': require('../models/talentrecurring.js'),'talentrecurrings': require('../models/talentrecurrings.js'),'team': require('../models/team.js'),'teams': require('../models/teams.js'),'transactions_store': require('../models/transactions_store.js'),'transactions_stores': require('../models/transactions_stores.js'),'trm_banner': require('../models/trm_banner.js'),'trm_call_log': require('../models/trm_call_log.js'),'trm_call_logs': require('../models/trm_call_logs.js'),'trm_categories': require('../models/trm_categories.js'),'trm_category': require('../models/trm_category.js'),'trm_feedback': require('../models/trm_feedback.js'),'trm_feedbacks': require('../models/trm_feedbacks.js'),'trm_location': require('../models/trm_location.js'),'trm_script': require('../models/trm_script.js'),'trm_script_categories': require('../models/trm_script_categories.js'),'trm_script_category': require('../models/trm_script_category.js'),'trm_scripts': require('../models/trm_scripts.js'),'trm_user': require('../models/trm_user.js'),'trm_user_email': require('../models/trm_user_email.js'),'trm_user_emails': require('../models/trm_user_emails.js'),'trm_user_option': require('../models/trm_user_option.js'),'trollbox': require('../models/trollbox.js'),'trollboxes': require('../models/trollboxes.js'),'user': require('../models/user.js'),'user_app': require('../models/user_app.js'),'user_apps': require('../models/user_apps.js'),'user_email': require('../models/user_email.js'),'user_emails': require('../models/user_emails.js'),'user_option': require('../models/user_option.js'),'user_options': require('../models/user_options.js'),'users': require('../models/users.js'),'verified_contact': require('../models/verified_contact.js'),'verified_contacts': require('../models/verified_contacts.js'),'vicidial': require('../models/vicidial.js'),'vicidial_agent_log': require('../models/vicidial_agent_log.js'),'vicidial_agent_logs': require('../models/vicidial_agent_logs.js'),'vicidial_closer_log': require('../models/vicidial_closer_log.js'),'vicidial_closer_logs': require('../models/vicidial_closer_logs.js'),'vicidial_live_agent': require('../models/vicidial_live_agent.js'),'vicidial_live_agents': require('../models/vicidial_live_agents.js'),'vicidial_log': require('../models/vicidial_log.js'),'vicidial_logs': require('../models/vicidial_logs.js'),'vicidial_recs': require('../models/vicidial_recs.js'),'vicidial_report': require('../models/vicidial_report.js'),'vicidial_reports': require('../models/vicidial_reports.js'),'vicidial_scorecard_report': require('../models/vicidial_scorecard_report.js'),'vicidial_scorecard_reports': require('../models/vicidial_scorecard_reports.js'),'vicidial_user': require('../models/vicidial_user.js'),'vicidial_users': require('../models/vicidial_users.js'),'vicidials': require('../models/vicidials.js')},
    model = models[name],
    relationship,
    relations,
    difference

  if (model && (_.isArray(data) || _.isObject(data))) {
    relationship = hashRelation(model.relationship || [])

    relations = _.pick(data, _.keys(relationship))

    _.each(relations, function (property, key) {
      data[key] = modelify(relationship[key], property)
    })

    if (model.create && _.isFunction(model.create)) {
      /* jshint newcap: false */
      data = model.create(data)
    } else {
      data = new model(data)
    }
  }

  return data
}

function hashRelation (relationships) {
  return _.reduce(relationships, function (object, relationship) {
    let keys = relationship.split(':'),
      modelName = keys.pop(),
      propertyName = keys.pop() || modelName

    object[propertyName] = modelName

    return object
  }, {})
}

module.exports = modelify

},{"../models/access_token.js":10,"../models/access_tokens.js":11,"../models/admin_alert.js":12,"../models/admin_alerts.js":13,"../models/agent_lead.js":14,"../models/agent_leads.js":15,"../models/alert.js":16,"../models/alerts.js":17,"../models/app.js":18,"../models/app_xorigin.js":19,"../models/app_xorigins.js":20,"../models/apps.js":21,"../models/bad_account.js":22,"../models/bad_accounts.js":23,"../models/bam_cast_cat.js":24,"../models/bam_casting.js":25,"../models/bam_castings.js":26,"../models/bam_cd_user.js":27,"../models/bam_cd_users.js":28,"../models/bam_favorite_castings.js":29,"../models/bam_friend.js":30,"../models/bam_friends.js":31,"../models/bam_role.js":32,"../models/bam_roles.js":33,"../models/bam_talent_dance.js":34,"../models/bam_talent_media2.js":35,"../models/bam_talent_music.js":36,"../models/bam_talent_resume.js":37,"../models/bam_talent_social.js":38,"../models/bam_talent_socials.js":39,"../models/bam_talentci.js":40,"../models/bam_talentcis.js":41,"../models/bam_talentinfo1.js":42,"../models/bam_talentinfo2.js":43,"../models/bam_talentinfo3.js":44,"../models/bam_talentrecurring.js":45,"../models/bam_talenttracking.js":46,"../models/bam_talenttrackings.js":47,"../models/bam_user.js":48,"../models/bam_zip.js":49,"../models/banned_email.js":50,"../models/banned_emails.js":51,"../models/callback.js":52,"../models/callbacks.js":53,"../models/campaign.js":54,"../models/campaign_app_log.js":55,"../models/campaign_app_logs.js":56,"../models/campaign_app_queue.js":57,"../models/campaign_app_queues.js":58,"../models/campaign_sender.js":59,"../models/campaign_sender_address.js":60,"../models/campaign_sender_addresses.js":61,"../models/campaign_sender_did.js":62,"../models/campaign_sender_dids.js":63,"../models/campaign_sender_type.js":64,"../models/campaign_sender_types.js":65,"../models/campaign_senders.js":66,"../models/campaigns.js":67,"../models/casting_app.js":68,"../models/casting_apps.js":69,"../models/castings_call_log.js":70,"../models/castings_call_logs.js":71,"../models/castings_evil.js":72,"../models/castings_evils.js":73,"../models/cd_claim_sale.js":74,"../models/cd_claim_sales.js":75,"../models/cd_log.js":76,"../models/cd_logs.js":77,"../models/cd_user_campaign_subscription.js":78,"../models/cd_user_campaign_subscriptions.js":79,"../models/cd_user_subscription.js":80,"../models/cd_user_subscriptions.js":81,"../models/col_recurring.js":82,"../models/col_recurrings.js":83,"../models/contest.js":84,"../models/contest_link.js":85,"../models/contest_links.js":86,"../models/contest_media.js":87,"../models/contest_medias.js":88,"../models/contests.js":89,"../models/conversation.js":90,"../models/conversations.js":91,"../models/data.js":92,"../models/datum.js":93,"../models/did_log.js":94,"../models/did_logs.js":95,"../models/email_template.js":96,"../models/email_templates.js":97,"../models/et_leads.js":98,"../models/et_online.js":99,"../models/et_onlines.js":100,"../models/favorite_talent.js":101,"../models/favorite_talents.js":102,"../models/featured_casting.js":103,"../models/featured_casting_admin.js":104,"../models/featured_casting_admins.js":105,"../models/featured_castings.js":106,"../models/feedback.js":107,"../models/feedbacks.js":108,"../models/future_recurring.js":109,"../models/future_recurrings.js":110,"../models/inbound_did.js":111,"../models/inbound_dids.js":112,"../models/job_order.js":113,"../models/knowledge_base.js":114,"../models/lead_assignment.js":115,"../models/lead_assignments.js":116,"../models/legacy_package.js":117,"../models/legacy_packages.js":118,"../models/link_campaign.js":119,"../models/link_campaigns.js":120,"../models/liveagent_contact.js":121,"../models/liveagent_contacts.js":122,"../models/liveagent_sync_to_liveagent.js":123,"../models/liveagent_sync_to_liveagents.js":124,"../models/liveagent_ticket.js":125,"../models/liveagent_tickets.js":126,"../models/location.js":127,"../models/locations.js":128,"../models/market.js":129,"../models/markets.js":130,"../models/media.js":131,"../models/medias.js":132,"../models/message.js":133,"../models/message_template.js":134,"../models/message_template_categories.js":135,"../models/message_template_category.js":136,"../models/message_templates.js":137,"../models/messages.js":138,"../models/payment.js":139,"../models/payments.js":140,"../models/poster_stat.js":141,"../models/poster_stats.js":142,"../models/project.js":143,"../models/project_app.js":144,"../models/project_apps.js":145,"../models/project_stat.js":146,"../models/project_stats.js":147,"../models/projects.js":148,"../models/promocode.js":149,"../models/promocodes.js":150,"../models/qa_answer.js":151,"../models/qa_answers.js":152,"../models/qa_choice.js":153,"../models/qa_choices.js":154,"../models/qa_question.js":155,"../models/qa_questions.js":156,"../models/qa_section.js":157,"../models/qa_sections.js":158,"../models/quickpost.js":159,"../models/quickposts.js":160,"../models/recording_log.js":161,"../models/recording_logs.js":162,"../models/reminder.js":163,"../models/reminders.js":164,"../models/report_abuse.js":165,"../models/report_abuse_reason.js":166,"../models/report_abuse_reasons.js":167,"../models/report_abuses.js":168,"../models/sale.js":169,"../models/sale_sources_tls.js":170,"../models/sale_sources_tlss.js":171,"../models/sales.js":172,"../models/sales_source.js":173,"../models/sales_sources.js":174,"../models/schedule.js":175,"../models/schedule_import.js":176,"../models/schedule_note.js":177,"../models/schedule_notes.js":178,"../models/schedules.js":179,"../models/search_talent.js":180,"../models/search_talents.js":181,"../models/sender_option.js":182,"../models/sender_options.js":183,"../models/sms_message.js":184,"../models/sms_messages.js":185,"../models/sms_stat.js":186,"../models/sms_stats.js":187,"../models/sms_thread.js":188,"../models/sms_threads.js":189,"../models/sound_board.js":190,"../models/staff_notes.js":191,"../models/star_talent.js":192,"../models/star_talents.js":193,"../models/tag.js":194,"../models/tag_type.js":195,"../models/tag_types.js":196,"../models/tags.js":197,"../models/talent_autosub.js":198,"../models/talent_general.js":199,"../models/talent_generals.js":200,"../models/talent_payment_option.js":201,"../models/talent_payment_options.js":202,"../models/talent_sale.js":203,"../models/talent_sales.js":204,"../models/talent_song.js":205,"../models/talent_songs.js":206,"../models/talent_video.js":207,"../models/talent_videos.js":208,"../models/talentorder.js":209,"../models/talentorders.js":210,"../models/talentordertracking.js":211,"../models/talentordertrackings.js":212,"../models/talentrecurring.js":213,"../models/talentrecurrings.js":214,"../models/team.js":215,"../models/teams.js":216,"../models/transactions_store.js":217,"../models/transactions_stores.js":218,"../models/trm_banner.js":219,"../models/trm_call_log.js":220,"../models/trm_call_logs.js":221,"../models/trm_categories.js":222,"../models/trm_category.js":223,"../models/trm_feedback.js":224,"../models/trm_feedbacks.js":225,"../models/trm_location.js":226,"../models/trm_script.js":227,"../models/trm_script_categories.js":228,"../models/trm_script_category.js":229,"../models/trm_scripts.js":230,"../models/trm_user.js":231,"../models/trm_user_email.js":232,"../models/trm_user_emails.js":233,"../models/trm_user_option.js":234,"../models/trollbox.js":235,"../models/trollboxes.js":236,"../models/user.js":237,"../models/user_app.js":238,"../models/user_apps.js":239,"../models/user_email.js":240,"../models/user_emails.js":241,"../models/user_option.js":242,"../models/user_options.js":243,"../models/users.js":244,"../models/verified_contact.js":245,"../models/verified_contacts.js":246,"../models/vicidial.js":247,"../models/vicidial_agent_log.js":248,"../models/vicidial_agent_logs.js":249,"../models/vicidial_closer_log.js":250,"../models/vicidial_closer_logs.js":251,"../models/vicidial_live_agent.js":252,"../models/vicidial_live_agents.js":253,"../models/vicidial_log.js":254,"../models/vicidial_logs.js":255,"../models/vicidial_recs.js":256,"../models/vicidial_report.js":257,"../models/vicidial_reports.js":258,"../models/vicidial_scorecard_report.js":259,"../models/vicidial_scorecard_reports.js":260,"../models/vicidial_user.js":261,"../models/vicidial_users.js":262,"../models/vicidials.js":263,"lodash":429}],412:[function(require,module,exports){
'use strict'
let query_string = require('./query_string.js')

//this -> element to paginate
//per_page - default: 25
//total
//page - default: 1
//name
module.exports = function(element, options) {
  let qs = query_string()
  let $this = $(element)

  if (!options) {
    options = {}
  }

  if (!options.per_page) {
    options.per_page = 25
  }

  if (!options.count) {
    options.count = 25
  }

  options.page = parseInt(qs[options.name])

  if (!options.page) {
    options.page = 1
  }

  let url = window.location.pathname
  let page_count = options.total ? Math.ceil(options.total / options.per_page) : options.page
  let infinate = typeof options.total === 'undefined'

  if (page_count <= 1 && !infinate) {
    $this.empty()
    return
  }

  let ul = $('<ul>').addClass(options.class)

  qs[options.name] = 1
  let prevv = $('<li>').append(
    $('<a>').attr('href', url + '?' + $.param(qs)).append(
      $('<span>').html('&laquo')
    )
  )

  qs[options.name] = options.page == 1 ? 1 : options.page - 1
  let prev = $('<li>').append(
    $('<a>').attr('href', url + '?' + $.param(qs)).append(
      $('<span>').text('Previous')
    )
  )

  if (options.page != 1) {
    ul.append(prevv)
    ul.append(prev)
  }

  let pages = []

  let start = options.page - 5,
    end = options.page + 5

  for(let i = start; i <= end; i++) {
    if (i > 0 && i <= page_count) {
      qs[options.name] = i
      let li = $('<li>').addClass('display-none-zz-xs').append(
        $('<a>').attr('href', url + '?' + $.param(qs)).text(i).addClass(options.page == i ? 'active' : '')
      )
      pages.push(li)
    }
  }

  qs[options.name] = options.page == page_count ? options.page : options.page + 1
  qs[options.name] = infinate ? options.page + 1 : qs[options.name]
  let next = $('<li>').append(
    $('<a>').attr('href', url + '?' + $.param(qs)).append(
      $('<span>').text('Next')
    )
  )

  qs[options.name] = page_count
  let nextt = $('<li>').append(
    $('<a>').attr('href', url + '?' + $.param(qs)).append(
      $('<span>').html('&raquo')
    )
  )

  ul.append(pages)

  if (page_count != options.page) {
    ul.append(next)
    ul.append(nextt)
  }

  if (infinate && options.count >= options.per_page) {
    ul.append(next)
  }

  $this.empty()
  $this.append(ul)
}

},{"./query_string.js":414}],413:[function(require,module,exports){
'use strict'

function unmask (phone) {
  return phone.replace(/\-/g, '').replace(/\(/g, '').replace(/\)/g, '')
}

function mask (phone) {
  if (phone.length == 10) { return '(' + phone.substring(0, 3) + ')' + phone.substring(3, 6) + '-' + phone.substring(6, 10) }
}

module.exports = {
  unmask: unmask,
  mask: mask
}

},{}],414:[function(require,module,exports){
'use strict'

module.exports = function (str) {
  return (str || document.location.search).replace(/(^\?)/, '').split('&').map(
    function (n) {
      if (!n) {
        // return if empty
        return this
      }

      n = n.split('=')
      n[1] = decodeURIComponent(n[1])
      n[1] = n[1].replace(/\+/g, ' ')

      if (this[n[0]] != null) {
        if (this[n[0]] instanceof Array) {
          this[n[0]] = this[n[0]].concat(n[1])
        } else {
          this[n[0]] = [ this[n[0]], n[1] ]
        }
      } else {
        this[n[0]] = n[1]
      }

      return this
    }.bind({}))[0]
}

},{}],415:[function(require,module,exports){
'use strict'

let REST = require('./rest.js'),
  model = require('./model.js'),
  _ = require('lodash')

function Resource (url, settings) {
  let self = this
  self.$$url = url
  self.$$settings = settings || {}
  self.$$keys = url.replace(/.*:\/\//g, '').match(/:[a-zA-Z]+/g)
}

Resource.prototype.interpolate = function (data) {
  let self = this
  data = _.clone(data)
  return {
    url: _(self.$$keys).reduce(function (url, key) {
      let dataKey = key.substring(1)
      if (data && data[dataKey]) {
        url = url.replace(key, data[dataKey])
        delete data[dataKey]
      } else {
        url = url.replace(key, '')
      }
      return url.replace(/\/$/, '')
    }, self.$$url),
    data: data
  }
}

Resource.prototype.child = function (url, settings) {
  return new Resource(this.$$url + url, settings)
}

_.each(REST.$$methods, function (method) {
  Resource.prototype[method] = function (data, settings) {
    let self = this,
      params = self.interpolate(data),
      newSettings = _.assign({}, settings, self.$$settings)

    if (newSettings.model) {
      // changed interceptors to interceptor
      newSettings.interceptors = [{
        responseSuccess: _.partial(model, newSettings.model)
      }]
      delete newSettings.model
    }

    // Check if we are doing a GET request
    if (method.toUpperCase() == 'GET') {
      // Check if we have a query or q?
      if (
        typeof params.data !== 'undefined' &&
        typeof params.data.query !== 'undefined'
      ) {
        // CLONE to be safe
        params.data.q = _.clone(params.data.query)

        // Remove the old reference
        delete params.data.query
      }

      // Check for the old query format
      if (
        typeof params.data !== 'undefined' &&
        typeof params.data.q !== 'undefined'
      ) {
        // Check if we have a string/json already
        if (typeof params.data.q !== 'string') {
          params.data.q = JSON.stringify(params.data.q)
        }
      }
    }

    return REST[method](params.url, params.data, newSettings)
  }
})

module.exports = Resource

},{"./model.js":411,"./rest.js":416,"lodash":429}],416:[function(require,module,exports){
'use strict'
let $ = require('jquery'), _ = require('lodash'), api = require('./../config/api.js'),
  REST = {}

// set up ajax to use cross domain
$.ajaxSetup({
  crossDomain: true
})

REST.interceptor = {
  request: _.identity,
  response: _.identity,
  responseSuccess: _.identity,
  responseError: _.identity
}

REST.settings = {
}

if (localStorage.getItem('access_token')) {
  REST.settings.headers = {
    Authorization: 'Bearer ' + localStorage.getItem('access_token')
  }
}

REST.$$runInterceptors = runInterceptors
REST.$$restMethod = restMethod

function runInterceptors (interceptors, data, name, context) {
  data = (_.isArray(data) || _.isArguments(data)) ? data : [data]
  return _.reduce(interceptors, function (newData, interceptor) {
    let fn = (interceptor[name] || _.identity)
    return fn.apply(context, data)
  }, data)
}

function restMethod (object, method) {
  object[method] = function (url, data, settings) {
    let promise, config, interceptors

    settings = _.clone(settings || {})

    config = {
      url: url,
      type: method,
      data: data
    }

    if (settings.interceptors) {
      interceptors = settings.interceptors
      delete settings.interceptors
    } else {
      interceptors = [ REST.interceptor ]
    }

    // replaced line below to foreach
    // interceptors = interceptors.concat(REST.interceptors)
    _(interceptors).forEach(function (interceptor) {
      _.assign(interceptor, REST.interceptor)
    }, interceptors)

    config = _.assign(config, settings, REST.settings)

    config = runInterceptors(interceptors, config, 'request', this)

    promise = $.when()

    // check aouth expiry
    if (localStorage.getItem('access_token') && localStorage.getItem('refresh_token') && localStorage.getItem('expires_on')) {
      let expires_on = parseInt(localStorage.getItem('expires_on'))
      let now = Math.round(new Date().getTime() / 1000)

      let diff = expires_on - now

      // Check if expired
      if (diff < 1) {
        promise = $.ajax({
          url: api.base.replace('/v1', '') + '/oauth/access_token',
          method: 'POST',
          data: {
            refresh_token: localStorage.getItem('refresh_token'),
            client_secret: api.client_secret,
            client_id: api.client_id,
            user_type: api.type == '/talent' ? 'bam_talentci' : (api.type == '/cd' ? 'bam_cd_user' : 'bam_user'),
            grant_type: 'refresh_token'
          }
        })
      }
    }

    return promise.then(function (res) {
      if (res && res.access_token) {
        localStorage.setItem('access_token', res.access_token)
        localStorage.setItem('refresh_token', res.refresh_token)
        localStorage.setItem('expires_on', Math.round(new Date().getTime() / 1000) + parseInt(res.expires_in))

        config.headers = {
          Authorization: 'Bearer ' + localStorage.getItem('access_token')
        }

        REST.settings.headers = {
          Authorization: 'Bearer ' + localStorage.getItem('access_token')
        }
      }

      let promise2 = $.ajax(config).then(function () {
        return runInterceptors(interceptors, arguments, 'responseSuccess', this)
      }, function () {
        return runInterceptors(interceptors, arguments, 'responseError', this)
      })

      promise2.always(function () {
        runInterceptors(interceptors, arguments, 'response', this)
      })

      return promise2
    })
  }

  return object
}

REST.$$methods = [ 'put', 'patch', 'delete', 'get', 'post' ]

REST = _.reduce(REST.$$methods, restMethod, REST)

module.exports = REST

},{"./../config/api.js":7,"jquery":6,"lodash":429}],417:[function(require,module,exports){
'use strict'

let crossroads = require('crossroads'),
  _ = require('lodash')

function Router () {
  let self = this
  self.$$controllers = {}
  self.$$params = []
}

Router.prototype.add = function (url, controller) {
  let self = this

  controller = self.$$controllers[controller]

  if (_.isFunction(controller)) {
    crossroads.addRoute(url, function () {
      controller.apply(null, self.$$params.concat(_.toArray(arguments)))
    })
  }

  return self
}

Router.prototype.finalize = function () {
  crossroads.parse(window.location.pathname)
}

module.exports = new Router()

},{"crossroads":3,"lodash":429}],418:[function(require,module,exports){
'use strict'

let _ = require('lodash'),
  resumeExperience = require('./../values/resume_experience'),
  resumePerformance = require('./../values/resume_performance'),
  talent = {
    getExperience: getExperience,
    getPerformance: getPerformance,
    getHeight: getHeight,
    getFullName: getFullName
  }

function getExperience (experience) {
  return resumeExperience[experience] || ''
}

function getPerformance (performance) {
  return resumePerformance[performance] || ''
}

function getHeight (inches) {
  let feet = Math.floor(inches / 12)
  inches %= 12

  feet = (feet || 0) + '\''
  inches = (inches || 0) + '"'

  // for minimum height display (22 or 23 inches)
  if ((feet == "1'" && inches == '10"') || feet == "1'" && inches == '11"') {
    feet = "< 2'"
    inches = '0"'
  }

  return feet + ' ' + inches
}

function getFullName (fname, lname) {
  return _.compact([fname || '', lname || '']).join(' ')
}

module.exports = talent

},{"./../values/resume_experience":425,"./../values/resume_performance":426,"lodash":429}],419:[function(require,module,exports){
module.exports=[
	"Average",
	"Athletic",
	"Muscular",
	"Extra-Large",
	"Large",
	"Lean-Muscle",
	"Medium",
	"Petite",
	"Slim"
]

},{}],420:[function(require,module,exports){
module.exports=[
	"African",
	"African American",
	"American Indian",
	"Asian",
	"Caucasian",
	"East Indian",
	"Hispanic",
	"Middle Eastern"
]

},{}],421:[function(require,module,exports){
module.exports={
	"Albany, NY": "yellow-marks",
	"Albuquerque, NM": "",
	"Atlanta, GA": "",
	"Augusta, ME": "",
	"Baltimore, MD": "",
	"Billings, MT": "",
	"Birmingham, AL": "",
	"Boise, ID": "",
	"Boston, MA": "",
	"Buffalo, NY": "",
	"Charleston, SC": "",
	"Charleston, WV": "",
	"Charlotte, NC": "",
	"Chicago, IL": "yellow-marks",
	"Cleveland, OH": "",
	"Columbia, SC": "",
	"Columbus, OH": "",
	"Dallas, TX": "",
	"Denver, CO": "",
	"Des Moines, IA": "",
	"Detroit, MI": "yellow-marks",
	"El Paso, TX": "",
	"Fargo, ND": "",
	"Grand Junction, CO": "",
	"Hartford, CT": "",
	"Honolulu, HI": "",
	"Houston, TX": "",
	"Indianapolis, IN": "",
	"Jackson, MS": "",
	"Jacksonville, FL": "",
	"Kansas City, KS": "",
	"Kansas City, MO": "",
	"Las Vegas, NV": "yellow-marks",
	"Little Rock, AR": "",
	"Los Angeles, CA": "yellow-marks",
	"Louisville, KY": "",
	"Memphis, TN": "",
	"Miami, FL": "",
	"Milwaukee, WI": "",
	"Minneapolis, MN": "",
	"Nashville, TN": "",
	"New Orleans, LA": "",
	"New York City, NY": "yellow-marks",
	"Norfolk, VA": "",
	"Oklahoma City, OK": "",
	"Omaha, NE": "",
	"Orlando, FL": "",
	"Philadelphia, PA": "",
	"Phoenix, AZ": "",
	"Pittsburgh, PA": "",
	"Portland, ME": "",
	"Portland, OR": "",
	"Raleigh, NC": "",
	"Rapid City, SD": "",
	"Reno, NV": "",
	"St Louis, MO": "",
	"Salt Lake City, UT": "",
	"San Antonio, TX": "",
	"San Diego, CA": "yellow-marks",
	"San Francisco, CA": "yellow-marks",
	"Seattle, WA": "",
	"Tampa, FL": "",
	"Washington, DC": "",
	"Wichita, KS": "",
	"All Markets": "all-markets",
	"Calgary-Edm, AB": "green-marks",
	"Ottawa, ON": "green-marks",
	"Montreal, QC": "green-marks",
	"Toronto, ON": "green-marks",
	"Vancouver, BC": "green-marks"
}

},{}],422:[function(require,module,exports){
module.exports=[
	null,
    "DJ",
    "Singer",
    "Song Writer",
    "Teacher",
    "Player",
    "Lyricist",
    "Sound Man",
    "Composer",
    "Conductor"
]

},{}],423:[function(require,module,exports){
module.exports={
	"43": "Acting - Acrobatics/Stunts",
	"41": "Acting - Comedy/Clown",
	"61": "Acting - Other",
	"42": "Acting - Variety Acts",
	"1": "Commercials",
	"16": "Crew - Assistant &amp; Entry Level",
	"49": "Crew - Acounting/Payroll/HR",
	"35": "Crew - Camera/Editor",
	"48": "Crew - Graphic/Web/Animate",
	"34": "Crew - Lighting/Sound",
	"37": "Crew - Make Up/ Stylist",
	"51": "Crew - Management",
	"25": "Crew - Marketing / PR",
	"38": "Crew - Other",
	"36": "Crew - Producer/Director",
	"40": "Crew - Showbiz Internship",
	"52": "Crew - Talent/Casting Mgmt",
	"50": "Crew - Technology/MIS",
	"47": "Crew - TV/Radio",
	"39": "Crew - Writing/Script/Edit",
	"3": "Dance - Ballet/Classic",
	"56": "Dance - Choreography",
	"54": "Dance - Club/Gogo",
	"53": "Dance - HipHop",
	"4": "Dance - Modern/Jazz",
	"58": "Dance - Other/General",
	"57": "Dance - Teacher",
	"55": "Dance - Traditional/Latin",
	"5": "Episodic TV - Pilots",
	"6": "Episodic TV - SAG",
	"7": "Episodic TV - AFTRA",
	"8": "Episodic TV - Non-Union",
	"60": "Extras",
	"9": "Feature Film - SAG",
	"10": "Feature Film - Non-SAG",
	"11": "Feature Film - Student Films",
	"12": "Feature Film - Short Film",
	"13": "Feature Film - Documentaries",
	"14": "Feature Film - Low Budget/Independent",
	"15": "Infomercials",
	"17": "Industrial/Traning Films",
	"27": "Internet",
	"18": "Modeling - Runway",
	"19": "Modeling - Hair/Cosmetics",
	"20": "Modeling - Print",
	"21": "Music Videos",
	"44": "Music - Band",
	"45": "Music - DJ/Sound",
	"30": "Music - Horns",
	"32": "Music - Drums",
	"31": "Music - Keyboards",
	"33": "Music - Other",
	"29": "Music - Strings",
	"46": "Music - Teacher",
	"28": "Music - Vocals",
	"59": "Reality TV",
	"22": "Theatre - Equity (Union)",
	"23": "Theatre - Non-Equity",
	"24": "Trade Shows/Live Events/Promo Model",
	"26": "Voice-Over"
}

},{}],424:[function(require,module,exports){
module.exports=[
	"Non-Union",
	"SAG",
	"AFTRA",
	"Equity",
	"AAE",
	"ACTRA",
	"AEA",
	"AEA",
	"AGMA",
	"AGVA",
	"BAE",
	"CAEA",
	"UBCP",
	"Union"
]

},{}],425:[function(require,module,exports){
module.exports={
	"0": "< 1 year",
	"1": "1 - 2 years",
	"2": "2 - 5 years",
	"5": "5 - 7 years",
	"7": "7 - 10 years",
	"10": "> 10 years"
}

},{}],426:[function(require,module,exports){
module.exports={
	"0": "0",
	"10": "< 10",
	"20": "10 - 20",
	"50": "20 - 50",
	"100": "50 - 100",
	"1000": "> 100"
}

},{}],427:[function(require,module,exports){
module.exports={
	"2": "acting",
	"3": "music",
	"4": "dance",
	"5": "social"
}

},{}],428:[function(require,module,exports){
module.exports={
	2: "primary",
	1: "secondary"
}

},{}],429:[function(require,module,exports){
(function (global){
/**
 * @license
 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern -d -o ./index.js`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '3.10.1';

  /** Used to compose bitmasks for wrapper metadata. */
  var BIND_FLAG = 1,
      BIND_KEY_FLAG = 2,
      CURRY_BOUND_FLAG = 4,
      CURRY_FLAG = 8,
      CURRY_RIGHT_FLAG = 16,
      PARTIAL_FLAG = 32,
      PARTIAL_RIGHT_FLAG = 64,
      ARY_FLAG = 128,
      REARG_FLAG = 256;

  /** Used as default options for `_.trunc`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect when a function becomes hot. */
  var HOT_COUNT = 150,
      HOT_SPAN = 16;

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2;

  /** Used as the `TypeError` message for "Functions" methods. */
  var FUNC_ERROR_TEXT = 'Expected a function';

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      objectTag = '[object Object]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      weakMapTag = '[object WeakMap]';

  var arrayBufferTag = '[object ArrayBuffer]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
      reUnescapedHtml = /[&<>"'`]/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;

  /**
   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
   */
  var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g,
      reHasRegExpChars = RegExp(reRegExpChars.source);

  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect hexadecimal string values. */
  var reHasHexPrefix = /^0[xX]/;

  /** Used to detect host constructors (Safari > 5). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^\d+$/;

  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to match words to create compound words. */
  var reWords = (function() {
    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';

    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
  }());

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'isFinite',
    'parseFloat', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
  cloneableTags[dateTag] = cloneableTags[float32Tag] =
  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[stringTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[mapTag] = cloneableTags[setTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map latin-1 supplementary letters to basic latin letters. */
  var deburredLetters = {
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '`': '&#96;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&#96;': '`'
  };

  /** Used to determine if values are of the language type `Object`. */
  var objectTypes = {
    'function': true,
    'object': true
  };

  /** Used to escape characters for inclusion in compiled regexes. */
  var regexpEscapes = {
    '0': 'x30', '1': 'x31', '2': 'x32', '3': 'x33', '4': 'x34',
    '5': 'x35', '6': 'x36', '7': 'x37', '8': 'x38', '9': 'x39',
    'A': 'x41', 'B': 'x42', 'C': 'x43', 'D': 'x44', 'E': 'x45', 'F': 'x46',
    'a': 'x61', 'b': 'x62', 'c': 'x63', 'd': 'x64', 'e': 'x65', 'f': 'x66',
    'n': 'x6e', 'r': 'x72', 't': 'x74', 'u': 'x75', 'v': 'x76', 'x': 'x78'
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Detect free variable `exports`. */
  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;

  /** Detect free variable `self`. */
  var freeSelf = objectTypes[typeof self] && self && self.Object && self;

  /** Detect free variable `window`. */
  var freeWindow = objectTypes[typeof window] && window && window.Object && window;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;

  /**
   * Used as a reference to the global object.
   *
   * The `this` value is used if it's the global object to avoid Greasemonkey's
   * restricted `window` object, otherwise the `window` object is used.
   */
  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;

  /*--------------------------------------------------------------------------*/

  /**
   * The base implementation of `compareAscending` which compares values and
   * sorts them in ascending order without guaranteeing a stable sort.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {number} Returns the sort order indicator for `value`.
   */
  function baseCompareAscending(value, other) {
    if (value !== other) {
      var valIsNull = value === null,
          valIsUndef = value === undefined,
          valIsReflexive = value === value;

      var othIsNull = other === null,
          othIsUndef = other === undefined,
          othIsReflexive = other === other;

      if ((value > other && !othIsNull) || !valIsReflexive ||
          (valIsNull && !othIsUndef && othIsReflexive) ||
          (valIsUndef && othIsReflexive)) {
        return 1;
      }
      if ((value < other && !valIsNull) || !othIsReflexive ||
          (othIsNull && !valIsUndef && valIsReflexive) ||
          (othIsUndef && valIsReflexive)) {
        return -1;
      }
    }
    return 0;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for callback shorthands and `this` binding.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {Function} predicate The function invoked per iteration.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromRight) {
    var length = array.length,
        index = fromRight ? length : -1;

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without support for binary searches.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    if (value !== value) {
      return indexOfNaN(array, fromIndex);
    }
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isFunction` without support for environments
   * with incorrect `typeof` results.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
   */
  function baseIsFunction(value) {
    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
    return typeof value == 'function' || false;
  }

  /**
   * Converts `value` to a string if it's not one. An empty string is returned
   * for `null` or `undefined` values.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */
  function baseToString(value) {
    return value == null ? '' : (value + '');
  }

  /**
   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
   * of `string` that is not found in `chars`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @param {string} chars The characters to find.
   * @returns {number} Returns the index of the first character not found in `chars`.
   */
  function charsLeftIndex(string, chars) {
    var index = -1,
        length = string.length;

    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimRight` to get the index of the last character
   * of `string` that is not found in `chars`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @param {string} chars The characters to find.
   * @returns {number} Returns the index of the last character not found in `chars`.
   */
  function charsRightIndex(string, chars) {
    var index = string.length;

    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
    return index;
  }

  /**
   * Used by `_.sortBy` to compare transformed elements of a collection and stable
   * sort them in ascending order.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @returns {number} Returns the sort order indicator for `object`.
   */
  function compareAscending(object, other) {
    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
  }

  /**
   * Used by `_.sortByOrder` to compare multiple properties of a value to another
   * and stable sort them.
   *
   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
   * a value is sorted in ascending order if its corresponding order is "asc", and
   * descending if "desc".
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {boolean[]} orders The order to sort by for each property.
   * @returns {number} Returns the sort order indicator for `object`.
   */
  function compareMultiple(object, other, orders) {
    var index = -1,
        objCriteria = object.criteria,
        othCriteria = other.criteria,
        length = objCriteria.length,
        ordersLength = orders.length;

    while (++index < length) {
      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
      if (result) {
        if (index >= ordersLength) {
          return result;
        }
        var order = orders[index];
        return result * ((order === 'asc' || order === true) ? 1 : -1);
      }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
  }

  /**
   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  function deburrLetter(letter) {
    return deburredLetters[letter];
  }

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeHtmlChar(chr) {
    return htmlEscapes[chr];
  }

  /**
   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @param {string} leadingChar The capture group for a leading character.
   * @param {string} whitespaceChar The capture group for a whitespace character.
   * @returns {string} Returns the escaped character.
   */
  function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
    if (leadingChar) {
      chr = regexpEscapes[chr];
    } else if (whitespaceChar) {
      chr = stringEscapes[chr];
    }
    return '\\' + chr;
  }

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the index at which the first occurrence of `NaN` is found in `array`.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
   */
  function indexOfNaN(array, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 0 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      var other = array[index];
      if (other !== other) {
        return index;
      }
    }
    return -1;
  }

  /**
   * Checks if `value` is object-like.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   */
  function isObjectLike(value) {
    return !!value && typeof value == 'object';
  }

  /**
   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
   * character code is whitespace.
   *
   * @private
   * @param {number} charCode The character code to inspect.
   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
   */
  function isSpace(charCode) {
    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = -1,
        result = [];

    while (++index < length) {
      if (array[index] === placeholder) {
        array[index] = PLACEHOLDER;
        result[++resIndex] = index;
      }
    }
    return result;
  }

  /**
   * An implementation of `_.uniq` optimized for sorted arrays without support
   * for callback shorthands and `this` binding.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} [iteratee] The function invoked per iteration.
   * @returns {Array} Returns the new duplicate-value-free array.
   */
  function sortedUniq(array, iteratee) {
    var seen,
        index = -1,
        length = array.length,
        resIndex = -1,
        result = [];

    while (++index < length) {
      var value = array[index],
          computed = iteratee ? iteratee(value, index, array) : value;

      if (!index || seen !== computed) {
        seen = computed;
        result[++resIndex] = value;
      }
    }
    return result;
  }

  /**
   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the first non-whitespace character.
   */
  function trimmedLeftIndex(string) {
    var index = -1,
        length = string.length;

    while (++index < length && isSpace(string.charCodeAt(index))) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedRightIndex(string) {
    var index = string.length;

    while (index-- && isSpace(string.charCodeAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  function unescapeHtmlChar(chr) {
    return htmlUnescapes[chr];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the given `context` object.
   *
   * @static
   * @memberOf _
   * @category Utility
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // using `context` to mock `Date#getTime` use in `_.now`
   * var mock = _.runInContext({
   *   'Date': function() {
   *     return { 'getTime': getTimeMock };
   *   }
   * });
   *
   * // or creating a suped-up `defer` in Node.js
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  function runInContext(context) {
    // Avoid issues with some ES3 environments that attempt to use values, named
    // after built-in constructors like `Object`, for the creation of literals.
    // ES5 clears this up by stating that literals must use built-in constructors.
    // See https://es5.github.io/#x11.1.5 for more details.
    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;

    /** Native constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Number = context.Number,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for native method references. */
    var arrayProto = Array.prototype,
        objectProto = Object.prototype,
        stringProto = String.prototype;

    /** Used to resolve the decompiled source of functions. */
    var fnToString = Function.prototype.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /**
     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
     * of values.
     */
    var objToString = objectProto.toString;

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Native method references. */
    var ArrayBuffer = context.ArrayBuffer,
        clearTimeout = context.clearTimeout,
        parseFloat = context.parseFloat,
        pow = Math.pow,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        Set = getNative(context, 'Set'),
        setTimeout = context.setTimeout,
        splice = arrayProto.splice,
        Uint8Array = context.Uint8Array,
        WeakMap = getNative(context, 'WeakMap');

    /* Native method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeCreate = getNative(Object, 'create'),
        nativeFloor = Math.floor,
        nativeIsArray = getNative(Array, 'isArray'),
        nativeIsFinite = context.isFinite,
        nativeKeys = getNative(Object, 'keys'),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = getNative(Date, 'now'),
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random;

    /** Used as references for `-Infinity` and `Infinity`. */
    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;

    /** Used as references for the maximum length and index of an array. */
    var MAX_ARRAY_LENGTH = 4294967295,
        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

    /**
     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
     * of an array-like value.
     */
    var MAX_SAFE_INTEGER = 9007199254740991;

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
     * Methods that operate on and return arrays, collections, and functions can
     * be chained together. Methods that retrieve a single value or may return a
     * primitive value will automatically end the chain returning the unwrapped
     * value. Explicit chaining may be enabled using `_.chain`. The execution of
     * chained methods is lazy, that is, execution is deferred until `_#value`
     * is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
     * fusion is an optimization strategy which merge iteratee calls; this can help
     * to avoid the creation of intermediate data structures and greatly reduce the
     * number of iteratee executions.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
     * `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
     * and `where`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
     * `unescape`, `uniqueId`, `value`, and `words`
     *
     * The wrapper method `sample` will return a wrapped value when `n` is provided,
     * otherwise an unwrapped value is returned.
     *
     * @name _
     * @constructor
     * @category Chain
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // returns an unwrapped value
     * wrapped.reduce(function(total, n) {
     *   return total + n;
     * });
     * // => 6
     *
     * // returns a wrapped value
     * var squares = wrapped.map(function(n) {
     *   return n * n;
     * });
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The function whose prototype all chaining wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
     */
    function LodashWrapper(value, chainAll, actions) {
      this.__wrapped__ = value;
      this.__actions__ = actions || [];
      this.__chain__ = !!chainAll;
    }

    /**
     * An object environment feature flags.
     *
     * @static
     * @memberOf _
     * @type Object
     */
    var support = lodash.support = {};

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB). Change the following template settings to use
     * alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type Object
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type string
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type Object
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type Function
         */
        '_': lodash
      }
    };

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = POSITIVE_INFINITY;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = arrayCopy(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = arrayCopy(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = arrayCopy(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || arrLength < LARGE_ARRAY_SIZE || (arrLength == length && takeCount == length)) {
        return baseWrapperValue((isRight && isArr) ? array.reverse() : array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a cache object to store key/value pairs.
     *
     * @private
     * @static
     * @name Cache
     * @memberOf _.memoize
     */
    function MapCache() {
      this.__data__ = {};
    }

    /**
     * Removes `key` and its value from the cache.
     *
     * @private
     * @name delete
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
     */
    function mapDelete(key) {
      return this.has(key) && delete this.__data__[key];
    }

    /**
     * Gets the cached value for `key`.
     *
     * @private
     * @name get
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the cached value.
     */
    function mapGet(key) {
      return key == '__proto__' ? undefined : this.__data__[key];
    }

    /**
     * Checks if a cached value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapHas(key) {
      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
    }

    /**
     * Sets `value` to `key` of the cache.
     *
     * @private
     * @name set
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to cache.
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache object.
     */
    function mapSet(key, value) {
      if (key != '__proto__') {
        this.__data__[key] = value;
      }
      return this;
    }

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates a cache object to store unique values.
     *
     * @private
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var length = values ? values.length : 0;

      this.data = { 'hash': nativeCreate(null), 'set': new Set };
      while (length--) {
        this.push(values[length]);
      }
    }

    /**
     * Checks if `value` is in `cache` mimicking the return signature of
     * `_.indexOf` by returning `0` if the value is found, else `-1`.
     *
     * @private
     * @param {Object} cache The cache to search.
     * @param {*} value The value to search for.
     * @returns {number} Returns `0` if `value` is found, else `-1`.
     */
    function cacheIndexOf(cache, value) {
      var data = cache.data,
          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];

      return result ? 0 : -1;
    }

    /**
     * Adds `value` to the cache.
     *
     * @private
     * @name push
     * @memberOf SetCache
     * @param {*} value The value to cache.
     */
    function cachePush(value) {
      var data = this.data;
      if (typeof value == 'string' || isObject(value)) {
        data.set.add(value);
      } else {
        data.hash[value] = true;
      }
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a new array joining `array` with `other`.
     *
     * @private
     * @param {Array} array The array to join.
     * @param {Array} other The other array to join.
     * @returns {Array} Returns the new concatenated array.
     */
    function arrayConcat(array, other) {
      var index = -1,
          length = array.length,
          othIndex = -1,
          othLength = other.length,
          result = Array(length + othLength);

      while (++index < length) {
        result[index] = array[index];
      }
      while (++othIndex < othLength) {
        result[index++] = other[othIndex];
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function arrayCopy(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * A specialized version of `_.forEach` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEach(array, iteratee) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (iteratee(array[index], index, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.forEachRight` for arrays without support for
     * callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEachRight(array, iteratee) {
      var length = array.length;

      while (length--) {
        if (iteratee(array[length], length, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.every` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     */
    function arrayEvery(array, predicate) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (!predicate(array[index], index, array)) {
          return false;
        }
      }
      return true;
    }

    /**
     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
     * with one argument: (value).
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {*} Returns the extremum value.
     */
    function arrayExtremum(array, iteratee, comparator, exValue) {
      var index = -1,
          length = array.length,
          computed = exValue,
          result = computed;

      while (++index < length) {
        var value = array[index],
            current = +iteratee(value);

        if (comparator(current, computed)) {
          computed = current;
          result = value;
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.filter` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function arrayFilter(array, predicate) {
      var index = -1,
          length = array.length,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result[++resIndex] = value;
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.map` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function arrayMap(array, iteratee) {
      var index = -1,
          length = array.length,
          result = Array(length);

      while (++index < length) {
        result[index] = iteratee(array[index], index, array);
      }
      return result;
    }

    /**
     * Appends the elements of `values` to `array`.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to append.
     * @returns {Array} Returns `array`.
     */
    function arrayPush(array, values) {
      var index = -1,
          length = values.length,
          offset = array.length;

      while (++index < length) {
        array[offset + index] = values[index];
      }
      return array;
    }

    /**
     * A specialized version of `_.reduce` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the first element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduce(array, iteratee, accumulator, initFromArray) {
      var index = -1,
          length = array.length;

      if (initFromArray && length) {
        accumulator = array[++index];
      }
      while (++index < length) {
        accumulator = iteratee(accumulator, array[index], index, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.reduceRight` for arrays without support for
     * callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the last element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
      var length = array.length;
      if (initFromArray && length) {
        accumulator = array[--length];
      }
      while (length--) {
        accumulator = iteratee(accumulator, array[length], length, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.some` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function arraySome(array, predicate) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (predicate(array[index], index, array)) {
          return true;
        }
      }
      return false;
    }

    /**
     * A specialized version of `_.sum` for arrays without support for callback
     * shorthands and `this` binding..
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */
    function arraySum(array, iteratee) {
      var length = array.length,
          result = 0;

      while (length--) {
        result += +iteratee(array[length]) || 0;
      }
      return result;
    }

    /**
     * Used by `_.defaults` to customize its `_.assign` use.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function assignDefaults(objectValue, sourceValue) {
      return objectValue === undefined ? sourceValue : objectValue;
    }

    /**
     * Used by `_.template` to customize its `_.assign` use.
     *
     * **Note:** This function is like `assignDefaults` except that it ignores
     * inherited property values when checking if a property is `undefined`.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @param {string} key The key associated with the object and source values.
     * @param {Object} object The destination object.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function assignOwnDefaults(objectValue, sourceValue, key, object) {
      return (objectValue === undefined || !hasOwnProperty.call(object, key))
        ? sourceValue
        : objectValue;
    }

    /**
     * A specialized version of `_.assign` for customizing assigned values without
     * support for argument juggling, multiple sources, and `this` binding `customizer`
     * functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     */
    function assignWith(object, source, customizer) {
      var index = -1,
          props = keys(source),
          length = props.length;

      while (++index < length) {
        var key = props[index],
            value = object[key],
            result = customizer(value, source[key], key, object, source);

        if ((result === result ? (result !== value) : (value === value)) ||
            (value === undefined && !(key in object))) {
          object[key] = result;
        }
      }
      return object;
    }

    /**
     * The base implementation of `_.assign` without support for argument juggling,
     * multiple sources, and `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return source == null
        ? object
        : baseCopy(source, keys(source), object);
    }

    /**
     * The base implementation of `_.at` without support for string collections
     * and individual key arguments.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {number[]|string[]} props The property names or indexes of elements to pick.
     * @returns {Array} Returns the new array of picked elements.
     */
    function baseAt(collection, props) {
      var index = -1,
          isNil = collection == null,
          isArr = !isNil && isArrayLike(collection),
          length = isArr ? collection.length : 0,
          propsLength = props.length,
          result = Array(propsLength);

      while(++index < propsLength) {
        var key = props[index];
        if (isArr) {
          result[index] = isIndex(key, length) ? collection[key] : undefined;
        } else {
          result[index] = isNil ? undefined : collection[key];
        }
      }
      return result;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property names to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @returns {Object} Returns `object`.
     */
    function baseCopy(source, props, object) {
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];
        object[key] = source[key];
      }
      return object;
    }

    /**
     * The base implementation of `_.callback` which supports specifying the
     * number of arguments to provide to `func`.
     *
     * @private
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */
    function baseCallback(func, thisArg, argCount) {
      var type = typeof func;
      if (type == 'function') {
        return thisArg === undefined
          ? func
          : bindCallback(func, thisArg, argCount);
      }
      if (func == null) {
        return identity;
      }
      if (type == 'object') {
        return baseMatches(func);
      }
      return thisArg === undefined
        ? property(func)
        : baseMatchesProperty(func, thisArg);
    }

    /**
     * The base implementation of `_.clone` without support for argument juggling
     * and `this` binding `customizer` functions.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The object `value` belongs to.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates clones with source counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
      var result;
      if (customizer) {
        result = object ? customizer(value, key, object) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return arrayCopy(value, result);
        }
      } else {
        var tag = objToString.call(value),
            isFunc = tag == funcTag;

        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = initCloneObject(isFunc ? {} : value);
          if (!isDeep) {
            return baseAssign(result, value);
          }
        } else {
          return cloneableTags[tag]
            ? initCloneByTag(value, tag, isDeep)
            : (object ? value : {});
        }
      }
      // Check for circular references and return its corresponding clone.
      stackA || (stackA = []);
      stackB || (stackB = []);

      var length = stackA.length;
      while (length--) {
        if (stackA[length] == value) {
          return stackB[length];
        }
      }
      // Add the source value to the stack of traversed objects and associate it with its clone.
      stackA.push(value);
      stackB.push(result);

      // Recursively populate clone (susceptible to call stack limits).
      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
      });
      return result;
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} prototype The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(prototype) {
        if (isObject(prototype)) {
          object.prototype = prototype;
          var result = new object;
          object.prototype = undefined;
        }
        return result || {};
      };
    }());

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts an index
     * of where to slice the arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Object} args The arguments provide to `func`.
     * @returns {number} Returns the timer id.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of `_.difference` which accepts a single array
     * of values to exclude.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values) {
      var length = array ? array.length : 0,
          result = [];

      if (!length) {
        return result;
      }
      var index = -1,
          indexOf = getIndexOf(),
          isCommon = indexOf == baseIndexOf,
          cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
          valuesLength = values.length;

      if (cache) {
        indexOf = cacheIndexOf;
        isCommon = false;
        values = cache;
      }
      outer:
      while (++index < length) {
        var value = array[index];

        if (isCommon && value === value) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === value) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (indexOf(values, value, 0) < 0) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * Gets the extremum value of `collection` invoking `iteratee` for each value
     * in `collection` to generate the criterion by which the value is ranked.
     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(collection, iteratee, comparator, exValue) {
      var computed = exValue,
          result = computed;

      baseEach(collection, function(value, index, collection) {
        var current = +iteratee(value, index, collection);
        if (comparator(current, computed) || (current === exValue && current === result)) {
          computed = current;
          result = value;
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = start == null ? 0 : (+start || 0);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : (+end || 0);
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : (end >>> 0);
      start >>>= 0;

      while (start < length) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
     * without support for callback shorthands and `this` binding, which iterates
     * over `collection` using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function} predicate The function invoked per iteration.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @param {boolean} [retKey] Specify returning the key of the found element
     *  instead of the element itself.
     * @returns {*} Returns the found element or its key, else `undefined`.
     */
    function baseFind(collection, predicate, eachFunc, retKey) {
      var result;
      eachFunc(collection, function(value, key, collection) {
        if (predicate(value, key, collection)) {
          result = retKey ? key : value;
          return false;
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with added support for restricting
     * flattening and specifying the start index.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, isDeep, isStrict, result) {
      result || (result = []);

      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index];
        if (isObjectLike(value) && isArrayLike(value) &&
            (isStrict || isArray(value) || isArguments(value))) {
          if (isDeep) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, isDeep, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForIn` and `baseForOwn` which iterates
     * over `object` properties returned by `keysFunc` invoking `iteratee` for
     * each property. Iteratee functions may exit iteration early by explicitly
     * returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forIn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForIn(object, iteratee) {
      return baseFor(object, iteratee, keysIn);
    }

    /**
     * The base implementation of `_.forOwn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from those provided.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the new array of filtered property names.
     */
    function baseFunctions(object, props) {
      var index = -1,
          length = props.length,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var key = props[index];
        if (isFunction(object[key])) {
          result[++resIndex] = key;
        }
      }
      return result;
    }

    /**
     * The base implementation of `get` without support for string paths
     * and default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path of the property to get.
     * @param {string} [pathKey] The key representation of path.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path, pathKey) {
      if (object == null) {
        return;
      }
      if (pathKey !== undefined && pathKey in toObject(object)) {
        path = [pathKey];
      }
      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[path[index++]];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `_.isEqual` without support for `this` binding
     * `customizer` functions.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = arrayTag,
          othTag = arrayTag;

      if (!objIsArr) {
        objTag = objToString.call(object);
        if (objTag == argsTag) {
          objTag = objectTag;
        } else if (objTag != objectTag) {
          objIsArr = isTypedArray(object);
        }
      }
      if (!othIsArr) {
        othTag = objToString.call(other);
        if (othTag == argsTag) {
          othTag = objectTag;
        } else if (othTag != objectTag) {
          othIsArr = isTypedArray(other);
        }
      }
      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && !(objIsArr || objIsObj)) {
        return equalByTag(object, other, objTag);
      }
      if (!isLoose) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
        }
      }
      if (!isSameTag) {
        return false;
      }
      // Assume cyclic values are equal.
      // For more information on detecting circular references see https://es5.github.io/#JO.
      stackA || (stackA = []);
      stackB || (stackB = []);

      var length = stackA.length;
      while (length--) {
        if (stackA[length] == object) {
          return stackB[length] == other;
        }
      }
      // Add `object` and `other` to the stack of traversed objects.
      stackA.push(object);
      stackB.push(other);

      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);

      stackA.pop();
      stackB.pop();

      return result;
    }

    /**
     * The base implementation of `_.isMatch` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} matchData The propery names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = toObject(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.map` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which does not clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        var key = matchData[0][0],
            value = matchData[0][1];

        return function(object) {
          if (object == null) {
            return false;
          }
          return object[key] === value && (value !== undefined || (key in toObject(object)));
        };
      }
      return function(object) {
        return baseIsMatch(object, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to compare.
     * @returns {Function} Returns the new function.
     */
    function baseMatchesProperty(path, srcValue) {
      var isArr = isArray(path),
          isCommon = isKey(path) && isStrictComparable(srcValue),
          pathKey = (path + '');

      path = toPath(path);
      return function(object) {
        if (object == null) {
          return false;
        }
        var key = pathKey;
        object = toObject(object);
        if ((isArr || !isCommon) && !(key in object)) {
          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
          if (object == null) {
            return false;
          }
          key = last(path);
          object = toObject(object);
        }
        return object[key] === srcValue
          ? (srcValue !== undefined || (key in object))
          : baseIsEqual(srcValue, object[key], undefined, true);
      };
    }

    /**
     * The base implementation of `_.merge` without support for argument juggling,
     * multiple sources, and `this` binding `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     * @returns {Object} Returns `object`.
     */
    function baseMerge(object, source, customizer, stackA, stackB) {
      if (!isObject(object)) {
        return object;
      }
      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
          props = isSrcArr ? undefined : keys(source);

      arrayEach(props || source, function(srcValue, key) {
        if (props) {
          key = srcValue;
          srcValue = source[key];
        }
        if (isObjectLike(srcValue)) {
          stackA || (stackA = []);
          stackB || (stackB = []);
          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
        }
        else {
          var value = object[key],
              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
              isCommon = result === undefined;

          if (isCommon) {
            result = srcValue;
          }
          if ((result !== undefined || (isSrcArr && !(key in object))) &&
              (isCommon || (result === result ? (result !== value) : (value === value)))) {
            object[key] = result;
          }
        }
      });
      return object;
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
      var length = stackA.length,
          srcValue = source[key];

      while (length--) {
        if (stackA[length] == srcValue) {
          object[key] = stackB[length];
          return;
        }
      }
      var value = object[key],
          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
          isCommon = result === undefined;

      if (isCommon) {
        result = srcValue;
        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
          result = isArray(value)
            ? value
            : (isArrayLike(value) ? arrayCopy(value) : []);
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          result = isArguments(value)
            ? toPlainObject(value)
            : (isPlainObject(value) ? value : {});
        }
        else {
          isCommon = false;
        }
      }
      // Add the source value to the stack of traversed objects and associate
      // it with its merged value.
      stackA.push(srcValue);
      stackB.push(result);

      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
      } else if (result === result ? (result !== value) : (value === value)) {
        object[key] = result;
      }
    }

    /**
     * The base implementation of `_.property` without support for deep paths.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @returns {Function} Returns the new function.
     */
    function baseProperty(key) {
      return function(object) {
        return object == null ? undefined : object[key];
      };
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     */
    function basePropertyDeep(path) {
      var pathKey = (path + '');
      path = toPath(path);
      return function(object) {
        return baseGet(object, path, pathKey);
      };
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * index arguments and capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0;
      while (length--) {
        var index = indexes[length];
        if (index != previous && isIndex(index)) {
          var previous = index;
          splice.call(array, index, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for argument juggling
     * and returning floating-point numbers.
     *
     * @private
     * @param {number} min The minimum possible value.
     * @param {number} max The maximum possible value.
     * @returns {number} Returns the random number.
     */
    function baseRandom(min, max) {
      return min + nativeFloor(nativeRandom() * (max - min + 1));
    }

    /**
     * The base implementation of `_.reduce` and `_.reduceRight` without support
     * for callback shorthands and `this` binding, which iterates over `collection`
     * using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} accumulator The initial value.
     * @param {boolean} initFromCollection Specify using the first or last element
     *  of `collection` as the initial value.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @returns {*} Returns the accumulated value.
     */
    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
      eachFunc(collection, function(value, index, collection) {
        accumulator = initFromCollection
          ? (initFromCollection = false, value)
          : iteratee(accumulator, value, index, collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `setData` without support for hot loop detection.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      start = start == null ? 0 : (+start || 0);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : (+end || 0);
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortBy` which uses `comparer` to define
     * the sort order of `array` and replaces criteria objects with their
     * corresponding values.
     *
     * @private
     * @param {Array} array The array to sort.
     * @param {Function} comparer The function to define sort order.
     * @returns {Array} Returns `array`.
     */
    function baseSortBy(array, comparer) {
      var length = array.length;

      array.sort(comparer);
      while (length--) {
        array[length] = array[length].value;
      }
      return array;
    }

    /**
     * The base implementation of `_.sortByOrder` without param guards.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {boolean[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseSortByOrder(collection, iteratees, orders) {
      var callback = getCallback(),
          index = -1;

      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });

      var result = baseMap(collection, function(value) {
        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.sum` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */
    function baseSum(collection, iteratee) {
      var result = 0;
      baseEach(collection, function(value, index, collection) {
        result += +iteratee(value, index, collection) || 0;
      });
      return result;
    }

    /**
     * The base implementation of `_.uniq` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The function invoked per iteration.
     * @returns {Array} Returns the new duplicate-value-free array.
     */
    function baseUniq(array, iteratee) {
      var index = -1,
          indexOf = getIndexOf(),
          length = array.length,
          isCommon = indexOf == baseIndexOf,
          isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
          seen = isLarge ? createCache() : null,
          result = [];

      if (seen) {
        indexOf = cacheIndexOf;
        isCommon = false;
      } else {
        isLarge = false;
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value, index, array) : value;

        if (isCommon && value === value) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (indexOf(seen, computed, 0) < 0) {
          if (iteratee || isLarge) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.values` and `_.valuesIn` which creates an
     * array of `object` property values corresponding to the property names
     * of `props`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} props The property names to get values for.
     * @returns {Object} Returns the array of property values.
     */
    function baseValues(object, props) {
      var index = -1,
          length = props.length,
          result = Array(length);

      while (++index < length) {
        result[index] = object[props[index]];
      }
      return result;
    }

    /**
     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
     * and `_.takeWhile` without support for callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to peform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      var index = -1,
          length = actions.length;

      while (++index < length) {
        var action = actions[index];
        result = action.func.apply(action.thisArg, arrayPush([result], action.args));
      }
      return result;
    }

    /**
     * Performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function binaryIndex(array, value, retHighest) {
      var low = 0,
          high = array ? array.length : low;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return binaryIndexBy(array, value, identity, retHighest);
    }

    /**
     * This function is like `binaryIndex` except that it invokes `iteratee` for
     * `value` and each element of `array` to compute their sort ranking. The
     * iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function binaryIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array ? array.length : 0,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsUndef = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            isDef = computed !== undefined,
            isReflexive = computed === computed;

        if (valIsNaN) {
          var setLow = isReflexive || retHighest;
        } else if (valIsNull) {
          setLow = isReflexive && isDef && (retHighest || computed != null);
        } else if (valIsUndef) {
          setLow = isReflexive && (retHighest || isDef);
        } else if (computed == null) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * A specialized version of `baseCallback` which only supports `this` binding
     * and specifying the number of arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */
    function bindCallback(func, thisArg, argCount) {
      if (typeof func != 'function') {
        return identity;
      }
      if (thisArg === undefined) {
        return func;
      }
      switch (argCount) {
        case 1: return function(value) {
          return func.call(thisArg, value);
        };
        case 3: return function(value, index, collection) {
          return func.call(thisArg, value, index, collection);
        };
        case 4: return function(accumulator, value, index, collection) {
          return func.call(thisArg, accumulator, value, index, collection);
        };
        case 5: return function(value, other, key, object, source) {
          return func.call(thisArg, value, other, key, object, source);
        };
      }
      return function() {
        return func.apply(thisArg, arguments);
      };
    }

    /**
     * Creates a clone of the given array buffer.
     *
     * @private
     * @param {ArrayBuffer} buffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function bufferClone(buffer) {
      var result = new ArrayBuffer(buffer.byteLength),
          view = new Uint8Array(result);

      view.set(new Uint8Array(buffer));
      return result;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders) {
      var holdersLength = holders.length,
          argsIndex = -1,
          argsLength = nativeMax(args.length - holdersLength, 0),
          leftIndex = -1,
          leftLength = partials.length,
          result = Array(leftLength + argsLength);

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        result[holders[argsIndex]] = args[argsIndex];
      }
      while (argsLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders) {
      var holdersIndex = -1,
          holdersLength = holders.length,
          argsIndex = -1,
          argsLength = nativeMax(args.length - holdersLength, 0),
          rightIndex = -1,
          rightLength = partials.length,
          result = Array(argsLength + rightLength);

      while (++argsIndex < argsLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        result[offset + holders[holdersIndex]] = args[argsIndex++];
      }
      return result;
    }

    /**
     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
     *
     * @private
     * @param {Function} setter The function to set keys and values of the accumulator object.
     * @param {Function} [initializer] The function to initialize the accumulator object.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee, thisArg) {
        var result = initializer ? initializer() : {};
        iteratee = getCallback(iteratee, thisArg, 3);

        if (isArray(collection)) {
          var index = -1,
              length = collection.length;

          while (++index < length) {
            var value = collection[index];
            setter(result, value, iteratee(value, index, collection), collection);
          }
        } else {
          baseEach(collection, function(value, key, collection) {
            setter(result, value, iteratee(value, key, collection), collection);
          });
        }
        return result;
      };
    }

    /**
     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return restParam(function(object, sources) {
        var index = -1,
            length = object == null ? 0 : sources.length,
            customizer = length > 2 ? sources[length - 2] : undefined,
            guard = length > 2 ? sources[2] : undefined,
            thisArg = length > 1 ? sources[length - 1] : undefined;

        if (typeof customizer == 'function') {
          customizer = bindCallback(customizer, thisArg, 5);
          length -= 2;
        } else {
          customizer = typeof thisArg == 'function' ? thisArg : undefined;
          length -= (customizer ? 1 : 0);
        }
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        var length = collection ? getLength(collection) : 0;
        if (!isLength(length)) {
          return eachFunc(collection, iteratee);
        }
        var index = fromRight ? length : -1,
            iterable = toObject(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var iterable = toObject(object),
            props = keysFunc(object),
            length = props.length,
            index = fromRight ? length : -1;

        while ((fromRight ? index-- : ++index < length)) {
          var key = props[index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` and invokes it with the `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new bound function.
     */
    function createBindWrapper(func, thisArg) {
      var Ctor = createCtorWrapper(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(thisArg, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a `Set` cache object to optimize linear searches of large arrays.
     *
     * @private
     * @param {Array} [values] The values to cache.
     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
     */
    function createCache(values) {
      return (nativeCreate && Set) ? new SetCache(values) : null;
    }

    /**
     * Creates a function that produces compound words out of the words in a
     * given string.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        var index = -1,
            array = words(deburr(string)),
            length = array.length,
            result = '';

        while (++index < length) {
          result = callback(result, array[index], index);
        }
        return result;
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtorWrapper(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors.
        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a `_.curry` or `_.curryRight` function.
     *
     * @private
     * @param {boolean} flag The curry bit flag.
     * @returns {Function} Returns the new curry function.
     */
    function createCurry(flag) {
      function curryFunc(func, arity, guard) {
        if (guard && isIterateeCall(func, arity, guard)) {
          arity = undefined;
        }
        var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
        result.placeholder = curryFunc.placeholder;
        return result;
      }
      return curryFunc;
    }

    /**
     * Creates a `_.defaults` or `_.defaultsDeep` function.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Function} Returns the new defaults function.
     */
    function createDefaults(assigner, customizer) {
      return restParam(function(args) {
        var object = args[0];
        if (object == null) {
          return object;
        }
        args.push(customizer);
        return assigner.apply(undefined, args);
      });
    }

    /**
     * Creates a `_.max` or `_.min` function.
     *
     * @private
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {Function} Returns the new extremum function.
     */
    function createExtremum(comparator, exValue) {
      return function(collection, iteratee, thisArg) {
        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
          iteratee = undefined;
        }
        iteratee = getCallback(iteratee, thisArg, 3);
        if (iteratee.length == 1) {
          collection = isArray(collection) ? collection : toIterable(collection);
          var result = arrayExtremum(collection, iteratee, comparator, exValue);
          if (!(collection.length && result === exValue)) {
            return result;
          }
        }
        return baseExtremum(collection, iteratee, comparator, exValue);
      };
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */
    function createFind(eachFunc, fromRight) {
      return function(collection, predicate, thisArg) {
        predicate = getCallback(predicate, thisArg, 3);
        if (isArray(collection)) {
          var index = baseFindIndex(collection, predicate, fromRight);
          return index > -1 ? collection[index] : undefined;
        }
        return baseFind(collection, predicate, eachFunc);
      };
    }

    /**
     * Creates a `_.findIndex` or `_.findLastIndex` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */
    function createFindIndex(fromRight) {
      return function(array, predicate, thisArg) {
        if (!(array && array.length)) {
          return -1;
        }
        predicate = getCallback(predicate, thisArg, 3);
        return baseFindIndex(array, predicate, fromRight);
      };
    }

    /**
     * Creates a `_.findKey` or `_.findLastKey` function.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new find function.
     */
    function createFindKey(objectFunc) {
      return function(object, predicate, thisArg) {
        predicate = getCallback(predicate, thisArg, 3);
        return baseFind(object, predicate, objectFunc, true);
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return function() {
        var wrapper,
            length = arguments.length,
            index = fromRight ? length : -1,
            leftIndex = 0,
            funcs = Array(length);

        while ((fromRight ? index-- : ++index < length)) {
          var func = funcs[leftIndex++] = arguments[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
            wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? -1 : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      };
    }

    /**
     * Creates a function for `_.forEach` or `_.forEachRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */
    function createForEach(arrayFunc, eachFunc) {
      return function(collection, iteratee, thisArg) {
        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
          ? arrayFunc(collection, iteratee)
          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
      };
    }

    /**
     * Creates a function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new each function.
     */
    function createForIn(objectFunc) {
      return function(object, iteratee, thisArg) {
        if (typeof iteratee != 'function' || thisArg !== undefined) {
          iteratee = bindCallback(iteratee, thisArg, 3);
        }
        return objectFunc(object, iteratee, keysIn);
      };
    }

    /**
     * Creates a function for `_.forOwn` or `_.forOwnRight`.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new each function.
     */
    function createForOwn(objectFunc) {
      return function(object, iteratee, thisArg) {
        if (typeof iteratee != 'function' || thisArg !== undefined) {
          iteratee = bindCallback(iteratee, thisArg, 3);
        }
        return objectFunc(object, iteratee);
      };
    }

    /**
     * Creates a function for `_.mapKeys` or `_.mapValues`.
     *
     * @private
     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
     * @returns {Function} Returns the new map function.
     */
    function createObjectMapper(isMapKeys) {
      return function(object, iteratee, thisArg) {
        var result = {};
        iteratee = getCallback(iteratee, thisArg, 3);

        baseForOwn(object, function(value, key, object) {
          var mapped = iteratee(value, key, object);
          key = isMapKeys ? mapped : key;
          value = isMapKeys ? value : mapped;
          result[key] = value;
        });
        return result;
      };
    }

    /**
     * Creates a function for `_.padLeft` or `_.padRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify padding from the right.
     * @returns {Function} Returns the new pad function.
     */
    function createPadDir(fromRight) {
      return function(string, length, chars) {
        string = baseToString(string);
        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
      };
    }

    /**
     * Creates a `_.partial` or `_.partialRight` function.
     *
     * @private
     * @param {boolean} flag The partial bit flag.
     * @returns {Function} Returns the new partial function.
     */
    function createPartial(flag) {
      var partialFunc = restParam(function(func, partials) {
        var holders = replaceHolders(partials, partialFunc.placeholder);
        return createWrapper(func, flag, undefined, partials, holders);
      });
      return partialFunc;
    }

    /**
     * Creates a function for `_.reduce` or `_.reduceRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */
    function createReduce(arrayFunc, eachFunc) {
      return function(collection, iteratee, accumulator, thisArg) {
        var initFromArray = arguments.length < 3;
        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
      };
    }

    /**
     * Creates a function that wraps `func` and invokes it with optional `this`
     * binding of, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & ARY_FLAG,
          isBind = bitmask & BIND_FLAG,
          isBindKey = bitmask & BIND_KEY_FLAG,
          isCurry = bitmask & CURRY_FLAG,
          isCurryBound = bitmask & CURRY_BOUND_FLAG,
          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
          Ctor = isBindKey ? undefined : createCtorWrapper(func);

      function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it to other functions.
        var length = arguments.length,
            index = length,
            args = Array(length);

        while (index--) {
          args[index] = arguments[index];
        }
        if (partials) {
          args = composeArgs(args, partials, holders);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight);
        }
        if (isCurry || isCurryRight) {
          var placeholder = wrapper.placeholder,
              argsHolders = replaceHolders(args, placeholder);

          length -= argsHolders.length;
          if (length < arity) {
            var newArgPos = argPos ? arrayCopy(argPos) : undefined,
                newArity = nativeMax(arity - length, 0),
                newsHolders = isCurry ? argsHolders : undefined,
                newHoldersRight = isCurry ? undefined : argsHolders,
                newPartials = isCurry ? args : undefined,
                newPartialsRight = isCurry ? undefined : args;

            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);

            if (!isCurryBound) {
              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
            }
            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
                result = createHybridWrapper.apply(undefined, newData);

            if (isLaziable(func)) {
              setData(result, newData);
            }
            result.placeholder = placeholder;
            return result;
          }
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        if (argPos) {
          args = reorder(args, argPos);
        }
        if (isAry && ary < args.length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtorWrapper(func);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates the padding required for `string` based on the given `length`.
     * The `chars` string is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {string} string The string to create padding for.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the pad for `string`.
     */
    function createPadding(string, length, chars) {
      var strLength = string.length;
      length = +length;

      if (strLength >= length || !nativeIsFinite(length)) {
        return '';
      }
      var padLength = length - strLength;
      chars = chars == null ? ' ' : (chars + '');
      return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
    }

    /**
     * Creates a function that wraps `func` and invokes it with the optional `this`
     * binding of `thisArg` and the `partials` prepended to those provided to
     * the wrapper.
     *
     * @private
     * @param {Function} func The function to partially apply arguments to.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to the new function.
     * @returns {Function} Returns the new bound function.
     */
    function createPartialWrapper(func, bitmask, thisArg, partials) {
      var isBind = bitmask & BIND_FLAG,
          Ctor = createCtorWrapper(func);

      function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it `func`.
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength);

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        precision = precision === undefined ? 0 : (+precision || 0);
        if (precision) {
          precision = pow(10, precision);
          return func(number * precision) / precision;
        }
        return func(number);
      };
    }

    /**
     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
     *
     * @private
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {Function} Returns the new index function.
     */
    function createSortedIndex(retHighest) {
      return function(array, value, iteratee, thisArg) {
        var callback = getCallback(iteratee);
        return (iteratee == null && callback === baseCallback)
          ? binaryIndex(array, value, retHighest)
          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags.
     *  The bitmask may be composed of the following flags:
     *     1 - `_.bind`
     *     2 - `_.bindKey`
     *     4 - `_.curry` or `_.curryRight` of a bound function
     *     8 - `_.curry`
     *    16 - `_.curryRight`
     *    32 - `_.partial`
     *    64 - `_.partialRight`
     *   128 - `_.rearg`
     *   256 - `_.ary`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      length -= (holders ? holders.length : 0);
      if (bitmask & PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func),
          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];

      if (data) {
        mergeData(newData, data);
        bitmask = newData[1];
        arity = newData[9];
      }
      newData[9] = arity == null
        ? (isBindKey ? 0 : func.length)
        : (nativeMax(arity - length, 0) || 0);

      if (bitmask == BIND_FLAG) {
        var result = createBindWrapper(newData[0], newData[2]);
      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
        result = createPartialWrapper.apply(undefined, newData);
      } else {
        result = createHybridWrapper.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setter(result, newData);
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing arrays.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var index = -1,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
        return false;
      }
      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index],
            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;

        if (result !== undefined) {
          if (result) {
            continue;
          }
          return false;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (isLoose) {
          if (!arraySome(other, function(othValue) {
                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
              })) {
            return false;
          }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
          return false;
        }
      }
      return true;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag) {
      switch (tag) {
        case boolTag:
        case dateTag:
          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
          return +object == +other;

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case numberTag:
          // Treat `NaN` vs. `NaN` as equal.
          return (object != +object)
            ? other != +other
            : object == +other;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings primitives and string
          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
          return object == (other + '');
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var objProps = keys(object),
          objLength = objProps.length,
          othProps = keys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isLoose) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      var skipCtor = isLoose;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key],
            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;

        // Recursively compare objects (susceptible to call stack limits).
        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
          return false;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (!skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Gets the appropriate "callback" function. If the `_.callback` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseCallback` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function} Returns the chosen function or its result.
     */
    function getCallback(func, thisArg, argCount) {
      var result = lodash.callback || callback;
      result = result === callback ? baseCallback : result;
      return argCount ? result(func, thisArg, argCount) : result;
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = func.name,
          array = realNames[result],
          length = array ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseIndexOf` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function|number} Returns the chosen function or its result.
     */
    function getIndexOf(collection, target, fromIndex) {
      var result = lodash.indexOf || indexOf;
      result = result === indexOf ? baseIndexOf : result;
      return collection ? result(collection, target, fromIndex) : result;
    }

    /**
     * Gets the "length" property value of `object`.
     *
     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
     * that affects Safari on at least iOS 8.1-8.3 ARM64.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {*} Returns the "length" value.
     */
    var getLength = baseProperty('length');

    /**
     * Gets the propery names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = pairs(object),
          length = result.length;

      while (length--) {
        result[length][2] = isStrictComparable(result[length][1]);
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = object == null ? undefined : object[key];
      return isNative(value) ? value : undefined;
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add array properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      var Ctor = object.constructor;
      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
        Ctor = Object;
      }
      return new Ctor;
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return bufferClone(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          var buffer = object.buffer;
          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          var result = new Ctor(object.source, reFlags.exec(object));
          result.lastIndex = object.lastIndex;
      }
      return result;
    }

    /**
     * Invokes the method at `path` on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function invokePath(object, path, args) {
      if (object != null && !isKey(path, object)) {
        path = toPath(path);
        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
        path = last(path);
      }
      var func = object == null ? object : object[path];
      return func == null ? undefined : func.apply(object, args);
    }

    /**
     * Checks if `value` is array-like.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     */
    function isArrayLike(value) {
      return value != null && isLength(getLength(value));
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
      length = length == null ? MAX_SAFE_INTEGER : length;
      return value > -1 && value % 1 == 0 && value < length;
    }

    /**
     * Checks if the provided arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
          ? (isArrayLike(object) && isIndex(index, object.length))
          : (type == 'string' && index in object)) {
        var other = object[index];
        return value === value ? (value === other) : (other !== other);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      var type = typeof value;
      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
        return true;
      }
      if (isArray(value)) {
        return false;
      }
      var result = !reIsDeepProp.test(value);
      return result || (object != null && value in toObject(object));
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func);
      if (!(funcName in LazyWrapper.prototype)) {
        return false;
      }
      var other = lodash[funcName];
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     */
    function isLength(value) {
      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers required to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
     * augment function arguments, making the order in which they are executed important,
     * preventing the merging of metadata. However, we make an exception for a safe
     * common case where curried functions have `_.ary` and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < ARY_FLAG;

      var isCombo =
        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = arrayCopy(value);
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function mergeDefaults(objectValue, sourceValue) {
      return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
    }

    /**
     * A specialized version of `_.pick` which picks `object` properties specified
     * by `props`.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} props The property names to pick.
     * @returns {Object} Returns the new object.
     */
    function pickByArray(object, props) {
      object = toObject(object);

      var index = -1,
          length = props.length,
          result = {};

      while (++index < length) {
        var key = props[index];
        if (key in object) {
          result[key] = object[key];
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.pick` which picks `object` properties `predicate`
     * returns truthy for.
     *
     * @private
     * @param {Object} object The source object.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Object} Returns the new object.
     */
    function pickByCallback(object, predicate) {
      var result = {};
      baseForIn(object, function(value, key, object) {
        if (predicate(value, key, object)) {
          result[key] = value;
        }
      });
      return result;
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = arrayCopy(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity function
     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = (function() {
      var count = 0,
          lastCalled = 0;

      return function(key, value) {
        var stamp = now(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return key;
          }
        } else {
          count = 0;
        }
        return baseSetData(key, value);
      };
    }());

    /**
     * A fallback implementation of `Object.keys` which creates an array of the
     * own enumerable property names of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function shimKeys(object) {
      var props = keysIn(object),
          propsLength = props.length,
          length = propsLength && object.length;

      var allowIndexes = !!length && isLength(length) &&
        (isArray(object) || isArguments(object));

      var index = -1,
          result = [];

      while (++index < propsLength) {
        var key = props[index];
        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to an array-like object if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array|Object} Returns the array-like object.
     */
    function toIterable(value) {
      if (value == null) {
        return [];
      }
      if (!isArrayLike(value)) {
        return values(value);
      }
      return isObject(value) ? value : Object(value);
    }

    /**
     * Converts `value` to an object if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Object} Returns the object.
     */
    function toObject(value) {
      return isObject(value) ? value : Object(value);
    }

    /**
     * Converts `value` to property path array if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array} Returns the property path array.
     */
    function toPath(value) {
      if (isArray(value)) {
        return value;
      }
      var result = [];
      baseToString(value).replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      return wrapper instanceof LazyWrapper
        ? wrapper.clone()
        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `collection` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the new array containing chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if (guard ? isIterateeCall(array, size, guard) : size == null) {
        size = 1;
      } else {
        size = nativeMax(nativeFloor(size) || 1, 1);
      }
      var index = 0,
          length = array ? array.length : 0,
          resIndex = -1,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[++resIndex] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array ? array.length : 0,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[++resIndex] = value;
        }
      }
      return result;
    }

    /**
     * Creates an array of unique `array` values not included in the other
     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The arrays of values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.difference([1, 2, 3], [4, 2]);
     * // => [1, 3]
     */
    var difference = restParam(function(array, values) {
      return (isObjectLike(array) && isArrayLike(array))
        ? baseDifference(array, baseFlatten(values, false, true))
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      return baseSlice(array, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      n = length - (+n || 0);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that match the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRightWhile([1, 2, 3], function(n) {
     *   return n > 1;
     * });
     * // => [1]
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
     * // => ['barney', 'fred']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
     * // => ['barney']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropWhile([1, 2, 3], function(n) {
     *   return n < 3;
     * });
     * // => [3]
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
     * // => ['fred', 'pebbles']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.dropWhile(users, 'active', false), 'user');
     * // => ['pebbles']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.dropWhile(users, 'active'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8], '*', 1, 2);
     * // => [4, '*', 8]
     */
    function fill(array, value, start, end) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(chr) {
     *   return chr.user == 'barney';
     * });
     * // => 0
     *
     * // using the `_.matches` callback shorthand
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findIndex(users, 'active', false);
     * // => 0
     *
     * // using the `_.property` callback shorthand
     * _.findIndex(users, 'active');
     * // => 2
     */
    var findIndex = createFindIndex();

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(chr) {
     *   return chr.user == 'pebbles';
     * });
     * // => 2
     *
     * // using the `_.matches` callback shorthand
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findLastIndex(users, 'active', false);
     * // => 2
     *
     * // using the `_.property` callback shorthand
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    var findLastIndex = createFindIndex(true);

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias head
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.first([1, 2, 3]);
     * // => 1
     *
     * _.first([]);
     * // => undefined
     */
    function first(array) {
      return array ? array[0] : undefined;
    }

    /**
     * Flattens a nested array. If `isDeep` is `true` the array is recursively
     * flattened, otherwise it is only flattened a single level.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, 3, [4]]]);
     * // => [1, 2, 3, [4]]
     *
     * // using `isDeep`
     * _.flatten([1, [2, 3, [4]]], true);
     * // => [1, 2, 3, 4]
     */
    function flatten(array, isDeep, guard) {
      var length = array ? array.length : 0;
      if (guard && isIterateeCall(array, isDeep, guard)) {
        isDeep = false;
      }
      return length ? baseFlatten(array, isDeep) : [];
    }

    /**
     * Recursively flattens a nested array.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to recursively flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, 3, [4]]]);
     * // => [1, 2, 3, 4]
     */
    function flattenDeep(array) {
      var length = array ? array.length : 0;
      return length ? baseFlatten(array, true) : [];
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
     * performs a faster binary search.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
     *  to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // using `fromIndex`
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     *
     * // performing a binary search
     * _.indexOf([1, 1, 2, 2], 2, true);
     * // => 2
     */
    function indexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      if (typeof fromIndex == 'number') {
        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
      } else if (fromIndex) {
        var index = binaryIndex(array, value);
        if (index < length &&
            (value === value ? (value === array[index]) : (array[index] !== array[index]))) {
          return index;
        }
        return -1;
      }
      return baseIndexOf(array, value, fromIndex || 0);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      return dropRight(array, 1);
    }

    /**
     * Creates an array of unique values that are included in all of the provided
     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of shared values.
     * @example
     * _.intersection([1, 2], [4, 2], [2, 1]);
     * // => [2]
     */
    var intersection = restParam(function(arrays) {
      var othLength = arrays.length,
          othIndex = othLength,
          caches = Array(length),
          indexOf = getIndexOf(),
          isCommon = indexOf == baseIndexOf,
          result = [];

      while (othIndex--) {
        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
      }
      var array = arrays[0],
          index = -1,
          length = array ? array.length : 0,
          seen = caches[0];

      outer:
      while (++index < length) {
        value = array[index];
        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
          var othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(value);
          }
          result.push(value);
        }
      }
      return result;
    });

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array ? array.length : 0;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
     *  or `true` to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // using `fromIndex`
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     *
     * // performing a binary search
     * _.lastIndexOf([1, 1, 2, 2], 2, true);
     * // => 3
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      var index = length;
      if (typeof fromIndex == 'number') {
        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
      } else if (fromIndex) {
        index = binaryIndex(array, value, true) - 1;
        var other = array[index];
        if (value === value ? (value === other) : (other !== other)) {
          return index;
        }
        return -1;
      }
      if (value !== value) {
        return indexOfNaN(array, index, true);
      }
      while (index--) {
        if (array[index] === value) {
          return index;
        }
      }
      return -1;
    }

    /**
     * Removes all provided values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3, 1, 2, 3];
     *
     * _.pull(array, 2, 3);
     * console.log(array);
     * // => [1, 1]
     */
    function pull() {
      var args = arguments,
          array = args[0];

      if (!(array && array.length)) {
        return array;
      }
      var index = 0,
          indexOf = getIndexOf(),
          length = args.length;

      while (++index < length) {
        var fromIndex = 0,
            value = args[index];

        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * Removes elements from `array` corresponding to the given indexes and returns
     * an array of the removed elements. Indexes may be specified as an array of
     * indexes or as individual arguments.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
     *  specified as individual indexes or arrays of indexes.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [5, 10, 15, 20];
     * var evens = _.pullAt(array, 1, 3);
     *
     * console.log(array);
     * // => [5, 15]
     *
     * console.log(evens);
     * // => [10, 20]
     */
    var pullAt = restParam(function(array, indexes) {
      indexes = baseFlatten(indexes);

      var result = baseAt(array, indexes);
      basePullAt(array, indexes.sort(baseCompareAscending));
      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is bound to
     * `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate, thisArg) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getCallback(predicate, thisArg, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias tail
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.rest([1, 2, 3]);
     * // => [2, 3]
     */
    function rest(array) {
      return drop(array, 1);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of `Array#slice` to support node
     * lists in IE < 9 and to ensure dense arrays are returned.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value` should
     * be inserted into `array` in order to maintain its sort order. If an iteratee
     * function is provided it is invoked for `value` and each element of `array`
     * to compute their sort ranking. The iteratee is bound to `thisArg` and
     * invoked with one argument; (value).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     *
     * _.sortedIndex([4, 4, 5, 5], 5);
     * // => 2
     *
     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
     *
     * // using an iteratee function
     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
     *   return this.data[word];
     * }, dict);
     * // => 1
     *
     * // using the `_.property` callback shorthand
     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
     * // => 1
     */
    var sortedIndex = createSortedIndex();

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 4, 5, 5], 5);
     * // => 4
     */
    var sortedLastIndex = createSortedIndex(true);

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      n = length - (+n || 0);
      return baseSlice(array, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
     * and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRightWhile([1, 2, 3], function(n) {
     *   return n > 1;
     * });
     * // => [2, 3]
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
     * // => ['pebbles']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
     * // => ['fred', 'pebbles']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
     * // => []
     */
    function takeRightWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is bound to
     * `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeWhile([1, 2, 3], function(n) {
     *   return n < 3;
     * });
     * // => [1, 2]
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false},
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.takeWhile(users, 'active', false), 'user');
     * // => ['barney', 'fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.takeWhile(users, 'active'), 'user');
     * // => []
     */
    function takeWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all of the provided arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([1, 2], [4, 2], [2, 1]);
     * // => [1, 2, 4]
     */
    var union = restParam(function(arrays) {
      return baseUniq(baseFlatten(arrays, false, true));
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurence of each element
     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
     * for sorted arrays. If an iteratee function is provided it is invoked for
     * each element in the array to generate the criterion by which uniqueness
     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, array).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias unique
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {boolean} [isSorted] Specify the array is sorted.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new duplicate-value-free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     *
     * // using `isSorted`
     * _.uniq([1, 1, 2], true);
     * // => [1, 2]
     *
     * // using an iteratee function
     * _.uniq([1, 2.5, 1.5, 2], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => [1, 2.5]
     *
     * // using the `_.property` callback shorthand
     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniq(array, isSorted, iteratee, thisArg) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (isSorted != null && typeof isSorted != 'boolean') {
        thisArg = iteratee;
        iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
        isSorted = false;
      }
      var callback = getCallback();
      if (!(iteratee == null && callback === baseCallback)) {
        iteratee = callback(iteratee, thisArg, 3);
      }
      return (isSorted && getIndexOf() == baseIndexOf)
        ? sortedUniq(array, iteratee)
        : baseUniq(array, iteratee);
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     *
     * _.unzip(zipped);
     * // => [['fred', 'barney'], [30, 40], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var index = -1,
          length = 0;

      array = arrayFilter(array, function(group) {
        if (isArrayLike(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      var result = Array(length);
      while (++index < length) {
        result[index] = arrayMap(array, baseProperty(index));
      }
      return result;
    }

    /**
     * This method is like `_.unzip` except that it accepts an iteratee to specify
     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
     * and invoked with four arguments: (accumulator, value, index, group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee] The function to combine regrouped values.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee, thisArg) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      iteratee = bindCallback(iteratee, thisArg, 4);
      return arrayMap(result, function(group) {
        return arrayReduce(group, iteratee, undefined, true);
      });
    }

    /**
     * Creates an array excluding all provided values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to filter.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.without([1, 2, 1, 3], 1, 2);
     * // => [3]
     */
    var without = restParam(function(array, values) {
      return isArrayLike(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the provided arrays.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of values.
     * @example
     *
     * _.xor([1, 2], [4, 2]);
     * // => [1, 4]
     */
    function xor() {
      var index = -1,
          length = arguments.length;

      while (++index < length) {
        var array = arguments[index];
        if (isArrayLike(array)) {
          var result = result
            ? arrayPush(baseDifference(result, array), baseDifference(array, result))
            : array;
        }
      }
      return result ? baseUniq(result) : [];
    }

    /**
     * Creates an array of grouped elements, the first of which contains the first
     * elements of the given arrays, the second of which contains the second elements
     * of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     */
    var zip = restParam(unzip);

    /**
     * The inverse of `_.pairs`; this method returns an object composed from arrays
     * of property names and values. Provide either a single two dimensional array,
     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
     * and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @alias object
     * @category Array
     * @param {Array} props The property names.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject([['fred', 30], ['barney', 40]]);
     * // => { 'fred': 30, 'barney': 40 }
     *
     * _.zipObject(['fred', 'barney'], [30, 40]);
     * // => { 'fred': 30, 'barney': 40 }
     */
    function zipObject(props, values) {
      var index = -1,
          length = props ? props.length : 0,
          result = {};

      if (length && !values && !isArray(props[0])) {
        values = [];
      }
      while (++index < length) {
        var key = props[index];
        if (values) {
          result[key] = values[index];
        } else if (key) {
          result[key[0]] = key[1];
        }
      }
      return result;
    }

    /**
     * This method is like `_.zip` except that it accepts an iteratee to specify
     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
     * and invoked with four arguments: (accumulator, value, index, group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee] The function to combine grouped values.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
     * // => [111, 222]
     */
    var zipWith = restParam(function(arrays) {
      var length = arrays.length,
          iteratee = length > 2 ? arrays[length - 2] : undefined,
          thisArg = length > 1 ? arrays[length - 1] : undefined;

      if (length > 2 && typeof iteratee == 'function') {
        length -= 2;
      } else {
        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
        thisArg = undefined;
      }
      arrays.length = length;
      return unzipWith(arrays, iteratee, thisArg);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object that wraps `value` with explicit method
     * chaining enabled.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _.chain(users)
     *   .sortBy('age')
     *   .map(function(chr) {
     *     return chr.user + ' is ' + chr.age;
     *   })
     *   .first()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor is
     * bound to `thisArg` and invoked with one argument; (value). The purpose of
     * this method is to "tap into" a method chain in order to perform operations
     * on intermediate results within the chain.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @param {*} [thisArg] The `this` binding of `interceptor`.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor, thisArg) {
      interceptor.call(thisArg, value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @param {*} [thisArg] The `this` binding of `interceptor`.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor, thisArg) {
      return interceptor.call(thisArg, value);
    }

    /**
     * Enables explicit method chaining on the wrapper object.
     *
     * @name chain
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // without explicit chaining
     * _(users).first();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // with explicit chaining
     * _(users).chain()
     *   .first()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chained sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Creates a new array joining a wrapped array with any additional arrays
     * and/or values.
     *
     * @name concat
     * @memberOf _
     * @category Chain
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var wrapped = _(array).concat(2, [3], [[4]]);
     *
     * console.log(wrapped.value());
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    var wrapperConcat = restParam(function(values) {
      values = baseFlatten(values);
      return this.thru(function(array) {
        return arrayConcat(isArray(array) ? array : [toObject(array)], values);
      });
    });

    /**
     * Creates a clone of the chained sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).map(function(value) {
     *   return Math.pow(value, 2);
     * });
     *
     * var other = [3, 4];
     * var otherWrapped = wrapped.plant(other);
     *
     * otherWrapped.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * Reverses the wrapped array so the first element becomes the last, the
     * second element becomes the second to last, and so on.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;

      var interceptor = function(value) {
        return (wrapped && wrapped.__dir__ < 0) ? value : value.reverse();
      };
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(interceptor);
    }

    /**
     * Produces the result of coercing the unwrapped value to a string.
     *
     * @name toString
     * @memberOf _
     * @category Chain
     * @returns {string} Returns the coerced string value.
     * @example
     *
     * _([1, 2, 3]).toString();
     * // => '1,2,3'
     */
    function wrapperToString() {
      return (this.value() + '');
    }

    /**
     * Executes the chained sequence to extract the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @alias run, toJSON, valueOf
     * @category Chain
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements corresponding to the given keys, or indexes,
     * of `collection`. Keys may be specified as individual arguments or as arrays
     * of keys.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(number|number[]|string|string[])} [props] The property names
     *  or indexes of elements to pick, specified individually or in arrays.
     * @returns {Array} Returns the new array of picked elements.
     * @example
     *
     * _.at(['a', 'b', 'c'], [0, 2]);
     * // => ['a', 'c']
     *
     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
     * // => ['barney', 'pebbles']
     */
    var at = restParam(function(collection, props) {
      return baseAt(collection, baseFlatten(props));
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the number of times the key was returned by `iteratee`.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([4.3, 6.1, 6.4], function(n) {
     *   return Math.floor(n);
     * });
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy([4.3, 6.1, 6.4], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * The predicate is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias all
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'active': false },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.every(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
        predicate = undefined;
      }
      if (typeof predicate != 'function' || thisArg !== undefined) {
        predicate = getCallback(predicate, thisArg, 3);
      }
      return func(collection, predicate);
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias select
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * _.filter([4, 5, 6], function(n) {
     *   return n % 2 == 0;
     * });
     * // => [4, 6]
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.filter(users, 'active', false), 'user');
     * // => ['fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.filter(users, 'active'), 'user');
     * // => ['barney']
     */
    function filter(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      predicate = getCallback(predicate, thisArg, 3);
      return func(collection, predicate);
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias detect
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.result(_.find(users, function(chr) {
     *   return chr.age < 40;
     * }), 'user');
     * // => 'barney'
     *
     * // using the `_.matches` callback shorthand
     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.result(_.find(users, 'active', false), 'user');
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.result(_.find(users, 'active'), 'user');
     * // => 'barney'
     */
    var find = createFind(baseEach);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(baseEachRight, true);

    /**
     * Performs a deep comparison between each element in `collection` and the
     * source object, returning the first element that has equivalent property
     * values.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Object} source The object of property values to match.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
     * // => 'barney'
     *
     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
     * // => 'fred'
     */
    function findWhere(collection, source) {
      return find(collection, baseMatches(source));
    }

    /**
     * Iterates over elements of `collection` invoking `iteratee` for each element.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection). Iteratee functions may exit iteration early
     * by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length" property
     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
     * may be used for object iteration.
     *
     * @static
     * @memberOf _
     * @alias each
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEach(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from left to right and returns the array
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
     *   console.log(n, key);
     * });
     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
     */
    var forEach = createForEach(arrayEach, baseEach);

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias eachRight
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEachRight(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from right to left and returns the array
     */
    var forEachRight = createForEach(arrayEachRight, baseEachRight);

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is an array of the elements responsible for generating the key.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([4.2, 6.1, 6.4], function(n) {
     *   return Math.floor(n);
     * });
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * _.groupBy([4.2, 6.1, 6.4], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * // using the `_.property` callback shorthand
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        result[key] = [value];
      }
    });

    /**
     * Checks if `value` is in `collection` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
     * from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @alias contains, include
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {*} target The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
     * // => true
     *
     * _.includes('pebbles', 'eb');
     * // => true
     */
    function includes(collection, target, fromIndex, guard) {
      var length = collection ? getLength(collection) : 0;
      if (!isLength(length)) {
        collection = values(collection);
        length = collection.length;
      }
      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
        fromIndex = 0;
      } else {
        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
      }
      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
        ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
        : (!!length && getIndexOf(collection, target, fromIndex) > -1);
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the last element responsible for generating the key. The
     * iteratee function is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var keyData = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.indexBy(keyData, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keyData, function(object) {
     *   return String.fromCharCode(object.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keyData, function(object) {
     *   return this.fromCharCode(object.code);
     * }, String);
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     */
    var indexBy = createAggregator(function(result, value, key) {
      result[key] = value;
    });

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `methodName` is a function it is
     * invoked for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invoke([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invoke = restParam(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          isProp = isKey(path),
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
      });
      return result;
    });

    /**
     * Creates an array of values by running each element in `collection` through
     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
     * `sum`, `uniq`, and `words`
     *
     * @static
     * @memberOf _
     * @alias collect
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function timesThree(n) {
     *   return n * 3;
     * }
     *
     * _.map([1, 2], timesThree);
     * // => [3, 6]
     *
     * _.map({ 'a': 1, 'b': 2 }, timesThree);
     * // => [3, 6] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee, thisArg) {
      var func = isArray(collection) ? arrayMap : baseMap;
      iteratee = getCallback(iteratee, thisArg, 3);
      return func(collection, iteratee);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, while the second of which
     * contains elements `predicate` returns falsey for. The predicate is bound
     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * _.partition([1, 2, 3], function(n) {
     *   return n % 2;
     * });
     * // => [[1, 3], [2]]
     *
     * _.partition([1.2, 2.3, 3.4], function(n) {
     *   return this.floor(n) % 2;
     * }, Math);
     * // => [[1.2, 3.4], [2.3]]
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * var mapper = function(array) {
     *   return _.pluck(array, 'user');
     * };
     *
     * // using the `_.matches` callback shorthand
     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
     * // => [['pebbles'], ['barney', 'fred']]
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.map(_.partition(users, 'active', false), mapper);
     * // => [['barney', 'pebbles'], ['fred']]
     *
     * // using the `_.property` callback shorthand
     * _.map(_.partition(users, 'active'), mapper);
     * // => [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Gets the property value of `path` from all elements in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|string} path The path of the property to pluck.
     * @returns {Array} Returns the property values.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.pluck(users, 'user');
     * // => ['barney', 'fred']
     *
     * var userIndex = _.indexBy(users, 'user');
     * _.pluck(userIndex, 'age');
     * // => [36, 40] (iteration order is not guaranteed)
     */
    function pluck(collection, path) {
      return map(collection, property(path));
    }

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` through `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not provided the first element of `collection` is used as the initial
     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
     * and `sortByOrder`
     *
     * @static
     * @memberOf _
     * @alias foldl, inject
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.reduce([1, 2], function(total, n) {
     *   return total + n;
     * });
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     *   return result;
     * }, {});
     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
     */
    var reduce = createReduce(arrayReduce, baseEach);

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias foldr
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    var reduceRight = createReduce(arrayReduceRight, baseEachRight);

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * _.reject([1, 2, 3, 4], function(n) {
     *   return n % 2 == 0;
     * });
     * // => [1, 3]
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.reject(users, 'active', false), 'user');
     * // => ['fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.reject(users, 'active'), 'user');
     * // => ['barney']
     */
    function reject(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      predicate = getCallback(predicate, thisArg, 3);
      return func(collection, function(value, index, collection) {
        return !predicate(value, index, collection);
      });
    }

    /**
     * Gets a random element or `n` random elements from a collection.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to sample.
     * @param {number} [n] The number of elements to sample.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {*} Returns the random sample(s).
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     *
     * _.sample([1, 2, 3, 4], 2);
     * // => [3, 1]
     */
    function sample(collection, n, guard) {
      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
        collection = toIterable(collection);
        var length = collection.length;
        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
      }
      var index = -1,
          result = toArray(collection),
          length = result.length,
          lastIndex = length - 1;

      n = nativeMin(n < 0 ? 0 : (+n || 0), length);
      while (++index < n) {
        var rand = baseRandom(index, lastIndex),
            value = result[rand];

        result[rand] = result[index];
        result[index] = value;
      }
      result.length = n;
      return result;
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      return sample(collection, POSITIVE_INFINITY);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable properties for objects.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the size of `collection`.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      var length = collection ? getLength(collection) : 0;
      return isLength(length) ? length : keys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * The function returns as soon as it finds a passing value and does not iterate
     * over the entire collection. The predicate is bound to `thisArg` and invoked
     * with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias any
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.some(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, thisArg) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
        predicate = undefined;
      }
      if (typeof predicate != 'function' || thisArg !== undefined) {
        predicate = getCallback(predicate, thisArg, 3);
      }
      return func(collection, predicate);
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection through `iteratee`. This method performs
     * a stable sort, that is, it preserves the original sort order of equal elements.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * _.sortBy([1, 2, 3], function(n) {
     *   return Math.sin(n);
     * });
     * // => [3, 1, 2]
     *
     * _.sortBy([1, 2, 3], function(n) {
     *   return this.sin(n);
     * }, Math);
     * // => [3, 1, 2]
     *
     * var users = [
     *   { 'user': 'fred' },
     *   { 'user': 'pebbles' },
     *   { 'user': 'barney' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.sortBy(users, 'user'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function sortBy(collection, iteratee, thisArg) {
      if (collection == null) {
        return [];
      }
      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
        iteratee = undefined;
      }
      var index = -1;
      iteratee = getCallback(iteratee, thisArg, 3);

      var result = baseMap(collection, function(value, key, collection) {
        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
      });
      return baseSortBy(result, compareAscending);
    }

    /**
     * This method is like `_.sortBy` except that it can sort by multiple iteratees
     * or property names.
     *
     * If a property name is provided for an iteratee the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If an object is provided for an iteratee the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
     *  The iteratees to sort by, specified as individual values or arrays of values.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
     *
     * _.map(_.sortByAll(users, 'user', function(chr) {
     *   return Math.floor(chr.age / 10);
     * }), _.values);
     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */
    var sortByAll = restParam(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var guard = iteratees[2];
      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
        iteratees.length = 1;
      }
      return baseSortByOrder(collection, baseFlatten(iteratees), []);
    });

    /**
     * This method is like `_.sortByAll` except that it allows specifying the
     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
     * values are sorted in ascending order. Otherwise, a value is sorted in
     * ascending order if its corresponding order is "asc", and descending if "desc".
     *
     * If a property name is provided for an iteratee the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If an object is provided for an iteratee the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {boolean[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // sort by `user` in ascending order and by `age` in descending order
     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */
    function sortByOrder(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (guard && isIterateeCall(iteratees, orders, guard)) {
        orders = undefined;
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseSortByOrder(collection, iteratees, orders);
    }

    /**
     * Performs a deep comparison between each element in `collection` and the
     * source object, returning an array of all elements that have equivalent
     * property values.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Object} source The object of property values to match.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
     * ];
     *
     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
     * // => ['barney']
     *
     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
     * // => ['fred']
     */
    function where(collection, source) {
      return filter(collection, baseMatches(source));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Gets the number of milliseconds that have elapsed since the Unix epoch
     * (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @category Date
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => logs the number of milliseconds it took for the deferred function to be invoked
     */
    var now = nativeNow || function() {
      return new Date().getTime();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it is called `n` or more times.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => logs 'done saving!' after the two async saves have completed
     */
    function after(n, func) {
      if (typeof func != 'function') {
        if (typeof n == 'function') {
          var temp = n;
          n = func;
          func = temp;
        } else {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
      }
      n = nativeIsFinite(n = +n) ? n : 0;
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that accepts up to `n` arguments ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      if (guard && isIterateeCall(func, n, guard)) {
        n = undefined;
      }
      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it is called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery('#add').on('click', _.before(5, addContactToList));
     * // => allows adding up to 4 contacts to the list
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        if (typeof n == 'function') {
          var temp = n;
          n = func;
          func = temp;
        } else {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
      }
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and prepends any additional `_.bind` arguments to those provided to the
     * bound function.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind` this method does not set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var greet = function(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * };
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // using placeholders
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = restParam(function(func, thisArg, partials) {
      var bitmask = BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, bind.placeholder);
        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method. Method names may be specified as individual arguments or as arrays
     * of method names. If no method names are provided all enumerable function
     * properties, own and inherited, of `object` are bound.
     *
     * **Note:** This method does not set the "length" property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} [methodNames] The object method names to bind,
     *  specified as individual method names or arrays of method names.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'onClick': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view);
     * jQuery('#docs').on('click', view.onClick);
     * // => logs 'clicked docs' when the element is clicked
     */
    var bindAll = restParam(function(object, methodNames) {
      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);

      var index = -1,
          length = methodNames.length;

      while (++index < length) {
        var key = methodNames[index];
        object[key] = createWrapper(object[key], BIND_FLAG, object);
      }
      return object;
    });

    /**
     * Creates a function that invokes the method at `object[key]` and prepends
     * any additional `_.bindKey` arguments to those provided to the bound function.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist.
     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object the method belongs to.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // using placeholders
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = restParam(function(object, key, partials) {
      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, bindKey.placeholder);
        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts one or more arguments of `func` that when
     * called either invokes `func` returning its result, if all `func` arguments
     * have been provided, or returns a function that accepts one or more of the
     * remaining `func` arguments, and so on. The arity of `func` may be specified
     * if `func.length` is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method does not set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // using placeholders
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    var curry = createCurry(CURRY_FLAG);

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method does not set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // using placeholders
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    var curryRight = createCurry(CURRY_RIGHT_FLAG);

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed invocations. Provide an options object to indicate that `func`
     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
     * Subsequent calls to the debounced function return the result of the last
     * `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the the debounced function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=false] Specify invoking on the leading
     *  edge of the timeout.
     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
     *  delayed before it is invoked.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // avoid costly calculations while the window size is in flux
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // ensure `batchLog` is invoked once after 1 second of debounced calls
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', _.debounce(batchLog, 250, {
     *   'maxWait': 1000
     * }));
     *
     * // cancel a debounced call
     * var todoChanges = _.debounce(batchLog, 1000);
     * Object.observe(models.todo, todoChanges);
     *
     * Object.observe(models, function(changes) {
     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
     *     todoChanges.cancel();
     *   }
     * }, ['delete']);
     *
     * // ...at some point `models.todo` is changed
     * models.todo.completed = true;
     *
     * // ...before 1 second has passed `models.todo` is deleted
     * // which cancels the debounced `todoChanges` call
     * delete models.todo;
     */
    function debounce(func, wait, options) {
      var args,
          maxTimeoutId,
          result,
          stamp,
          thisArg,
          timeoutId,
          trailingCall,
          lastCalled = 0,
          maxWait = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = wait < 0 ? 0 : (+wait || 0);
      if (options === true) {
        var leading = true;
        trailing = false;
      } else if (isObject(options)) {
        leading = !!options.leading;
        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function cancel() {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        if (maxTimeoutId) {
          clearTimeout(maxTimeoutId);
        }
        lastCalled = 0;
        maxTimeoutId = timeoutId = trailingCall = undefined;
      }

      function complete(isCalled, id) {
        if (id) {
          clearTimeout(id);
        }
        maxTimeoutId = timeoutId = trailingCall = undefined;
        if (isCalled) {
          lastCalled = now();
          result = func.apply(thisArg, args);
          if (!timeoutId && !maxTimeoutId) {
            args = thisArg = undefined;
          }
        }
      }

      function delayed() {
        var remaining = wait - (now() - stamp);
        if (remaining <= 0 || remaining > wait) {
          complete(trailingCall, maxTimeoutId);
        } else {
          timeoutId = setTimeout(delayed, remaining);
        }
      }

      function maxDelayed() {
        complete(trailing, timeoutId);
      }

      function debounced() {
        args = arguments;
        stamp = now();
        thisArg = this;
        trailingCall = trailing && (timeoutId || !leading);

        if (maxWait === false) {
          var leadingCall = leading && !timeoutId;
        } else {
          if (!maxTimeoutId && !leading) {
            lastCalled = stamp;
          }
          var remaining = maxWait - (stamp - lastCalled),
              isCalled = remaining <= 0 || remaining > maxWait;

          if (isCalled) {
            if (maxTimeoutId) {
              maxTimeoutId = clearTimeout(maxTimeoutId);
            }
            lastCalled = stamp;
            result = func.apply(thisArg, args);
          }
          else if (!maxTimeoutId) {
            maxTimeoutId = setTimeout(maxDelayed, remaining);
          }
        }
        if (isCalled && timeoutId) {
          timeoutId = clearTimeout(timeoutId);
        }
        else if (!timeoutId && wait !== maxWait) {
          timeoutId = setTimeout(delayed, wait);
        }
        if (leadingCall) {
          isCalled = true;
          result = func.apply(thisArg, args);
        }
        if (isCalled && !timeoutId && !maxTimeoutId) {
          args = thisArg = undefined;
        }
        return result;
      }
      debounced.cancel = cancel;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // logs 'deferred' after one or more milliseconds
     */
    var defer = restParam(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => logs 'later' after one second
     */
    var delay = restParam(function(func, wait, args) {
      return baseDelay(func, wait, args);
    });

    /**
     * Creates a function that returns the result of invoking the provided
     * functions with the `this` binding of the created function, where each
     * successive invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {...Function} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow(_.add, square);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the provided functions from right to left.
     *
     * @static
     * @memberOf _
     * @alias backflow, compose
     * @category Function
     * @param {...Function} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight(square, _.add);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is coerced to a string and used as the
     * cache key. The `func` is invoked with the `this` binding of the memoized
     * function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoizing function.
     * @example
     *
     * var upperCase = _.memoize(function(string) {
     *   return string.toUpperCase();
     * });
     *
     * upperCase('fred');
     * // => 'FRED'
     *
     * // modifying the result cache
     * upperCase.cache.set('fred', 'BARNEY');
     * upperCase('fred');
     * // => 'BARNEY'
     *
     * // replacing `_.memoize.Cache`
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'barney' };
     * var identity = _.memoize(_.identity);
     *
     * identity(object);
     * // => { 'user': 'fred' }
     * identity(other);
     * // => { 'user': 'fred' }
     *
     * _.memoize.Cache = WeakMap;
     * var identity = _.memoize(_.identity);
     *
     * identity(object);
     * // => { 'user': 'fred' }
     * identity(other);
     * // => { 'user': 'barney' }
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
      };
      memoized.cache = new memoize.Cache;
      return memoized;
    }

    /**
     * Creates a function that runs each argument through a corresponding
     * transform function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms] The functions to transform
     * arguments, specified as individual functions or arrays of functions.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var modded = _.modArgs(function(x, y) {
     *   return [x, y];
     * }, square, doubled);
     *
     * modded(1, 2);
     * // => [1, 4]
     *
     * modded(5, 10);
     * // => [25, 20]
     */
    var modArgs = restParam(function(func, transforms) {
      transforms = baseFlatten(transforms);
      if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = transforms.length;
      return restParam(function(args) {
        var index = nativeMin(args.length, length);
        while (index--) {
          args[index] = transforms[index](args[index]);
        }
        return func.apply(this, args);
      });
    });

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        return !predicate.apply(this, arguments);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first call. The `func` is invoked
     * with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // `initialize` invokes `createApplication` once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with `partial` arguments prepended
     * to those provided to the new function. This method is like `_.bind` except
     * it does **not** alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // using placeholders
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = createPartial(PARTIAL_FLAG);

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to those provided to the new function.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // using placeholders
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified indexes where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes,
     *  specified as individual indexes or arrays of indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, 2, 0, 1);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     *
     * var map = _.rearg(_.map, [1, 0]);
     * map(function(n) {
     *   return n * 3;
     * }, [1, 2, 3]);
     * // => [3, 6, 9]
     */
    var rearg = restParam(function(func, indexes) {
      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as an array.
     *
     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.restParam(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function restParam(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            rest = Array(length);

        while (++index < length) {
          rest[index] = args[start + index];
        }
        switch (start) {
          case 0: return func.call(this, rest);
          case 1: return func.call(this, args[0], rest);
          case 2: return func.call(this, args[0], args[1], rest);
        }
        var otherArgs = Array(start + 1);
        index = -1;
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = rest;
        return func.apply(this, otherArgs);
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the created
     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
     *
     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * // with a Promise
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function(array) {
        return func.apply(this, array);
      };
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed invocations. Provide an options object to indicate
     * that `func` should be invoked on the leading and/or trailing edge of the
     * `wait` timeout. Subsequent calls to the throttled function return the
     * result of the last `func` call.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the the throttled function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=true] Specify invoking on the leading
     *  edge of the timeout.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // avoid excessively updating the position while scrolling
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
     *   'trailing': false
     * }));
     *
     * // cancel a trailing throttled call
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (options === false) {
        leading = false;
      } else if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
    }

    /**
     * Creates a function that provides `value` to the wrapper function as its
     * first argument. Any additional arguments provided to the function are
     * appended to those provided to the wrapper function. The wrapper is invoked
     * with the `this` binding of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} wrapper The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      wrapper = wrapper == null ? identity : wrapper;
      return createWrapper(wrapper, PARTIAL_FLAG, undefined, [value], []);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
     * otherwise they are assigned by reference. If `customizer` is provided it is
     * invoked to produce the cloned values. If `customizer` returns `undefined`
     * cloning is handled by the method instead. The `customizer` is bound to
     * `thisArg` and invoked with two argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var shallow = _.clone(users);
     * shallow[0] === users[0];
     * // => true
     *
     * var deep = _.clone(users, true);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.clone(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 0
     */
    function clone(value, isDeep, customizer, thisArg) {
      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
        isDeep = false;
      }
      else if (typeof isDeep == 'function') {
        thisArg = customizer;
        customizer = isDeep;
        isDeep = false;
      }
      return typeof customizer == 'function'
        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1))
        : baseClone(value, isDeep);
    }

    /**
     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
     * to produce the cloned values. If `customizer` returns `undefined` cloning
     * is handled by the method instead. The `customizer` is bound to `thisArg`
     * and invoked with two argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the deep cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var deep = _.cloneDeep(users);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.cloneDeep(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 20
     */
    function cloneDeep(value, customizer, thisArg) {
      return typeof customizer == 'function'
        ? baseClone(value, true, bindCallback(customizer, thisArg, 1))
        : baseClone(value, true);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    function gt(value, other) {
      return value > other;
    }

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    function gte(value, other) {
      return value >= other;
    }

    /**
     * Checks if `value` is classified as an `arguments` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    function isArguments(value) {
      return isObjectLike(value) && isArrayLike(value) &&
        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
    }

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(function() { return arguments; }());
     * // => false
     */
    var isArray = nativeIsArray || function(value) {
      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
    };

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
    }

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    function isDate(value) {
      return isObjectLike(value) && objToString.call(value) == dateTag;
    }

    /**
     * Checks if `value` is a DOM element.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
    }

    /**
     * Checks if `value` is empty. A value is considered empty unless it is an
     * `arguments` object, array, string, or jQuery-like collection with a length
     * greater than `0` or an object with own enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Array|Object|string} value The value to inspect.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
          (isObjectLike(value) && isFunction(value.splice)))) {
        return !value.length;
      }
      return !keys(value).length;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent. If `customizer` is provided it is invoked to compare values.
     * If `customizer` returns `undefined` comparisons are handled by the method
     * instead. The `customizer` is bound to `thisArg` and invoked with three
     * arguments: (value, other [, index|key]).
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. Functions and DOM nodes
     * are **not** supported. Provide a customizer function to extend support
     * for comparing other values.
     *
     * @static
     * @memberOf _
     * @alias eq
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'fred' };
     *
     * object == other;
     * // => false
     *
     * _.isEqual(object, other);
     * // => true
     *
     * // using a customizer callback
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqual(array, other, function(value, other) {
     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
     *     return true;
     *   }
     * });
     * // => true
     */
    function isEqual(value, other, customizer, thisArg) {
      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(10);
     * // => true
     *
     * _.isFinite('10');
     * // => false
     *
     * _.isFinite(true);
     * // => false
     *
     * _.isFinite(Object(10));
     * // => false
     *
     * _.isFinite(Infinity);
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in older versions of Chrome and Safari which return 'function' for regexes
      // and Safari 8 equivalents which return 'object' for typed array constructors.
      return isObject(value) && objToString.call(value) == funcTag;
    }

    /**
     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(1);
     * // => false
     */
    function isObject(value) {
      // Avoid a V8 JIT bug in Chrome 19-20.
      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
      var type = typeof value;
      return !!value && (type == 'object' || type == 'function');
    }

    /**
     * Performs a deep comparison between `object` and `source` to determine if
     * `object` contains equivalent property values. If `customizer` is provided
     * it is invoked to compare values. If `customizer` returns `undefined`
     * comparisons are handled by the method instead. The `customizer` is bound
     * to `thisArg` and invoked with three arguments: (value, other, index|key).
     *
     * **Note:** This method supports comparing properties of arrays, booleans,
     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
     * and DOM nodes are **not** supported. Provide a customizer function to extend
     * support for comparing other values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.isMatch(object, { 'age': 40 });
     * // => true
     *
     * _.isMatch(object, { 'age': 36 });
     * // => false
     *
     * // using a customizer callback
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatch(object, source, function(value, other) {
     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
     * });
     * // => true
     */
    function isMatch(object, source, customizer, thisArg) {
      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
      return baseIsMatch(object, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
     * which returns `true` for `undefined` and other non-numeric values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a native function.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (value == null) {
        return false;
      }
      if (isFunction(value)) {
        return reIsNative.test(fnToString.call(value));
      }
      return isObjectLike(value) && reIsHostCtor.test(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
     * as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isNumber(8.4);
     * // => true
     *
     * _.isNumber(NaN);
     * // => true
     *
     * _.isNumber('8.4');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * **Note:** This method assumes objects created by the `Object` constructor
     * have no inherited enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      var Ctor;

      // Exit early for non `Object` objects.
      if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
          (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
        return false;
      }
      // IE < 9 iterates inherited properties before own properties. If the first
      // iterated property is an object's own property then there are no inherited
      // enumerable properties.
      var result;
      // In most environments an object's own properties are iterated before
      // its inherited properties. If the last iterated property is an object's
      // own property then there are no inherited enumerable properties.
      baseForIn(value, function(subValue, key) {
        result = key;
      });
      return result === undefined || hasOwnProperty.call(value, result);
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    function isRegExp(value) {
      return isObject(value) && objToString.call(value) == regexpTag;
    }

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    function isTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
    }

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    function lt(value, other) {
      return value < other;
    }

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    function lte(value, other) {
      return value <= other;
    }

    /**
     * Converts `value` to an array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * (function() {
     *   return _.toArray(arguments).slice(1);
     * }(1, 2, 3));
     * // => [2, 3]
     */
    function toArray(value) {
      var length = value ? getLength(value) : 0;
      if (!isLength(length)) {
        return values(value);
      }
      if (!length) {
        return [];
      }
      return arrayCopy(value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable
     * properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return baseCopy(value, keysIn(value));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Recursively merges own enumerable properties of the source object(s), that
     * don't resolve to `undefined` into the destination object. Subsequent sources
     * overwrite property assignments of previous sources. If `customizer` is
     * provided it is invoked to produce the merged values of the destination and
     * source properties. If `customizer` returns `undefined` merging is handled
     * by the method instead. The `customizer` is bound to `thisArg` and invoked
     * with five arguments: (objectValue, sourceValue, key, object, source).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var users = {
     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
     * };
     *
     * var ages = {
     *   'data': [{ 'age': 36 }, { 'age': 40 }]
     * };
     *
     * _.merge(users, ages);
     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
     *
     * // using a customizer callback
     * var object = {
     *   'fruits': ['apple'],
     *   'vegetables': ['beet']
     * };
     *
     * var other = {
     *   'fruits': ['banana'],
     *   'vegetables': ['carrot']
     * };
     *
     * _.merge(object, other, function(a, b) {
     *   if (_.isArray(a)) {
     *     return a.concat(b);
     *   }
     * });
     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
     */
    var merge = createAssigner(baseMerge);

    /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object. Subsequent sources overwrite property assignments of previous sources.
     * If `customizer` is provided it is invoked to produce the assigned values.
     * The `customizer` is bound to `thisArg` and invoked with five arguments:
     * (objectValue, sourceValue, key, object, source).
     *
     * **Note:** This method mutates `object` and is based on
     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
     *
     * @static
     * @memberOf _
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using a customizer callback
     * var defaults = _.partialRight(_.assign, function(value, other) {
     *   return _.isUndefined(value) ? other : value;
     * });
     *
     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */
    var assign = createAssigner(function(object, source, customizer) {
      return customizer
        ? assignWith(object, source, customizer)
        : baseAssign(object, source);
    });

    /**
     * Creates an object that inherits from the given `prototype` object. If a
     * `properties` object is provided its own enumerable properties are assigned
     * to the created object.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties, guard) {
      var result = baseCreate(prototype);
      if (guard && isIterateeCall(prototype, properties, guard)) {
        properties = undefined;
      }
      return properties ? baseAssign(result, properties) : result;
    }

    /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object for all destination properties that resolve to `undefined`. Once a
     * property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */
    var defaults = createDefaults(assign, assignDefaults);

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
     * // => { 'user': { 'name': 'barney', 'age': 36 } }
     *
     */
    var defaultsDeep = createDefaults(merge, mergeDefaults);

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(chr) {
     *   return chr.age < 40;
     * });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // using the `_.matches` callback shorthand
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findKey(users, 'active', false);
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    var findKey = createFindKey(baseForOwn);

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(chr) {
     *   return chr.age < 40;
     * });
     * // => returns `pebbles` assuming `_.findKey` returns `barney`
     *
     * // using the `_.matches` callback shorthand
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findLastKey(users, 'active', false);
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    var findLastKey = createFindKey(baseForOwnRight);

    /**
     * Iterates over own and inherited enumerable properties of an object invoking
     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
     */
    var forIn = createForIn(baseFor);

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
     */
    var forInRight = createForIn(baseForRight);

    /**
     * Iterates over own enumerable properties of an object invoking `iteratee`
     * for each property. The `iteratee` is bound to `thisArg` and invoked with
     * three arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a' and 'b' (iteration order is not guaranteed)
     */
    var forOwn = createForOwn(baseForOwn);

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
     */
    var forOwnRight = createForOwn(baseForOwnRight);

    /**
     * Creates an array of function property names from all enumerable properties,
     * own and inherited, of `object`.
     *
     * @static
     * @memberOf _
     * @alias methods
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the new array of property names.
     * @example
     *
     * _.functions(_);
     * // => ['after', 'ary', 'assign', ...]
     */
    function functions(object) {
      return baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the property value at `path` of `object`. If the resolved value is
     * `undefined` the `defaultValue` is used in its place.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': { 'c': 3 } } };
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b.c');
     * // => true
     *
     * _.has(object, ['a', 'b', 'c']);
     * // => true
     */
    function has(object, path) {
      if (object == null) {
        return false;
      }
      var result = hasOwnProperty.call(object, path);
      if (!result && !isKey(path)) {
        path = toPath(path);
        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
        if (object == null) {
          return false;
        }
        path = last(path);
        result = hasOwnProperty.call(object, path);
      }
      return result || (isLength(object.length) && isIndex(path, object.length) &&
        (isArray(object) || isArguments(object)));
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite property
     * assignments of previous values unless `multiValue` is `true`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to invert.
     * @param {boolean} [multiValue] Allow multiple values per key.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     *
     * // with `multiValue`
     * _.invert(object, true);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function invert(object, multiValue, guard) {
      if (guard && isIterateeCall(object, multiValue, guard)) {
        multiValue = undefined;
      }
      var index = -1,
          props = keys(object),
          length = props.length,
          result = {};

      while (++index < length) {
        var key = props[index],
            value = object[key];

        if (multiValue) {
          if (hasOwnProperty.call(result, value)) {
            result[value].push(key);
          } else {
            result[value] = [key];
          }
        }
        else {
          result[value] = key;
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    var keys = !nativeKeys ? shimKeys : function(object) {
      var Ctor = object == null ? undefined : object.constructor;
      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
          (typeof object != 'function' && isArrayLike(object))) {
        return shimKeys(object);
      }
      return isObject(object) ? nativeKeys(object) : [];
    };

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      if (object == null) {
        return [];
      }
      if (!isObject(object)) {
        object = Object(object);
      }
      var length = object.length;
      length = (length && isLength(length) &&
        (isArray(object) || isArguments(object)) && length) || 0;

      var Ctor = object.constructor,
          index = -1,
          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
          result = Array(length),
          skipIndexes = length > 0;

      while (++index < length) {
        result[index] = (index + '');
      }
      for (var key in object) {
        if (!(skipIndexes && isIndex(key, length)) &&
            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * property of `object` through `iteratee`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    var mapKeys = createObjectMapper(true);

    /**
     * Creates an object with the same keys as `object` and values generated by
     * running each own enumerable property of `object` through `iteratee`. The
     * iteratee function is bound to `thisArg` and invoked with three arguments:
     * (value, key, object).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
     *   return n * 3;
     * });
     * // => { 'a': 3, 'b': 6 }
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * // using the `_.property` callback shorthand
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    var mapValues = createObjectMapper();

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable properties of `object` that are not omitted.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to omit, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.omit(object, 'age');
     * // => { 'user': 'fred' }
     *
     * _.omit(object, _.isNumber);
     * // => { 'user': 'fred' }
     */
    var omit = restParam(function(object, props) {
      if (object == null) {
        return {};
      }
      if (typeof props[0] != 'function') {
        var props = arrayMap(baseFlatten(props), String);
        return pickByArray(object, baseDifference(keysIn(object), props));
      }
      var predicate = bindCallback(props[0], props[1], 3);
      return pickByCallback(object, function(value, key, object) {
        return !predicate(value, key, object);
      });
    });

    /**
     * Creates a two dimensional array of the key-value pairs for `object`,
     * e.g. `[[key1, value1], [key2, value2]]`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the new array of key-value pairs.
     * @example
     *
     * _.pairs({ 'barney': 36, 'fred': 40 });
     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
     */
    function pairs(object) {
      object = toObject(object);

      var index = -1,
          props = keys(object),
          length = props.length,
          result = Array(length);

      while (++index < length) {
        var key = props[index];
        result[index] = [key, object[key]];
      }
      return result;
    }

    /**
     * Creates an object composed of the picked `object` properties. Property
     * names may be specified as individual arguments or as arrays of property
     * names. If `predicate` is provided it is invoked for each property of `object`
     * picking the properties `predicate` returns truthy for. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to pick, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.pick(object, 'user');
     * // => { 'user': 'fred' }
     *
     * _.pick(object, _.isString);
     * // => { 'user': 'fred' }
     */
    var pick = restParam(function(object, props) {
      if (object == null) {
        return {};
      }
      return typeof props[0] == 'function'
        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
        : pickByArray(object, baseFlatten(props));
    });

    /**
     * This method is like `_.get` except that if the resolved value is a function
     * it is invoked with the `this` binding of its parent object and its result
     * is returned.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a.b.c', 'default');
     * // => 'default'
     *
     * _.result(object, 'a.b.c', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      var result = object == null ? undefined : object[path];
      if (result === undefined) {
        if (object != null && !isKey(path, object)) {
          path = toPath(path);
          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
          result = object == null ? undefined : object[last(path)];
        }
        result = result === undefined ? defaultValue : result;
      }
      return isFunction(result) ? result.call(object) : result;
    }

    /**
     * Sets the property value of `path` on `object`. If a portion of `path`
     * does not exist it is created.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to augment.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, 'x[0].y.z', 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      if (object == null) {
        return object;
      }
      var pathKey = (path + '');
      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = path[index];
        if (isObject(nested)) {
          if (index == lastIndex) {
            nested[key] = value;
          } else if (nested[key] == null) {
            nested[key] = isIndex(path[index + 1]) ? [] : {};
          }
        }
        nested = nested[key];
      }
      return object;
    }

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own enumerable
     * properties through `iteratee`, with each invocation potentially mutating
     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
     * with four arguments: (accumulator, value, key, object). Iteratee functions
     * may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Array|Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * });
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     * });
     * // => { 'a': 3, 'b': 6 }
     */
    function transform(object, iteratee, accumulator, thisArg) {
      var isArr = isArray(object) || isTypedArray(object);
      iteratee = getCallback(iteratee, thisArg, 4);

      if (accumulator == null) {
        if (isArr || isObject(object)) {
          var Ctor = object.constructor;
          if (isArr) {
            accumulator = isArray(object) ? new Ctor : [];
          } else {
            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
          }
        } else {
          accumulator = {};
        }
      }
      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Creates an array of the own enumerable property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable property values
     * of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Checks if `n` is between `start` and up to but not including, `end`. If
     * `end` is not specified it is set to `start` with `start` then set to `0`.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} n The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     */
    function inRange(value, start, end) {
      start = +start || 0;
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = +end || 0;
      }
      return value >= nativeMin(start, end) && value < nativeMax(start, end);
    }

    /**
     * Produces a random number between `min` and `max` (inclusive). If only one
     * argument is provided a number between `0` and the given number is returned.
     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
     * number is returned instead of an integer.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} [min=0] The minimum possible value.
     * @param {number} [max=1] The maximum possible value.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(min, max, floating) {
      if (floating && isIterateeCall(min, max, floating)) {
        max = floating = undefined;
      }
      var noMin = min == null,
          noMax = max == null;

      if (floating == null) {
        if (noMax && typeof min == 'boolean') {
          floating = min;
          min = 1;
        }
        else if (typeof max == 'boolean') {
          floating = max;
          noMax = true;
        }
      }
      if (noMin && noMax) {
        max = 1;
        noMax = false;
      }
      min = +min || 0;
      if (noMax) {
        max = min;
        min = 0;
      } else {
        max = +max || 0;
      }
      if (floating || min % 1 || max % 1) {
        var rand = nativeRandom();
        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
      }
      return baseRandom(min, max);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar');
     * // => 'fooBar'
     *
     * _.camelCase('__foo_bar__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
    });

    /**
     * Capitalizes the first character of `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('fred');
     * // => 'Fred'
     */
    function capitalize(string) {
      string = baseToString(string);
      return string && (string.charAt(0).toUpperCase() + string.slice(1));
    }

    /**
     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = baseToString(string);
      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search from.
     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = baseToString(string);
      target = (target + '');

      var length = string.length;
      position = position === undefined
        ? length
        : nativeMin(position < 0 ? 0 : (+position || 0), length);

      position -= target.length;
      return position >= 0 && string.indexOf(target, position) == position;
    }

    /**
     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
     * their corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional characters
     * use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value.
     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * Backticks are escaped because in Internet Explorer < 9, they can break out
     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
     * for more details.
     *
     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
     * to reduce XSS vectors.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
      string = baseToString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
     */
    function escapeRegExp(string) {
      string = baseToString(string);
      return (string && reHasRegExpChars.test(string))
        ? string.replace(reRegExpChars, escapeRegExpChar)
        : (string || '(?:)');
    }

    /**
     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__foo_bar__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = baseToString(string);
      length = +length;

      var strLength = string.length;
      if (strLength >= length || !nativeIsFinite(length)) {
        return string;
      }
      var mid = (length - strLength) / 2,
          leftLength = nativeFloor(mid),
          rightLength = nativeCeil(mid);

      chars = createPadding('', rightLength, chars);
      return chars.slice(0, leftLength) + string + chars;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padLeft('abc', 6);
     * // => '   abc'
     *
     * _.padLeft('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padLeft('abc', 3);
     * // => 'abc'
     */
    var padLeft = createPadDir();

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padRight('abc', 6);
     * // => 'abc   '
     *
     * _.padRight('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padRight('abc', 3);
     * // => 'abc'
     */
    var padRight = createPadDir(true);

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
     * in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
     * of `parseInt`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
      // Chrome fails to trim leading <BOM> whitespace characters.
      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
      if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      string = trim(string);
      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=0] The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n) {
      var result = '';
      string = baseToString(string);
      n = +n;
      if (n < 1 || !string || !nativeIsFinite(n)) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        string += string;
      } while (n);

      return result;
    }

    /**
     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--foo-bar');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__foo_bar__');
     * // => 'Foo Bar'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = baseToString(string);
      position = position == null
        ? 0
        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);

      return string.lastIndexOf(target, position) == position;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is provided it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options] The options object.
     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
     * @param {Object} [options.imports] An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
     * @param {string} [options.variable] The data object variable name.
     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // using the "interpolate" delimiter to create a compiled template
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // using the HTML "escape" delimiter to escape data property values
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the internal `print` function in "evaluate" delimiters
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // using custom template delimiters
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // using backslashes to treat delimiters as plain text
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // using the `imports` option to import `jQuery` as `jq`
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the `sourceURL` option to specify a custom sourceURL for the template
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
     *
     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // using the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and a stack trace
     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, otherOptions) {
      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
        options = otherOptions = undefined;
      }
      string = baseToString(string);
      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);

      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products requires returning the `match`
        // string in order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
      }
      chars = (chars + '');
      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimLeft('  abc  ');
     * // => 'abc  '
     *
     * _.trimLeft('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimLeft(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(trimmedLeftIndex(string));
      }
      return string.slice(charsLeftIndex(string, (chars + '')));
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimRight('  abc  ');
     * // => '  abc'
     *
     * _.trimRight('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimRight(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(0, trimmedRightIndex(string) + 1);
      }
      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object|number} [options] The options object or maximum string length.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.trunc('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', 24);
     * // => 'hi-diddly-ho there, n...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function trunc(string, options, guard) {
      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (options != null) {
        if (isObject(options)) {
          var separator = 'separator' in options ? options.separator : separator;
          length = 'length' in options ? (+options.length || 0) : length;
          omission = 'omission' in options ? baseToString(options.omission) : omission;
        } else {
          length = +options || 0;
        }
      }
      string = baseToString(string);
      if (length >= string.length) {
        return string;
      }
      var end = length - omission.length;
      if (end < 1) {
        return omission;
      }
      var result = string.slice(0, end);
      if (separator == null) {
        return result + omission;
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              newEnd,
              substring = string.slice(0, end);

          if (!separator.global) {
            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            newEnd = match.index;
          }
          result = result.slice(0, newEnd == null ? end : newEnd);
        }
      } else if (string.indexOf(separator, end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
     * corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
     * entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = baseToString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      if (guard && isIterateeCall(string, pattern, guard)) {
        pattern = undefined;
      }
      string = baseToString(string);
      return string.match(pattern || reWords) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Function} func The function to attempt.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // avoid throwing errors for invalid selectors
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = restParam(function(func, args) {
      try {
        return func.apply(undefined, args);
      } catch(e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and arguments of the created function. If `func` is a property name the
     * created callback returns the property value for a given element. If `func`
     * is an object the created callback returns `true` for elements that contain
     * the equivalent object properties, otherwise it returns `false`.
     *
     * @static
     * @memberOf _
     * @alias iteratee
     * @category Utility
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // wrap to create custom callback shorthands
     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
     *   if (!match) {
     *     return callback(func, thisArg);
     *   }
     *   return function(object) {
     *     return match[2] == 'gt'
     *       ? object[match[1]] > match[3]
     *       : object[match[1]] < match[3];
     *   };
     * });
     *
     * _.filter(users, 'age__gt36');
     * // => [{ 'user': 'fred', 'age': 40 }]
     */
    function callback(func, thisArg, guard) {
      if (guard && isIterateeCall(func, thisArg, guard)) {
        thisArg = undefined;
      }
      return isObjectLike(func)
        ? matches(func)
        : baseCallback(func, thisArg);
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var getter = _.constant(object);
     *
     * getter() === object;
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * This method returns the first argument provided to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.identity(object) === object;
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that performs a deep comparison between a given object
     * and `source`, returning `true` if the given object has equivalent property
     * values, else `false`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, true));
    }

    /**
     * Creates a function that compares the property value of `path` on a given
     * object to `value`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * _.find(users, _.matchesProperty('user', 'fred'));
     * // => { 'user': 'fred' }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, true));
    }

    /**
     * Creates a function that invokes the method at `path` on a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': _.constant(2) } } },
     *   { 'a': { 'b': { 'c': _.constant(1) } } }
     * ];
     *
     * _.map(objects, _.method('a.b.c'));
     * // => [2, 1]
     *
     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */
    var method = restParam(function(path, args) {
      return function(object) {
        return invokePath(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path on `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = restParam(function(object, args) {
      return function(path) {
        return invokePath(object, path, args);
      };
    });

    /**
     * Adds all own enumerable function properties of a source object to the
     * destination object. If `object` is a function then methods are added to
     * its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.chain=true] Specify whether the functions added
     *  are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      if (options == null) {
        var isObj = isObject(source),
            props = isObj ? keys(source) : undefined,
            methodNames = (props && props.length) ? baseFunctions(source, props) : undefined;

        if (!(methodNames ? methodNames.length : isObj)) {
          methodNames = false;
          options = source;
          source = object;
          object = this;
        }
      }
      if (!methodNames) {
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = true,
          index = -1,
          isFunc = isFunction(object),
          length = methodNames.length;

      if (options === false) {
        chain = false;
      } else if (isObject(options) && 'chain' in options) {
        chain = options.chain;
      }
      while (++index < length) {
        var methodName = methodNames[index],
            func = source[methodName];

        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = (function(func) {
            return function() {
              var chainAll = this.__chain__;
              if (chain || chainAll) {
                var result = object(this.__wrapped__),
                    actions = result.__actions__ = arrayCopy(this.__actions__);

                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
                result.__chain__ = chainAll;
                return result;
              }
              return func.apply(object, arrayPush([this.value()], arguments));
            };
          }(func));
        }
      }
      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      root._ = oldDash;
      return this;
    }

    /**
     * A no-operation function that returns `undefined` regardless of the
     * arguments it receives.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.noop(object) === undefined;
     * // => true
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that returns the property value at `path` on a
     * given object.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': 2 } } },
     *   { 'a': { 'b': { 'c': 1 } } }
     * ];
     *
     * _.map(objects, _.property('a.b.c'));
     * // => [2, 1]
     *
     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the property value at a given path on `object`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return baseGet(object, toPath(path), path + '');
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. If `end` is not specified it is
     * set to `start` with `start` then set to `0`. If `end` is less than `start`
     * a zero-length range is created unless a negative `step` is specified.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the new array of numbers.
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    function range(start, end, step) {
      if (step && isIterateeCall(start, end, step)) {
        end = step = undefined;
      }
      start = +start || 0;
      step = step == null ? 1 : (+step || 0);

      if (end == null) {
        end = start;
        start = 0;
      } else {
        end = +end || 0;
      }
      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (++index < length) {
        result[index] = start;
        start += step;
      }
      return result;
    }

    /**
     * Invokes the iteratee function `n` times, returning an array of the results
     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
     * one argument; (index).
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
     * // => [3, 6, 4]
     *
     * _.times(3, function(n) {
     *   mage.castSpell(n);
     * });
     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
     *
     * _.times(3, function(n) {
     *   this.cast(n);
     * }, mage);
     * // => also invokes `mage.castSpell(n)` three times
     */
    function times(n, iteratee, thisArg) {
      n = nativeFloor(n);

      // Exit early to avoid a JSC JIT bug in Safari 8
      // where `Array(0)` is treated as `Array(1)`.
      if (n < 1 || !nativeIsFinite(n)) {
        return [];
      }
      var index = -1,
          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));

      iteratee = bindCallback(iteratee, thisArg, 1);
      while (++index < n) {
        if (index < MAX_ARRAY_LENGTH) {
          result[index] = iteratee(index);
        } else {
          iteratee(index);
        }
      }
      return result;
    }

    /**
     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {string} [prefix] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return baseToString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} augend The first number to add.
     * @param {number} addend The second number to add.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    function add(augend, addend) {
      return (+augend || 0) + (+addend || 0);
    }

    /**
     * Calculates `n` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Calculates `n` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Gets the maximum value of `collection`. If `collection` is empty or falsey
     * `-Infinity` is returned. If an iteratee function is provided it is invoked
     * for each value in `collection` to generate the criterion by which the value
     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => -Infinity
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.max(users, function(chr) {
     *   return chr.age;
     * });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using the `_.property` callback shorthand
     * _.max(users, 'age');
     * // => { 'user': 'fred', 'age': 40 }
     */
    var max = createExtremum(gt, NEGATIVE_INFINITY);

    /**
     * Gets the minimum value of `collection`. If `collection` is empty or falsey
     * `Infinity` is returned. If an iteratee function is provided it is invoked
     * for each value in `collection` to generate the criterion by which the value
     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => Infinity
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.min(users, function(chr) {
     *   return chr.age;
     * });
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // using the `_.property` callback shorthand
     * _.min(users, 'age');
     * // => { 'user': 'barney', 'age': 36 }
     */
    var min = createExtremum(lt, POSITIVE_INFINITY);

    /**
     * Calculates `n` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Gets the sum of the values in `collection`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 6]);
     * // => 10
     *
     * _.sum({ 'a': 4, 'b': 6 });
     * // => 10
     *
     * var objects = [
     *   { 'n': 4 },
     *   { 'n': 6 }
     * ];
     *
     * _.sum(objects, function(object) {
     *   return object.n;
     * });
     * // => 10
     *
     * // using the `_.property` callback shorthand
     * _.sum(objects, 'n');
     * // => 10
     */
    function sum(collection, iteratee, thisArg) {
      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
        iteratee = undefined;
      }
      iteratee = getCallback(iteratee, thisArg, 3);
      return iteratee.length == 1
        ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee)
        : baseSum(collection, iteratee);
    }

    /*------------------------------------------------------------------------*/

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    // Add functions to the `Map` cache.
    MapCache.prototype['delete'] = mapDelete;
    MapCache.prototype.get = mapGet;
    MapCache.prototype.has = mapHas;
    MapCache.prototype.set = mapSet;

    // Add functions to the `Set` cache.
    SetCache.prototype.push = cachePush;

    // Assign cache to `_.memoize`.
    memoize.Cache = MapCache;

    // Add functions that return wrapped values when chaining.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.callback = callback;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.functions = functions;
    lodash.groupBy = groupBy;
    lodash.indexBy = indexBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.invert = invert;
    lodash.invoke = invoke;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.modArgs = modArgs;
    lodash.negate = negate;
    lodash.omit = omit;
    lodash.once = once;
    lodash.pairs = pairs;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pluck = pluck;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.restParam = restParam;
    lodash.set = set;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortByAll = sortByAll;
    lodash.sortByOrder = sortByOrder;
    lodash.spread = spread;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.times = times;
    lodash.toArray = toArray;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.union = union;
    lodash.uniq = uniq;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.where = where;
    lodash.without = without;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.backflow = flowRight;
    lodash.collect = map;
    lodash.compose = flowRight;
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.extend = assign;
    lodash.iteratee = callback;
    lodash.methods = functions;
    lodash.object = zipObject;
    lodash.select = filter;
    lodash.tail = rest;
    lodash.unique = uniq;

    // Add functions to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add functions that return unwrapped values when chaining.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.deburr = deburr;
    lodash.endsWith = endsWith;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.findWhere = findWhere;
    lodash.first = first;
    lodash.floor = floor;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isBoolean = isBoolean;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isMatch = isMatch;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isString = isString;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.min = min;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padLeft = padLeft;
    lodash.padRight = padRight;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.sum = sum;
    lodash.template = template;
    lodash.trim = trim;
    lodash.trimLeft = trimLeft;
    lodash.trimRight = trimRight;
    lodash.trunc = trunc;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.words = words;

    // Add aliases.
    lodash.all = every;
    lodash.any = some;
    lodash.contains = includes;
    lodash.eq = isEqual;
    lodash.detect = find;
    lodash.foldl = reduce;
    lodash.foldr = reduceRight;
    lodash.head = first;
    lodash.include = includes;
    lodash.inject = reduce;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!lodash.prototype[methodName]) {
          source[methodName] = func;
        }
      });
      return source;
    }()), false);

    /*------------------------------------------------------------------------*/

    // Add functions capable of returning wrapped and unwrapped values when chaining.
    lodash.sample = sample;

    lodash.prototype.sample = function(n) {
      if (!this.__chain__ && n == null) {
        return sample(this.value());
      }
      return this.thru(function(value) {
        return sample(value, n);
      });
    };

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type string
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        var filtered = this.__filtered__;
        if (filtered && !index) {
          return new LazyWrapper(this);
        }
        n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);

        var result = this.clone();
        if (filtered) {
          result.__takeCount__ = nativeMin(result.__takeCount__, n);
        } else {
          result.__views__.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type != LAZY_MAP_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
        var result = this.clone();
        result.__iteratees__.push({ 'iteratee': getCallback(iteratee, thisArg, 1), 'type': type });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.first` and `_.last`.
    arrayEach(['first', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
    arrayEach(['initial', 'rest'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
    arrayEach(['pluck', 'where'], function(methodName, index) {
      var operationName = index ? 'filter' : 'map',
          createCallback = index ? baseMatches : property;

      LazyWrapper.prototype[methodName] = function(value) {
        return this[operationName](createCallback(value));
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.reject = function(predicate, thisArg) {
      predicate = getCallback(predicate, thisArg, 1);
      return this.filter(function(value) {
        return !predicate(value);
      });
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = start == null ? 0 : (+start || 0);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = (+end || 0);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
      return this.reverse().takeWhile(predicate, thisArg).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(POSITIVE_INFINITY);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
          retUnwrapped = /^(?:first|last)$/.test(methodName),
          lodashFunc = lodash[retUnwrapped ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName];

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var args = retUnwrapped ? [1] : arguments,
            chainAll = this.__chain__,
            value = this.__wrapped__,
            isHybrid = !!this.__actions__.length,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var interceptor = function(value) {
          return (retUnwrapped && chainAll)
            ? lodashFunc(value, 1)[0]
            : lodashFunc.apply(undefined, arrayPush([value], args));
        };

        var action = { 'func': thru, 'args': [interceptor], 'thisArg': undefined },
            onlyLazy = isLazy && !isHybrid;

        if (retUnwrapped && !chainAll) {
          if (onlyLazy) {
            value = value.clone();
            value.__actions__.push(action);
            return func.call(value);
          }
          return lodashFunc.call(undefined, this.value())[0];
        }
        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push(action);
          return new LodashWrapper(result, chainAll);
        }
        return this.thru(interceptor);
      };
    });

    // Add `Array` and `String` methods to `lodash.prototype`.
    arrayEach(['join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
      var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          return func.apply(this.value(), args);
        }
        return this[chainName](function(value) {
          return func.apply(value, args);
        });
      };
    });

    // Map minified function names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name,
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': undefined }];

    // Add functions to the lazy wrapper.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chaining functions to the `lodash` wrapper.
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.concat = wrapperConcat;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toString = wrapperToString;
    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add function aliases to the `lodash` wrapper.
    lodash.prototype.collect = lodash.prototype.map;
    lodash.prototype.head = lodash.prototype.first;
    lodash.prototype.select = lodash.prototype.filter;
    lodash.prototype.tail = lodash.prototype.rest;

    return lodash;
  }

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers like r.js check for condition patterns like the following:
  if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
    // Expose lodash to the global object when an AMD loader is present to avoid
    // errors in cases where lodash is loaded by a script tag and not intended
    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
    // more details.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    define(function() {
      return _;
    });
  }
  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
  else if (freeExports && freeModule) {
    // Export for Node.js or RingoJS.
    if (moduleExports) {
      (freeModule.exports = _)._ = _;
    }
    // Export for Rhino with CommonJS support.
    else {
      freeExports._ = _;
    }
  }
  else {
    // Export for a browser or Rhino.
    root._ = _;
  }
}.call(this));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],430:[function(require,module,exports){
// shim for using process in browser

var process = module.exports = {};
var queue = [];
var draining = false;

function drainQueue() {
    if (draining) {
        return;
    }
    draining = true;
    var currentQueue;
    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        var i = -1;
        while (++i < len) {
            currentQueue[i]();
        }
        len = queue.length;
    }
    draining = false;
}
process.nextTick = function (fun) {
    queue.push(fun);
    if (!draining) {
        setTimeout(drainQueue, 0);
    }
};

process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

// TODO(shtylman)
process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],431:[function(require,module,exports){
'use strict';

module.exports = require('./lib/core.js')
require('./lib/done.js')
require('./lib/es6-extensions.js')
require('./lib/node-extensions.js')
},{"./lib/core.js":432,"./lib/done.js":433,"./lib/es6-extensions.js":434,"./lib/node-extensions.js":435}],432:[function(require,module,exports){
'use strict';

var asap = require('asap')

module.exports = Promise;
function Promise(fn) {
  if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new')
  if (typeof fn !== 'function') throw new TypeError('not a function')
  var state = null
  var value = null
  var deferreds = []
  var self = this

  this.then = function(onFulfilled, onRejected) {
    return new self.constructor(function(resolve, reject) {
      handle(new Handler(onFulfilled, onRejected, resolve, reject))
    })
  }

  function handle(deferred) {
    if (state === null) {
      deferreds.push(deferred)
      return
    }
    asap(function() {
      var cb = state ? deferred.onFulfilled : deferred.onRejected
      if (cb === null) {
        (state ? deferred.resolve : deferred.reject)(value)
        return
      }
      var ret
      try {
        ret = cb(value)
      }
      catch (e) {
        deferred.reject(e)
        return
      }
      deferred.resolve(ret)
    })
  }

  function resolve(newValue) {
    try { //Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
      if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.')
      if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
        var then = newValue.then
        if (typeof then === 'function') {
          doResolve(then.bind(newValue), resolve, reject)
          return
        }
      }
      state = true
      value = newValue
      finale()
    } catch (e) { reject(e) }
  }

  function reject(newValue) {
    state = false
    value = newValue
    finale()
  }

  function finale() {
    for (var i = 0, len = deferreds.length; i < len; i++)
      handle(deferreds[i])
    deferreds = null
  }

  doResolve(fn, resolve, reject)
}


function Handler(onFulfilled, onRejected, resolve, reject){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null
  this.onRejected = typeof onRejected === 'function' ? onRejected : null
  this.resolve = resolve
  this.reject = reject
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, onFulfilled, onRejected) {
  var done = false;
  try {
    fn(function (value) {
      if (done) return
      done = true
      onFulfilled(value)
    }, function (reason) {
      if (done) return
      done = true
      onRejected(reason)
    })
  } catch (ex) {
    if (done) return
    done = true
    onRejected(ex)
  }
}

},{"asap":2}],433:[function(require,module,exports){
'use strict';

var Promise = require('./core.js')
var asap = require('asap')

module.exports = Promise
Promise.prototype.done = function (onFulfilled, onRejected) {
  var self = arguments.length ? this.then.apply(this, arguments) : this
  self.then(null, function (err) {
    asap(function () {
      throw err
    })
  })
}
},{"./core.js":432,"asap":2}],434:[function(require,module,exports){
'use strict';

//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = require('./core.js')
var asap = require('asap')

module.exports = Promise

/* Static Functions */

function ValuePromise(value) {
  this.then = function (onFulfilled) {
    if (typeof onFulfilled !== 'function') return this
    return new Promise(function (resolve, reject) {
      asap(function () {
        try {
          resolve(onFulfilled(value))
        } catch (ex) {
          reject(ex);
        }
      })
    })
  }
}
ValuePromise.prototype = Promise.prototype

var TRUE = new ValuePromise(true)
var FALSE = new ValuePromise(false)
var NULL = new ValuePromise(null)
var UNDEFINED = new ValuePromise(undefined)
var ZERO = new ValuePromise(0)
var EMPTYSTRING = new ValuePromise('')

Promise.resolve = function (value) {
  if (value instanceof Promise) return value

  if (value === null) return NULL
  if (value === undefined) return UNDEFINED
  if (value === true) return TRUE
  if (value === false) return FALSE
  if (value === 0) return ZERO
  if (value === '') return EMPTYSTRING

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then
      if (typeof then === 'function') {
        return new Promise(then.bind(value))
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex)
      })
    }
  }

  return new ValuePromise(value)
}

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr)

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([])
    var remaining = args.length
    function res(i, val) {
      try {
        if (val && (typeof val === 'object' || typeof val === 'function')) {
          var then = val.then
          if (typeof then === 'function') {
            then.call(val, function (val) { res(i, val) }, reject)
            return
          }
        }
        args[i] = val
        if (--remaining === 0) {
          resolve(args);
        }
      } catch (ex) {
        reject(ex)
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i])
    }
  })
}

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) { 
    reject(value);
  });
}

Promise.race = function (values) {
  return new Promise(function (resolve, reject) { 
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    })
  });
}

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
}

},{"./core.js":432,"asap":2}],435:[function(require,module,exports){
'use strict';

//This file contains then/promise specific extensions that are only useful for node.js interop

var Promise = require('./core.js')
var asap = require('asap')

module.exports = Promise

/* Static Functions */

Promise.denodeify = function (fn, argumentCount) {
  argumentCount = argumentCount || Infinity
  return function () {
    var self = this
    var args = Array.prototype.slice.call(arguments)
    return new Promise(function (resolve, reject) {
      while (args.length && args.length > argumentCount) {
        args.pop()
      }
      args.push(function (err, res) {
        if (err) reject(err)
        else resolve(res)
      })
      var res = fn.apply(self, args)
      if (res && (typeof res === 'object' || typeof res === 'function') && typeof res.then === 'function') {
        resolve(res)
      }
    })
  }
}
Promise.nodeify = function (fn) {
  return function () {
    var args = Array.prototype.slice.call(arguments)
    var callback = typeof args[args.length - 1] === 'function' ? args.pop() : null
    var ctx = this
    try {
      return fn.apply(this, arguments).nodeify(callback, ctx)
    } catch (ex) {
      if (callback === null || typeof callback == 'undefined') {
        return new Promise(function (resolve, reject) { reject(ex) })
      } else {
        asap(function () {
          callback.call(ctx, ex)
        })
      }
    }
  }
}

Promise.prototype.nodeify = function (callback, ctx) {
  if (typeof callback != 'function') return this

  this.then(function (value) {
    asap(function () {
      callback.call(ctx, null, value)
    })
  }, function (err) {
    asap(function () {
      callback.call(ctx, err)
    })
  })
}

},{"./core.js":432,"asap":2}],436:[function(require,module,exports){
/*!
  * $script.js JS loader & dependency manager
  * https://github.com/ded/script.js
  * (c) Dustin Diaz 2014 | License MIT
  */

(function (name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (typeof define == 'function' && define.amd) define(definition)
  else this[name] = definition()
})('$script', function () {
  var doc = document
    , head = doc.getElementsByTagName('head')[0]
    , s = 'string'
    , f = false
    , push = 'push'
    , readyState = 'readyState'
    , onreadystatechange = 'onreadystatechange'
    , list = {}
    , ids = {}
    , delay = {}
    , scripts = {}
    , scriptpath
    , urlArgs

  function every(ar, fn) {
    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
    return 1
  }
  function each(ar, fn) {
    every(ar, function (el) {
      fn(el)
      return 1
    })
  }

  function $script(paths, idOrDone, optDone) {
    paths = paths[push] ? paths : [paths]
    var idOrDoneIsDone = idOrDone && idOrDone.call
      , done = idOrDoneIsDone ? idOrDone : optDone
      , id = idOrDoneIsDone ? paths.join('') : idOrDone
      , queue = paths.length
    function loopFn(item) {
      return item.call ? item() : list[item]
    }
    function callback() {
      if (!--queue) {
        list[id] = 1
        done && done()
        for (var dset in delay) {
          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
        }
      }
    }
    setTimeout(function () {
      each(paths, function loading(path, force) {
        if (path === null) return callback()
        
        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
        }
        
        if (scripts[path]) {
          if (id) ids[id] = 1
          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
        }

        scripts[path] = 1
        if (id) ids[id] = 1
        create(path, callback)
      })
    }, 0)
    return $script
  }

  function create(path, fn) {
    var el = doc.createElement('script'), loaded
    el.onload = el.onerror = el[onreadystatechange] = function () {
      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
      el.onload = el[onreadystatechange] = null
      loaded = 1
      scripts[path] = 2
      fn()
    }
    el.async = 1
    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
    head.insertBefore(el, head.lastChild)
  }

  $script.get = create

  $script.order = function (scripts, id, done) {
    (function callback(s) {
      s = scripts.shift()
      !scripts.length ? $script(s, id, done) : $script(s, callback)
    }())
  }

  $script.path = function (p) {
    scriptpath = p
  }
  $script.urlArgs = function (str) {
    urlArgs = str;
  }
  $script.ready = function (deps, ready, req) {
    deps = deps[push] ? deps : [deps]
    var missing = [];
    !each(deps, function (dep) {
      list[dep] || missing[push](dep);
    }) && every(deps, function (dep) {return list[dep]}) ?
      ready() : !function (key) {
      delay[key] = delay[key] || []
      delay[key][push](ready)
      req && req(missing)
    }(deps.join('|'))
    return $script
  }

  $script.done = function (idOrDone) {
    $script([null], idOrDone)
  }

  return $script
});

},{}],437:[function(require,module,exports){
/*jslint onevar:true, undef:true, newcap:true, regexp:true, bitwise:true, maxerr:50, indent:4, white:false, nomen:false, plusplus:false */
/*global define:false, require:false, exports:false, module:false, signals:false */

/** @license
 * JS Signals <http://millermedeiros.github.com/js-signals/>
 * Released under the MIT license
 * Author: Miller Medeiros
 * Version: 1.0.0 - Build: 268 (2012/11/29 05:48 PM)
 */

(function(global){

    // SignalBinding -------------------------------------------------
    //================================================================

    /**
     * Object that represents a binding between a Signal and a listener function.
     * <br />- <strong>This is an internal constructor and shouldn't be called by regular users.</strong>
     * <br />- inspired by Joa Ebert AS3 SignalBinding and Robert Penner's Slot classes.
     * @author Miller Medeiros
     * @constructor
     * @internal
     * @name SignalBinding
     * @param {Signal} signal Reference to Signal object that listener is currently bound to.
     * @param {Function} listener Handler function bound to the signal.
     * @param {boolean} isOnce If binding should be executed just once.
     * @param {Object} [listenerContext] Context on which listener will be executed (object that should represent the `this` variable inside listener function).
     * @param {Number} [priority] The priority level of the event listener. (default = 0).
     */
    function SignalBinding(signal, listener, isOnce, listenerContext, priority) {

        /**
         * Handler function bound to the signal.
         * @type Function
         * @private
         */
        this._listener = listener;

        /**
         * If binding should be executed just once.
         * @type boolean
         * @private
         */
        this._isOnce = isOnce;

        /**
         * Context on which listener will be executed (object that should represent the `this` variable inside listener function).
         * @memberOf SignalBinding.prototype
         * @name context
         * @type Object|undefined|null
         */
        this.context = listenerContext;

        /**
         * Reference to Signal object that listener is currently bound to.
         * @type Signal
         * @private
         */
        this._signal = signal;

        /**
         * Listener priority
         * @type Number
         * @private
         */
        this._priority = priority || 0;
    }

    SignalBinding.prototype = {

        /**
         * If binding is active and should be executed.
         * @type boolean
         */
        active : true,

        /**
         * Default parameters passed to listener during `Signal.dispatch` and `SignalBinding.execute`. (curried parameters)
         * @type Array|null
         */
        params : null,

        /**
         * Call listener passing arbitrary parameters.
         * <p>If binding was added using `Signal.addOnce()` it will be automatically removed from signal dispatch queue, this method is used internally for the signal dispatch.</p>
         * @param {Array} [paramsArr] Array of parameters that should be passed to the listener
         * @return {*} Value returned by the listener.
         */
        execute : function (paramsArr) {
            var handlerReturn, params;
            if (this.active && !!this._listener) {
                params = this.params? this.params.concat(paramsArr) : paramsArr;
                handlerReturn = this._listener.apply(this.context, params);
                if (this._isOnce) {
                    this.detach();
                }
            }
            return handlerReturn;
        },

        /**
         * Detach binding from signal.
         * - alias to: mySignal.remove(myBinding.getListener());
         * @return {Function|null} Handler function bound to the signal or `null` if binding was previously detached.
         */
        detach : function () {
            return this.isBound()? this._signal.remove(this._listener, this.context) : null;
        },

        /**
         * @return {Boolean} `true` if binding is still bound to the signal and have a listener.
         */
        isBound : function () {
            return (!!this._signal && !!this._listener);
        },

        /**
         * @return {boolean} If SignalBinding will only be executed once.
         */
        isOnce : function () {
            return this._isOnce;
        },

        /**
         * @return {Function} Handler function bound to the signal.
         */
        getListener : function () {
            return this._listener;
        },

        /**
         * @return {Signal} Signal that listener is currently bound to.
         */
        getSignal : function () {
            return this._signal;
        },

        /**
         * Delete instance properties
         * @private
         */
        _destroy : function () {
            delete this._signal;
            delete this._listener;
            delete this.context;
        },

        /**
         * @return {string} String representation of the object.
         */
        toString : function () {
            return '[SignalBinding isOnce:' + this._isOnce +', isBound:'+ this.isBound() +', active:' + this.active + ']';
        }

    };


/*global SignalBinding:false*/

    // Signal --------------------------------------------------------
    //================================================================

    function validateListener(listener, fnName) {
        if (typeof listener !== 'function') {
            throw new Error( 'listener is a required param of {fn}() and should be a Function.'.replace('{fn}', fnName) );
        }
    }

    /**
     * Custom event broadcaster
     * <br />- inspired by Robert Penner's AS3 Signals.
     * @name Signal
     * @author Miller Medeiros
     * @constructor
     */
    function Signal() {
        /**
         * @type Array.<SignalBinding>
         * @private
         */
        this._bindings = [];
        this._prevParams = null;

        // enforce dispatch to aways work on same context (#47)
        var self = this;
        this.dispatch = function(){
            Signal.prototype.dispatch.apply(self, arguments);
        };
    }

    Signal.prototype = {

        /**
         * Signals Version Number
         * @type String
         * @const
         */
        VERSION : '1.0.0',

        /**
         * If Signal should keep record of previously dispatched parameters and
         * automatically execute listener during `add()`/`addOnce()` if Signal was
         * already dispatched before.
         * @type boolean
         */
        memorize : false,

        /**
         * @type boolean
         * @private
         */
        _shouldPropagate : true,

        /**
         * If Signal is active and should broadcast events.
         * <p><strong>IMPORTANT:</strong> Setting this property during a dispatch will only affect the next dispatch, if you want to stop the propagation of a signal use `halt()` instead.</p>
         * @type boolean
         */
        active : true,

        /**
         * @param {Function} listener
         * @param {boolean} isOnce
         * @param {Object} [listenerContext]
         * @param {Number} [priority]
         * @return {SignalBinding}
         * @private
         */
        _registerListener : function (listener, isOnce, listenerContext, priority) {

            var prevIndex = this._indexOfListener(listener, listenerContext),
                binding;

            if (prevIndex !== -1) {
                binding = this._bindings[prevIndex];
                if (binding.isOnce() !== isOnce) {
                    throw new Error('You cannot add'+ (isOnce? '' : 'Once') +'() then add'+ (!isOnce? '' : 'Once') +'() the same listener without removing the relationship first.');
                }
            } else {
                binding = new SignalBinding(this, listener, isOnce, listenerContext, priority);
                this._addBinding(binding);
            }

            if(this.memorize && this._prevParams){
                binding.execute(this._prevParams);
            }

            return binding;
        },

        /**
         * @param {SignalBinding} binding
         * @private
         */
        _addBinding : function (binding) {
            //simplified insertion sort
            var n = this._bindings.length;
            do { --n; } while (this._bindings[n] && binding._priority <= this._bindings[n]._priority);
            this._bindings.splice(n + 1, 0, binding);
        },

        /**
         * @param {Function} listener
         * @return {number}
         * @private
         */
        _indexOfListener : function (listener, context) {
            var n = this._bindings.length,
                cur;
            while (n--) {
                cur = this._bindings[n];
                if (cur._listener === listener && cur.context === context) {
                    return n;
                }
            }
            return -1;
        },

        /**
         * Check if listener was attached to Signal.
         * @param {Function} listener
         * @param {Object} [context]
         * @return {boolean} if Signal has the specified listener.
         */
        has : function (listener, context) {
            return this._indexOfListener(listener, context) !== -1;
        },

        /**
         * Add a listener to the signal.
         * @param {Function} listener Signal handler function.
         * @param {Object} [listenerContext] Context on which listener will be executed (object that should represent the `this` variable inside listener function).
         * @param {Number} [priority] The priority level of the event listener. Listeners with higher priority will be executed before listeners with lower priority. Listeners with same priority level will be executed at the same order as they were added. (default = 0)
         * @return {SignalBinding} An Object representing the binding between the Signal and listener.
         */
        add : function (listener, listenerContext, priority) {
            validateListener(listener, 'add');
            return this._registerListener(listener, false, listenerContext, priority);
        },

        /**
         * Add listener to the signal that should be removed after first execution (will be executed only once).
         * @param {Function} listener Signal handler function.
         * @param {Object} [listenerContext] Context on which listener will be executed (object that should represent the `this` variable inside listener function).
         * @param {Number} [priority] The priority level of the event listener. Listeners with higher priority will be executed before listeners with lower priority. Listeners with same priority level will be executed at the same order as they were added. (default = 0)
         * @return {SignalBinding} An Object representing the binding between the Signal and listener.
         */
        addOnce : function (listener, listenerContext, priority) {
            validateListener(listener, 'addOnce');
            return this._registerListener(listener, true, listenerContext, priority);
        },

        /**
         * Remove a single listener from the dispatch queue.
         * @param {Function} listener Handler function that should be removed.
         * @param {Object} [context] Execution context (since you can add the same handler multiple times if executing in a different context).
         * @return {Function} Listener handler function.
         */
        remove : function (listener, context) {
            validateListener(listener, 'remove');

            var i = this._indexOfListener(listener, context);
            if (i !== -1) {
                this._bindings[i]._destroy(); //no reason to a SignalBinding exist if it isn't attached to a signal
                this._bindings.splice(i, 1);
            }
            return listener;
        },

        /**
         * Remove all listeners from the Signal.
         */
        removeAll : function () {
            var n = this._bindings.length;
            while (n--) {
                this._bindings[n]._destroy();
            }
            this._bindings.length = 0;
        },

        /**
         * @return {number} Number of listeners attached to the Signal.
         */
        getNumListeners : function () {
            return this._bindings.length;
        },

        /**
         * Stop propagation of the event, blocking the dispatch to next listeners on the queue.
         * <p><strong>IMPORTANT:</strong> should be called only during signal dispatch, calling it before/after dispatch won't affect signal broadcast.</p>
         * @see Signal.prototype.disable
         */
        halt : function () {
            this._shouldPropagate = false;
        },

        /**
         * Dispatch/Broadcast Signal to all listeners added to the queue.
         * @param {...*} [params] Parameters that should be passed to each handler.
         */
        dispatch : function (params) {
            if (! this.active) {
                return;
            }

            var paramsArr = Array.prototype.slice.call(arguments),
                n = this._bindings.length,
                bindings;

            if (this.memorize) {
                this._prevParams = paramsArr;
            }

            if (! n) {
                //should come after memorize
                return;
            }

            bindings = this._bindings.slice(); //clone array in case add/remove items during dispatch
            this._shouldPropagate = true; //in case `halt` was called before dispatch or during the previous dispatch.

            //execute all callbacks until end of the list or until a callback returns `false` or stops propagation
            //reverse loop since listeners with higher priority will be added at the end of the list
            do { n--; } while (bindings[n] && this._shouldPropagate && bindings[n].execute(paramsArr) !== false);
        },

        /**
         * Forget memorized arguments.
         * @see Signal.memorize
         */
        forget : function(){
            this._prevParams = null;
        },

        /**
         * Remove all bindings from signal and destroy any reference to external objects (destroy Signal object).
         * <p><strong>IMPORTANT:</strong> calling any method on the signal instance after calling dispose will throw errors.</p>
         */
        dispose : function () {
            this.removeAll();
            delete this._bindings;
            delete this._prevParams;
        },

        /**
         * @return {string} String representation of the object.
         */
        toString : function () {
            return '[Signal active:'+ this.active +' numListeners:'+ this.getNumListeners() +']';
        }

    };


    // Namespace -----------------------------------------------------
    //================================================================

    /**
     * Signals namespace
     * @namespace
     * @name signals
     */
    var signals = Signal;

    /**
     * Custom event broadcaster
     * @see Signal
     */
    // alias for backwards compatibility (see #gh-44)
    signals.Signal = Signal;



    //exports to multiple environments
    if(typeof define === 'function' && define.amd){ //AMD
        define(function () { return signals; });
    } else if (typeof module !== 'undefined' && module.exports){ //node
        module.exports = signals;
    } else { //browser
        //use string because of Google closure compiler ADVANCED_MODE
        /*jslint sub:true */
        global['signals'] = signals;
    }

}(this));

},{}],438:[function(require,module,exports){
module.exports = function (core, user) {
  let $this, scheduleId

  $(document).on('click', '.show-add-note-btn', function () {
    $this = $(this)
    scheduleId = $this.attr('data-id')

    if (scheduleId) {
      $('#talent-add-note-modal').modal('show')
    } else {
      alert('Add talent on like it list first to add note.')
    }
  })

  $(document).on('click', '#add-note-btn', function () {
    if (scheduleId) {
      let data = {
        scheduleId: scheduleId,
        body: $('#add-note-body').val()
      }

      if (!data.body) {
        $('#add-note-required').fadeIn().delay(3000).fadeOut()
      } else {
        core.resource.schedule_note.post(data)
          .then(function (res) {
            $('#add-note-success').fadeIn().delay(3000).fadeOut()

            let str = '<div class="note-item">' +
              '<div class="name-date">' +
                '<div class="name">' + user.bam_cd_user.getFullName() + '</div>' +
                '<div class="date">' + moment(res.created_at).format('YY-MM-DD HH:mm') + '</div>' +
              '</div>' +
              '<div class="note-body">' + res.body + '</div>' +
              '<a href="#" class="show-edit-note-btn" data-id="' + scheduleId + '-' + res.id + '"><i class="fa fa-pencil"></i> Edit this note</a>' +
            '</div>'

            $this.parents('.talent-note-v2').find('#schedule-notes').append(str)
            $('#add-note-body').val('')

            setTimeout(function () {
              $('#talent-add-note-modal').modal('hide')
            }, 800)
          })
      }
    }
  })
}

},{}],439:[function(require,module,exports){
module.exports = function (core, user) {
  self = this
  self.core = core
  self.user = user

  // FOR TOP ALERT
  let data = {
    query: [
      [ 'orderBy', 'created_at', 'DESC' ],
      [ 'where', 'priority', '=', '1' ],
      [ 'where', 'app_id', '=', '8']
    ],
    per_page: 1
  }

  self.core.resource.alert.get(data)
    .then(function (res) {
      if (res.data && res.data[0] && res.data[0].body) {
        res.data[0].body = res.data[0].body
          .replace(/702-446-0888/g, '424-688-1722')
          .replace(/702-446-0808/g, '424-688-1722')
      }
      self.core.service.databind('#top-alert-div', res.data[0])
      // to determine margin-top of body.. move down if top-alert-div is visible
      let topAlertDiv = $('#top-alert-div')
      if (topAlertDiv.is(':visible')) {
        $('#menu-content-demo').css('padding-top', '100px')
        $('#main-wrapper').css('margin-top', '40px')
      } else {
        $('#menu-content-demo').css('padding-top', '66px')
        $('#main-wrapper').css('margin-top', '0px')
      }
    })
}

},{}],440:[function(require,module,exports){
module.exports = function (core) {
  $('[data-date-picker]').each(function () {
    $(this).datepicker({
      dateFormat: $(this).attr('data-date-format')
    })
  })
}

},{}],441:[function(require,module,exports){
// need to manually call bootstrap dropdown.. i dont know the reason
module.exports = function () {
  $('.dropdown-toggle').dropdown()
}

},{}],442:[function(require,module,exports){
module.exports = function (core, user) {
  let $this, scheduleId, noteId
  $(document).on('click', '.show-edit-note-btn', function (e) {
    e.preventDefault()
    $this = $(this)
    let id = $this.attr('data-id').split('-')
    scheduleId = id[0]
    noteId = id[1]

    if (scheduleId) {
      let data = {
        scheduleId: scheduleId,
        noteId: noteId
      }

      core.resource.schedule_note.get(data)
        .then(function (res) {
          core.service.databind('#talent-edit-note-modal', res)
          $('#talent-edit-note-modal').modal('show')
        })
    }
  })

  $(document).on('click', '#edit-note-btn', function () {
    if (scheduleId && noteId) {
      let data = {
        scheduleId: scheduleId,
        noteId: noteId,
        body: $('#edit-note-body').val()
      }

      if (!data.body) {
        $('#edit-note-required').fadeIn().delay(3000).fadeOut()
      } else {
        core.resource.schedule_note.patch(data)
          .then(function (res) {
            $('#edit-note-success').fadeIn().delay(3000).fadeOut()
            $this.parents('.note-item').find('.note-body').text(res.body)
            $('#talent-edit-note-modal').modal('hide')
          })
      }
    }
  })
}

},{}],443:[function(require,module,exports){
module.exports = function (core, user) {
  if (!user || !parseInt(user.bam_cd_user_id, 10)) {
    return
  }

  var banner = $('#email-verify-banner')
  if (!banner.length) {
    return
  }

  function showBanner (status) {
    if (!status || status.verified) {
      banner.hide()
      $('#main-wrapper').css('margin-top', '0px')
      return
    }

    banner.find('[data-email]').text(status.email || '')

    if (status.sent) {
      banner.find('[data-message-sent]').show()
      banner.find('[data-message-pending]').hide()
    } else {
      banner.find('[data-message-sent]').hide()
      banner.find('[data-message-pending]').show()
    }

    banner.show()
    $('#main-wrapper').css('margin-top', '40px')
  }

  function refreshStatus () {
    return core.service.rest.get(core.config.api.base + '/cd/email_verification/status')
      .then(showBanner)
      .catch(function () {
        banner.hide()
      })
  }

  banner.on('click', '[data-action="resend"]', function (e) {
    e.preventDefault()
    core.service.rest.post(core.config.api.base + '/cd/email_verification/send', {})
      .then(function () {
        banner.find('[data-message-sent]').show()
        banner.find('[data-message-pending]').hide()
        banner.find('[data-feedback]').text('Verification email sent.').show().delay(4000).fadeOut()
      })
      .catch(function () {
        banner.find('[data-feedback]').text('Could not send verification email. Please try again.').show()
      })
  })

  banner.on('click', '[data-action="change-email"]', function (e) {
    e.preventDefault()
    var nextEmail = window.prompt('Enter the email address you want to use:', banner.find('[data-email]').text())
    if (!nextEmail) {
      return
    }

    core.service.rest.patch(core.config.api.base + '/cd/email_verification/email', { email: nextEmail })
      .then(function (res) {
        banner.find('[data-email]').text(res.email || nextEmail)
        banner.find('[data-message-sent]').show()
        banner.find('[data-message-pending]').hide()
        banner.find('[data-feedback]').text('Verification email sent to ' + (res.email || nextEmail) + '.').show()
      })
      .catch(function () {
        banner.find('[data-feedback]').text('Could not update email. It may already be in use.').show()
      })
  })

  refreshStatus()
}

},{}],444:[function(require,module,exports){
module.exports = function () {
  $(document).on('click', '.favorite-button', function () {
    let $this = $(this)
    let talentnum

    let id = $this.parent().attr('data-id')

    if (id) {
      id = id.split('-')
      talentnum = id.length > 2 ? id[2] : id[0]
    } else {
      let getURL = window.location.pathname
      let extracttn = getURL.split('/')
      talentnum = extracttn[2]
    }

    if (parseInt(talentnum)) {
      // not favorited yet, favorite it!
      if ($this.hasClass('btn-outline')) {
        let data = {
          bam_talentnum: talentnum
        }

        // create favorite
        self.core.resource.favorite_talent.post(data)
          .then(function (res) {
          // change color
            if ($this.hasClass('producers-pick-btn')) { $this.removeClass('btn-outline').addClass('producers-pick') } else { $this.removeClass('btn-outline').addClass('btn-warning') }
            $this.find('.favorite-button-text').text('Added to Favorites')
          })
      }
      // already favorite, remove favorite!
      else if ($this.hasClass('btn-warning') || $this.hasClass('producers-pick')) {
        // use id as favorite id
        let data = {
          favoriteId: talentnum
        }

        // remove favorite
        self.core.resource.favorite_talent.delete(data)
          .then(function (res) {
          // change color
            if ($this.hasClass('producers-pick')) { $this.removeClass('producers-pick').addClass('btn-outline') } else { $this.removeClass('btn-warning').addClass('btn-outline') }
            $this.find('.favorite-button-text').text('Add to Favorites')
          })
      }
    }
  })
}

},{}],445:[function(require,module,exports){
module.exports = function () {
  // ===== Scroll to Top ====
  $(window).scroll(function () {
    if ($(this).scrollTop() >= 500) { // If page is scrolled more than 50px
      $('#go-to-top-btn').fadeIn(200) // Fade in the arrow
    } else {
      $('#go-to-top-btn').fadeOut(200) // Else fade out the arrow
    }
  })
  $('#go-to-top-btn').click(function () { // When arrow is clicked
    $('body,html').animate({
      scrollTop: 0 // Scroll to top of body
    }, 500)
  })
}

},{}],446:[function(require,module,exports){
module.exports = function (core, user) {
  if (user && user.bam_cd_user) {
    core.service.databind('#main-menu', user.bam_cd_user)
    core.service.databind('#main-navbar-collapse', user.bam_cd_user)
  }
}

},{}],447:[function(require,module,exports){
module.exports = function (core, user) {
  let projects
  let user_id
  let bam_role_id
  let $button

  $(document).on('click', '.add-to-like-it-list', function () {
    if (!$(this).hasClass('liked-talent')) { // Add
      console.log($(this))
      $('#add-like-it-list-modal #casting-list').val(-1).select2()
      $('#add-like-it-list-modal #role-list').val(-1).select2()

      let promise = $.when()
      let $this = $(this)
      $button = $this
      console.log($button, 'button')

      let id = $this.parent().attr('data-id')
      id = id.split('-')
      console.log(this)
      console.log(id)
      user_id = id[0]
      console.log(user_id)

      if (id.length > 1 && parseInt(id[1])) {
        bam_role_id = id[1]
        addToLikeItList()
      } else {
        $('#add-like-it-list-modal').modal('show')

        if (!projects) {
          let data = {
            q: [
              [ 'with', 'bam_roles' ]
            ]
          }

          promise = core.resource.project.get(data)
        }

        promise.then(function (res) {
          if (!projects) {
            projects = res
          }

          core.service.databind('#add-like-it-list-modal #casting-list', projects)
        })
      }
    } else { // Remove
      if (confirm('Are you sure you want to remove this talent from your Like it List?')) {
        let $this = $(this)
        $button = $this

        let scheduleId = $button.find('.like-it-list-schedule-id').val()

        let data = {
          scheduleId: scheduleId,
          rating: 0
        }

        self.core.resource.schedule.put(data)
          .then(function (res) {
            $button.removeClass('btn-success liked-talent').addClass('btn-outline')
            $button.find('span').text('Add to Like it List')
            $button.closest('.talent-item').find('.show-add-note-btn').attr('data-id', '')
          })
      }
    }
  })

  $(document).on('mouseenter', '.add-to-like-it-list', function () {
    if ($(this).hasClass('btn-success')) {
      $(this).find('span').text('Remove from Like it List')
      $(this).find('i').removeClass('fa-check').addClass('fa-times')
      $(this).attr('title', 'Remove from Like it List')
      $(this).removeClass('btn-success')
      $(this).addClass('btn-danger')
    }
  }).on('mouseleave', '.add-to-like-it-list', function () {
    if ($(this).hasClass('btn-danger')) {
      $(this).find('span').text('Added to Like it List')
      $(this).find('i').removeClass('fa-times').addClass('fa-check')
      $(this).removeAttr('title')
      $(this).removeClass('btn-danger')
      $(this).addClass('btn-success')
    }
  })

  $('#add-like-it-list-modal #casting-list').on('change', function () {
    let project = _.find(projects.data, function (p) {
      return p.casting_id == $('#add-like-it-list-modal #casting-list').val()
    })

    core.service.databind('#add-like-it-list-modal #role-list', project)
  })

  $('#add-like-it-list-button').on('click', addToLikeItList)

  function addToLikeItList () {
    if (!bam_role_id) { bam_role_id = $('#add-like-it-list-modal #role-list').val() }

    let data = {
      q: [
        [ 'where', 'bam_role_id', '=', bam_role_id ],
        [ 'where', 'invitee_id', '=', user_id ]
      ]
    }

    core.resource.schedule.get(data)
      .then(function (res) {
        console.log(res)
        let schedule = _.first(res.data)

        if (schedule) {
          // update
          let data = {
            scheduleId: schedule.id,
            rating: 5
          }

          core.resource.schedule.patch(data)
            .then(function (res) {
              let total = parseInt($('#like-it-list-total').text().replace('(', '').replace(')', ''))

              if (total) {
                total++
              } else {
                total = 1
              }

              $('#like-it-list-total').text('(' + total + ')')

              $button.find('.like-it-list-schedule-id').val(res.id)
              $button.removeClass('btn-outline').addClass('btn-success liked-talent')
              $button.find('i').removeClass('fa-plus').addClass('fa-check')
              $button.find('span').text('Added to Like it List')
              $('#add-like-it-list-modal').modal('hide')
              $button.closest('.talent-item').find('.show-add-note-btn').attr('data-id', res.id)
            })
        } else if (!schedule) {
          // create
          let data = {
            bam_role_id: bam_role_id,
            rating: 5,
            invitee_id: user_id,
            inviter_id: user.id,
            invitee_status: self.core.resource.schedule_cd_status.PENDING,
            inviter_status: self.core.resource.schedule_cd_status.PENDING,
            status: self.core.resource.schedule_status.PENDING
          }

          core.resource.schedule.post(data)
            .then(function (res) {
              let total = parseInt($('#like-it-list-total').text().replace('(', '').replace(')', ''))

              if (total) {
                total++
              } else {
                total = 1
              }

              $('#like-it-list-total').text('(' + total + ')')

              $button.find('.like-it-list-schedule-id').val(res.id)
              $button.removeClass('btn-outline').addClass('btn-success liked-talent')
              $button.find('i').removeClass('fa-plus').addClass('fa-check')
              $button.find('span').text('Added to Like it List')
              $('#add-like-it-list-modal').modal('hide')
              $button.closest('.talent-item').find('.show-add-note-btn').attr('data-id', res.id)
            })
        }
      })
  }
}

},{}],448:[function(require,module,exports){
module.exports = function (core, user) {
  let isInit = false
  let markers = []
  let circles = []
  let google = null
  let DISTANCE_UNIT = 'm'

  let location = {
    LAT: 39.154557,
    LNG: -101.008301
  }

  let lngLat = []
  let placesLngLat = []

  let el = $('#location-filter-map')
  let el2 = $('#lng-lat')

  let addMarker = function (location, map, options) {
    let marker = new google.Marker($.extend({ map: map, position: location }, options))
    // listen to dragend event
    marker.addListener('dragend', function (event) {
      location.LAT = event.latLng.lat()
      location.LNG = event.latLng.lng()
    })
    markers.push(marker)
  }

  let addCircle = function (center, radius, map) {
    let circle = new google.Circle({
      strokeColor: '#FF0000',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: '#FF0000',
      fillOpacity: 0.35,
      map: map,
      center: center,
      radius: radius
    })
    circles.push(circle)
  }

  let radius = function () {
    let miles = $('#place-miles-in').val()
    return miles * 1609.344
  }

  let clearMarkers = function () {
    _.each(markers, function (marker) {
      marker.setMap(null)
    })
    _.each(circles, function (circle) {
      circle.setMap(null)
    })
    markers = []
    circles = []
  }

  let updateStatus = function () {
    if (placesLngLat.length > 0) {
      lngLat = []
      _.each(placesLngLat, function (place, index) {
        updateCircleRadius(circles[index])

        let range = calculateRange(
          place.lng,
          place.lat,
          $('#place-miles-in').val())
        if (lngLat.length == 0) {
          lngLat.push(range)
        } else {
          // calculated longitude
          lngLat[0].lng.max = _.max([lngLat[0].lng.max, range.lng.max])
          lngLat[0].lng.min = _.min([lngLat[0].lng.min, range.lng.min])
          // calculated latitude
          lngLat[0].lat.max = _.max([lngLat[0].lat.max, range.lat.max])
          lngLat[0].lat.min = _.min([lngLat[0].lat.min, range.lat.min])
        }
      })
      el2.val(JSON.stringify(lngLat))
    }
  }

  let updateCircleRadius = function (circle) {
    let miles = $('#place-miles-in').val()
    circle.setRadius(miles * 1609.344)
  }

  let bpotGetDueCoords = function (lat, lng, bearing, distance) {
    if (DISTANCE_UNIT == 'm') r = 3963.1676
    else r = 6378.1

    // new latitude in degrees
    let newLat = GeoPoint.radiansToDegrees(Math.asin(Math.sin(GeoPoint.degreesToRadians(lat)) * Math.cos(distance / r) + Math.cos(GeoPoint.degreesToRadians(lat)) * Math.sin(distance / r) * Math.cos(GeoPoint.degreesToRadians(bearing))))

    // new longitude in degrees
    let newLng = GeoPoint.radiansToDegrees(GeoPoint.degreesToRadians(lng) + Math.atan2(Math.sin(GeoPoint.degreesToRadians(bearing)) * Math.sin(distance / r) * Math.cos(GeoPoint.degreesToRadians(lat)), Math.cos(distance / r) - Math.sin(GeoPoint.degreesToRadians(lat)) * Math.sin(GeoPoint.degreesToRadians(newLat))))

    return {
      lng: newLng,
      lat: newLat
    }
  }

  let calculateRange = function (lng, lat, distance) {
    let path_top_right = bpotGetDueCoords(lat, lng, 45, distance)
    let path_bottom_right = bpotGetDueCoords(lat, lng, 135, distance)
    let path_bottom_left = bpotGetDueCoords(lat, lng, 225, distance)
    let path_top_left = bpotGetDueCoords(lat, lng, 315, distance)

    // longitude
    let longitude = {
      max: _.max([path_top_right.lng, path_bottom_right.lng, path_bottom_left.lng, path_top_left.lng]),
      min: _.min([path_top_right.lng, path_bottom_right.lng, path_bottom_left.lng, path_top_left.lng])
    }

    // latitude
    let latitude = {
      max: _.max([path_top_right.lat, path_bottom_right.lat, path_bottom_left.lat, path_top_left.lat]),
      min: _.min([path_top_right.lat, path_bottom_right.lat, path_bottom_left.lat, path_top_left.lat])
    }

    return {
      lng: longitude,
      lat: latitude
    }
  }

  let init = function (mapOptions) {
    let opt = {
      center: new google.LatLng(location.LAT, location.LNG),
      zoom: 6,
      mapTypeId: google.MapTypeId.ROADMAP,
      navigationControl: false
    }

    let map = new google.Map(el.get(0), $.extend(opt, mapOptions))
    let icon = {
      url: 'https://maps.gstatic.com/mapfiles/place_api/icons/geocode-71.png',
      size: new google.Size(71, 71),
      origin: new google.Point(0, 0),
      anchor: new google.Point(17, 34),
      scaledSize: new google.Size(25, 25)
    }

    addCircle(opt.center, 8046.72, map)

    placesLngLat.push({ lng: location.LNG, lat: location.LAT })

    el2.val(JSON.stringify(lngLat))

    // create the search box and link it to the UI element
    let input = $('#location-search-box').get(0)
    let searchBox = new google.places.SearchBox(input)

    // Bias the SearchBox results towards current map's viewport.
    map.addListener('bounds_changed', function () {
      searchBox.setBounds(map.getBounds())
    })

    // Listen for the event fired when the user selects a prediction and retrieve
    // more details for that place
    searchBox.addListener('places_changed', function () {
      let places = searchBox.getPlaces()

      if (places.length == 0) {
        return
      }

      lngLat = []
      el2.val('[]')
      placesLngLat = []

      // Clear old markers
      clearMarkers()

      // For each place, get the icon, name, and location
      let bounds = new google.LatLngBounds()

      _.each(places, function (place) {
        if (!place.geometry) {
          console.log('Returned place contained no geometry')
          return
        }

        let range = calculateRange(
          place.geometry.location.lng(),
          place.geometry.location.lat(),
          $('#place-miles-in').val())
        if (lngLat.length == 0) {
          lngLat.push(range)
        } else {
          // calculated longitude
          lngLat[0].lng.max = _.max([lngLat[0].lng.max, range.lng.max])
          lngLat[0].lng.min = _.min([lngLat[0].lng.min, range.lng.min])
          // calculated latitude
          lngLat[0].lat.max = _.max([lngLat[0].lat.max, range.lat.max])
          lngLat[0].lat.min = _.min([lngLat[0].lat.min, range.lat.min])
        }

        placesLngLat.push({ lng: place.geometry.location.lng(), lat: place.geometry.location.lat() })

        addCircle(place.geometry.location, radius(), map)

        if (place.geometry.viewport) {
          // Only geocodes have viewport
          bounds.union(place.geometry.viewport)
        } else {
          bounds.extend(place.geometry.location)
        }
      })

      el2.val(JSON.stringify(lngLat))

      map.fitBounds(bounds)
      map.setZoom(8)
    })
  }
  let GeoPoint = require('geopoint')
  let mapsApi = require('google-maps-api')(core.config.gapi.key, ['places'])
  mapsApi().then(function (mapApi) {
    google = mapApi

    if ($('#address-search').val() == 1) {
      init({})
      isInit = true
    };

    $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
      $('#address-search').val($(this).siblings('input[type="hidden"]').val())
      if ($('#address-search').val() == 1 && !isInit) {
        init({})
        isInit = true
      }
    })

    $('#place-miles').slider('value', $('#place-miles-in').val())

    $('#place-miles').on('slide', function (e, ui) {
      $('#place-miles-in').val(ui.value)
      if (circles.length > 0) {
        updateStatus()
      }
    })
  })
}

},{"geopoint":4,"google-maps-api":5}],449:[function(require,module,exports){
module.exports = function (core) {
  function clearAuthSession () {
    try {
      localStorage.removeItem('access_token')
      localStorage.removeItem('refresh_token')
      localStorage.removeItem('expires_on')
      sessionStorage.clear()
    } catch (err) {}

    if (core && core.service && core.service.rest && core.service.rest.settings) {
      core.service.rest.settings.headers = {}
    }
  }

  function logout (e) {
    if (e) {
      e.preventDefault()
      e.stopPropagation()
      if (typeof e.stopImmediatePropagation === 'function') {
        e.stopImmediatePropagation()
      }
    }

    clearAuthSession()
    window.location.replace('/login?logged_out=1')
    return false
  }

  document.addEventListener('click', function (e) {
    var target = e.target

    if (target && target.closest) {
      target = target.closest('.logout, a.logout, [data-logout]')
    }

    if (!target) {
      return
    }

    logout(e)
  }, true)

  $(document).on('click', '.logout, a.logout, [data-logout]', logout)
}

},{}],450:[function(require,module,exports){
module.exports = function () {
  // windowed new window
  $(document).on('click', '[target=_blank]', function (e) {
  // $('[target=_blank]').on('click', function(e) {
    let URL = this.href

    let x = screen.width / 2 - 1050 / 2
    let y = screen.height / 2 - 450 / 2

    window.open(URL, '_blank', 'height=' + screen.height / 2 + ', width=1000, left=' + x + ',top=' + y)
    return false
  })

  // full screen new window
  $(document).on('click', '[target=_blank-full]', function (e) {
    let URL = this.href

    window.open(URL, '_blank')
    return false
  })
}

},{}],451:[function(require,module,exports){
module.exports = function () {
  $('body').popover({ selector: '.popover-item' })
}

},{}],452:[function(require,module,exports){
module.exports = function (core) {
  $('[data-slider]').each(function () {
    let options = {
      disabled: $(this).data('disabled'),
      max: $(this).data('max'),
      min: $(this).data('min'),
      orientation: $(this).data('orientation'),
      range: $(this).data('range'),
      step: $(this).data('step'),
      value: $(this).data('value'),
      values: $(this).data('values')
    }

    switch ($(this).data('type')) {
    case 'age':
      options.slide = function (event, ui) {
        if (ui.values[0] < 3) {
          $('#age-min-text').text('<3')
          $('#age-min-input').val('<3')
        } else {
          $('#age-min-text').text(ui.values[0])
          $('#age-min-input').val(ui.values[0])
        }
        $('[name="age_min"]').val(ui.values[0])

        if (ui.values[1] > 70) {
          $('#age-max-text').text('70+')
          $('#age-max-input').val('70+')
        } else {
          $('#age-max-text').text(ui.values[1])
          $('#age-max-input').val(ui.values[1])
        }
        $('[name="age_max"]').val(ui.values[1])
      }

      break
    case 'height':
      options.slide = function (event, ui) {
        let inches1 = ui.values[0]
        let inches2 = ui.values[1]

        if (inches1 == '22' || inches1 == '23') {
          let feet1 = '2'
          inches1 = '0'

          if (inches2 == '22' || inches2 == '23') {
            let feet2 = '2'
            inches2 = '0'
          } else {
            let feet2 = Math.floor(inches2 / 12)
            inches2 %= 12
          }
        } else {
          let feet1 = Math.floor(inches1 / 12)
          let feet2 = Math.floor(inches2 / 12)

          inches1 %= 12
          inches2 %= 12
        }

        if (ui.values[0] == '22' || ui.values[0] == '23') {
          feet1 = '< 2'
        }

        if (ui.values[1] == '22' || ui.values[1] == '23') {
          feet2 = '< 2'
        }

        if (ui.values[0] == '23') {
          ui.values[0] == '22'
        }
        if (ui.values[1] == '23') {
          ui.values[1] == '22'
        }

        $('[name="height_min"]').val(ui.values[0])
        $('[name="height_max"]').val(ui.values[1])
        $('#height-min-dropdown').val(ui.values[0])
        $('#height-max-dropdown').val(ui.values[1])
      }
      break
    }

    $(this).slider(options)
  })
}

},{}],453:[function(require,module,exports){
module.exports = function () {
  $('[data-select]').each(function () {
    $(this).select2({
      placeholder: $(this).attr('data-placeholder')
    })
  })
}

},{}],454:[function(require,module,exports){
'use strict'

module.exports = function (core, user) {
  $(document).on('click', '#talent-photo, #view-resume-photos', function (e) {
    let id

    // Bind null data first
    self.core.service.databind('#talent-photos-modal, #talent-view-photos-modal', {
      getFullName: function () { return 'Loading' },
      getAge: function () { return 'Loading' },
      bam_talent_media2: []
    })

    if ($(e.target).is('a')) {
      id = $(e.target).attr('data-id')
    } else {
      id = $(e.target).parents('a').attr('data-id')
    }

    let data = {
      talentId: id,
      withs: [
        'bam_talent_media2',
        'bam_talentinfo1'
      ]
    }

    return self.core.resource.talent.get(data)
      .then(function (talent) {
        let photosArray = []

        $.each(talent.bam_talent_media2, function (index, value) {
          value.count = index
          // add only profile pic and main pictures (no thumbnails)
          if (value.type == 1 || value.type == 2) {
            photosArray.push(value)
          }
        })

        talent.bam_talent_media2 = photosArray
        self.core.service.databind('#talent-photos-modal, #talent-view-photos-modal', talent)

        // add active class to 1st photo in talent-view-photos modal so it will appear
        $('#carousel-custom #carousel-inner div.item').eq(1).addClass('active')
        $('#carousel-custom #carousel-inner div.item').not(':eq(1)').removeClass('active')

        $('#carousel-indicators li').eq(1).addClass('active')

        $('#carousel-indicators li').each(function (index, value) {
          $(this).attr('data-slide-to', index)
        })

        hidePrevOrNextBtn()
      })
  })

  $(document).on('click', 'a.left.carousel-control, a.right.carousel-control', function () {
    hidePrevOrNextBtn()
  })

  $(document).on('click', '.carousel-indicators>li', function () {
    setTimeout(function () {
      hidePrevOrNextBtn()
    }, 800)
  })

  let hidePrevOrNextBtn = function () {
    // hide previous button if first picture is visible
    if ($('#carousel-custom #carousel-inner div.item').eq(1).hasClass('active')) {
      $('a.left.carousel-control').hide()
    } else {
      $('a.left.carousel-control').show()
    }

    // hide next button if last picture is visible
    if ($('#carousel-custom #carousel-inner div.item').last().hasClass('active')) {
      $('a.right.carousel-control').hide()
    } else {
      $('a.right.carousel-control').show()
    }
  }
}

},{}],455:[function(require,module,exports){
'use strict'

module.exports = function (core, user) {
  $(document).on('click', '#talent-resume', function (e) {
    let id

    if ($(e.target).is('a')) {
      id = $(e.target).attr('data-id')
    } else {
      id = $(e.target).parents('a').attr('data-id')
    }

    let data = {
      talentId: id,
      query: [
        ['with', 'bam_talent_media2'],
        ['with', 'bam_talentinfo1'],
        ['with', 'bam_talentinfo2'],
        ['with', 'bam_talent_dance'],
        ['with', 'bam_talent_music']
      ]
    }

    return self.core.resource.talent.get(data)
      .then(function (talent) {
        _.each(talent.bam_talent_music, function (res, ind) {
          if (res.music_type2 == '1') {
            talent.bam_talent_music[ind].music_role = 'DJ'
          }
          if (res.music_type2 == '2') {
            talent.bam_talent_music[ind].music_role = 'Singer'
          }
          if (res.music_type2 == '3') {
            talent.bam_talent_music[ind].music_role = 'Song Writer'
            talent.bam_talent_music[ind].music_role = 'Player'
          }
          if (res.music_type2 == '6') {
            talent.bam_talent_music[ind].music_role = 'Lyricist'
          }
          if (res.music_type2 == '7') {
            talent.bam_talent_music[ind].music_role = 'Sound Man'
          }
          if (res.music_type2 == '8') {
            talent.bam_talent_music[ind].music_role = 'Composer'
          }
          if (res.music_type2 == '9') {
            talent.bam_talent_music[ind].music_role = 'Conductor'
          }
        })

        self.core.service.databind('#talent-resume-modal', talent)
      })
  })

  $('#uidemo-tabs-default-demo-musician').find('a').on('click', function (e) {
    e.preventDefault()
    if ($(this).hasClass('show-more-btn')) {
      $(this).closest('div').find('p').each(function () {
        if ($(this).hasClass('main')) {
          $(this).addClass('hide')
        } else {
          $(this).removeClass('hide')
        }
      })
      $(this).removeClass('show-more-btn').addClass('show-less-btn').html('Show less...')
    } else {
      $(this).closest('div').find('p').each(function () {
        if ($(this).hasClass('main')) {
          $(this).removeClass('hide')
        } else {
          $(this).addClass('hide')
        }
      })
      $(this).removeClass('show-less-btn').addClass('show-more-btn').html('Show more...')
    }
  })

  $('#uidemo-tabs-default-demo-dance').find('a').on('click', function (e) {
    e.preventDefault()
    if ($(this).hasClass('show-more-btn')) {
      $(this).closest('div').find('p').each(function () {
        if ($(this).hasClass('main')) {
          $(this).addClass('hide')
        } else {
          $(this).removeClass('hide')
        }
      })
      $(this).removeClass('show-more-btn').addClass('show-less-btn').html('Show less...')
    } else {
      $(this).closest('div').find('p').each(function () {
        if ($(this).hasClass('main')) {
          $(this).removeClass('hide')
        } else {
          $(this).addClass('hide')
        }
      })
      $(this).removeClass('show-less-btn').addClass('show-more-btn').html('Show more...')
    }
  })

  // close resume modal before opening photo modal
  $(document).on('click', '#view-resume-photos', function () {
    $('#talent-resume-modal').modal('toggle')
  })
}

},{}],456:[function(require,module,exports){
module.exports = function (core, user) {
  let handler = require('../event-handlers/alternate-emails.js')(core, user)

  $(document).on('click', '#add_email', handler.addEmail)
  $(document).on('click', '.set-email', function () {
    let id = $(this).parent().attr('id')
    handler.setEmail(id)
  })

  $(document).on('click', '.set-email-sec', function () {
    let id = $(this).parent().attr('id')
    handler.setEmailSec(id)
  })

  $(document).on('click', '.delete', function () {
    let id = $(this).parent().attr('id')
    handler.deleteEmail(id)
  })
}

},{"../event-handlers/alternate-emails.js":489}],457:[function(require,module,exports){
module.exports = function (core, user) {
  function thirty_pc () {
    let height = $(window).height()
    let errorPage = (height)
    errorPage = parseInt(errorPage) - 80 + 'px'
    $('#error-page').css('height', errorPage)
    $('#content-wrapper').css('padding', '20px')
  }

  $(document).ready(function () {
    thirty_pc()
    $(window).bind('resize', errorPage)
  })
}

},{}],458:[function(require,module,exports){
module.exports = function (core, user) {
  let handler = require('../event-handlers/feedback.js')(core, user)

  $(document).on('click', '#add-feedback-btn', handler.addNewFeedback)

  // upload file input design
  $('#upload-file-name').pixelFileInput({ placeholder: '(No File Selected) Click here to select file... ' })
  $('.pfi-choose')[0].innerHTML = '<i class="fa fa-paperclip"></i> Choose File'

  // reset modal contents on close
  $('#add-feedback-modal').on('hidden.bs.modal', function () {
    $('#feedback-message').val('')
    $('#upload-file-name').val('')
  })

  // $(document).on('click', '#attach-file-btn', function(e){
  //   e.preventDefault();
  //   $('#upload-file-name').click();
  // });
}

},{"../event-handlers/feedback.js":490}],459:[function(require,module,exports){
// commenting all this and transferring to role.landing.js

// Modal Ghost onboarding

// uncomment this show modal
// $(document).ready(function(){
//   $('#ghost-onboarding-modal').modal('show');
// });
// $('#ghost-onboarding-modal').modal({backdrop: 'static', keyboard: false})

// $(document).on('click', '.proceed-btn.confirm-email', function(){
//   $('#onboarding-confirm-email').hide();
//   $('#onboarding-create-password').show();
// });

// $(document).on('click', '.proceed-btn.create-password', function(){
//   $('#onboarding-create-password').hide();
//   $('#onboarding-other-email').show();
// });

// $(document).on('click', '.proceed-btn.other-email', function(){
//   $('#onboarding-other-email').hide();
//   $('#onboarding-name').show();
// });

// $(document).on('click', '.proceed-btn.your-name', function(){
//   $('#onboarding-name').hide();
//   $('#onboarding-contact-num1').show();
// });

// $(document).on('click', '.proceed-btn.contact-num1', function(){
//   $('#onboarding-contact-num1').hide();
//   $('#onboarding-contact-num2').show();
// });

// $(document).on('click', '.proceed-btn.contact-num2', function(){
//   $('#onboarding-contact-num2').hide();
//   $('#onboarding-company-name').show();
// });

// $(document).on('click', '.proceed-btn.company-name', function(){
//   $('#onboarding-company-name').hide();
//   $('#onboarding-congratulations').show();
// });

},{}],460:[function(require,module,exports){
module.exports = function (core, user) {
  let qs = core.service.query_string()

  if (qs.logged_out === '1') {
    user = { id: 0, bam_cd_user_id: 0 }
    core.service.rest.settings.headers = {}
    localStorage.removeItem('access_token')
    localStorage.removeItem('refresh_token')
    localStorage.removeItem('expires_on')
    sessionStorage.clear()
  }

  if (qs.logged_out === '1') {
    $('.signin-input').fadeIn()
    return
  }

  if (parseInt(user.bam_cd_user_id, 10)) {
    $('#redirect-login-page').fadeIn()
    let qs = core.service.query_string()
    window.location = qs.redirect ? decodeURIComponent(qs.redirect) : '/welcome'
  } else {
    core.service.rest.settings.headers = {}

    localStorage.removeItem('refresh_token')
    localStorage.removeItem('access_token')

    $('.signin-input').fadeIn()

    $('#login-form').on('submit', function (e) {
      e.preventDefault()
      let email = $('#email').val()
      let pass = $('#password').val()

      if (!email) {
        $('#invalid-email').fadeIn().delay(5000).fadeOut()
        return
      }

      if (!pass) {
        $('#invalid-pass').fadeIn().delay(5000).fadeOut()
        return
      }

      core.service.rest.post(core.config.api.base.replace('/v1', '') + '/oauth/token', {
        username: email,
        password: pass,
        user_type: 'bam_cd_user',
        client_id: '74d89ce4c4838cf495ddf6710796ae4d5420dc91',
        client_secret: '61c9b2b17db77a27841bbeeabff923448b0f6388',
        grant_type: 'password'
      })
        .then(function (result) {
          let qs = core.service.query_string()

          localStorage.setItem('access_token', result.access_token)
          if (result.refresh_token) {
            localStorage.setItem('refresh_token', result.refresh_token)
          }
          var expiresIn = parseInt(result.expires_in, 10)
          if (!expiresIn && result.expires_at) {
            expiresIn = Math.max(0, Math.round((new Date(result.expires_at).getTime() - Date.now()) / 1000))
          }
          if (!expiresIn) {
            expiresIn = 31536000
          }
          localStorage.setItem('expires_on', Math.round(new Date().getTime() / 1000) + expiresIn)
          window.location = qs.redirect ? decodeURIComponent(qs.redirect) : '/welcome'
        },
        function (error) {
          if (error.responseText) {
            error = JSON.parse(error.responseText)

            if (error.errors && error.errors.auth && error.errors.auth == 'You shall not pass!') {
              $('#invalid-user').show()
              $('#invalid-user').delay(5000).fadeOut()
            } else {
              $('#duplicate-email').show()
              $('#duplicate-email').delay(5000).fadeOut()
            }
          }
        })
    })
  }
}

},{}],461:[function(require,module,exports){
module.exports = function (core, user, projectId, roleId) {
  let Handler = require('../event-handlers/message.js')(core, user, projectId, roleId)

  $(document).on('click', '.remove-talent', Handler.deleteConvo)
  $(document).on('click', '.show-conversation', e => {
    e.preventDefault()
    $('.talent-item').removeClass('active')
    $(e.target).parents('.talent-item').addClass('active')

    let id = $(e.target).attr('data-id')
    Handler.renderMessages(id)
  })

  $(document).on('click', '.reply', Handler.reply)

  let windowHeight = window.innerHeight - 157
  $('#messages-panel')[0].style.height = windowHeight + 'px'
}

},{"../event-handlers/message.js":491}],462:[function(require,module,exports){
module.exports = function (core, user) {
  let handler = require('../event-handlers/password.forgot.js')(core, user)

  $(document).on('click', '#send-email-btn', handler.sendLinkToEmail)
}

},{"../event-handlers/password.forgot.js":492}],463:[function(require,module,exports){
module.exports = function (core, user) {
  let handler = require('../event-handlers/password.reset.js')(core, user)

  $(document).on('click', '#reset-password-btn', handler.resetPassword)

  // on enter key, click reset btn
  $('#confirm-password').keyup(function (event) {
    if (event.keyCode == 13) {
      $('#reset-password-btn').click()
    }
  })
}

},{"../event-handlers/password.reset.js":493}],464:[function(require,module,exports){
module.exports = function (core, user) {
  let handler = require('../event-handlers/project.create.js')(core, user)

  $('#create-project-btn').on('click', handler.createNewProject)

  $('.calendar-input').mask('9999-99-99')

  $('#bs-datepicker-submissiondeadline').datepicker({
    defaultDate: +1,
    dateFormat: 'yy-mm-dd',
    minDate: 0
  })

  $('#bs-datepicker-audition').datepicker({
    dateFormat: 'yy-mm-dd',
    minDate: 0
  })

  $('#bs-datepicker-shootdate').datepicker({
    dateFormat: 'yy-mm-dd',
    minDate: 0
  })

  $('#bs-datepicker-open-call').datepicker({
    dateFormat: 'yy-mm-dd',
    minDate: 0
  })

  $('#bs-timepicker-open-call-from').timepicker()
  $('#bs-timepicker-open-call-to').timepicker()

  // let hideElem = document.getElementById("hide-open-call-onload");
  $('#hide-option-2').ready(function () {
    $('#open-call-option-content').hide()
  })

  $('#self-submission-option').on('click', function () {
    $('#self-submissions-option-content').show()
    $('#project-type-title').text('Self Submission Details')
    $('#open-call-option-content').hide()
  })

  $('#open-call-option').on('click', function () {
    $('#open-call-option-content').show()
    $('#project-type-title').text('Open Call Details')
    $('#self-submissions-option-content').hide()
  })

  function dontAllowLetters (element) {
    element.keydown(function (e) {
      // Allow: backspace, delete, tab, escape, and enter
      if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
      // Allow: Ctrl+A, Command+A
            (e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
      // Allow: home, end, left, right, down, up
            (e.keyCode >= 35 && e.keyCode <= 40)) {
        // let it happen, don't do anything
        return
      }
      // Ensure that it is a number and stop the keypress
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault()
      }
    })
  }

  dontAllowLetters($('#project-rate'))
  dontAllowLetters($('#zip-code'))

  $('#find-markets-btn').on('click', handler.autoSelectMarkets)

  $('#toggle-manual-markets-div').on('click', handler.toggleManualMarketsDiv)

  $('#toggle-all-markets-checked').on('click', handler.toggleAllMarketsChecked)

  $(document).on('click', '.calendar-btn', function (e) {
    e.preventDefault()
    $(this).siblings('input.calendar-input').datepicker('show')
  })

  $(document).on('click', '#nationwide-market-checkbox', function () {
    $(this).toggleClass('checked')

    if ($(this).hasClass('checked')) {
      $('.hide-if-nationwide').addClass('hide')
    } else {
      $('.hide-if-nationwide').removeClass('hide')
    }
  })

  $(document).on('click', '#image-holder', function () {
    $('#photo-uploader').click()
  })

  function readURL (input) {
    let reader = new FileReader()

    reader.onload = function (e) {
      $('#preview').attr('src', e.target.result)
      $('#main-casting-image-div').addClass('uploaded')
    }

    reader.readAsDataURL(input.files[0])
  }

  $('#photo-uploader').change(function () {
    if (this.files && this.files[0]) {
      $('#default-image-preview').hide()
      $('#remove-button').show()

      if (this.files[0].type.indexOf('image') == -1) {
        alert('Invalid Type')
        $('#preview').attr('src', 'blank')
        $('#main-casting-image-div').removeClass('uploaded')
        return false
      }
      // console.log("render");
      readURL(this)
    }
  })

  $(document).on('click', '#remove-button', function () {
    $('#default-image-preview').show()
    $('#remove-button').hide()
    $('#main-casting-image-div').removeClass('uploaded')
    $('#preview').attr('src', 'blank')
    $('#main-casting-image-div').addClass('image-edited')
  })
}

},{"../event-handlers/project.create.js":494}],465:[function(require,module,exports){
module.exports = function (core, user, projectId) {
  let handler = require('../event-handlers/project.edit.js')(core, user, projectId)

  $('#update-project-btn').on('click', handler.updateProject)

  $('.calendar-input').mask('9999-99-99')

  $('#bs-datepicker-submissiondeadline').datepicker({
    defaultDate: +1,
    dateFormat: 'yy-mm-dd',
    minDate: 0
  })

  $('#bs-datepicker-audition').datepicker({
    dateFormat: 'yy-mm-dd',
    minDate: 0
  })

  $('#bs-datepicker-shootdate').datepicker({
    dateFormat: 'yy-mm-dd',
    minDate: 0
  })

  $('#bs-datepicker-open-call').datepicker({
    dateFormat: 'DD, MM dth',
    minDate: 0
  })

  $('#bs-timepicker-open-call-from').timepicker()
  $('#bs-timepicker-open-call-to').timepicker()

  $('#self-submission-option').on('click', function () {
    $('#self-submissions-option-content').show()
    $('#project-type-title').text('Self Submission Details')
    $('#open-call-option-content').hide()
  })

  $('#open-call-option').on('click', function () {
    $('#open-call-option-content').show()
    $('#project-type-title').text('Open Call Details')
    $('#self-submissions-option-content').hide()
  })

  function dontAllowLetters (element) {
    element.keydown(function (e) {
      // Allow: backspace, delete, tab, escape, and enter
      if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
      // Allow: Ctrl+A, Command+A
            (e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
      // Allow: home, end, left, right, down, up
            (e.keyCode >= 35 && e.keyCode <= 40)) {
        // let it happen, don't do anything
        return
      }
      // Ensure that it is a number and stop the keypress
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault()
      }
    })
  }

  dontAllowLetters($('#project-rate'))
  dontAllowLetters($('#zip-code'))

  $('#find-markets-btn').on('click', handler.autoSelectMarkets)

  $('#toggle-manual-markets-div').on('click', handler.toggleManualMarketsDiv)

  $('#toggle-all-markets-checked').on('click', handler.toggleAllMarketsChecked)

  $(document).on('click', '.calendar-btn', function () {
    $(this).siblings('input.calendar-input').datepicker().focus()
  })

  $(document).on('click', '#nationwide-market-checkbox', function () {
    $(this).toggleClass('checked')

    if ($(this).hasClass('checked')) {
      $('.hide-if-nationwide').addClass('hide')
    } else {
      $('.hide-if-nationwide').removeClass('hide')
      $('#zip-code').val('')
    }
  })

  $(document).on('click', '#image-holder', function () {
    $('#photo-uploader').click()
  })

  function readURL (input) {
    let reader = new FileReader()

    reader.onload = function (e) {
      $('#preview').attr('src', e.target.result)
      $('#main-casting-image-div').addClass('uploaded')
      $('#main-casting-image-div').addClass('image-edited')
    }

    reader.readAsDataURL(input.files[0])
  }

  $('#photo-uploader').change(function () {
    if (this.files && this.files[0]) {
      $('#default-image-preview').hide()
      $('#remove-button').show()
      // if(this.files[0].size > 528385){

      //   alert("Image Size should not be greater than 500Kb");
      //   $("#preview").attr("src","blank");
      //   $('#main-casting-image-div').removeClass('uploaded');
      //   return false;
      // }
      if (this.files[0].type.indexOf('image') == -1) {
        alert('Invalid Type')
        $('#preview').attr('src', 'blank')
        $('#main-casting-image-div').removeClass('uploaded')
        return false
      }
      // console.log("render");
      readURL(this)
    }
  })

  $(document).on('click', '#remove-button', function () {
    $('#default-image-preview').show()
    $('#remove-button').hide()
    $('#main-casting-image-div').removeClass('uploaded')
    $('#preview').attr('src', 'blank')
    $('#main-casting-image-div').addClass('image-edited')
  })
}

},{"../event-handlers/project.edit.js":495}],466:[function(require,module,exports){
module.exports = function (core, user) {
  let handler = require('../event-handlers/project.index.js')(core, user)

  $(document).on('click', '#project-search-btn', handler.refreshList)
  $(document).on('change', '#project-status[name="status"]', handler.refreshList)

  $(document).on('keydown', '#project-name', function (e) {
    if (e.which == 13) { // enter key
      $('#project-search-btn').click()
    }
  })

  $('#watch-video-modal').on('hidden.bs.modal', function (e) {
    $('#watch-video-modal iframe').attr('src', $('#watch-video-modal iframe').attr('src'))
  })
}

},{"../event-handlers/project.index.js":496}],467:[function(require,module,exports){
module.exports = function (core, user) {
  let handler = require('../event-handlers/project.quickpost.js')(core, user)
  $(document).on('click', '#btn-send-to-booking', handler.addToBooking)
}

},{"../event-handlers/project.quickpost.js":497}],468:[function(require,module,exports){
module.exports = function (core, user, projectId) {
  let handler = require('../event-handlers/project.show.js')(core, user, projectId)
}

},{"../event-handlers/project.show.js":498}],469:[function(require,module,exports){
'use strict'

module.exports = function (core, user, projectId) {
  let handler = require('../event-handlers/project.worksheet.js')(core, user, projectId)
  $('#projects-list').on('change', handler.projectChanged)
  $('#roles-list').on('change', handler.refreshList)
}

},{"../event-handlers/project.worksheet.js":499}],470:[function(require,module,exports){
module.exports = function (core) {
  $('#phone').mask('999-999-9999')

  function oauthLogin (email, pass) {
    return core.service.rest.post(core.config.api.base.replace('/v1', '') + '/oauth/token', {
      username: email,
      password: pass,
      client_id: '74d89ce4c4838cf495ddf6710796ae4d5420dc91',
      client_secret: '61c9b2b17db77a27841bbeeabff923448b0f6388',
      grant_type: 'password',
      user_type: 'bam_cd_user'
    })
  }

  function persistToken (result) {
    localStorage.setItem('access_token', result.access_token)
    if (result.refresh_token) {
      localStorage.setItem('refresh_token', result.refresh_token)
    }
    var expiresIn = parseInt(result.expires_in, 10)
    if (!expiresIn && result.expires_at) {
      expiresIn = Math.max(0, Math.round((new Date(result.expires_at).getTime() - Date.now()) / 1000))
    }
    if (!expiresIn) {
      expiresIn = 31536000
    }
    localStorage.setItem('expires_on', Math.round(new Date().getTime() / 1000) + expiresIn)
    core.service.rest.settings.headers = { Authorization: 'Bearer ' + result.access_token }
  }

  function withTimeout (promise, ms, label) {
    return new Promise(function (resolve, reject) {
      var timer = setTimeout(function () {
        reject(new Error((label || 'request') + ' timed out'))
      }, ms)

      promise.then(function (result) {
        clearTimeout(timer)
        resolve(result)
      }).catch(function (err) {
        clearTimeout(timer)
        reject(err)
      })
    })
  }

  function loginWithRetry (email, pass, attempts) {
    attempts = attempts || 0
    var delay = Math.min(750 * Math.pow(1.5, attempts), 5000)

    return withTimeout(oauthLogin(email, pass), 20000, 'sign in').catch(function (err) {
      if (attempts >= 8) {
        throw err
      }

      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          loginWithRetry(email, pass, attempts + 1).then(resolve).catch(reject)
        }, delay)
      })
    })
  }

  function sendSignupEmails () {
    return core.service.rest.post(core.config.api.base + '/cd/email_verification/send', {
      welcome: 1
    }).catch(function () {})
  }

  function finishSignup (result) {
    persistToken(result)

    var params = [
      'access_token=' + encodeURIComponent(result.access_token),
      'refresh_token=' + encodeURIComponent(result.refresh_token || ''),
      'expires_in=' + encodeURIComponent(result.expires_in || 31536000)
    ]

    window.location.replace('/welcome?' + params.join('&'))
  }

  function showDuplicateEmailMessage () {
    $('#email').focus().css('border-color', '#b94a48')
    $('#req-uniqueemailtxt').text('That email is already registered. Try signing in, or use Forgot Password if you need help.').show()
    $('#error-signup').show()
  }

  function runSignup () {
    let lname = $('#last-name').val()
    let fname = $('#first-name').val()
    let email = $('#email').val()
    let phone = $('#phone').val()
    let pass = $('#password').val()
    let confirmpass = $('#confirm-password').val()

    let regexName = new RegExp('[a-zA-Z]$')
    let regexPass = new RegExp('^[a-zA-Z0-9]*$')
    let regexEmail = new RegExp('^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$')

    if (!lname) {
      $('#last-name').focus().css('border-color', '#b94a48')
      $('#req-lname').show().delay(5000).fadeOut()
      $('#req-lnametxt').text('This field is required.').show().delay(5000).fadeOut()
      return
    } else {
      if (!regexName.test(lname)) {
        $('#last-name').focus().css('border-color', '#b94a48')
        $('#req-lname').show().delay(5000).fadeOut()
        $('#req-lnametxt').text('Invalid Last Name').show().delay(5000).fadeOut()
        return
      }
      $('#last-name').css('border-color', '#d6d6d6')
    }

    if (!fname) {
      $('#first-name').focus().css('border-color', '#b94a48')
      $('#req-fname').show().delay(5000).fadeOut()
      $('#req-fnametxt').text('This field is required.').show().delay(5000).fadeOut()
      return
    } else {
      if (!regexName.test(fname)) {
        $('#first-name').focus().css('border-color', '#b94a48')
        $('#req-fname').show().delay(5000).fadeOut()
        $('#req-fnametxt').text('Invalid First Name').show().delay(5000).fadeOut()
        return
      }
      $('#first-name').css('border-color', '#d6d6d6')
    }

    if (!email) {
      $('#email').focus().css('border-color', '#b94a48')
      $('#req-email').show().delay(5000).fadeOut()
      $('#req-emailtxt').text('This field is required.').show().delay(5000).fadeOut()
      return
    } else {
      if (!regexEmail.test(email)) {
        $('#email').focus().css('border-color', '#b94a48')
        $('#req-email').show().delay(5000).fadeOut()
        $('#req-emailtxt').text('Invalid Email Address.').show().delay(5000).fadeOut()
        return
      } $('#email').css('border-color', '#d6d6d6')
    }
    if (!phone) {
      $('#phone').focus().css('border-color', '#b94a48')
      $('#req-phone').show().delay(5000).fadeOut()
      $('#req-phonetxt').text('This field is required.').show().delay(5000).fadeOut()
      return
    } else {
      phone = phone.replace(/-/g, '')
    }
    $('#phone').css('border-color', '#d6d6d6')

    if (!pass) {
      $('#password').focus().css('border-color', '#b94a48')
      $('#req-pass').show().delay(5000).fadeOut()
      $('#req-passtxt').text('This field is required.').show().delay(5000).fadeOut()
      return
    } else {
      if (!regexPass.test(pass)) {
        $('#password').focus().css('border-color', '#b94a48')
        $('#req-pass').show().delay(5000).fadeOut()
        $('#req-passtxt').text('Invalid Password.').show().delay(5000).fadeOut()
        return
      } else {
        if (!/[A-Z]+/.test(pass)) {
          $('#password').focus().css('border-color', '#b94a48')
          $('#pass-min-letter').show().delay(5000).fadeOut()
          $('#pass-min-letter').text('Password must have atleast 1 capital letter').show().delay(5000).fadeOut()
          return
        } else {
          if (pass.length < 8) {
            $('#password').focus().css('border-color', '#b94a48')
            $('#pass-min-length').show().delay(5000).fadeOut()
            $('#pass-min-length').text('Password must contain atleast 8 characters').show().delay(5000).fadeOut()
            return
          }
        }
      }
      $('#password').css('border-color', '#d6d6d6')
    }
    if (!confirmpass) {
      $('#confirm-password').focus().css('border-color', '#b94a48')
      $('#req-confirmpass').show().delay(5000).fadeOut()
      $('#req-confirmpasstxt').text('This field is required.').show().delay(5000).fadeOut()
      return
    } else {
      if (!regexPass.test(confirmpass)) {
        $('#confirm-password').focus().css('border-color', '#b94a48')
        $('#req-confirmpass').show().delay(5000).fadeOut()
        $('#req-confirmpasstxt').text('Invalid Password.').show().delay(5000).fadeOut()
        return
      }
      $('#confirm-password').css('border-color', '#d6d6d6')
    }

    if (pass != confirmpass) {
      $('#password, #confirm-password').focus().css('border-color', '#b94a48')
      $('#req-confirmpass').show().delay(5000).fadeOut()
      $('#req-unmatchtxt').text('Password doesn\'t match.').show().delay(5000).fadeOut()
      return
    }

    let data = {
      lname: lname,
      fname: fname,
      email1: email,
      phone1: phone,
      pass: pass,
      status: 1,
      app_ids: [1],
      self_signup: 1
    }

    $('#sign-up').prop('disabled', true)
    $('.loader').show()

    withTimeout(core.resource.cd_user.post(data), 45000, 'account setup')
      .then(function () {
        return loginWithRetry(email, pass)
      })
      .then(function (result) {
        persistToken(result)
        return sendSignupEmails().then(function () {
          return result
        })
      })
      .then(finishSignup)
      .catch(function (err) {
        var duplicate = err && err.responseJSON && err.responseJSON.errors && err.responseJSON.errors.email1

        if (duplicate) {
          return loginWithRetry(email, pass).then(function (result) {
            persistToken(result)
            return sendSignupEmails().then(function () {
              return result
            })
          }).then(finishSignup).catch(function () {
            showDuplicateEmailMessage()
          })
        }

        return loginWithRetry(email, pass).then(function (result) {
          persistToken(result)
          return sendSignupEmails().then(function () {
            return result
          })
        }).then(finishSignup).catch(function () {
          $('#req-ok').text('Account may have been created. Please sign in with your email and password.').show()
          $('#req-confirmemail').show()
          setTimeout(function () {
            window.location = '/login'
          }, 2000)
        })
      })
      .finally(function () {
        $('#sign-up').prop('disabled', false)
        $('.loader').hide()
      })
  }

  $('#send-casting').click(function (e) {
    e.preventDefault()

    let form = {}
    form.user_id = 1
    form.name = $('input[name=\'name\']').val()
    form.body = $('textarea[name=\'body\']').val()
    form.lazy_project_status_id = 1

    core.resource.quickpost.post(form)
      .then(function (result) {
        $('#success-div').removeClass('hide')
        $('input[name=\'name\']').val('')
        $('textarea[name=\'body\']').val('')
        setTimeout(function () {
          $('#quick-post').modal('hide')
          $('#success-div').addClass('hide')
        }, 1000)
      })
  })

  $('#signup-form').on('submit', function (e) {
    e.preventDefault()
    runSignup()
  })

  $('#sign-up').click(function (e) {
    e.preventDefault()
    runSignup()
  })
}

},{}],471:[function(require,module,exports){
module.exports = function (core, user, roleId, projectId) {
  let handler = require('../event-handlers/role.booked.js')(core, user, roleId, projectId)

  $('#roles-list').on('change', handler.refreshRole)
  $('#search-button').on('click', handler.findMatches)

  // refine search toggle location search
  $(document).on('click', '#location-search-change-btn', function (e) {
    e.preventDefault()
    $('#location-search-display').show()
    $('#location-search-change').hide()
  })
  $(document).on('click', '#location-search-display-btn', function (e) {
    e.preventDefault()
    $('#location-search-display').hide()
    $('#location-search-change').show()
  })

  $(document).on('click', '#toggle-advanced-filters-btn', function (e) {
    e.preventDefault()
    $('#advanced-filters-div').slideToggle()
  })

  $(window).on('scroll', function () {
    if ($(window).scrollTop() + $(window).height() > $(document).height() - 100) {
      handler.findMatches(true)
    }
  })

  $(document).on('keyup', '#age-min-input', function () {
    $('#age-range-slider').slider('values', 0, $(this).val())
    $('input[name="age_min"]').val($(this).val())
  })

  $(document).on('keyup', '#age-max-input', function () {
    $('#age-range-slider').slider('values', 1, $(this).val())
    $('input[name="age_max"]').val($(this).val())
  })

  $(document).on('change', '#height-min-dropdown', function () {
    $('#height-range-slider').slider('values', 0, $(this).val())
    $('input[name="height_min"]').val($(this).val())
  })

  $(document).on('change', '#height-max-dropdown', function () {
    $('#height-range-slider').slider('values', 1, $(this).val())
    $('input[name="height_max"]').val($(this).val())
  })
}

},{"../event-handlers/role.booked.js":500}],472:[function(require,module,exports){
module.exports = function (core, user, roleId, projectId) {
  let handler = require('../event-handlers/role.callbacks.js')(core, user, roleId, projectId)

  $('#roles-list').on('change', handler.refreshRole)
  $('#search-button').on('click', handler.findMatches)

  // refine search toggle location search
  $(document).on('click', '#location-search-change-btn', function (e) {
    e.preventDefault()
    $('#location-search-display').show()
    $('#location-search-change').hide()
  })
  $(document).on('click', '#location-search-display-btn', function (e) {
    e.preventDefault()
    $('#location-search-display').hide()
    $('#location-search-change').show()
  })

  $(document).on('click', '#toggle-advanced-filters-btn', function (e) {
    e.preventDefault()
    $('#advanced-filters-div').slideToggle()
  })

  $(window).on('scroll', function () {
    if ($(window).scrollTop() + $(window).height() > $(document).height() - 100) {
      handler.findMatches(true)
    }
  })

  $(document).on('keyup', '#age-min-input', function () {
    $('#age-range-slider').slider('values', 0, $(this).val())
    $('input[name="age_min"]').val($(this).val())
  })

  $(document).on('keyup', '#age-max-input', function () {
    $('#age-range-slider').slider('values', 1, $(this).val())
    $('input[name="age_max"]').val($(this).val())
  })

  $(document).on('change', '#height-min-dropdown', function () {
    $('#height-range-slider').slider('values', 0, $(this).val())
    $('input[name="height_min"]').val($(this).val())
  })

  $(document).on('change', '#height-max-dropdown', function () {
    $('#height-range-slider').slider('values', 1, $(this).val())
    $('input[name="height_max"]').val($(this).val())
  })
}

},{"../event-handlers/role.callbacks.js":501}],473:[function(require,module,exports){
module.exports = function (core, user, projectId) {
  let handler = require('../event-handlers/role.create.js')(core, user, projectId)

  $('#save-role-btn').on('click', handler.saveNewRole)
  $('#save-and-add-role-btn').on('click', handler.saveNewRole)

  $('#cancel-role-btn').on('click', handler.cancelRole)

  let age_range_sliders_options = {
    'range': true,
    'min': 0,
    'max': 100,
    'values': [ 0, 100 ]
  }

  $('.ui-slider-age-range').slider(age_range_sliders_options)

  $('.ui-slider-age-range').on('slide', function (event, ui) {
    $('#age-range-min').text(ui.values[ 0 ])
    $('#age-range-max').text(ui.values[ 1 ])
  })

  let height_range_sliders_options = {
    'range': true,
    'min': 22,
    'max': 96,
    'values': [ 22, 96 ]
  }

  $('.ui-slider-height-range').slider(height_range_sliders_options)

  $('.ui-slider-height-range').on('slide', function (event, ui) {
    let inches1 = ui.values[0]
    let inches2 = ui.values[1]

    if (inches1 == '22' || inches1 == '23') {
      let feet1 = '2'
      inches1 = '0'

      if (inches2 == '22' || inches2 == '23') {
        let feet2 = '2'
        inches2 = '0'
      } else {
        let feet2 = Math.floor(inches2 / 12)
        inches2 %= 12
      }
    } else {
      let feet1 = Math.floor(inches1 / 12)
      let feet2 = Math.floor(inches2 / 12)

      inches1 %= 12
      inches2 %= 12
    }

    if (ui.values[0] == '22' || ui.values[0] == '23') {
      feet1 = '< 2'
    }

    if (ui.values[1] == '22' || ui.values[1] == '23') {
      feet2 = '< 2'
    }

    $('#height-span').html(feet1 + ' ft ' + inches1 + ' in' + ' to ' + feet2 + ' ft ' + inches2 + ' in')

    if (ui.values[0] == '23') {
      ui.values[0] == '22'
    }
    if (ui.values[1] == '23') {
      ui.values[1] == '22'
    }

    $('#heightinches').val(ui.values[0] + ',' + ui.values[1])
  })

  // uncheck all checkboxes if any is chosen
  $('#ethnicity-any').on('click', function () {
    $('input[name="ethnicity"]:not(".ethnicity-any-checkbox")').attr('checked', 'checked')
    $('input[name="ethnicity"]:not(".ethnicity-any-checkbox")').val(1)
  }, function () {
    $('input[name="ethnicity"]:not(".ethnicity-any-checkbox")').removeAttr('checked')
    $('input[name="ethnicity"]:not(".ethnicity-any-checkbox")').val(0)
  })

  $('#built-any').on('click', function () {
    $('input[name="built"]:not(".built-any-checkbox")').attr('checked', 'checked')
    $('input[name="built"]:not(".built-any-checkbox")').val(1)
  }, function () {
    $('input[name="built"]:not(".built-any-checkbox")').removeAttr('checked')
    $('input[name="built"]:not(".built-any-checkbox")').val(0)
  })

  $('#hair-any').on('click', function () {
    $('input[name="hair-color"]:not(".hair-any-checkbox")').attr('checked', 'checked')
    $('input[name="hair-color"]:not(".hair-any-checkbox")').val(1)
  }, function () {
    $('input[name="hair-color"]:not(".hair-any-checkbox")').removeAttr('checked')
    $('input[name="hair-color"]:not(".hair-any-checkbox")').val(0)
  })

  // uncheck Any checkbox if specific value is checked
  $('input[name="ethnicity"]:not(".ethnicity-any-checkbox")').on('click', function () {
    $('#ethnicity-any').removeAttr('checked')
    $('#ethnicity-any').val(0)
  })

  $('input[name="built"]:not(".built-any-checkbox")').on('click', function () {
    $('#built-any').removeAttr('checked')
    $('#built-any').val('checked')
  })

  $('input[name="hair-color"]:not(".hair-any-checkbox")').on('click', function () {
    $('#hair-any').removeAttr('checked')
    $('#hair-any').val(0)
  })

  $(document).on('keyup', '#age-min-input', function () {
    $('#age-range-slider').slider('values', 0, $(this).val())
    $('input[name="age_min"]').val($(this).val())
  })

  $(document).on('keyup', '#age-max-input', function () {
    $('#age-range-slider').slider('values', 1, $(this).val())
    $('input[name="age_max"]').val($(this).val())
  })

  $(document).on('change', '#height-min-dropdown', function () {
    $('#height-range-slider').slider('values', 0, $(this).val())
    $('input[name="height_min"]').val($(this).val())
  })

  $(document).on('change', '#height-max-dropdown', function () {
    $('#height-range-slider').slider('values', 1, $(this).val())
    $('input[name="height_max"]').val($(this).val())
  })

  // for checkbox values convert to 1 (if checked) and 0 (if not checked)
  $('input[type=\'checkbox\']').change(function () {
    this.value = (Number(this.checked))
  })

  // set date for shoot, audition and expiry of roles
  $('.calendar-input').mask('9999-99-99')

  $('#datepicker-role-expiryDate').datepicker({
    defaultDate: +1,
    dateFormat: 'yy-mm-dd',
    minDate: 0
  })

  $('#datepicker-role-auditionDate').datepicker({
    defaultDate: +1,
    dateFormat: 'yy-mm-dd',
    minDate: 0
  })

  $('#datepicker-role-shootDate').datepicker({
    defaultDate: +1,
    dateFormat: 'yy-mm-dd',
    minDate: 0
  })

  $(document).on('click', '.calendar-btn', function () {
    $(this).siblings('input.calendar-input').datepicker().focus()
  })

  function dontAllowLetters (element) {
    element.keydown(function (e) {
      // Allow: backspace, delete, tab, escape, and enter
      if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
      // Allow: Ctrl+A, Command+A
            (e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
      // Allow: home, end, left, right, down, up
            (e.keyCode >= 35 && e.keyCode <= 40)) {
        // let it happen, don't do anything
        return
      }
      // Ensure that it is a number and stop the keypress
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault()
      }
    })
  }

  dontAllowLetters($('#role-number-text'))
}

},{"../event-handlers/role.create.js":502}],474:[function(require,module,exports){
module.exports = function (core, user, projectId, roleId) {
  let handler = require('../event-handlers/role.edit.js')(core, user, projectId, roleId)

  $('#update-role-btn').on('click', handler.updateRole)

  $('#cancel-role-btn').on('click', handler.cancelRole)

  let age_range_sliders_options = {
    'range': true,
    'min': 0,
    'max': 100,
    'values': [ 0, 100 ]
  }

  $('.ui-slider-age-range').slider(age_range_sliders_options)

  $('.ui-slider-age-range').on('slide', function (event, ui) {
    $('#age-range-min').text(' ' + ui.values[ 0 ])
    $('#age-range-max').text(ui.values[ 1 ])
  })

  let height_range_sliders_options = {
    'range': true,
    'min': 22,
    'max': 96,
    'values': [ 22, 96 ]
  }

  $('.ui-slider-height-range').slider(height_range_sliders_options)

  $('.ui-slider-height-range').on('slide', function (event, ui) {
    let inches1 = ui.values[0]
    let inches2 = ui.values[1]

    if (inches1 == '22' || inches1 == '23') {
      let feet1 = '2'
      inches1 = '0'

      if (inches2 == '22' || inches2 == '23') {
        let feet2 = '2'
        inches2 = '0'
      } else {
        let feet2 = Math.floor(inches2 / 12)
        inches2 %= 12
      }
    } else {
      let feet1 = Math.floor(inches1 / 12)
      let feet2 = Math.floor(inches2 / 12)

      inches1 %= 12
      inches2 %= 12
    }

    if (ui.values[0] == '22' || ui.values[0] == '23') {
      feet1 = '< 2'
    }

    if (ui.values[1] == '22' || ui.values[1] == '23') {
      feet2 = '< 2'
    }

    $('#height-min-span').html(feet1 + '\' ' + inches1 + '"')
    $('#height-max-span').html(feet2 + '\' ' + inches2 + '"')

    if (ui.values[0] == '23') {
      ui.values[0] == '22'
    }
    if (ui.values[1] == '23') {
      ui.values[1] == '22'
    }

    $('#heightinches').val(ui.values[0] + ',' + ui.values[1])
  })

  // uncheck all checkboxes if any is chosen
  $('#ethnicity-any').on('click', function () {
    $('input[name="ethnicity"]:not(".ethnicity-any-checkbox")').attr('checked', 'checked')
    $('input[name="ethnicity"]:not(".ethnicity-any-checkbox")').val(1)
  }, function () {
    $('input[name="ethnicity"]:not(".ethnicity-any-checkbox")').removeAttr('checked')
    $('input[name="ethnicity"]:not(".ethnicity-any-checkbox")').val(0)
  })

  $('#built-any').on('click', function () {
    $('input[name="built"]:not(".built-any-checkbox")').attr('checked', 'checked')
    $('input[name="built"]:not(".built-any-checkbox")').val(1)
  }, function () {
    $('input[name="built"]:not(".built-any-checkbox")').removeAttr('checked')
    $('input[name="built"]:not(".built-any-checkbox")').val(0)
  })

  $('#hair-any').on('click', function () {
    $('input[name="hair-color"]:not(".hair-any-checkbox")').attr('checked', 'checked')
    $('input[name="hair-color"]:not(".hair-any-checkbox")').val(1)
  }, function () {
    $('input[name="hair-color"]:not(".hair-any-checkbox")').removeAttr('checked')
    $('input[name="hair-color"]:not(".hair-any-checkbox")').val(0)
  })

  // uncheck Any checkbox if specific value is checked
  $('input[name="ethnicity"]:not(".ethnicity-any-checkbox")').on('click', function () {
    $('#ethnicity-any').removeAttr('checked')
    $('#ethnicity-any').val(0)
  })

  $('input[name="built"]:not(".built-any-checkbox")').on('click', function () {
    $('#built-any').removeAttr('checked')
    $('#built-any').val('checked')
  })

  $('input[name="hair-color"]:not(".hair-any-checkbox")').on('click', function () {
    $('#hair-any').removeAttr('checked')
    $('#hair-any').val(0)
  })

  // for checkbox values convert to 1 (if checked) and 0 (if not checked)
  $('input[type=\'checkbox\']').change(function () {
    this.value = (Number(this.checked))
  })

  $(document).on('keyup', '#age-min-input', function () {
    $('#age-range-slider').slider('values', 0, $(this).val())
    $('input[name="age_min"]').val($(this).val())
  })

  $(document).on('keyup', '#age-max-input', function () {
    $('#age-range-slider').slider('values', 1, $(this).val())
    $('input[name="age_max"]').val($(this).val())
  })

  $(document).on('change', '#height-min-dropdown', function () {
    $('#height-range-slider').slider('values', 0, $(this).val())
    $('input[name="height_min"]').val($(this).val())
  })

  $(document).on('change', '#height-max-dropdown', function () {
    $('#height-range-slider').slider('values', 1, $(this).val())
    $('input[name="height_max"]').val($(this).val())
  })

  // set date for shoot, audition and expiry of roles
  $('.calendar-input').mask('9999-99-99')

  $('#datepicker-role-expiryDate').datepicker({
    defaultDate: +1,
    dateFormat: 'yy-mm-dd',
    minDate: 0
  })

  $('#datepicker-role-auditionDate').datepicker({
    defaultDate: +1,
    dateFormat: 'yy-mm-dd',
    minDate: 0
  })

  $('#datepicker-role-shootDate').datepicker({
    defaultDate: +1,
    dateFormat: 'yy-mm-dd',
    minDate: 0
  })

  $(document).on('click', '.calendar-btn', function () {
    $(this).siblings('input.calendar-input').datepicker().focus()
  })

  function dontAllowLetters (element) {
    element.keydown(function (e) {
      // Allow: backspace, delete, tab, escape, and enter
      if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
      // Allow: Ctrl+A, Command+A
            (e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
      // Allow: home, end, left, right, down, up
            (e.keyCode >= 35 && e.keyCode <= 40)) {
        // let it happen, don't do anything
        return
      }
      // Ensure that it is a number and stop the keypress
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault()
      }
    })
  }

  dontAllowLetters($('#role-number-text'))
}

},{"../event-handlers/role.edit.js":503}],475:[function(require,module,exports){
module.exports = function (core, user, projectId, roleId) {
  let handler = require('../event-handlers/role.find-talents.js')(core, user, projectId, roleId)

  setTimeout(function () {
    $('#search-by-location').click()
  }, 500)

  $('#hasphotoForm').click(function () {
    if ($('#has-photo').is(':checked')) {
      $('#radio-selected').text('Yes')
    } else {
      $('#radio-selected').text('Any')
    }
  })

  $('#genderForm :checkbox').change(function () {
    if ($(this).is(':checked')) {
      if ($('#checkboxFemale').is(':checked')) {
        $('#selected').text($(this).val())
      } else if ($('#checkboxMale').is(':checked')) {
        $('#selected').text($(this).val())
      }
      if ($('#checkboxMale').is(':checked') && $('#checkboxFemale').is(':checked')) {
        $('#selected').text('Any')
      }
    } else {
      if ($('#checkboxFemale').is(':checked')) {
        $('#selected').text('Female')
      } else if ($('#checkboxMale').is(':checked')) {
        $('#selected').text('Male')
      }
      if (!$('#checkboxMale').is(':checked') && !$('#checkboxFemale').is(':checked')) {
        $('#selected').text('Any')
      }
    }
  })

  // $('#roles-list').on('change', handler.refreshRole);

  $(document).on('change', '#roles-list', function (e) {
    e.preventDefault()

    handler.refreshRole()
  })

  $('#search-button').on('click', handler.findMatches)
  $('#add-all-button').on('click', handler.addAll)

  $('#place-miles').slider('value', $('#place-miles-in').val())

  $('#place-miles').on('slide', function (e, ui) {
    $('#place-miles-in').val(ui.value)
  })

  // refine search toggle location search
  $(document).on('click', '#location-search-change-btn', function (e) {
    e.preventDefault()
    $('#location-search-display').show()
    $('#location-search-change').hide()
  })
  $(document).on('click', '#location-search-display-btn', function (e) {
    e.preventDefault()
    $('#location-search-display').hide()
    $('#location-search-change').show()
  })

  $(document).on('click', '#toggle-advanced-filters-btn', function (e) {
    e.preventDefault()
    $('#advanced-filters-div').slideToggle()
  })

  $(document).on('mouseover', '.talent-function-icon.profile', function () {
    $('.text-function-label.profile').css('opacity', '1')
  })

  $(document).on('mouseover', '.talent-function-icon.photos', function () {
    $('.text-function-label.photos').css('opacity', '1')
  })

  $(document).on('mouseover', '.talent-function-icon.notes', function () {
    $('.text-function-label.notes').css('opacity', '1')
  })

  $(document).on('mouseover', '.talent-function-icon.favorites', function () {
    $('.text-function-label.favorites').css('opacity', '1')
  })

  $(document).on('mouseover', '.talent-function-icon.add-role', function () {
    $('.text-function-label.add-role').css('opacity', '1')
  })

  $(document).on('mouseleave', '.talent-function-icon', function () {
    $('.text-function-label').css('opacity', '0')
  })

  // add notes function back
  $(document).on('click', '.talent-note-v2 .back-btn', function () {
    $(this).closest('.talent-item').find('.talent-note-v2').hide()
    $(this).closest('.talent-item').find('.talent-photo-v2').show()
    $(this).closest('.talent-item').find('.talent-functions-v2 ').show()
  })

  // talents add notes function
  $(document).on('click', '.talent-function-icon.notes', function () {
    $(this).closest('.talent-item').find('.talent-note-v2').show()
    $(this).closest('.talent-item').find('.talent-photo-v2').hide()
    $(this).closest('.talent-item').find('.talent-functions-v2 ').hide()
  })

  $(window).on('scroll', function () {
    if ($(window).scrollTop() + $(window).height() > $(document).height() - 100) {
      handler.findMatches(true)
    }
  })

  $(document).on('keyup', '#age-min-input', function () {
    $('#age-range-slider').slider('values', 0, $(this).val())
    $('input[name="age_min"]').val($(this).val())
  })

  $(document).on('keyup', '#age-max-input', function () {
    $('#age-range-slider').slider('values', 1, $(this).val())
    $('input[name="age_max"]').val($(this).val())
  })

  $(document).on('change', '#height-min-dropdown', function () {
    $('#height-range-slider').slider('values', 0, $(this).val())
    $('input[name="height_min"]').val($(this).val())
  })

  $(document).on('change', '#height-max-dropdown', function () {
    $('#height-range-slider').slider('values', 1, $(this).val())
    $('input[name="height_max"]').val($(this).val())
  })
  $('#filter-warning').show()
  $('#show_only_matched').on('click', function () {
    if ($(this).is(':checked')) {
      handler.findMatches()
      $('#search-button').prop('disabled', true)
      $('#filter-warning').show()
    } else {
      $('#search-button').prop('disabled', false)
      $('#filter-warning').hide()
    }
  })

  $('#show_only_matched').prop('checked', true)
  $('#search-button').prop('disabled', true)
}

},{"../event-handlers/role.find-talents.js":504}],476:[function(require,module,exports){
module.exports = function (core, user, projectId, roleId) {
  let handler = require('../event-handlers/role.landing.js')(core, user, projectId, roleId)

  // open modal if logo is clicked on this page
  $(document).on('click', '#navbar-main-logo', function (e) {
    e.preventDefault()
    $('#ghost-onboarding-modal').modal('show')
  })

  $('#projects-list').on('change', function () {
    let projectId = $(this).val()

    return handler.findRolesForSelectedProject(projectId)
  })

  $('#roles-list').on('change', handler.redirectToSelectedRole)

  $('input[name="phone1"]').mask('999-999-9999')
  $('input[name="phone2"]').mask('999-999-9999')

  $('#search-button').on('click', handler.findMatches)

  // refine search toggle location search
  $(document).on('click', '#location-search-change-btn', function (e) {
    e.preventDefault()
    $('#location-search-display').show()
    $('#location-search-change').hide()
  })
  $(document).on('click', '#location-search-display-btn', function (e) {
    e.preventDefault()
    $('#location-search-display').hide()
    $('#location-search-change').show()
  })

  $(document).on('click', '#contact-talent-btn', handler.confirmCdInfo)

  $(document).on('click', '.proceed-btn.confirm-email', function () {
    $('#onboarding-confirm-email').hide()
    $('#onboarding-create-password').show()
    $('input[name="cdpass"]').focus()
  })

  $(document).on('click', '.proceed-btn.create-password', function () {
    if ($('#cdpass').val()) {
      if ($('#cdpass').val() == $('#conf_cdpass').val()) {
        $('#onboarding-create-password').hide()
        $('#onboarding-other-email').show()
        $('input[name="email2"]').focus()
      } else {
        $('#empty_password').addClass('hide')
        $('#password_mismatch').removeClass('hide')
      }
    } else {
      $('#password_mismatch').addClass('hide')
      $('#empty_password').removeClass('hide')
    }
  })

  $(document).on('click', '.proceed-btn.other-email, .skip-btn.other-email', function () {
    $('#onboarding-other-email').hide()
    $('#onboarding-name').show()
    $('input[name="fname"]').focus()
  })

  $(document).on('click', '.proceed-btn.your-name', function () {
    $('#onboarding-name').hide()
    $('#onboarding-contact-num1').show()
    $('input[name="phone1"]').focus()
  })

  $(document).on('click', '.proceed-btn.contact-num1', function () {
    $('#onboarding-contact-num1').hide()
    $('#onboarding-contact-num2').show()
    $('input[name="phone2"]').focus()
  })

  $(document).on('click', '.proceed-btn.contact-num2, .skip-btn.contact-num2', function () {
    $('#onboarding-contact-num2').hide()
    $('#onboarding-company-name').show()
    $('input[name="company"]').focus()
  })

  // $(document).on('click', '.proceed-btn.company-name', function(){
  //   $('#onboarding-company-name').hide();
  //   $('#onboarding-congratulations').show();
  // });

  $(document).on('click', '.save-details-btn', handler.updateCdInfo)

  $(window).on('scroll', function () {
    if ($(window).scrollTop() + $(window).height() > $(document).height() - 100) {
      handler.findMatches(true)
    }
  })
}

},{"../event-handlers/role.landing.js":505}],477:[function(require,module,exports){
module.exports = function (core, user, projectId, roleId) {
  let handler = require('../event-handlers/role.like-it-list.js')(core, user, projectId, roleId)

  $('#roles-list').on('change', handler.refreshRole)
  $('#search-button').on('click', handler.findMatches)

  // refine search toggle location search
  $(document).on('click', '#location-search-change-btn', function (e) {
    e.preventDefault()
    $('#location-search-display').show()
    $('#location-search-change').hide()
  })

  $(document).on('click', '#location-search-display-btn', function (e) {
    e.preventDefault()
    $('#location-search-display').hide()
    $('#location-search-change').show()
  })

  $(window).on('scroll', function () {
    if ($(window).scrollTop() + $(window).height() > $(document).height() - 100) {
      handler.findMatches(true)
    }
  })

  $('#send-invites-button').on('click', handler.sendInvites)

  $('#additional-filters').removeClass('hide')

  $(document).on('click', '.like-it-list-checkbox', function () {
    $(this).toggleClass('checked')
    handler.countCheckedTalents()

    $('#remove-all-checked-talents-btn-disabled').removeAttr('disabled')

    let checked_talents = []
    let checked = $('.like-it-list-checkbox.checked')

    $.each(checked, function (index, value) {
      checked_talents.push(value)
    })

    let length = checked_talents.length
    if (length == 0) {
      $('#remove-all-checked-talents-btn-disabled').prop('disabled', true)
      $('#mark-all-talents-as-checked-btn').removeClass('hide')
      $('#mark-all-talents-as-unchecked-btn').addClass('hide')
    }
  })

  $(document).on('click', '#mark-all-talents-as-checked-btn', function () {
    let checkbox = $('.like-it-list-checkbox')

    $.each(checkbox, function (index, value) {
      // check if already checked
      if (!$(this).hasClass('checked')) {
        // check if not 1st element (dummy data-bind element has no id attribute)
        if ($(this).attr('id')) {
          $(this).click()
        }
      }
    })

    $('#mark-all-talents-as-checked-btn').addClass('hide')
    $('#mark-all-talents-as-unchecked-btn').removeClass('hide')
  })

  $(document).on('click', '#mark-all-talents-as-unchecked-btn', function () {
    let checkbox = $('.like-it-list-checkbox')

    $.each(checkbox, function (index, value) {
      // check if already checked
      if ($(this).hasClass('checked')) {
        // check if not 1st element (dummy data-bind element has no id attribute)
        if ($(this).attr('id')) {
          $(this).click()
        }
      }
    })

    $('#remove-all-checked-talents-btn-disabled').prop('disabled', true)
    $('#mark-all-talents-as-checked-btn').removeClass('hide')
    $('#mark-all-talents-as-unchecked-btn').addClass('hide')
  })

  $(document).on('click', '#remove-all-checked-talents-btn', handler.removeAllChecked)

  $(document).on('click', '#remove-all-like-it-list', handler.removeAllLikeItList)

  // add notes function back
  $(document).on('click', '.talent-note-v2 .back-btn', function () {
    $(this).closest('.talent-item').find('.talent-note-v2').hide()
    $(this).closest('.talent-item').find('.talent-photo-v2').show()
    $(this).closest('.talent-item').find('.talent-functions-v2 ').show()
  })

  // talents add notes function
  $(document).on('click', '.talent-function-icon.notes', function () {
    $(this).closest('.talent-item').find('.talent-note-v2').show()
    $(this).closest('.talent-item').find('.talent-photo-v2').hide()
    $(this).closest('.talent-item').find('.talent-functions-v2 ').hide()
  })
  $('#filter-warning').hide()
  $('#show_only_matched').on('click', function () {
    if ($(this).is(':checked')) {
      handler.findMatches()
      $('#search-button').prop('disabled', true)
      $('#filter-warning').show()
    } else {
      $('#search-button').prop('disabled', false)
      $('#filter-warning').hide()
    }
  })
}

},{"../event-handlers/role.like-it-list.js":506}],478:[function(require,module,exports){
module.exports = function (core, user, projectId, roleId) {
  let handler = require('../event-handlers/role.publiclikeitlist.js')(core, user, projectId, roleId)

  $('#roles-list').on('change', handler.refreshRole)
  $('#search-button').on('click', handler.findMatches)

  $('#place-miles').slider('value', $('#place-miles-in').val())

  $('#place-miles').on('slide', function (e, ui) {
    $('#place-miles-in').val(ui.value)
  })

  // refine search toggle location search
  $(document).on('click', '#location-search-change-btn', function (e) {
    e.preventDefault()
    $('#location-search-display').show()
    $('#location-search-change').hide()
  })
  $(document).on('click', '#location-search-display-btn', function (e) {
    e.preventDefault()
    $('#location-search-display').hide()
    $('#location-search-change').show()
  })

  $(document).on('click', '#toggle-advanced-filters-btn', function (e) {
    e.preventDefault()
    $('#advanced-filters-div').slideToggle()
  })

  $(window).on('scroll', function () {
    if ($(window).scrollTop() + $(window).height() > $(document).height() - 100) {
      handler.findMatches(true)
    }
  })

  $(document).on('keyup', '#age-min-input', function () {
    $('#age-range-slider').slider('values', 0, $(this).val())
    $('input[name="age_min"]').val($(this).val())
  })

  $(document).on('keyup', '#age-max-input', function () {
    $('#age-range-slider').slider('values', 1, $(this).val())
    $('input[name="age_max"]').val($(this).val())
  })

  $(document).on('change', '#height-min-dropdown', function () {
    $('#height-range-slider').slider('values', 0, $(this).val())
    $('input[name="height_min"]').val($(this).val())
  })

  $(document).on('change', '#height-max-dropdown', function () {
    $('#height-range-slider').slider('values', 1, $(this).val())
    $('input[name="height_max"]').val($(this).val())
  })

  // add notes function back
  $(document).on('click', '.talent-note-v2 .back-btn', function () {
    $(this).closest('.talent-item').find('.talent-note-v2').hide()
    $(this).closest('.talent-item').find('.talent-photo-v2').show()
    $(this).closest('.talent-item').find('.talent-functions-v2 ').show()
  })

  // talents add notes function
  $(document).on('click', '.talent-function-icon.notes', function () {
    $(this).closest('.talent-item').find('.talent-note-v2').show()
    $(this).closest('.talent-item').find('.talent-photo-v2').hide()
    $(this).closest('.talent-item').find('.talent-functions-v2 ').hide()
  })

  $('.mark-talent-as-checked').hide()
  $('#filter-warning').hide()
  $('#show_only_matched').on('click', function () {
    if ($(this).is(':checked')) {
      handler.findMatches()
      $('#search-button').prop('disabled', true)
      $('#filter-warning').show()
    } else {
      $('#search-button').prop('disabled', false)
      $('#filter-warning').hide()
    }
  })
}

},{"../event-handlers/role.publiclikeitlist.js":507}],479:[function(require,module,exports){
$(document).on('click', '#scheduled-photo-view-2', function () {
  $('#role-list-container .view-container, #schedule-time-container .view-container').addClass('talent-photo-view')
  $('#role-list-container .view-container, #schedule-time-container .view-container').removeClass('talent-confirmation-view submission-note-view casting-note-view list-view')
  $('#role-list-container .draggable-item, #schedule-time-container .draggable-item').addClass('display-inline-block')
})
$(document).on('click', '#scheduled-confirmation-view-2', function () {
  $('#role-list-container .view-container, #schedule-time-container .view-container').addClass('talent-confirmation-view')
  $('#role-list-container .view-container, #schedule-time-container .view-container').removeClass('talent-photo-view submission-note-view casting-note-view list-view')
  $('#role-list-container .draggable-item, #schedule-time-container .draggable-item').addClass('display-block')
  $('#role-list-container .draggable-item, #schedule-time-container .draggable-item').removeClass('display-inline-block')
})
$(document).on('click', '#scheduled-submission-note-view-2', function () {
  $('#role-list-container .view-container, #schedule-time-container .view-container').addClass('submission-note-view')
  $('#role-list-container .view-container, #schedule-time-container .view-container').removeClass('talent-photo-view talent-confirmation-view casting-note-view list-view')
  $('#role-list-container .draggable-item, #schedule-time-container .draggable-item').addClass('display-block')
  $('#role-list-container .draggable-item, #schedule-time-container .draggable-item').removeClass('display-inline-block')
})
$(document).on('click', '#scheduled-casting-note-view-2', function () {
  $('#role-list-container .view-container, #schedule-time-container .view-container').addClass('casting-note-view')
  $('#role-list-container .view-container, #schedule-time-container .view-container').removeClass('talent-photo-view submission-note-view talent-confirmation-view list-view')
  $('#role-list-container .draggable-item, #schedule-time-container .draggable-item').addClass('display-block')
  $('#role-list-container .draggable-item, #schedule-time-container .draggable-item').removeClass('display-inline-block')
})
$(document).on('click', '#scheduled-list-view-2', function () {
  $('#role-list-container .view-container, #schedule-time-container .view-container').addClass('list-view')
  $('#role-list-container .view-container, #schedule-time-container .view-container').removeClass('talent-photo-view submission-note-view talent-confirmation-view casting-note-view')
  $('#role-list-container .draggable-item, #schedule-time-container .draggable-item').addClass('display-block')
  $('#role-list-container .draggable-item, #schedule-time-container .draggable-item').removeClass('display-inline-block')
})

// $(document).on('click', '#scheduled-photo-view-1', function(){
//   $('#schedule-time-container .view-container').addClass('talent-photo-view')
//   $('#schedule-time-container .view-container').removeClass('talent-confirmation-view submission-note-view casting-note-view list-view');
// });
// $(document).on('click', '#scheduled-confirmation-view-1', function(){
//   $('#schedule-time-container .view-container').addClass('talent-confirmation-view')
//   $('#schedule-time-container .view-container').removeClass('talent-photo-view submission-note-view casting-note-view list-view');
// });
// $(document).on('click', '#scheduled-submission-note-view-1', function(){
//   $('#schedule-time-container .view-container').addClass('submission-note-view')
//   $('#schedule-time-container .view-container').removeClass('talent-photo-view talent-confirmation-view casting-note-view list-view');
// });
// $(document).on('click', '#scheduled-casting-note-view-1', function(){
//   $('#schedule-time-container .view-container').addClass('casting-note-view')
//   $('#schedule-time-container .view-container').removeClass('talent-photo-view submission-note-view talent-confirmation-view list-view');
// });
// $(document).on('click', '#scheduled-list-view-1', function(){
//   $('#schedule-time-container .view-container').addClass('list-view')
//   $('#schedule-time-container .view-container').removeClass('talent-photo-view submission-note-view talent-confirmation-view casting-note-view');
// });

$(function () {
  let $height = $(window).height()
  let $adheight = $height - 200
  $('#role-list-container').css('height', $adheight + 'px')
  $('#role-list-container').slimScroll({ height: $adheight })
  $('#schedule-time-container').css('height', $adheight + 'px')
  $('#schedule-time-container').slimScroll({ height: $adheight })
})

},{}],480:[function(require,module,exports){
module.exports = function (core, user, projectId, roleId) {
  let handler = require('../event-handlers/role.submissions.js')(core, user, projectId, roleId)

  setTimeout(function () {
    $('#search-by-location').click()
  }, 500)

  $('#hasphotoForm').click(function () {
    if ($('#has-photo').is(':checked')) {
      $('#radio-selected').text('Yes')
    } else {
      $('#radio-selected').text('Any')
    }
  })

  $('#place-miles').slider('value', $('#place-miles-in').val())

  $('#place-miles').on('slide', function (e, ui) {
    $('#place-miles-in').val(ui.value)
  })

  $('#genderForm :checkbox').change(function () {
    if ($(this).is(':checked')) {
      if ($('#checkboxFemale').is(':checked')) {
        $('#selected').text($(this).val())
      } else if ($('#checkboxMale').is(':checked')) {
        $('#selected').text($(this).val())
      }
      if ($('#checkboxMale').is(':checked') && $('#checkboxFemale').is(':checked')) {
        $('#selected').text('Any')
      }
    } else {
      if ($('#checkboxFemale').is(':checked')) {
        $('#selected').text('Female')
      } else if ($('#checkboxMale').is(':checked')) {
        $('#selected').text('Male')
      }
      if (!$('#checkboxMale').is(':checked') && !$('#checkboxFemale').is(':checked')) {
        $('#selected').text('Any')
      }
    }
  })

  $('#roles-list').on('change', handler.refreshRole)
  $('#search-button').on('click', handler.findMatches)
  $('#add-all-button').on('click', handler.addAll)

  // refine search toggle location search
  $(document).on('click', '#location-search-change-btn', function (e) {
    e.preventDefault()
    $('#location-search-display').show()
    $('#location-search-change').hide()
  })
  $(document).on('click', '#location-search-display-btn', function (e) {
    e.preventDefault()
    $('#location-search-display').hide()
    $('#location-search-change').show()
  })

  $(document).on('click', '#toggle-advanced-filters-btn', function (e) {
    e.preventDefault()
    $('#advanced-filters-div').slideToggle()
  })

  // add notes function back
  $(document).on('click', '.talent-note-v2 .back-btn', function () {
    $(this).closest('.talent-item').find('.talent-note-v2').hide()
    $(this).closest('.talent-item').find('.talent-photo-v2').show()
    $(this).closest('.talent-item').find('.talent-functions-v2 ').show()
  })

  // talents add notes function
  $(document).on('click', '.talent-function-icon.notes', function () {
    $(this).closest('.talent-item').find('.talent-note-v2').show()
    $(this).closest('.talent-item').find('.talent-photo-v2').hide()
    $(this).closest('.talent-item').find('.talent-functions-v2 ').hide()
  })

  $(window).on('scroll', function () {
    if ($(window).scrollTop() + $(window).height() > $(document).height() - 100) {
      handler.findMatches(true)
    }
  })

  $(document).on('keyup', '#age-min-input', function () {
    $('#age-range-slider').slider('values', 0, $(this).val())
    $('input[name="age_min"]').val($(this).val())
  })

  $(document).on('keyup', '#age-max-input', function () {
    $('#age-range-slider').slider('values', 1, $(this).val())
    $('input[name="age_max"]').val($(this).val())
  })

  $(document).on('change', '#height-min-dropdown', function () {
    $('#height-range-slider').slider('values', 0, $(this).val())
    $('input[name="height_min"]').val($(this).val())
  })

  $(document).on('change', '#height-max-dropdown', function () {
    $('#height-range-slider').slider('values', 1, $(this).val())
    $('input[name="height_max"]').val($(this).val())
  })

  $('#filter-warning').show()
  $('#show_only_matched').on('click', function () {
    if ($(this).is(':checked')) {
      handler.findMatches()
      $('#search-button').prop('disabled', true)
      $('#filter-warning').show()
    } else {
      $('#search-button').prop('disabled', false)
      $('#filter-warning').hide()
    }
  })

  $('#show_only_matched').prop('checked', true)
  $('#search-button').prop('disabled', true)
}

},{"../event-handlers/role.submissions.js":508}],481:[function(require,module,exports){
'use strict'

module.exports = function (core, user, projectId, roleId) {
  let handler = require('../event-handlers/role.worksheet.js')(core, user, projectId, roleId)

  $('#filter-button').on('click', handler.refresh)
  $('#reschedule-button').on('click', handler.reschedule)
  $('#add-note-button').on('click', handler.addNote)
  $('#reply-button').on('click', handler.reply)
  $(document).on('click', '.reschedule-button', handler.setScheduleId)
  $(document).on('click', '.add-note-button', handler.setScheduleId)
  $(document).on('click', '.accept-button', handler.updateScheduleStatus)
  $(document).on('click', '.decline-button', handler.updateScheduleStatus)
  $(document).on('click', '.callback-button', handler.updateScheduleCDStatus)
  $(document).on('click', '.hired-button', handler.updateScheduleCDStatus)
  $(document).on('click', '.message-button', handler.showMessageModal)

  $('#message-modal').on('hidden.bs.modal', function (e) {
    $('#message-modal iframe').attr('src', $('#message-modal iframe').attr('src'))
  })
}

},{"../event-handlers/role.worksheet.js":509}],482:[function(require,module,exports){
'use strict'

module.exports = function (core, user) {
  let handler = require('../event-handlers/settings.js')(core, user)

  $('#update-settings-button').on('click', handler.updateUser)
  $('#update-password-button').on('click', handler.updatePassword)
}

},{"../event-handlers/settings.js":510}],483:[function(require,module,exports){
module.exports = function (core, user) {
  let handler = require('../event-handlers/talent.favorite.js')(core, user)

  // talents add notes function
  $(document).on('click', '.talent-function-icon.notes', function () {
    $(this).closest('.talent-item').find('.talent-note-v2').show()
    $(this).closest('.talent-item').find('.talent-photo-v2').hide()
    $(this).closest('.talent-item').find('.talent-functions-v2 ').hide()
  })

  // add notes function back
  $(document).on('click', '.talent-note-v2 .back-btn', function () {
    $(this).closest('.talent-item').find('.talent-note-v2').hide()
    $(this).closest('.talent-item').find('.talent-photo-v2').show()
    $(this).closest('.talent-item').find('.talent-functions-v2 ').show()
  })

  $('.search-button').on('click', handler.refresh)

  $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
    $('#address-search').val($(this).siblings('input[type="hidden"]').val())
  })

  $('#place-miles').slider('value', $('#place-miles-in').val())

  $('#place-miles').on('slide', function (e, ui) {
    $('#place-miles-in').val(ui.value)
  })

  $(document).on('mouseover', '.talent-function-icon.profile', function () {
    $('.text-function-label.profile').css('opacity', '1')
  })

  $(document).on('mouseover', '.talent-function-icon.photos', function () {
    $('.text-function-label.photos').css('opacity', '1')
  })

  $(document).on('mouseover', '.talent-function-icon.notes', function () {
    $('.text-function-label.notes').css('opacity', '1')
  })

  $(document).on('mouseover', '.talent-function-icon.favorites', function () {
    $('.text-function-label.favorites').css('opacity', '1')
  })

  $(document).on('mouseover', '.talent-function-icon.add-role', function () {
    $('.text-function-label.add-role').css('opacity', '1')
  })

  $(document).on('mouseleave', '.talent-function-icon', function () {
    $('.text-function-label').css('opacity', '0')
  })

  $(window).on('scroll', function () {
    if ($(window).scrollTop() + $(window).height() > $(document).height() - 100) {
      handler.refresh(true)
    }
  })
}

},{"../event-handlers/talent.favorite.js":511}],484:[function(require,module,exports){
module.exports = function (core, user) {
  let handler = require('../event-handlers/talent.index.js')(core, user)

  $('#hasphotoForm').click(function () {
    if ($('#has-photo').is(':checked')) {
      $('#radio-selected').text('Yes')
    } else {
      $('#radio-selected').text('Any')
    }
  })

  $('#genderForm :checkbox').change(function () {
    if ($(this).is(':checked')) {
      if ($('#checkboxFemale').is(':checked')) {
        $('#selected').text($(this).val())
      } else if ($('#checkboxMale').is(':checked')) {
        $('#selected').text($(this).val())
      }
      if ($('#checkboxMale').is(':checked') && $('#checkboxFemale').is(':checked')) {
        $('#selected').text('Any')
      }
    } else {
      if ($('#checkboxFemale').is(':checked')) {
        $('#selected').text('Female')
      } else if ($('#checkboxMale').is(':checked')) {
        $('#selected').text('Male')
      }
      if (!$('#checkboxMale').is(':checked') && !$('#checkboxFemale').is(':checked')) {
        $('#selected').text('Any')
      }
    }
  })

  $('.search-button').on('click', handler.refresh)

  // talents functions menu
  $(document).on('mouseover', '.talent-function-icon.profile', function () {
    $('.text-function-label.profile').css('opacity', '1')
  })

  $(document).on('mouseover', '.talent-function-icon.photos', function () {
    $('.text-function-label.photos').css('opacity', '1')
  })

  $(document).on('mouseover', '.talent-function-icon.notes', function () {
    $('.text-function-label.notes').css('opacity', '1')
  })

  $(document).on('mouseover', '.talent-function-icon.favorites', function () {
    $('.text-function-label.favorites').css('opacity', '1')
  })

  $(document).on('mouseover', '.talent-function-icon.add-role', function () {
    $('.text-function-label.add-role').css('opacity', '1')
  })

  $(document).on('mouseleave', '.talent-function-icon', function () {
    $('.text-function-label').css('opacity', '0')
  })

  // talents add notes function
  $(document).on('click', '.talent-function-icon.notes', function () {
    $(this).closest('.talent-item').find('.talent-note-v2').show()
    $(this).closest('.talent-item').find('.talent-photo-v2').hide()
    $(this).closest('.talent-item').find('.talent-functions-v2 ').hide()
  })

  // add notes function back
  $(document).on('click', '.talent-note-v2 .back-btn', function () {
    $(this).closest('.talent-item').find('.talent-note-v2').hide()
    $(this).closest('.talent-item').find('.talent-photo-v2').show()
    $(this).closest('.talent-item').find('.talent-functions-v2 ').show()
  })

  $(window).on('scroll', function () {
    if ($(window).scrollTop() + $(window).height() > $(document).height() - 100) {
      handler.refresh(true)
    }
  })

  $(document).on('keyup', '#age-min-input', function () {
    $('#age-range-slider').slider('values', 0, $(this).val())
    $('input[name="age_min"]').val($(this).val())
  })

  $(document).on('keyup', '#age-max-input', function () {
    $('#age-range-slider').slider('values', 1, $(this).val())
    $('input[name="age_max"]').val($(this).val())
  })

  $(document).on('change', '#height-min-dropdown', function () {
    $('#height-range-slider').slider('values', 0, $(this).val())
    $('input[name="height_min"]').val($(this).val())
  })

  $('#place-miles').slider('value', $('#place-miles-in').val())

  $('#place-miles').on('slide', function (e, ui) {
    $('#place-miles-in').val(ui.value)
  })

  $(document).on('change', '#height-max-dropdown', function () {
    $('#height-range-slider').slider('values', 1, $(this).val())
    $('input[name="height_max"]').val($(this).val())
  })

  // refine search toggle location search
  $(document).on('click', '#location-search-change-btn', function (e) {
    e.preventDefault()
    $('#location-search-display').show()
    $('#location-search-change').hide()
  })
  $(document).on('click', '#location-search-display-btn', function (e) {
    e.preventDefault()
    $('#location-search-display').hide()
    $('#location-search-change').show()
  })

  $(document).on('click', '#toggle-advanced-filters-btn', function (e) {
    e.preventDefault()
    $('#advanced-filters-div').slideToggle()
  })

  $(document).on('click', '#toggle-add-location-filter-btn', function (e) {
    e.preventDefault()
    $('#add-location-filter-div').slideToggle()
  })

  // responsive filter turns to modal when mobile
  $(document).ready(function () {
    if ($(this).width() <= 752) {
      $('#filter-content-modal').css('display', 'none')
      $('#filter-content-modal').addClass('modal fade')
    } else {
      $('#filter-content-modal').css('display', 'block')
      $('#filter-content-modal').removeClass('modal fade')
    }
  })
  $(window).resize(function () {
    if ($(this).width() <= 752) {
      $('#filter-content-modal').css('display', 'none')
      $('#filter-content-modal').addClass('modal fade')
    } else {
      $('#filter-content-modal').css('display', 'block')
      $('#filter-content-modal').removeClass('modal fade')
    }
  })
}

},{"../event-handlers/talent.index.js":512}],485:[function(require,module,exports){
module.exports = function (core, user, talentnum) {
  let handler = require('../event-handlers/talent.resume.js')(core, user, talentnum)

  $(document).on('click', '.photo-click', function () {
    $('#talent-photo').click()
  })
}

},{"../event-handlers/talent.resume.js":513}],486:[function(require,module,exports){
module.exports = function (core, user, talentnum) {
  let handler = require('../event-handlers/unsubscribe.js')(core, user)

  $('#savebtn').on('click', function () {
    handler.saveChanges()
  })
}

},{"../event-handlers/unsubscribe.js":514}],487:[function(require,module,exports){
module.exports = function (core, user) {
  let qs = core.service.query_string()
  let email = qs.email || ''
  let code = qs.code || ''

  if (!email || !code) {
    $('#verify-email-error').show()
    return
  }

  core.service.rest.post(core.config.api.base + '/cd/email_verification/verify', {
    email: email,
    code: code
  }).then(function () {
    $('#verify-email-success').show()
    setTimeout(function () {
      window.location = user && parseInt(user.bam_cd_user_id, 10) ? '/welcome' : '/login'
    }, 2500)
  }).catch(function () {
    $('#verify-email-error').show()
  })
}

},{}],488:[function(require,module,exports){
module.exports = function (core, user) {
  core.resource.project.get().then(function (res) {
    if (res.total) {
      $('#profile-link').removeClass('hide')
    }
  })
}

},{}],489:[function(require,module,exports){

'use strict'

function Handler (core, user) {
  self = this
  self.core = core
  self.user = user
  console.log(user)
  self.getAllEmails()
}

Handler.prototype.getAllEmails = function () {
  let qs = self.core.service.query_string()
  let emails = {
    with_trashed: 1,
    query: [
      ['user_id', self.user.id],
      ['orderBy', 'created_at', 'DESC']
    ],
    page: qs.page || 1,
    per_page: 10
  }

  self.core.resource.user_email.get(emails)
    .then(function (res) {
      console.log(res)
      self.core.service.databind('#alt_emails', res)
      self.core.service.paginate('#pagination', { total: res.total, class: 'pagination', name: 'page', per_page: res.per_page })
      $('.email').val('')
    })
}

Handler.prototype.addEmail = function () {
  let email = $('.email').val()

  let data = {
    email: email
  }
  if (email.length > 0) {
    self.core.resource.user_email.post(data)
      .then(function (res) {
        $.growl.notice({
          title: '<i class=\'fa fa-check\'> </i> Updated succesfully!',
          message: ''
        })
        self.getAllEmails()
        $('.email').text('')
      }, function (error) {
        if (error) {
          $.growl.error({
            title: '<i class=\'fa fa-times\'> </i> Invalid email address!',
            message: ''
          })
        }
      })
  }
}

Handler.prototype.setEmail = function (id) {
  self.core.resource.user_email.get({
    with_trashed: 1,
    id: id
  })
    .then(function (res) {
      let data = {
        cdUserId: self.user.bam_cd_user.user_id,
        email1: res.email
      }
      self.core.resource.cd_user.patch(data)
        .then(function (res1) {
          console.log(res1)
        })

      self.core.resource.user_email.delete({ id: id, with_trashed: 1 })
        .then(function (res2) {
          self.getAllEmails()
          $.growl.notice({
            title: '<i class=\'fa fa-check\'> </i> Updated succesfully!',
            message: ''
          })
        })
    })
}

Handler.prototype.setEmailSec = function (id) {
  self.core.resource.user_email.get({
    with_trashed: 1,
    id: id
  })
    .then(function (res) {
      let data = {
        cdUserId: self.user.bam_cd_user.user_id,
        email2: res.email
      }
      self.core.resource.cd_user.patch(data)
        .then(function (res1) {
          console.log(res1)
        })

      self.core.resource.user_email.delete({ id: id, with_trashed: 1 })
        .then(function (res2) {
          self.getAllEmails()
          $.growl.notice({
            title: '<i class=\'fa fa-check\'> </i> Updated succesfully!',
            message: ''
          })
        })
    })
}

Handler.prototype.deleteEmail = function (id) {
  if (confirm('Are you sure you want to delete this email?')) {
    self.core.resource.user_email.delete({ id: id, with_trashed: 1 })
      .then(function (res) {
        console.log(res)
        self.getAllEmails()
        $.growl.notice({
          title: '<i class=\'fa fa-check\'> </i> Deleted successfully!',
          message: ''
        })
      })
  }
}

module.exports = function (core, user) {
  return new Handler(core, user)
}

},{}],490:[function(require,module,exports){
function handler (core, user) {
  let self = this
  self.core = core
  self.user = user
  self.getAllFeedbacks()
}

handler.prototype.getAllFeedbacks = function () {
  let self = this
  self.core.resource.feedback.get()
    .then(function (res) {
      _.each(res.data, function (n, i) {
        res.data[i].date = self.core.service.date
      })
      self.core.service.databind('#all-feedbacks-div', res)
    })
    .catch(function () {
      $('#all-feedbacks-div').html('<p class="text-muted">Unable to load feedback history.</p>')
    })
}

handler.prototype.addNewFeedback = function () {
  let self = this
  let msg = $.trim($('#feedback-message').val())

  if (!msg) {
    alert('Please enter a message before submitting feedback.')
    return
  }

  let attachedFile = $('#upload-file-name')[0].files[0]
  let data = new FormData()
  if (attachedFile) {
    data.append('file', attachedFile)
  }
  data.append('app_id', 9)
  data.append('body', msg)

  $('#add-feedback-btn').prop('disabled', true)

  $.ajax({
    url: self.core.config.api.base + '/feedbacks',
    type: 'POST',
    data: data,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('access_token')
    },
    cache: false,
    dataType: 'json',
    processData: false,
    contentType: false,
    crossDomain: true,
    timeout: 30000
  })
    .then(function () {
      $('#add-feedback-modal').modal('hide')
      $('#feedback-message').val('')
      $('#upload-file-name').val('')
      alert('Thank you — your feedback has been submitted.')
      self.getAllFeedbacks()
    })
    .catch(function (xhr) {
      var message = 'Unable to submit feedback. Please try again.'
      if (xhr && xhr.responseJSON && xhr.responseJSON.errors) {
        message = 'Unable to submit feedback. Please sign in again and retry.'
      }
      alert(message)
    })
    .always(function () {
      $('#add-feedback-btn').prop('disabled', false)
    })
}

module.exports = function (core, user) {
  return new handler(core, user)
}

},{}],491:[function(require,module,exports){
'use strict'
function Handler (core, user) {
  self = this
  self.core = core
  self.cdn = '//talentmedia.blob.core.windows.net/etdownload/'
  self.user = user
  self.me = user.id
  self.getConversations()
  console.log(self.me)
  console.log(self.me)
}

Handler.prototype.getConversations = () => {
  let data = {
    query: [
      [ 'with', 'users.bam_user' ],
      [ 'with', 'users.bam_cd_user' ],
      [ 'with', 'users.bam_talentci.bam_talent_media2_profile' ],
      [ 'orderBy', 'updated_at', 'DESC' ],
      [ 'with', { messages: [
        [ 'orderBy', 'created_at', 'ASC' ]
      ] } ]
    ]
  }
  core.resource.conversation.get(data)
    .then(conversations => {
      console.log(conversations)
      _.each(conversations.data, (c, i) => {
        _.each(c.users, user => {
          c.me = self.me
          self.messages = c.mesages
          c.name = 'Unknown'
          c.photo = '/images/filler.jpg'
          c.message = '...'
          c.created_at = moment(c.created_at)
          if (c.messages.length > 0) {
            c.created_at = moment(c.last_message.created_at)
            c.message = c.last_message.body
            if (c.message.length > 45) {
              c.message = c.message.slice(0, 45) + '...'
            }
          }

          if (user.bam_talentnum > 0) {
            c.name = user.bam_talentci.fname + ' ' + user.bam_talentci.lname
            c.address = user.bam_talentci.address1
            if (user.bam_talentci.bam_talent_media2_profile.length > 0) {
              c.photo = self.cdn + user.bam_talentci.bam_talent_media2_profile[0].bam_media_path_full
            }
          }

          if (user.bam_cd_user_id > 0) {
            c.name = user.bam_cd_user.fname + ' ' + user.bam_cd_user.lname
            c.address = user.bam_cd_user.address1
          }

          if (user.bam_user_id > 0) {
            c.name = user.bam_user.fname + ' ' + user.bam_user.lname
            c.address = user.bam_user.address1
          }
        })

        c.user = _.find(c.users, u => {
          return u.id === c.user_id
        })
      })

      self.conversations = conversations
      self.renderConversations()

      // Load first conversation
      if (conversations.data.length) {
        self.renderMessages(conversations.data[0].id)
        self.renderConversations()
        $('.show-conversation:visible').each((i, e) => {
          if (i === 0) {
            $(e).parents('.talent-item').addClass('active')
          }
        })
      }
    })
}

Handler.prototype.renderConversations = () => {
  self.core.service.databind('.from', self.conversations)
}

Handler.prototype.renderMessages = (id) => {
  let conversations = self.conversations
  let qs = core.service.query_string
  let conversation = _.find(conversations.data, (i) => {
    return i.id == id
  })

  let data = {
    page: qs.page || 1,
    conversationId: id,
    query: [
      ['orderBy', 'created_at', 'ASC']
    ]
  }

  core.resource.message.get(data)
    .then((message) => {
      console.log(message)
      core.service.databind('#to', message)
    })

  core.service.databind('#reply', conversation)
}

Handler.prototype.reply = (e) => {
  e.preventDefault()
  let container = $(e.target).parents('.message-content').find('.messages-container')

  let form = self.core.service.form.serializeObject('#message-reply')
  if (form.body.length) {
    console.log(container)
    core.resource.message.post(form)
      .then((res) => {
        self.renderMessages(res.conversation_id)
        self.getConversations()
        $(e.target).parent().parent().find('input[name=body]').val('')
      })
    container.scrollTop(9999)
  }
}

Handler.prototype.deleteConvo = (e) => {
  let del = $(e.target).attr('data-id')

  if (confirm('Are you sure you want to delete this conversation?')) {
    core.resource.conversation.delete({ conversationId: del })
      .then((res) => {
        self.getConversations()
      })
  }
}

Handler.prototype.activeFirst = () => {
}

module.exports = (core, user, projectId, roleId) => {
  return new Handler(core, user, projectId, roleId)
}

},{}],492:[function(require,module,exports){
'use strict'
let _ = require('lodash')

function handler (core, user) {
  self = this
  self.core = core
  self.user = user

  console.log(user)
}

handler.prototype.sendLinkToEmail = function (e) {
  e.preventDefault()

  let email = $('#email').val()

  if (/\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}\b/.test(email)) {
    let data = {
      email: email,
      type: 'bam_cd_user'
    }

    self.core.resource.reminder.post(data)
      .then(function (res) {
        $('#invalid-email').hide()
        $('#valid-email').fadeIn().delay(5000).fadeOut()
      }, function (res1) {
        $('#email-not-found').fadeIn().delay(5000).fadeOut()
      })
  } else {
    $('#valid-email').hide()
    $('#invalid-email').fadeIn().delay(5000).fadeOut()
  }
}

module.exports = function (core, user) {
  return new handler(core, user)
}

},{"lodash":429}],493:[function(require,module,exports){
'use strict'
let _ = require('lodash')

function handler (core, user) {
  self = this
  self.core = core
  self.user = user
}

handler.prototype.resetPassword = function () {
  let pass1 = $('#enter-password').val()
  let pass2 = $('#confirm-password').val()
  let qs = self.core.service.query_string()

  if (!pass1 || !pass2 || pass1 != pass2) {
    $('#invalid-pass').fadeIn().delay(5000).fadeOut()
    return
  }

  if (qs.token && qs.email) {
    self.core.service.rest.post(self.core.config.api.base + '/cd/password_reset/confirm', {
      email: qs.email,
      token: qs.token,
      pass: pass1
    }).then(function () {
      $('#success-pass').fadeIn().delay(5000).fadeOut()
      setTimeout(function () {
        window.location = '/login'
      }, 1500)
    }).catch(function () {
      $('#invalid-pass').fadeIn().delay(5000).fadeOut()
    })
    return
  }

  if (!self.user || !self.user.bam_cd_user) {
    $('#invalid-pass').fadeIn().delay(5000).fadeOut()
    return
  }

  let data = {
    cdUserId: self.user.bam_cd_user.user_id,
    pass: pass1
  }

  self.core.resource.cd_user.patch(data)
    .then(function () {
      $('#success-pass').fadeIn().delay(5000).fadeOut()
      setTimeout(function () {
        window.location = '/projects'
      })
    })
}

module.exports = function (core, user) {
  return new handler(core, user)
}

},{"lodash":429}],494:[function(require,module,exports){
'use strict'
// let layoutInit = require('./layout.js');

function handler (core, user, talentlogin) {
  self = this
  self.core = core
  self.user = user

  console.log(self.core.resource)

  // email autofill with CD email
  self.core.service.databind('#self-sub-email', self.user)
}

handler.prototype.createNewProject = function (e) {
  e.preventDefault()

  function parseDate (inputDate) {
    let timestamp = new Date()
    let revert = -1 * timestamp.getTimezoneOffset() * 60
    inputDate = inputDate.split('-')
    return Date.UTC(inputDate[0], inputDate[1] - 1, inputDate[2]) / 1000 - revert
  }

  let projectname = $('#project-name').val()
  let category = $('#project-category').val()

  let submissiondeadline = $('#bs-datepicker-submissiondeadline').val()
  let asaptimestamp = parseDate(submissiondeadline)

  let dd = new Date()

  let dn = dd.getFullYear() + '-' + (dd.getMonth() + 1) + '-' + dd.getDate()
  let submissiontimestamp = parseDate(dn)

  let rate = $('#project-rate').val()
  let ratedes = $('#project-rate-desc').val()

  let auditiondate = $('#bs-datepicker-audition').val()
  let auditiontimestamp = parseDate(auditiondate)

  let shootdate = $('#bs-datepicker-shootdate').val()
  let shoottimestamp = parseDate(shootdate)

  let union = $('input[type="radio"][name="radioUnion"]:checked').val()
  let projecttype = $('input[type="radio"][name="radioSubmissionType"]:checked').val()
  let zipcode = $('#zip-code').val()
  let auditiondesc = $('#audition-description').val()

  let promise = $.when()

  // sets checked boxes as market (after Auto Select Markets button is clicked (will check zipcode))
  let markets = []

  // Nationwide Casting
  if ($('#nationwide-market-checkbox').hasClass('checked')) {
    markets = 'N/A'
    zipcode = 'N/A'
  } else if (!$('.auto-markets-div').is(':visible')) { // if auto select markets btn was not clicked (save btn is clicked)
    promise = self.autoSelectMarkets()
      .then(function (res) {
        _.each(res, function (data) {
          markets.push(data.city + ', ' + data.state)
        })

        // if all checkboxes checked, set markets as N/A
        if ($('input[type="checkbox"][name="manual-market-checkbox"]:checked').length == $('input[type="checkbox"][name="manual-market-checkbox"]').length) {
          markets = 'N/A'
        } else {
          // for manually selected markets
          $('input[type="checkbox"][name="manual-market-checkbox"]:checked').next('span').each(function () {
            let text = $(this).text()
            if (markets.indexOf(text) == -1) {
              markets.push($(this).text())
            }
          })

          markets = markets.join('>')
        }

        return $.when()
      })
  } else {
    $('input[type="checkbox"][name="market-checkbox"]:checked').next('span').each(function () {
      markets.push($(this).text())
    })

    // if all checkboxes checked, set markets as N/A
    if ($('input[type="checkbox"][name="manual-market-checkbox"]:checked').length == $('input[type="checkbox"][name="manual-market-checkbox"]').length) {
      markets = 'N/A'
    } else {
      // for manually selected markets
      $('input[type="checkbox"][name="manual-market-checkbox"]:checked').next('span').each(function () {
        let text = $(this).text()
        if (markets.indexOf(text) == -1) {
          markets.push($(this).text())
        }
      })

      markets = markets.join('>')
      // because checkboxes are checked by default, the first hidden div in loop is included.. this will remove it from the value of market sent to data
      while (markets.charAt(0) === '>') { markets = markets.substr(1) }
    }
  }

  promise.then(function () {
    let submissiondeadline = $('#bs-datepicker-submissiondeadline').val()

    let data = {
      user_id: self.user.bam_cd_user_id,
      name: projectname,
      name_original: projectname,
      project: projectname,
      cat: category,
      date_created: submissiontimestamp,
      last_modified: submissiontimestamp,
      sub_timestamp: submissiontimestamp,
      asap: asaptimestamp,
      rate: rate,
      rate_des: ratedes,
      aud_timestamp: auditiontimestamp,
      shoot_timestamp: shoottimestamp,
      union2: union,
      project_type: projecttype,
      zip: zipcode,
      market: markets,
      location: zipcode,
      des: auditiondesc
      // app_id : 1
    }

    if (projectname.length < 1) {
      $('.project-name-error-required').fadeIn().delay(3000).fadeOut()
      $('#project-name').focus()
    } else if (projectname.length < 5) {
      $('.project-name-error-five').fadeIn().delay(3000).fadeOut()
      $('#project-name').focus()
    } else if (category.length < 1) {
      $('.category-error-required').fadeIn().delay(3000).fadeOut()
      $('#project-category').focus()
    } else if (submissiondeadline.length < 1) {
      $('.submission-deadline-error-required').fadeIn().delay(3000).fadeOut()
      $('#bs-datepicker-submissiondeadline').focus()
      $('.ui-datepicker').hide().delay(3000).fadeIn()
    } else if (auditiontimestamp < asaptimestamp) {
      $('.audition-date-error-invalid').fadeIn().delay(3000).fadeOut()
      $('#bs-datepicker-audition').focus()
      $('.ui-datepicker').hide().delay(3000).fadeIn()
    } else if (shoottimestamp <= auditiontimestamp) {
      $('.shoot-date-error-invalid').fadeIn().delay(3000).fadeOut()
      $('#bs-datepicker-shootdate').focus()
      $('.ui-datepicker').hide().delay(3000).fadeIn()
    } else if (rate.length < 1) {
      $('.rate-error-required').fadeIn().delay(3000).fadeOut()
      $('#project-rate').focus()
    } else if (zipcode.length < 1) {
      $('.zipcode-error-required').fadeIn().delay(3000).fadeOut()
      $('#zip-code').focus()
    } else if (markets.length < 1) {
      $('.markets-error-required').fadeIn().delay(3000).fadeOut()
      $('.auto-markets-div').focus()
    } else if (auditiondesc.length < 1) {
      $('.audition-description-error-required').fadeIn().delay(3000).fadeOut()
      $('#audition-description').focus()
    } else {
      if (projecttype == '1') {
        let selfSubEmail = $('#self-sub-email').val()
        let selfSubAddress = $('#self-sub-address').val()

        $('#create-project-btn').attr('disabled', 'disabled')
        if (selfSubEmail.length < 1 && selfSubAddress.length < 1) {
          $('.self-sub-error-required').fadeIn().delay(3000).fadeOut()
          $('#self-sub-email').focus()
        } else {
          data['snr'] = '1'
          data['snr_email'] = selfSubEmail
          // data["address2"] = selfSubAddress;
          data['srn_address'] = selfSubAddress

          let body1 = {}
          let body2 = {}

          body1.app_id = 1
          body2.app_id = 4

          return self.core.resource.project.post(data)
            .then(function (res) {
              body1.casting_id = res.casting_id
              body2.casting_id = res.casting_id

              if ($('#main-casting-image-div').hasClass('uploaded')) {
                self.uploadImage(res.casting_id)
                // self.loadImage(res.casting_id);
              }

              self.core.resource.project_app.post(body1).then(function (res) {
                console.log('result from ET post')
                console.log(res)
              })
              self.core.resource.project_app.post(body2).then(function (res) {
                console.log('result from AU psot')
                console.log(res)
                setTimeout(function () {
                  window.location = '/projects/' + res.casting_id + '/roles/create'
                }, 3000)
              })
            })
        }
      } else if (projecttype == '2') {
        $('#create-project-btn').attr('disabled', 'disabled')
        if ($('#bs-datepicker-open-call').val().length < 1) {
          $('.open-call-date-error-required').fadeIn().delay(3000).fadeOut()
          $('#bs-datepicker-open-call').focus()
          $('.ui-datepicker').hide().delay(3000).fadeIn()
        } else if ($('#open-call-location').val().length < 1) {
          $('.open-call-location-error-required').fadeIn().delay(3000).fadeOut()
          $('#open-call-location').focus()
        } else {
          data['snr'] = '2'
          data['app_date_time'] = $('#bs-datepicker-open-call').val() + ' from ' + $('#bs-timepicker-open-call-from').val() + ' to ' + $('#bs-timepicker-open-call-to').val()
          data['app_loc'] = $('#open-call-location').val()

          if ($('#appointment-only-checkbox:checked').length > 0) {
            data['by_app_only'] = '1'
          } else {
            data['by_app_only'] = '0'
          }

          let body1 = {}
          let body2 = {}

          body1.app_id = 1
          body2.app_id = 4

          return self.core.resource.project.post(data)
            .then(function (res) {
              body1.casting_id = res.casting_id
              body2.casting_id = res.casting_id
              if ($('#main-casting-image-div').hasClass('uploaded')) {
                self.uploadImage(res.casting_id)
              }

              self.core.resource.project_app.post(body1).then(function (res) {
                // console.log('results from ET post');
                console.log(res)
              })
              self.core.resource.project_app.post(body2).then(function (res) {
                // console.log('results from AU post');
                console.log(res)
                setTimeout(function () {
                  window.location = '/projects/' + res.casting_id + '/roles/create'
                }, 3000)
              })
            })
        }
      }
    }
  })
}

handler.prototype.autoSelectMarkets = function () {
  let deferred = $.Deferred()

  let zipcode = $('#zip-code').val()

  if (zipcode.length < 1) {
    $('.zipcode-error-required').fadeIn().delay(3000).fadeOut()
    $('#zip-code').focus()

    deferred.resolve()
  } else {
    let data = {
      zip: zipcode,
      distance: 500
    }

    self.core.resource.market.get(data)
      .then(function (res) {
        if (res.length < 1) {
          $('.zipcode-error-invalid').fadeIn().delay(3000).fadeOut()
          $('#zip-code').focus()
        }

        $('.auto-markets-div').removeClass('hide')
        self.core.service.databind('.auto-markets-div', { data: res })

        deferred.resolve(res)
      })
      .catch(function () {
        $('.zipcode-error-invalid').fadeIn().delay(3000).fadeOut()
        deferred.resolve([])
      })
  }

  return deferred.promise()
}

handler.prototype.toggleManualMarketsDiv = function (e) {
  e.preventDefault()
  $('.manual-markets-div').toggleClass('display-none')

  if ($('.manual-markets-div').hasClass('display-none')) {
    $(this).text('Manually select markets')
    $('#toggle-all-markets-checked').hide()
  } else {
    $(this).text('Hide markets')
    $('#toggle-all-markets-checked').show()
  }
}

handler.prototype.toggleAllMarketsChecked = function (e) {
  e.preventDefault()
  $(this).toggleClass('checked')

  if ($(this).hasClass('checked')) {
    $(this).text('Unselect All Markets')
    $('input[type="checkbox"][name="manual-market-checkbox"]').prop('checked', 'checked')
  } else {
    $(this).text('Select All Markets')
    $('input[type="checkbox"][name="manual-market-checkbox"]').removeAttr('checked')
  }
}

handler.prototype.uploadImage = function (casting_id) {
  let data = new FormData()
  data.append('casting_id', casting_id)
  data.append('file', $('#photo-uploader')[0].files[0])

  $.ajax({
    url: self.core.config.api.base + '/cd/casting_images',
    type: 'POST',
    data: data,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('access_token')
    },
    cache: false,
    dataType: 'json',
    processData: false, // Don't process the files
    contentType: false, // Set content type to false as jQuery will tell the server its a query string request,
    crossDomain: true

  })
}

module.exports = function (core, user, talentlogin) {
  return new handler(core, user, talentlogin)
}

},{}],495:[function(require,module,exports){
'use strict'

function handler (core, user, projectId) {
  self = this
  self.core = core
  self.user = user
  self.projectId = projectId

  self.getProjectInfo()
}

handler.prototype.getProjectInfo = function (e) {
  let data = {
    withs: [
      'bam_roles'
    ],
    wheres: [
      [ 'where', 'casting_id', '=', self.projectId ]
    ]
  }

  return self.core.resource.project.get(data)
    .then(function (res) {
      let asap = res.data[0]

      self.casting = asap

      console.log(asap)

      if (new Date().getTime() > asap.asap * 1000) {
        alert('This project has already expired, please update the submission deadline to update this project.')
        console.log(asap.asap)
      }

      if (asap.casting_image && !($('#main-casting-image-div').hasClass('edited-image'))) {
        $('#preview').attr('src', 'https://talentmedia.blob.core.windows.net/etdownload/' + asap.casting_image.media_path_full)
        $('#main-casting-image-div').addClass('uploaded')
      }

      if (res.total > 0) {
      //
        let casting = res.data[0]

        if (casting.market == 'N/A') {
          // $('input[type="checkbox"][name="manual-market-checkbox"]').prop('checked', 'checked');
          $('#nationwide-market-checkbox').click()
        } else {
          casting.market = casting.market.split('>')
        }

        // convert each market in object to lowercase and strip space and comma, then check checkbox of markets
        _.each(casting.market, function (data) {
          data = data.toLowerCase().replace(/[^a-zA-Z]+/g, '_')
          $('#market_' + data).prop('checked', 'checked')
        })

        casting.date = self.core.service.date

        if (casting.app_date_time) {
          casting.app_date_time = '<p>' + casting.app_date_time + '</p>'
          casting.app_date_time = $(casting.app_date_time).text() // strip tags
        }

        // determines which div to show for Submission details (self-response or open call div)
        if (casting.snr == '2') {
          $('#open-call-option-content').show()
          $('#self-submissions-option-content').hide()
          $('#open-call-option').click()
        } else {
          $('#self-submissions-option-content').show()
          $('#open-call-option-content').hide()
          $('#self-submission-option').click()
        }

        self.core.service.databind('.edit-project-wrapper', casting)
        return $.when()
      }
    })
}

handler.prototype.updateProject = function (e) {
  e.preventDefault()

  function parseDate (inputDate) {
    let timestamp = new Date()
    let revert = -1 * timestamp.getTimezoneOffset() * 60
    inputDate = inputDate.split('-')
    return Date.UTC(inputDate[0], inputDate[1] - 1, inputDate[2]) / 1000 - revert
  }

  let projectname = $('#project-name').val()
  let category = $('#project-category').val()

  let submissiondeadline = $('#bs-datepicker-submissiondeadline').val()
  let asaptimestamp = parseDate(submissiondeadline)

  let dn = new Date()

  let dd = dn.getFullYear() + '-' + (dn.getMonth() + 1) + '-' + dn.getDate()
  let submissiontimestamp = parseDate(dd)

  let rate = $('#project-rate').val()
  let ratedes = $('#project-rate-desc').val()

  let auditiondate = $('#bs-datepicker-audition').val()
  let auditiontimestamp = parseDate(auditiondate)

  let shootdate = $('#bs-datepicker-shootdate').val()
  let shoottimestamp = parseDate(shootdate)

  let union = $('input[type="radio"][name="radioUnion"]:checked').val()
  // let projecttype = $('input[type="radio"][name="radioSubmissionType"]:checked').val();
  let zipcode = $('#zip-code').val()
  let auditiondesc = $('#audition-description').val()

  let promise = $.when()

  // sets checked boxes as market (after Auto Select Markets button is clicked (will check zipcode))
  let markets = []

  // Nationwide Casting
  if ($('#nationwide-market-checkbox').hasClass('checked')) {
    markets = 'N/A'
    zipcode = 'N/A'
  } else if (!$('.auto-markets-div').is(':visible')) { // if auto select markets btn was not clicked (save btn is clicked)
    promise = self.autoSelectMarkets()
      .then(function (res) {
        _.each(res, function (data) {
          markets.push(data.city + ', ' + data.state)
        })

        // if all checkboxes checked, set markets as N/A
        if ($('input[type="checkbox"][name="manual-market-checkbox"]:checked').length == $('input[type="checkbox"][name="manual-market-checkbox"]').length) {
          markets = 'N/A'
        } else {
          // for manually selected markets
          $('input[type="checkbox"][name="manual-market-checkbox"]:checked').next('span').each(function () {
            let text = $(this).text()
            if (markets.indexOf(text) == -1) {
              markets.push($(this).text())
            }
          })

          markets = markets.join('>')
        }

        return $.when()
      })
  } else {
    $('input[type="checkbox"][name="market-checkbox"]:checked').next('span').each(function () {
      markets.push($(this).text())
    })

    // if all checkboxes checked, set markets as N/A
    if ($('input[type="checkbox"][name="manual-market-checkbox"]:checked').length == $('input[type="checkbox"][name="manual-market-checkbox"]').length) {
      markets = 'N/A'
    } else {
      // for manually selected markets
      $('input[type="checkbox"][name="manual-market-checkbox"]:checked').next('span').each(function () {
        let text = $(this).text()
        if (markets.indexOf(text) == -1) {
          markets.push($(this).text())
        }
      })

      markets = markets.join('>')
      // because checkboxes are checked by default, the first hidden div in loop is included.. this will remove it from the value of market sent to data
      while (markets.charAt(0) === '>') { markets = markets.substr(1) }
    }
  }

  promise.then(function () {
    let data = {
      projectId: self.projectId,
      user_id: self.user.bam_cd_user_id,
      name: projectname,
      name_original: projectname,
      project: projectname,
      cat: category,
      last_modified: submissiontimestamp,
      // sub_timestamp : submissiontimestamp,
      asap: asaptimestamp,
      rate: rate,
      rate_des: ratedes,
      status: 0,
      aud_timestamp: auditiontimestamp,
      shoot_timestamp: shoottimestamp,
      union2: union,
      // project_type : projecttype,
      zip: zipcode,
      market: markets,
      location: zipcode,
      des: auditiondesc
    }

    if (projectname.length < 1) {
      $('.project-name-error-required').fadeIn().delay(3000).fadeOut()
      $('#project-name').focus()
    } else if (projectname.length < 5) {
      $('.project-name-error-five').fadeIn().delay(3000).fadeOut()
      $('#project-name').focus()
    } else if (category.length < 1) {
      $('.category-error-required').fadeIn().delay(3000).fadeOut()
      $('#project-category').focus()
    } else if (submissiondeadline.length < 1) {
      $('.submission-deadline-error-required').fadeIn().delay(3000).fadeOut()
      $('#bs-datepicker-submissiondeadline').focus()
      $('.ui-datepicker').hide().delay(3000).fadeIn()
    } else if (auditiontimestamp < asaptimestamp) {
      $('.audition-date-error-invalid').fadeIn().delay(3000).fadeOut()
      $('#bs-datepicker-audition').focus()
      $('.ui-datepicker').hide().delay(3000).fadeIn()
    } else if (shoottimestamp <= auditiontimestamp) {
      $('.shoot-date-error-invalid').fadeIn().delay(3000).fadeOut()
      $('#bs-datepicker-shootdate').focus()
      $('.ui-datepicker').hide().delay(3000).fadeIn()
    } else if (rate.length < 1) {
      $('.rate-error-required').fadeIn().delay(3000).fadeOut()
      $('#project-rate').focus()
    } else if (zipcode.length < 1) {
      $('.zipcode-error-required').fadeIn().delay(3000).fadeOut()
      $('#zip-code').focus()
    } else if (markets.length < 1) {
      $('.markets-error-required').fadeIn().delay(3000).fadeOut()
      $('.auto-markets-div').focus()
    } else if (auditiondesc.length < 1) {
      $('.audition-description-error-required').fadeIn().delay(3000).fadeOut()
      $('#audition-description').focus()
    } else {
      if ($('#self-submissions-option-content').is(':visible')) {
        let selfSubEmail = $('#self-sub-email').val()
        let selfSubAddress = $('#self-sub-address').val()

        if (selfSubEmail.length < 1 && selfSubAddress.length < 1) {
          $('.self-sub-error-required').fadeIn().delay(3000).fadeOut()
          $('#self-sub-email').focus()
        } else {
          data['snr'] = '1'
          data['snr_email'] = selfSubEmail
          // data["address2"] = selfSubAddress;
          data['srn_address'] = selfSubAddress

          return self.core.resource.project.patch(data)
            .then(function (res) {
              if ($('#main-casting-image-div').hasClass('image-edited')) {
                if ($('#main-casting-image-div').hasClass('uploaded')) {
                  self.uploadImage(self.casting.casting_id)
                } else {
                  self.deleteImage(self.casting.casting_image.id)
                }
              }

              $('#update-profile-success-text').fadeIn().delay(3000).fadeOut()
            })
        }
      } else if ($('#open-call-option-content').is(':visible')) {
        if ($('#open-call-details').val().length < 1) {
          $('.open-call-date-error-required').fadeIn().delay(3000).fadeOut()
          $('#open-call-details').focus()
        } else if ($('#open-call-location').val().length < 1) {
          $('.open-call-location-error-required').fadeIn().delay(3000).fadeOut()
          $('#open-call-location').focus()
        } else {
          data['snr'] = '2'
          data['app_date_time'] = $('#open-call-details').val()
          data['app_loc'] = $('#open-call-location').val()

          if ($('#appointment-only-checkbox:checked').length > 0) {
            data['by_app_only'] = '1'
          } else {
            data['by_app_only'] = '0'
          }

          return self.core.resource.project.patch(data)
            .then(function (res) {
              if ($('#main-casting-image-div').hasClass('image-edited')) {
                if ($('#main-casting-image-div').hasClass('uploaded')) {
                  self.uploadImage(self.casting.casting_id)
                } else {
                  self.deleteImage(self.casting.casting_image.id)
                }
              }

              $('#update-profile-success-text').fadeIn().delay(3000).fadeOut()
            })
        }
      }
    }
  })
}

handler.prototype.autoSelectMarkets = function () {
  $('.manual-markets-div div label input:checkbox').attr('checked', false)

  let deferred = $.Deferred()

  let zipcode = $('#zip-code').val()

  if (zipcode.length < 1) {
    $('.zipcode-error-required').fadeIn().delay(3000).fadeOut()
    $('#zip-code').focus()

    deferred.resolve()
  } else {
    let data = {
      zip: zipcode,
      distance: 500
    }

    self.core.resource.market.get(data)
      .then(function (res) {
        if (res.length < 1) {
          $('.zipcode-error-invalid').fadeIn().delay(3000).fadeOut()
          $('#zip-code').focus()
        }

        self.core.service.databind('.auto-markets-div', { data: res })

        deferred.resolve(res)
      })
  }

  return deferred.promise()
}

handler.prototype.toggleManualMarketsDiv = function (e) {
  e.preventDefault()
  $('.manual-markets-div').toggleClass('display-none')

  if ($('.manual-markets-div').hasClass('display-none')) {
    $(this).text('Manually select markets')
    $('#toggle-all-markets-checked').hide()
  } else {
    $(this).text('Hide markets')
    $('#toggle-all-markets-checked').show()
  }
}

handler.prototype.toggleAllMarketsChecked = function (e) {
  e.preventDefault()
  $(this).toggleClass('checked')

  if ($(this).hasClass('checked')) {
    $(this).text('Unselect All Markets')
    $('input[type="checkbox"][name="manual-market-checkbox"]').prop('checked', 'checked')
  } else {
    $(this).text('Select All Markets')
    $('input[type="checkbox"][name="manual-market-checkbox"]').removeAttr('checked')
  }
}

handler.prototype.uploadImage = function (casting_id) {
  let data = new FormData()
  data.append('casting_id', casting_id)
  data.append('file', $('#photo-uploader')[0].files[0])

  $.ajax({
    url: self.core.config.api.base + '/cd/casting_images',
    type: 'POST',
    data: data,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('access_token')
    },
    cache: false,
    dataType: 'json',
    processData: false, // Don't process the files
    contentType: false, // Set content type to false as jQuery will tell the server its a query string request,
    crossDomain: true

  })
}

handler.prototype.deleteImage = function (image_id) {
  console.log(image_id)

  $.ajax({
    url: self.core.config.api.base + '/cd/casting_images/' + image_id,
    type: 'DELETE',
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('access_token')
    },
    cache: false,
    processData: false, // Don't process the files
    contentType: false, // Set content type to false as jQuery will tell the server its a query string request,
    crossDomain: true

  })
}

module.exports = function (core, user, projectId) {
  return new handler(core, user, projectId)
}

},{}],496:[function(require,module,exports){
'use strict'

let castingDisplay = require('../utils/casting-display.js')

function withTimeout (promise, ms, label) {
  return new Promise(function (resolve, reject) {
    var timer = setTimeout(function () {
      reject(new Error((label || 'request') + ' timed out'))
    }, ms)

    Promise.resolve(promise).then(function (result) {
      clearTimeout(timer)
      resolve(result)
    }).catch(function (err) {
      clearTimeout(timer)
      reject(err)
    })
  })
}

function handler (core, user) {
  let self = this
  self.core = core
  self.user = user
  self.refreshingProjects = false
  self.refreshList()
}

handler.prototype.hideLoading = function () {
  $('.loading-projects').addClass('hide').hide()
}

handler.prototype.renderProjects = function (res, searchflag) {
  let self = this

  res = castingDisplay.decorateProjectList(res || {})

  try {
    if (!res.total) {
      self.core.service.databind('#projects-list', res)
      $('#no-projects-found').removeClass('hide')

      if (searchflag == 1) {
        $('.no-projects-text').text('The Project Does Not Exist')
      } else {
        $('.no-projects-text').text('You Have No Active Projects')
      }
      return
    }

    $('#no-projects-found').addClass('hide')
    self.core.service.databind('#projects-list', res)
    self.core.service.paginate('#projects-pagination', { total: res.total, class: 'pagination', name: 'page', per_page: res.per_page })
    self.core.service.paginate('#projects-pagination2', { total: res.total, class: 'pagination', name: 'page', per_page: res.per_page })
  } catch (err) {
    console.error('project list render failed', err)
    $('#no-projects-found').removeClass('hide')
    $('.no-projects-text').text('Unable to display projects. Please refresh the page.')
  }
}

handler.prototype.refreshList = function () {
  let self = this
  if (self.refreshingProjects) {
    return
  }
  self.refreshingProjects = true

  let searchflag = 0

  let qs = self.core.service.query_string()

  let data = {
    query: [
      [ 'with', 'bam_roles' ],
      ['orderBy', 'sub_timestamp', 'DESC']
    ],
    page: qs.page || 1,
    per_page: 20
  }

  let searchterm = $('#project-name').val()

  if (searchterm) {
    data.query.push([ 'where', [
      [ 'where', 'project', 'LIKE', '%' + searchterm + '%' ],
      [ 'orWhere', 'name', 'LIKE', '%' + searchterm + '%' ],
      [ 'orWhere', 'name_original', 'LIKE', '%' + searchterm + '%' ],
      [ 'orWhere', 'casting_id', '=', searchterm ]
    ]
    ])
  }

  let status = $('#project-status').val()

  if (status) {
    if (status == '1') {
      data.query.push([ 'where', [
        [ 'where', 'status', '=', 1 ]
      ]
      ])
    } else if (status == '0') {
      data.query.push([ 'where', [
        [ 'where', 'status', '=', 0 ]
      ]
      ])
    }
  }

  let btnExpiredCastings = $('#btn-show-expired-castings')

  if (qs.expired == 'true') {
    btnExpiredCastings.text('Do not show Expired Projects')
    btnExpiredCastings.attr('href', 'projects?expired=false')
  } else {
    if (!searchterm) {
      data.query.push([ 'where', 'asap', '>=', Math.floor(new Date().getTime() / 1000)])
    }

    btnExpiredCastings.text('Show Expired Projects')
    btnExpiredCastings.attr('href', 'projects?expired=true')
  }

  if (searchterm || status != '') {
    searchflag = 1
  }

  withTimeout(self.core.resource.project.get(data), 30000, 'projects')
    .then(function (res) {
      self.renderProjects(res, searchflag)

      self.core.resource.project.get({ query: [ [ 'where', 'asap', '<', Math.floor(new Date().getTime() / 1000) ] ] })
        .then(function (expiredRes) {
          if (expiredRes && expiredRes.total) {
            $('#btn-show-expired-castings').removeClass('hide')
          }
        })
        .catch(function () {})
    })
    .catch(function (err) {
      console.error('projects request failed', err)
      $('#no-projects-found').removeClass('hide')
      $('.no-projects-text').text('Unable to load projects. Please refresh or sign in again.')
    })
    .then(function () {
      self.refreshingProjects = false
      self.hideLoading()
    }, function () {
      self.refreshingProjects = false
      self.hideLoading()
    })
}

module.exports = function (core, user) {
  return new handler(core, user)
}

},{"../utils/casting-display.js":515}],497:[function(require,module,exports){
'use strict'

function handler (core, user) {
  self = this
  self.core = core
  self.user = user
  self.refresh()
}

handler.prototype.refresh = function () {
  self.core.resource.quickpost.get()
    .then(function (result) {
      console.log(result)
    })
}

handler.prototype.addToBooking = function () {
  let form = self.core.service.form.serializeObject('#booking-form')

  if (!form.name) {
    $('#name-error').addClass('has-error')
  } else {
    $('#name-error').removeClass('has-error')
  }

  if (form.name && !form.body) {
    $('#body-error').addClass('has-error')
  } else {
    $('#body-error').removeClass('has-error')
  }

  if (form.name && form.body) {
    form.user_id = self.user.id
    form.lazy_project_status_id = 1
    self.core.resource.quickpost.post(form)
      .then(function (result) {
        $('#success-div').removeClass('hide')
        $('input[name=\'name\']').val('')
        $('textarea[name=\'body\']').val('')
        self.refresh()
      })
  }
}

module.exports = function (core, user) {
  return new handler(core, user)
}

},{}],498:[function(require,module,exports){
'use strict'

function handler (core, user, projectId) {
  self = this
  self.core = core
  self.user = user
  self.projectId = projectId

  self.getProjectInfo()
}

handler.prototype.getProjectInfo = function (e) {
  let data = {
    projectId: self.projectId,
    query: [
      [ 'with', 'bam_roles' ]
    ]
  }

  self.core.resource.project.get(data)
    .then(function (res) {
      self.project = res
      let markets = _.map(self.project.market.split('>'), function (m) {
        return { name: m }
      })

      self.project.markets = { data: markets }

      // if market is N/A change market value
      if (self.project.markets.data[0].name == 'N/A') { self.project.markets.data[0].name = 'All of United States' }

      self.core.service.databind('#project-details', self.project)

      // create dummy for faster databind
      _.each(self.project.bam_roles, function (role) {
        role.likeitlist = { total: '' }
        role.callbacks = { total: '' }
        role.booked = { total: '' }
        role.campaign = null
      })

      self.core.service.databind('.find-talents-wrapper', self.project)

      let promises = []

      _.each(self.project.bam_roles, function (role) {
        promises.push(self.getRoleStats(role))
      })

      return $.when.apply($, promises)
    })
    .then(function () {
      self.core.service.databind('.find-talents-wrapper', self.project)
    })
    .then(function () {
      // to check role timestamp
      // let timestamp = $('.role-expiry').text();
      // console.log('timestamp', timestamp);
      $('.role-expiry').each(function (index, value) {
        let $parent = $(this).parents('li')
        if ($(this).is(':contains("N/A")')) {
          $parent.find('.hide-if-null').hide()
        }
      })
    })
}

handler.prototype.getRoleStats = function (role) {
  let deferred = $.Deferred()

  role.getLikeItListCount().then(function (total) {
    role.likeitlist = { total: total }

    return role.getSchedulesCount(2)
  })
    .then(function (total) {
      role.callbacks = { total: total }

      return role.getSchedulesCount(3)
    })
    .then(function (total) {
      role.booked = { total: total }

      let data = {
        query: [
          [ 'where', 'bam_role_id', '=', role.role_id ]
        ]
      }

      return self.core.resource.campaign.get(data)
    })
    .then(function (res) {
      role.campaign = _.first(res.data)
      deferred.resolve()
    })

  return deferred.promise()
}

module.exports = function (core, user, projectId) {
  return new handler(core, user, projectId)
}

},{}],499:[function(require,module,exports){
'use strict'
let _ = require('lodash')

function handler (core, user, projectId) {
  let self = this
  self.core = core
  self.user = user
  self.projectId = projectId

  self.refreshProjects()
}

handler.prototype.hideLoading = function () {
  $('#campaigns-list .loading-worksheet').addClass('hide')
  $('#campaigns-list h3:contains("Loading Projects")').closest('.row').addClass('hide')
}

handler.prototype.showError = function (message) {
  self.hideLoading()
  $('#no-casting-div').removeClass('hide')
  $('.no-worksheet').addClass('hide')
  self.core.service.databind('#no-casting-div', {
    total: 0,
    data: [],
    error: message || 'Unable to load auditions. Please refresh the page.'
  })
}

handler.prototype.refreshProjects = function () {
  let self = this

  self.core.resource.project.get()
    .then(function (projects) {
      self.project = projects
      self.core.service.databind('#projects-list', projects)
      if (parseInt(self.projectId, 10)) {
        $('#projects-list').val(self.projectId).select2()
      }
      self.getRoles()
      self.refreshList()
    })
    .catch(function () {
      self.showError('Unable to load projects. Please refresh or sign in again.')
    })
}

handler.prototype.refreshList = function () {
  let self = this
  let qs = self.core.service.query_string()

  let data = {
    query: [
      ['select', 'roles.role_id'],
      ['join', 'roles', 'roles.casting_id', '=', 'castings.casting_id'],
      ['join', 'laret_campaigns', 'laret_campaigns.bam_role_id', '=', 'roles.role_id'],
      ['groupBy', 'roles.role_id']
    ],
    per_page: 500
  }

  if ($('#projects-list').val()) {
    data.query.push(['where', 'castings.casting_id', '=', $('#projects-list').val()])
  }

  if ($('#roles-list').val()) {
    data.query.push(['where', 'roles.role_id', '=', $('#roles-list').val()])
  }

  self.core.resource.project.get(data)
    .then(function (res) {
      let roleIds = _.map(res.data, 'role_id')
      roleIds.push(0)

      let data2 = {
        query: [
          ['whereIn', 'bam_role_id', roleIds],
          ['with', 'bam_role.bam_casting'],
          ['orderBy', 'created_at', 'DESC']
        ],
        page: qs.page || 1,
        per_page: 25
      }

      return self.core.resource.campaign.get(data2)
    })
    .then(function (res) {
      self.campaigns = res
      let promises = []

      _.each(self.campaigns.data, function (campaign) {
        promises.push(self.getCampaignTalentCount(campaign))
      })

      return $.when.apply($, promises)
    })
    .then(function () {
      self.campaigns.current_project_id = $('#projects-list').val()
      self.campaigns.current_role_id = $('#roles-list').val()

      if ($('#roles-list').val() === '') {
        self.campaigns.current_role_id = $('#roles-list option:nth-child(2)').val()
      }

      $('#no-casting-div').addClass('hide')

      if (self.campaigns.total === 0) {
        $('.no-worksheet').addClass('hide')
        $('#no-casting-div').removeClass('hide')
      } else {
        $('.no-worksheet').removeClass('hide')
      }

      self.core.service.databind('#no-casting-div', self.campaigns)
      self.core.service.databind('#campaigns-list', self.campaigns)
      self.core.service.paginate('#worksheet-pagination', { total: self.campaigns.total, class: 'pagination', name: 'page', per_page: self.campaigns.per_page })
      self.core.service.paginate('#worksheet-pagination2', { total: self.campaigns.total, class: 'pagination', name: 'page', per_page: self.campaigns.per_page })
      self.hideLoading()
    })
    .catch(function () {
      self.showError('Unable to load auditions. Please refresh the page.')
    })
}

handler.prototype.getCampaignTalentCount = function (campaign) {
  let deferred = $.Deferred()

  if (!campaign.bam_role || typeof campaign.bam_role.getLikeItList !== 'function') {
    deferred.resolve()
    return deferred.promise()
  }

  campaign.bam_role.getLikeItList()
    .then(function (res) {
      campaign.bam_role.likeitlist = res
      deferred.resolve()
    })
    .catch(function () {
      campaign.bam_role.likeitlist = { total: 0, data: [] }
      deferred.resolve()
    })

  return deferred.promise()
}

handler.prototype.projectChanged = function () {
  let self = this
  self.getRoles()
  self.refreshList()

  window.history.pushState({}, '', '/projects/' + ($('#projects-list').val() || 0) + '/worksheet')
}

handler.prototype.getRoles = function () {
  let self = this
  let projectId = $('#projects-list').val()

  let data = {
    projectId: projectId,
    query: [
      ['with', 'bam_roles']
    ]
  }

  self.core.resource.project.get(data)
    .then(function (res) {
      if (res.bam_roles && res.bam_roles.length > 0) {
        $('#role-div').removeClass('hide')
        self.core.service.databind('#roles-list', res)
      } else {
        $('#role-div').addClass('hide')
      }
    })
    .catch(function () {})
}

module.exports = function (core, user, projectId) {
  return new handler(core, user, projectId)
}

},{"lodash":429}],500:[function(require,module,exports){
'use strict'

function handler (core, user, projectId, roleId) {
  self = this
  self.core = core
  self.user = user
  self.projectId = projectId
  self.roleId = roleId
  self.page = 1
  self.first_load = true

  self.getProjectInfo()
}

handler.prototype.getProjectInfo = function () {
  let data = {
    projectId: self.projectId,
    query: [
      [ 'with', 'bam_roles' ]
    ]
  }

  self.core.resource.project.get(data)
    .then(function (res) {
      self.project = res

      self.core.service.databind('.page-header', self.project)
      self.core.service.databind('#project-details', self.project)
      self.core.service.databind('#roles-list', { data: self.project.bam_roles })
      self.core.service.databind('#no-booked', self.project)
      $('#roles-list').val(self.roleId)

      self.project.role = { role_id: self.roleId, likeitlist: { total: '' }, submissions: { total: '' } }
      self.core.service.databind('#project-links', self.project)

      self.refreshRole()
    })
}

handler.prototype.refreshRole = function () {
  self.done = false
  self.refreshing = false
  self.roleId = $('#roles-list').val()
  let role = _.find(self.project.bam_roles, function (r) {
    return r.role_id == $('#roles-list').val()
  })

  self.project.role = role
  self.project.role.bam_casting = self.project

  // change url
  window.history.pushState({}, '', '/projects/' + role.casting_id + '/roles/' + role.role_id + '/booked')

  // update filter form
  self.core.service.databind('#role-filter-form', self.project.role)

  // submissions count
  self.project.role.getSubmissionsCount()
    .then(function (count) {
      self.project.role.submissions = { total: count }

      self.core.service.databind('#project-links', self.project)
    })

  self.findMatches()
}

handler.prototype.findMatches = function (append) {
  if (self.refreshing) {
    return
  }

  append = append === true

  if (append && self.done) {
    return
  }

  self.page = append ? self.page + 1 : 1
  self.refreshing = true
  let data = self.getFilters()

  if (append) {
    self.first_load = self.first_load ? self.first_load : false
  } else {
    self.first_load = false
  }

  $('#search-loader').show()

  if (!append) {
    $('#role-matches-result').hide()
  }

  let options = {
    bam_role_id: self.roleId
  }

  self.core.resource.talent.search(data, options)
    .then(function (talents) {
      self.done = (talents.total < talents.per_page)

      _.each(talents.data, function (talent) {
        talent.talent_role_id = self.roleId
        talent.talent_project_id = self.projectId
      })

      try {
        self.core.service.databind('#role-matches-result', talents, append)
      } catch (e) { }

      self.refreshing = false

      $('#search-loader').hide()
      if (!append) {
        $('#no-booked').addClass('hide')
        $('#role-matches-result').show()
      } else {
        $('#no-booked').removeClass('hide')
      }
    })
}

handler.prototype.getFilters = function () {
  let form = self.core.service.form.serializeObject('#role-filter-form')
  let data = {
    per_page: 24,
    page: self.page,
    query: [
      [ 'join', 'bam.laret_users', 'bam.laret_users.bam_talentnum', '=', 'search.talents.talentnum' ],
      [ 'leftJoin', 'bam.laret_schedules', 'bam.laret_schedules.invitee_id', '=', 'bam.laret_users.id' ],
      [ 'where', 'bam.laret_schedules.rating', '<>', 0 ],
      [ 'where', 'bam.laret_schedules.status', '=', 3 ],
      [ 'where', 'bam.laret_schedules.bam_role_id', '=', $('#roles-list').val() ]
    ]
  }

  if (!self.first_load) {
    if (form.markets) {
      if (form.markets instanceof Array) {
        let subquery = []

        _.each(form.markets, function (market) {
          if (subquery.length == 0) {
            subquery.push([ 'where', 'city', 'like', '%' + market + '%' ])
          } else {
            subquery.push([ 'orWhere', 'city', 'like', '%' + market + '%' ])
          }

          subquery.push([ 'orWhere', 'city1', 'like', '%' + market + '%' ])
          subquery.push([ 'orWhere', 'city2', 'like', '%' + market + '%' ])
          subquery.push([ 'orWhere', 'city3', 'like', '%' + market + '%' ])
        })

        data.query.push([ 'where', subquery ])
      } else {
        data.query.push([ 'where', [
          [ 'where', 'city', '=', form.markets ],
          [ 'orWhere', 'city1', '=', form.markets ],
          [ 'orWhere', 'city2', '=', form.markets ],
          [ 'orWhere', 'city3', '=', form.markets ]
        ]
        ])
      }
    }

    if (parseInt(form.age_min)) {
      data.query.push([ 'where', 'dobyyyy', '<=', new Date().getFullYear() - parseInt(form.age_min) ])
    }

    if (parseInt(form.age_max)) {
      data.query.push([ 'where', 'dobyyyy', '>=', new Date().getFullYear() - parseInt(form.age_max) ])
    }

    if (form.sex) {
      data.query.push([ 'where', 'sex', '=', form.sex ])
    }

    if (form.has_photo) {
      data.query.push([ 'where', 'has_photos', '=', form.has_photo == 'true' ? 1 : 0 ])
    }

    if (form.search_text) {
      data.query.push([ 'where',
        [
          [ 'where', 'talentnum', '=', form.search_text ],
          [ 'orWhere', 'fname', 'LIKE', '%' + form.search_text + '%' ],
          [ 'orWhere', 'lname', 'LIKE', '%' + form.search_text + '%' ]
        ]
      ])
    }

    if (parseInt(form.height_min)) {
      data.query.push([ 'where', 'heightinches', '>=', form.height_min ])
    }

    if (parseInt(form.height_max)) {
      data.query.push([ 'where', 'heightinches', '<=', form.height_max ])
    }

    if (form.build) {
      if (form.build instanceof Array) {
        data.query.push([ 'whereIn', 'build', form.build ])
      } else {
        data.query.push([ 'where', 'build', '=', form.build ])
      }
    }

    if (form.ethnicity) {
      // African and African American are both searched if either is chosen
      if (form.ethnicity instanceof Array) {
        if (form.ethnicity.indexOf('African') > -1 && form.ethnicity.indexOf('African American') == -1) {
          form.ethnicity.push('African American')
        } else if (form.ethnicity.indexOf('African American') > -1 && form.ethnicity.indexOf('African') == -1) {
          form.ethnicity.push('African')
        }

        data.query.push([ 'whereIn', 'ethnicity', form.ethnicity ])
      } else {
        if (form.ethnicity == 'African') {
          data.query.push(['where', [
            [ 'where', 'ethnicity', '=', 'African' ],
            [ 'orWhere', 'ethnicity', '=', 'African American' ]
          ]
          ])
        } else if (form.ethnicity == 'African American') {
          data.query.push(['where', [
            [ 'where', 'ethnicity', '=', 'African American' ],
            [ 'orWhere', 'ethnicity', '=', 'African' ]
          ]
          ])
        } else {
          data.query.push([ 'where', 'ethnicity', '=', form.ethnicity ])
        }
      }
    }

    if (form.last_access) {
      data.query.push([ 'where', 'last_access', '>', Math.floor(new Date().getTime() / 1000) - parseInt(form.last_access) ])
    }

    if (form.young_old) {
      data.query.push([ 'orderBy', 'dobyyyy', form.young_old ])
      data.query.push([ 'orderBy', 'dobmm', form.young_old ])
      data.query.push([ 'orderBy', 'dobdd', form.young_old ])
    }

    if (form.union) {
      if (form.union == '1') {
        data.query.push([ 'where', [
          [ 'where', 'union_aea', '=', 'Yes' ],
          [ 'orWhere', 'union_aftra', '=', 'Yes' ],
          [ 'orWhere', 'union_other', '=', 'Yes' ],
          [ 'orWhere', 'union_sag', '=', 'Yes' ]
        ]
        ])
      } else {
        data.query.push([ 'where', [
          [ 'where', 'union_aea', '=', 'No' ],
          [ 'orWhere', 'union_aftra', '=', 'No' ],
          [ 'orWhere', 'union_other', '=', 'No' ],
          [ 'orWhere', 'union_sag', '=', 'No' ]
        ]
        ])
      }
    }
  }

  return data
}

module.exports = function (core, user, projectId, roleId) {
  return new handler(core, user, projectId, roleId)
}

},{}],501:[function(require,module,exports){
'use strict'

function handler (core, user, projectId, roleId) {
  self = this
  self.core = core
  self.user = user
  self.projectId = projectId
  self.roleId = roleId
  self.page = 1
  self.first_load = true

  self.getProjectInfo()
}

handler.prototype.getProjectInfo = function () {
  let data = {
    projectId: self.projectId,
    query: [
      [ 'with', 'bam_roles' ]
    ]
  }

  self.core.resource.project.get(data)
    .then(function (res) {
      self.project = res
      self.core.service.databind('.page-header', self.project)
      self.core.service.databind('#project-details', self.project)
      self.core.service.databind('#roles-list', { data: self.project.bam_roles })
      $('#roles-list').val(self.roleId)

      self.project.role = { role_id: self.roleId, likeitlist: { total: '' }, submissions: { total: '' } }
      self.core.service.databind('#project-links', self.project)
      self.core.service.databind('#no-callbacks-div', self.project)

      self.refreshRole()
    })
}

handler.prototype.refreshRole = function () {
  self.done = false
  self.refreshing = false
  self.roleId = $('#roles-list').val()
  let role = _.find(self.project.bam_roles, function (r) {
    return r.role_id == $('#roles-list').val()
  })

  self.project.role = role
  self.project.role.bam_casting = self.project

  // change url
  window.history.pushState({}, '', '/projects/' + role.casting_id + '/roles/' + role.role_id + '/callbacks')

  // update filter form
  self.core.service.databind('#role-filter-form', self.project.role)

  // submissions count
  self.project.role.getSubmissionsCount()
    .then(function (count) {
      self.project.role.submissions = { total: count }

      self.core.service.databind('#project-links', self.project)
    })

  self.findMatches()
}

handler.prototype.findMatches = function (append) {
  if (self.refreshing) {
    return
  }

  append = append === true

  if (append && self.done) {
    return
  }

  self.page = append ? self.page + 1 : 1
  self.refreshing = true
  let data = self.getFilters()

  if (append) {
    self.first_load = self.first_load ? self.first_load : false
  } else {
    self.first_load = false
  }

  $('#search-loader').show()

  if (!append) {
    $('#role-matches-result').hide()
  }

  let options = {
    bam_role_id: self.roleId
  }

  self.core.resource.talent.search(data, options)
    .then(function (talents) {
      self.done = (talents.total < talents.per_page)

      _.each(talents.data, function (talent) {
        talent.talent_role_id = self.roleId
        talent.talent_project_id = self.projectId
      })
      if (talents.total == 0) {
        $('#no-callbacks-div').removeClass('hide')
      }

      try {
        self.core.service.databind('#role-matches-result', talents, append)
      } catch (e) { }

      self.refreshing = false

      $('#search-loader').hide()
      if (!append) {
        $('#role-matches-result').show()
      }
    })
}

handler.prototype.getFilters = function () {
  let form = self.core.service.form.serializeObject('#role-filter-form')
  let data = {
    per_page: 24,
    page: self.page,
    query: [
      [ 'join', 'bam.laret_users', 'bam.laret_users.bam_talentnum', '=', 'search.talents.talentnum' ],
      [ 'leftJoin', 'bam.laret_schedules', 'bam.laret_schedules.invitee_id', '=', 'bam.laret_users.id' ],
      [ 'where', 'bam.laret_schedules.rating', '<>', 0 ],
      [ 'where', 'bam.laret_schedules.status', '=', 2 ],
      [ 'where', 'bam.laret_schedules.bam_role_id', '=', $('#roles-list').val() ]
    ]
  }

  if (!self.first_load) {
    if (form.markets) {
      if (form.markets instanceof Array) {
        let subquery = []

        _.each(form.markets, function (market) {
          if (subquery.length == 0) {
            subquery.push([ 'where', 'city', 'like', '%' + market + '%' ])
          } else {
            subquery.push([ 'orWhere', 'city', 'like', '%' + market + '%' ])
          }

          subquery.push([ 'orWhere', 'city1', 'like', '%' + market + '%' ])
          subquery.push([ 'orWhere', 'city2', 'like', '%' + market + '%' ])
          subquery.push([ 'orWhere', 'city3', 'like', '%' + market + '%' ])
        })

        data.query.push([ 'where', subquery ])
      } else {
        data.query.push([ 'where', [
          [ 'where', 'city', '=', form.markets ],
          [ 'orWhere', 'city1', '=', form.markets ],
          [ 'orWhere', 'city2', '=', form.markets ],
          [ 'orWhere', 'city3', '=', form.markets ]
        ]
        ])
      }
    }

    if (parseInt(form.age_min)) {
      data.query.push([ 'where', 'dobyyyy', '<=', new Date().getFullYear() - parseInt(form.age_min) ])
    }

    if (parseInt(form.age_max)) {
      data.query.push([ 'where', 'dobyyyy', '>=', new Date().getFullYear() - parseInt(form.age_max) ])
    }

    if (form.sex) {
      data.query.push([ 'where', 'sex', '=', form.sex ])
    }

    if (form.has_photo) {
      data.query.push([ 'where', 'has_photos', '=', form.has_photo == 'true' ? 1 : 0 ])
    }

    if (form.search_text) {
      data.query.push([ 'where',
        [
          [ 'where', 'talentnum', '=', form.search_text ],
          [ 'orWhere', 'fname', 'LIKE', '%' + form.search_text + '%' ],
          [ 'orWhere', 'lname', 'LIKE', '%' + form.search_text + '%' ]
        ]
      ])
    }

    if (parseInt(form.height_min)) {
      data.query.push([ 'where', 'heightinches', '>=', form.height_min ])
    }

    if (parseInt(form.height_max)) {
      data.query.push([ 'where', 'heightinches', '<=', form.height_max ])
    }

    if (form.build) {
      if (form.build instanceof Array) {
        data.query.push([ 'whereIn', 'build', form.build ])
      } else {
        data.query.push([ 'where', 'build', '=', form.build ])
      }
    }

    if (form.ethnicity) {
      // African and African American are both searched if either is chosen
      if (form.ethnicity instanceof Array) {
        if (form.ethnicity.indexOf('African') > -1 && form.ethnicity.indexOf('African American') == -1) {
          form.ethnicity.push('African American')
        } else if (form.ethnicity.indexOf('African American') > -1 && form.ethnicity.indexOf('African') == -1) {
          form.ethnicity.push('African')
        }

        data.query.push([ 'whereIn', 'ethnicity', form.ethnicity ])
      } else {
        if (form.ethnicity == 'African') {
          data.query.push(['where', [
            [ 'where', 'ethnicity', '=', 'African' ],
            [ 'orWhere', 'ethnicity', '=', 'African American' ]
          ]
          ])
        } else if (form.ethnicity == 'African American') {
          data.query.push(['where', [
            [ 'where', 'ethnicity', '=', 'African American' ],
            [ 'orWhere', 'ethnicity', '=', 'African' ]
          ]
          ])
        } else {
          data.query.push([ 'where', 'ethnicity', '=', form.ethnicity ])
        }
      }
    }

    if (form.last_access) {
      data.query.push([ 'where', 'last_access', '>', Math.floor(new Date().getTime() / 1000) - parseInt(form.last_access) ])
    }

    if (form.young_old) {
      data.query.push([ 'orderBy', 'dobyyyy', form.young_old ])
      data.query.push([ 'orderBy', 'dobmm', form.young_old ])
      data.query.push([ 'orderBy', 'dobdd', form.young_old ])
    }

    if (form.union) {
      if (form.union == '1') {
        data.query.push([ 'where', [
          [ 'where', 'union_aea', '=', 'Yes' ],
          [ 'orWhere', 'union_aftra', '=', 'Yes' ],
          [ 'orWhere', 'union_other', '=', 'Yes' ],
          [ 'orWhere', 'union_sag', '=', 'Yes' ]
        ]
        ])
      } else {
        data.query.push([ 'where', [
          [ 'where', 'union_aea', '=', 'No' ],
          [ 'orWhere', 'union_aftra', '=', 'No' ],
          [ 'orWhere', 'union_other', '=', 'No' ],
          [ 'orWhere', 'union_sag', '=', 'No' ]
        ]
        ])
      }
    }
  }

  return data
}

module.exports = function (core, user, projectId, roleId) {
  return new handler(core, user, projectId, roleId)
}

},{}],502:[function(require,module,exports){
'use strict'

function handler (core, user, projectId, roleId) {
  self = this
  self.core = core
  self.user = user
  self.projectId = projectId
  self.getProjectInfo()
  self.asap
}

handler.prototype.getProjectInfo = function (e) {
  let data = {
    projectId: self.projectId,
    query: [
      [ 'with', 'bam_roles' ]
    ]
  }

  self.core.resource.project.get(data)
    .then(function (res) {
      self.project = res

      let markets = _.map(self.project.market.split('>'), function (m) {
        return { name: m }
      })

      self.project.markets = { data: markets }

      self.core.service.databind('#project-details', self.project)
      self.core.service.databind('#project-overview-link', self.project)
    })
    .then(function () {
      let casting_id = self.project.casting_id
      let castingDataId = {
        query: [
          ['where', 'casting_id', casting_id ]
        ]
      }
      self.core.resource.project.get(castingDataId)
        .then(function (res) {
          self.asap = res.data[0].asap
        })
    })
}

handler.prototype.saveNewRole = function (e) {
  e.preventDefault()

  function parseDate (inputDate) {
    let timestamp = new Date()
    let revert = (-1 * timestamp.getTimezoneOffset() * 60)
    inputDate = inputDate.split('-')
    return Date.UTC(inputDate[0], inputDate[1] - 1, inputDate[2]) / 1000 - revert
  }

  let shootDate = $('#datepicker-role-shootDate').val()
  let shootTimestamp = parseDate(shootDate)
  let auditionDate = $('#datepicker-role-auditionDate').val()
  let auditionTimestamp = parseDate(auditionDate)
  let expiryDate = $('#datepicker-role-expiryDate').val()
  let expirationTimestamp = parseDate(expiryDate)
  let expirationValidation = new Date().getTime() / 1000 < expiryDate || !expiryDate

  // to be used later to determine where to link page
  let buttonId = $(this).attr('id')
  // let height = $('#heightinches').val(),
  // height = height.split(",");

  let age_min_val, age_max_val, height_min_val, height_max_val
  if ($('#age-min-input').val() == '<3') {
    age_min_val = 0
  } else {
    age_min_val = $('#age-min-input').val()
  }
  if ($('#age-max-input').val() == '70+') {
    age_max_val = 70
  } else {
    age_max_val = $('#age-max-input').val()
  }

  height_min_val = $('#height-min-dropdown').val()
  height_max_val = $('#height-max-dropdown').val()

  let data = {
    projectId: self.projectId,
    name: $('#role-name-text').val(),
    number_of_people: $('#role-number-text').val(),
    des: $('#role-description-text').val(),
    gender_male: $('#gender-male-checkbox').val(),
    gender_female: $('#gender-female-checkbox').val(),
    // age_min : $('#age-range-min').text(),
    age_min: age_min_val,
    // age_max : $('#age-range-max').text(),
    age_max: age_max_val,
    // height_min : height[0],
    height_min: height_min_val,
    // height_max : height[1],
    height_max: height_max_val,
    ethnicity_any: $('#ethnicity-any').val(),
    ethnicity_african: $('#ethnicity-african').val(),
    ethnicity_african_am: $('#ethnicity-african-am').val(),
    ethnicity_asian: $('#ethnicity-asian').val(),
    ethnicity_caribbian: $('#ethnicity-caribbian').val(),
    ethnicity_caucasian: $('#ethnicity-caucasian').val(),
    ethnicity_hispanic: $('#ethnicity-hispanic').val(),
    ethnicity_mediterranean: $('#ethnicity-mediterranean').val(),
    ethnicity_middle_est: $('#ethnicity-middle-est').val(),
    ethnicity_native_am: $('#ethnicity-american-in').val(),
    built_any: $('#built-any').val(),
    built_medium: $('#built-medium').val(),
    built_athletic: $('#built-athletic').val(),
    built_bb: $('#built-bb').val(),
    built_xlarge: $('#built-xlarge').val(),
    built_large: $('#built-large').val(),
    built_petite: $('#built-petite').val(),
    built_thin: $('#built-thin').val(),
    built_lm: $('#built-lm').val(),
    hair_any: $('#hair-any').val(),
    hair_auburn: $('#hair-auburn').val(),
    hair_black: $('#hair-black').val(),
    hair_blonde: $('#hair-blonde').val(),
    hair_brown: $('#hair-brown').val(),
    hair_chestnut: $('#hair-chestnut').val(),
    hair_dark_brown: $('#hair-dark-brown').val(),
    hair_grey: $('#hair-grey').val(),
    hair_red: $('#hair-red').val(),
    hair_salt_paper: $('#hair-salt-paper').val(),
    hair_white: $('#hair-white').val(),
    shoot_timestamp: shootTimestamp,
    audition_timestamp: auditionTimestamp,
    expiration_timestamp: expirationTimestamp
  }

  if (!data.expiration_timestamp) {
    data.expiration_timestamp = self.asap
  }

  // if any is chosen, change all keys to 0 aside from any
  if (data['ethnicity_any'] == 1) {
    for (let key in data) {
      if (key.startsWith('ethnicity') && key != 'ethnicity_any') {
        data[key] = 0
      }
    }
  }
  if (data['built_any'] == 1) {
    for (let key in data) {
      if (key.startsWith('built') && key != 'built_any') {
        data[key] = 0
      }
    }
  }
  if (data['hair_any'] == 1) {
    for (let key in data) {
      if (key.startsWith('hair') && key != 'hair_any') {
        data[key] = 0
      }
    }
  }

  if (!expiryDate) {
    $('.deadline-error-required').fadeIn().delay(3000).fadeOut()
    // $('#datepicker-role-expiryDate').focus();
    $('.ui-datepicker').hide().delay(3000).fadeIn()
  } else if (auditionTimestamp < expirationTimestamp) {
    $('.audition-date-error-invalid').fadeIn().delay(3000).fadeOut()
    // $('#datepicker-role-auditionDate').focus();
    $('.ui-datepicker').hide().delay(3000).fadeIn()
  } else if (shootTimestamp <= auditionTimestamp) {
    $('.shoot-date-error-invalid').fadeIn().delay(3000).fadeOut()
    // $('#datepicker-role-shootDate').focus();
    $('.ui-datepicker').hide().delay(3000).fadeIn()
  }

  if (!expiryDate) {
    $('.deadline-error-required').fadeIn().delay(3000).fadeOut()
    $('#datepicker-role-expiryDate').focus()
    $('.ui-datepicker').hide().delay(3000).fadeIn()
  } else if (auditionTimestamp < expirationTimestamp) {
    $('.audition-date-error-invalid').fadeIn().delay(3000).fadeOut()
    $('#datepicker-role-auditionDate').focus()
    $('.ui-datepicker').hide().delay(3000).fadeIn()
  } else if (shootTimestamp <= auditionTimestamp) {
    $('.shoot-date-error-invalid').fadeIn().delay(3000).fadeOut()
    $('#datepicker-role-shootDate').focus()
    $('.ui-datepicker').hide().delay(3000).fadeIn()
  }

  // if(expirationValidation){
  if (self.core.service.form.validate('#create-role-div')) { // for required text fields
    if ($('input[type="checkbox"][name="gender"]:checked').length < 1) {
      $('.gender-error-required').fadeIn().delay(3000).fadeOut()
      $('.gender-error-required').focus()
    } else {
      if ($('input[type="checkbox"][name="ethnicity"]:checked').length < 1) {
        data['ethnicity_any'] = 1
      }

      if ($('input[type="checkbox"][name="built"]:checked').length < 1) {
        data['built_any'] = 1
      }

      if ($('input[type="checkbox"][name="hair-color"]:checked').length < 1) {
        data['hair_any'] = 1
      }

      $('#save-and-add-role-btn').attr('disabled', 'disabled')
      $('#save-role-btn').attr('disabled', 'disabled')

      return self.core.resource.job.post(data)
        .then(function (res) {
          let role = res

          $('.role-saved-success').fadeIn()
          if (buttonId == 'save-and-add-role-btn') {
            $('#loading_role').addClass('fa fa-spin fa-spinner')
          }
          if (buttonId == 'save-role-btn') { // link to project overview page
            self.core.resource.project.patch({ projectId: self.projectId, status: 0 })
              .then(function (res) {
                $('#loading_role_match').addClass('fa fa-spin fa-spinner')
                window.location = '/projects/' + self.projectId + '/roles/' + role.role_id + '/find-talents'
              })
          } else { // 'save-and-add-role-btn' just reloads page
            self.core.resource.project.patch({ projectId: self.projectId, status: 0 })
              .then(function (res) {
                setTimeout(function () {
                  location.reload()
                }, 3000)
              })
          }
        })
    }
  }
}

handler.prototype.cancelRole = function (e) {
  if (window.confirm('Are you sure you want to cancel this role?')) {

  } else {
    e.preventDefault()
  }
}

module.exports = function (core, user, projectId) {
  return new handler(core, user, projectId)
}

},{}],503:[function(require,module,exports){
'use strict'

function handler (core, user, projectId, roleId) {
  self = this
  self.core = core
  self.user = user
  self.projectId = projectId
  self.roleId = roleId

  self.getProjectInfo()
  self.getRoleInfo()
}

handler.prototype.getProjectInfo = function (e) {
  let data = {
    projectId: self.projectId,
    query: [
      [ 'with', 'bam_roles' ]
    ]
  }

  self.core.resource.project.get(data)
    .then(function (res) {
      self.project = res

      let markets = _.map(self.project.market.split('>'), function (m) {
        return { name: m }
      })

      self.project.markets = { data: markets }
      console.log('project(casting)', self.project)
      console.log(self.project.casting_id)
      self.core.service.databind('#project-details', self.project)
      self.core.service.databind('#project-overview-link', self.project)
    })
}

handler.prototype.getRoleInfo = function (e) {
  let data = {
    projectId: self.projectId,
    jobId: self.roleId
  }

  return self.core.resource.job.get(data)
    .then(function (res) {
      console.log(res)
      if (res.age_min < 3) {
        // res.age_min = '<3';
        $('#age-min-input').val('<3')
      } else {
        $('#age-min-input').val(res.age_min)
      }
      if (res.age_max > 70) {
        $('#age-max-input').val('70+')
      } else {
        $('#age-max-input').val(res.age_max)
      }
      self.core.service.databind('#edit-role-div', res)
      return $.when()
    })
}

handler.prototype.updateRole = function () {
  function parseDate (inputDate) {
    let timestamp = new Date()
    let revert = (-1 * timestamp.getTimezoneOffset() * 60)
    inputDate = inputDate.split('-')
    return Date.UTC(inputDate[0], inputDate[1] - 1, inputDate[2]) / 1000 - revert
  }

  let shootDate = $('#datepicker-role-shootDate').val()
  let shootTimestamp = parseDate(shootDate)
  let auditionDate = $('#datepicker-role-auditionDate').val()
  let auditionTimestamp = parseDate(auditionDate)
  let expiryDate = $('#datepicker-role-expiryDate').val()
  console.log('expiryDate length', expiryDate.length)
  let expirationTimestamp = parseDate(expiryDate)
  let expirationValidation = new Date().getTime() / 1000 < expiryDate || !expiryDate

  console.log('validation', expirationValidation)

  let asap
  let casting_id = self.project.casting_id
  console.log('casting_id', casting_id)

  if (!expiryDate) {
    let castingDataId = {
      query: [
        ['where', 'casting_id', casting_id ]
      ]
    }
    self.core.resource.project.get(castingDataId)
      .then(function (res) {
        asap = res.data[0].asap
        console.log('ASAP:', res.data[0].asap)
      })
  }
  // to make sure all previous checked checkboxes are still saved
  let checkedCheckboxes = $('input[type="checkbox"]:checked')

  checkedCheckboxes.each(function () {
    $(this).val(1)
  })

  let age_min_val, age_max_val, height_min_val, height_max_val
  if ($('#age-min-input').val() == '<3') {
    age_min_val = 0
  } else {
    age_min_val = $('#age-min-input').val()
  }
  if ($('#age-max-input').val() == '70+') {
    age_max_val = 70
  } else {
    age_max_val = $('#age-max-input').val()
  }

  height_min_val = $('#height-min-dropdown').val()
  height_max_val = $('#height-max-dropdown').val()

  let data = {
    projectId: self.projectId,
    jobId: self.roleId,
    name: $('#role-name-text').val(),
    number_of_people: $('#role-number-text').val(),
    des: $('#role-description-text').val(),
    gender_male: $('#gender-male-checkbox').val(),
    gender_female: $('#gender-female-checkbox').val(),
    // age_min : $('#age-min-text').text(),
    // age_max : $('#age-max-text').text(),
    // height_min : $('input[name="height_min"]').val(),
    // height_max : $('input[name="height_max"]').val(),
    age_min: age_min_val,
    age_max: age_max_val,
    height_min: height_min_val,
    height_max: height_max_val,
    ethnicity_any: $('#ethnicity-any').val(),
    ethnicity_african: $('#ethnicity-african').val(),
    ethnicity_african_am: $('#ethnicity-african-am').val(),
    ethnicity_asian: $('#ethnicity-asian').val(),
    ethnicity_caribbian: $('#ethnicity-caribbian').val(),
    ethnicity_caucasian: $('#ethnicity-caucasian').val(),
    ethnicity_hispanic: $('#ethnicity-hispanic').val(),
    ethnicity_mediterranean: $('#ethnicity-mediterranean').val(),
    ethnicity_middle_est: $('#ethnicity-middle-est').val(),
    ethnicity_native_am: $('#ethnicity-american-in').val(),
    built_any: $('#built-any').val(),
    built_medium: $('#built-medium').val(),
    built_athletic: $('#built-athletic').val(),
    built_bb: $('#built-bb').val(),
    built_xlarge: $('#built-xlarge').val(),
    built_large: $('#built-large').val(),
    built_petite: $('#built-petite').val(),
    built_thin: $('#built-thin').val(),
    built_lm: $('#built-lm').val(),
    hair_any: $('#hair-any').val(),
    hair_auburn: $('#hair-auburn').val(),
    hair_black: $('#hair-black').val(),
    hair_blonde: $('#hair-blonde').val(),
    hair_brown: $('#hair-brown').val(),
    hair_chestnut: $('#hair-chestnut').val(),
    hair_dark_brown: $('#hair-dark-brown').val(),
    hair_grey: $('#hair-grey').val(),
    hair_red: $('#hair-red').val(),
    hair_salt_paper: $('#hair-salt-paper').val(),
    hair_white: $('#hair-white').val(),
    shoot_timestamp: shootTimestamp,
    audition_timestamp: auditionTimestamp,
    expiration_timestamp: expirationTimestamp

  }

  // if any is chosen, change all keys to 0 aside from any
  if (data['ethnicity_any'] == 1) {
    for (let key in data) {
      if (key.startsWith('ethnicity') && key != 'ethnicity_any') {
        data[key] = 0
      }
    }
  }
  if (data['built_any'] == 1) {
    for (let key in data) {
      if (key.startsWith('built') && key != 'built_any') {
        data[key] = 0
      }
    }
  }
  if (data['hair_any'] == 1) {
    for (let key in data) {
      if (key.startsWith('hair') && key != 'hair_any') {
        data[key] = 0
      }
    }
  }

  if (self.core.service.form.validate('#edit-role-div')) { // for required text fields
    if ($('input[type="checkbox"][name="gender"]:checked').length < 1) {
      $('.gender-error-required').fadeIn().delay(3000).fadeOut()
      $('.gender-error-required').focus()
    } else {
      if ($('input[type="checkbox"][name="ethnicity"]:checked').length < 1) {
        data['ethnicity_any'] = 1
      }

      if ($('input[type="checkbox"][name="built"]:checked').length < 1) {
        data['built_any'] = 1
      }

      if ($('input[type="checkbox"][name="hair-color"]:checked').length < 1) {
        data['hair_any'] = 1
      }

      return self.core.resource.job.patch(data)
        .then(function (res) {
          $('.role-updated-success').fadeIn()

          self.core.resource.project.patch({ projectId: self.projectId, status: 0 })
            .then(function (res) {
              console.log(res)
            })

          setTimeout(function () {
            self.getRoleInfo()
          }, 3000)
        })
    }
  }
}

handler.prototype.cancelRole = function (e) {
  if (window.confirm('Are you sure you want to cancel this role?')) {

  } else {
    e.preventDefault()
  }
}

module.exports = function (core, user, projectId, roleId) {
  return new handler(core, user, projectId, roleId)
}

},{}],504:[function(require,module,exports){
'use strict'

function Handler (core, user, projectId, roleId) {
  self = this
  self.core = core
  self.user = user
  self.projectId = projectId
  self.roleId = roleId
  self.page = 1

  self.xorigins = []

  if (self.user.user_apps.length > 0) {
    _.each(self.user.user_apps, function (app) {
      self.xorigins = _.union(self.xorigins, _.map(app.app.app_xorigins, function (xorigin) {
        return xorigin.x_origin
      }))
    })
  }

  self.xorigins = self.xorigins.length === 0 ? [-1] : self.xorigins

  self.getProjectInfo()
}

Handler.prototype.getProjectInfo = function () {
  let data = {
    projectId: self.projectId,
    query: [
      [ 'with', 'bam_roles' ]
    ]
  }

  self.core.resource.project.get(data)
    .then(function (res) {
      self.project = res

      self.core.service.databind('.page-header', self.project)
      self.core.service.databind('#project-details', self.project)
      self.core.service.databind('#roles-list', { data: self.project.bam_roles })
      $('#roles-list').val(self.roleId)

      self.project.role = { role_id: self.roleId, likeitlist: { total: '' }, submissions: { total: '' } }
      self.core.service.databind('#project-links', self.project)

      self.refreshRole()
    })
}

Handler.prototype.refreshRole = function () {
  self.done = false
  self.refreshing = false
  self.roleId = $('#roles-list').val()
  let role = _.find(self.project.bam_roles, function (r) {
    return r.role_id === parseInt($('#roles-list').val())
  })

  window.history.pushState({}, '', '/projects/' + self.projectId + '/roles/' + role.role_id + '/find-talents')

  role.bam_casting = self.project

  self.core.service.databind('#role-filter-form', role)
  $('#add-all-button span').text('Add All to Like it List')
  $('#add-all-button').removeClass('disabled')

  role.getLikeItListCount(self.xorigins)
    .then(function (count) {
      role.likeitlist = { total: count }

      self.core.service.databind('#add-all-total', role)
      return role.getSubmissionsCount(self.xorigins)
    })
    .then(function (count) {
      role.submissions = { total: count }
      self.project.role = role

      self.core.service.databind('#project-links', self.project)
    })

  self.findMatches()
}

Handler.prototype.findMatches = function (append) {
  if (self.refreshing) {
    return
  }

  append = append === true

  if (append && self.done) {
    $('#search-loader').addClass('hide')
    return
  }

  self.page = append ? self.page + 1 : 1
  self.refreshing = true
  let data = self.getFilters()

  $('#search-loader').show()

  if (!append) {
    $('#role-matches-result').hide()
  }

  let options = {
    bam_role_id: self.roleId
  }

  self.core.resource.talent.search(data, options)
    .then(function (talents) {
      if (talents.data.length === 0) {
        $('#search-loader').addClass('hide')
      }

      self.done = (talents.total < talents.per_page)

      _.each(talents.data, function (talent, ind) {
        talent.talent_role_id = self.roleId
        talent.talent_project_id = self.projectId

        let talentLoc = talent.getLocation()

        // since we use talent search, we assume city1 field
        let getState = talentLoc.split(', ')
        talent.sortState = getState[1]
        talent.sortCity = getState[0]
      })

      // sort state
      let sortResult = _.chain(talents.data).sortBy('sortCity').sortBy('sortState').value()
      talents.data = null // empty the array
      talents.data = sortResult // replace with sorted result

      if (talents.total === 0) {
        $('#add-all-div').addClass('hide')
      } else {
        $('#add-all-div').removeClass('hide')
      }

      // for total number of talent matches
      self.core.service.databind('#submission-total', talents)

      try {
        self.core.service.databind('#role-matches-result', talents, append)
      } catch (e) { console.log(e) }

      self.refreshing = false

      $('#search-loader').hide()
      if (!append) {
        $('#role-matches-result').show()
      }
    })
}

Handler.prototype.getFilters = function () {
  let form = self.core.service.form.serializeObject('#role-filter-form')

  let data = {
    per_page: 24,
    page: self.page,
    query: [ ]
  }

  if ($('#show_only_matched').is(':checked') === true) {
    let role = _.find(self.project.bam_roles, function (r) {
      return r.role_id === parseInt($('#roles-list').val())
    })

    window.history.pushState({}, '', '/projects/' + self.projectId + '/roles/' + role.role_id + '/find-talents')

    role.bam_casting = self.project
    self.core.service.databind('#role-filter-form', role)
  }

  if (parseInt(form.address_search) === 0) { // market filter
    if (form.markets) {
      if (form.markets instanceof Array) {
        let subquery = []

        _.each(form.markets, function (market) {
          if (subquery.length === 0) {
            subquery.push([ 'where', 'city', 'like', '%' + market + '%' ])
          } else {
            subquery.push([ 'orWhere', 'city', 'like', '%' + market + '%' ])
          }

          subquery.push([ 'orWhere', 'city1', 'like', '%' + market + '%' ])
          subquery.push([ 'orWhere', 'city2', 'like', '%' + market + '%' ])
          subquery.push([ 'orWhere', 'city3', 'like', '%' + market + '%' ])
        })

        data.query.push([ 'where', subquery ])
      } else {
        data.query.push([ 'where', [
          [ 'where', 'city', '=', form.markets ],
          [ 'orWhere', 'city1', '=', form.markets ],
          [ 'orWhere', 'city2', '=', form.markets ],
          [ 'orWhere', 'city3', '=', form.markets ]
        ]
        ])
      }
    }
  } else { // location filter
    let lngLat = JSON.parse(form.lng_lat)

    if (lngLat.length > 0) {
      data.query.push(['join', 'bam.laret_users', 'bam.laret_users.bam_talentnum', '=', 'talentnum'])
      data.query.push(['join', 'bam.laret_locations', 'bam.laret_locations.user_id', '=', 'bam.laret_users.id'])

      data.query.push(['where', 'bam.laret_locations.longitude', '>=', lngLat[0].lng.min - 0.3])
      data.query.push(['where', 'bam.laret_locations.longitude', '<=', lngLat[0].lng.max + 0.3])

      data.query.push(['where', 'bam.laret_locations.latitude', '>=', lngLat[0].lat.min - 0.3])
      data.query.push(['where', 'bam.laret_locations.latitude', '<=', lngLat[0].lat.max + 0.3])
    }
  }

  if (parseInt(form.age_min)) {
    if (form.age_min <= 2) {
      data.query.push([ 'where', 'dobyyyy', '<=', new Date().getFullYear() - 2 ])
    } else {
      // data.query.push([ 'where', 'dobyyyy', '<=', new Date().getFullYear() - parseInt(form.age_min) ]);
      data.query.push([ 'where', [
        [ 'where', 'dobyyyy', '<', new Date().getFullYear() - parseInt(form.age_min) ],
        [ 'orWhere', [
          [ 'where', 'dobyyyy', '=', new Date().getFullYear() - parseInt(form.age_min) ],
          [ 'where', [
            [ 'where', 'dobmm', '<', new Date().getMonth() + 1 ],
            [ 'orWhere', [
              [ 'where', 'dobmm', '=', new Date().getMonth() + 1 ],
              [ 'where', 'dobdd', '<=', new Date().getDate() ]
            ]]
          ]]
        ]]
      ]
      ])
    }
  }

  if (parseInt(form.age_max)) {
    if (form.age_max >= 71) {
      data.query.push([ 'where', 'dobyyyy', '>=', new Date().getFullYear() - 71 ])
    } else {
      data.query.push([ 'where', 'dobyyyy', '>=', new Date().getFullYear() - parseInt(form.age_max) ])
    }
  }

  if (form.sexMale && !form.sexFemale) {
    data.query.push([ 'where', 'sex', '=', form.sexMale ])
  }

  if (form.sexFemale && !form.sexMale) {
    data.query.push([ 'where', 'sex', '=', form.sexFemale ])
  }

  if (form.search_text) {
    data.query.push([ 'where',
      [
        [ 'where', 'talentnum', '=', form.search_text ],
        [ 'orWhere', 'fname', 'LIKE', '%' + form.search_text + '%' ],
        [ 'orWhere', 'lname', 'LIKE', '%' + form.search_text + '%' ]
      ]
    ])
  }

  if (parseInt(form.height_min)) {
    data.query.push([ 'where', 'heightinches', '>=', form.height_min ])
  }

  if (parseInt(form.height_max)) {
    data.query.push([ 'where', 'heightinches', '<=', form.height_max ])
  }

  if (form.build) {
    if (form.build instanceof Array) {
      data.query.push([ 'whereIn', 'build', form.build ])
    } else {
      data.query.push([ 'where', 'build', '=', form.build ])
    }
  }

  if (form.ethnicity) {
    // African and African American are both searched if either is chosen
    if (form.ethnicity instanceof Array) {
      if (form.ethnicity.indexOf('African') > -1 && form.ethnicity.indexOf('African American') === -1) {
        form.ethnicity.push('African American')
      } else if (form.ethnicity.indexOf('African American') > -1 && form.ethnicity.indexOf('African') === -1) {
        form.ethnicity.push('African')
      }

      data.query.push([ 'whereIn', 'ethnicity', form.ethnicity ])
    } else {
      if (form.ethnicity === 'African') {
        data.query.push(['where', [
          [ 'where', 'ethnicity', '=', 'African' ],
          [ 'orWhere', 'ethnicity', '=', 'African American' ]
        ]
        ])
      } else if (form.ethnicity === 'African American') {
        data.query.push(['where', [
          [ 'where', 'ethnicity', '=', 'African American' ],
          [ 'orWhere', 'ethnicity', '=', 'African' ]
        ]
        ])
      } else {
        data.query.push([ 'where', 'ethnicity', '=', form.ethnicity ])
      }
    }
  }

  if (form.last_access) {
    data.query.push([ 'where', 'last_access', '>', Math.floor(new Date().getTime() / 1000) - parseInt(form.last_access) ])
  }

  if (form.young_old) {
    data.query.push([ 'orderBy', 'dobyyyy', form.young_old ])
    data.query.push([ 'orderBy', 'dobmm', form.young_old ])
    data.query.push([ 'orderBy', 'dobdd', form.young_old ])
  }

  if (form.union) {
    if (parseInt(form.union) === 1) {
      data.query.push([ 'where', [
        [ 'where', 'union_aea', '=', 'Yes' ],
        [ 'orWhere', 'union_aftra', '=', 'Yes' ],
        [ 'orWhere', 'union_other', '=', 'Yes' ],
        [ 'orWhere', 'union_sag', '=', 'Yes' ]
      ]
      ])
    } else {
      data.query.push([ 'where', [
        [ 'where', 'union_aea', '=', 'No' ],
        [ 'orWhere', 'union_aftra', '=', 'No' ],
        [ 'orWhere', 'union_other', '=', 'No' ],
        [ 'orWhere', 'union_sag', '=', 'No' ]
      ]
      ])
    }
  }

  if (form.has_photo === 'true') {
    data.query.push([ 'where', 'has_photos', '=', form.has_photo === 'true' ? 1 : 0 ])
  }

  if (self.xorigins.length > 0) {
    data.query.push([ 'whereIn', 'x_origin', self.xorigins ])
  }

  return data
}

Handler.prototype.addAll = function () {
  let data = self.getFilters()

  self.core.service.rest.post(self.core.config.api.base + '/cd/talentci/import/' + self.roleId, data)
    .then(function () {
      $('#add-all-button span').text('Added to Like it List')
      $('#add-all-button').addClass('disabled')
    })
}

module.exports = function (core, user, projectId, roleId) {
  return new Handler(core, user, projectId, roleId)
}

},{}],505:[function(require,module,exports){
'use strict'

function handler (core, user, projectId, roleId) {
  self = this
  self.core = core
  self.user = user
  self.projectId = projectId
  self.roleId = roleId
  self.page = 1
  self.first_load = true

  self.getAllProjects()
  self.getProjectInfo()

  console.log(self.user)
}

handler.prototype.getAllProjects = function () {
  let data = {
    query: [
      [ 'with', 'bam_roles' ],
      ['orderBy', 'last_modified', 'DESC']
    ],
    per_page: 500
  }

  self.core.resource.project.get(data)
    .then(function (res) {
      self.core.service.databind('#projects-list', { data: res.data })
      $('#projects-list').val(self.projectId)
    })
}

handler.prototype.getProjectInfo = function () {
  let data = {
    projectId: self.projectId,
    query: [
      [ 'with', 'bam_roles' ]
    ]
  }

  self.core.resource.project.get(data)
    .then(function (res) {
      self.project = res

      let role = _.find(self.project.bam_roles, function (r) {
        return r.role_id == self.roleId
      })

      console.log(res)
      self.core.service.databind('#cd-email', res)
      self.core.service.databind('#roles-list', { data: self.project.bam_roles })
      $('#roles-list').val(self.roleId)
      role.bam_casting = self.project
      self.core.service.databind('#role-filter-form', role)
      self.core.service.databind('#ghost-onboarding', self.user.bam_cd_user)

      self.findMatches()
    })
}

handler.prototype.findRolesForSelectedProject = function (projectId) {
  let data = {
    projectId: projectId,
    query: [
      [ 'with', 'bam_roles' ]
    ]
  }

  self.core.resource.project.get(data)
    .then(function (res) {
      self.project = res

      self.core.service.databind('#roles-list', { data: self.project.bam_roles })
      $('#roles-list').val(self.roleId)
    })
}

handler.prototype.redirectToSelectedRole = function () {
  self.roleId = $('#roles-list').val()
  let role = _.find(self.project.bam_roles, function (r) {
    return r.role_id == $('#roles-list').val()
  })

  // redirect to new url
  window.location.replace('/projects/' + role.casting_id + '/roles/' + role.role_id + '/landing')
}

handler.prototype.findMatches = function (append) {
  if (self.refreshing) {
    return
  }

  append = append === true
  self.page = append ? self.page + 1 : 1
  self.refreshing = true
  let data = self.getFilters('submissions')

  $('#search-loader').show()

  if (!append) {
    $('#role-matches-result').hide()
  }

  self.core.resource.talent.search(data)
    .then(function (talents) {
      let promise = $.when(talents)

      if (talents.total < 24) {
        data = self.getFilters('matches')
        promise = self.core.resource.talent.search(data)
      }

      return promise
    })
    .then(function (talents) {
      self.core.service.databind('#role-matches-result', talents, append)
      self.refreshing = false

      $('#search-loader').hide()
      if (!append) {
        $('#role-matches-result').show()
      }

      $('#filter-content-modal').modal('hide')
    })
}

handler.prototype.getFilters = function (type) {
  let form = self.core.service.form.serializeObject('#role-filter-form')
  let data

  if (type == 'submissions') {
    data = {
      per_page: 24,
      page: self.page,
      query: [
        [ 'join', 'bam.laret_users', 'bam.laret_users.bam_talentnum', '=', 'search.talents.talentnum' ],
        [ 'leftJoin', 'bam.laret_schedules', 'bam.laret_schedules.invitee_id', '=', 'bam.laret_users.id' ],
        [ 'where', 'bam.laret_schedules.submission', '>', 0 ],
        [ 'where', 'bam.laret_schedules.bam_role_id', '=', self.roleId ]
      ]
    }
  } else if (type == 'matches') {
    data = {
      per_page: 24,
      page: self.page,
      query: [
      ]
    }
  }

  if (form.markets) {
    if (form.markets instanceof Array) {
      let subquery = []

      _.each(form.markets, function (market) {
        if (subquery.length == 0) {
          subquery.push([ 'where', 'city', 'like', '%' + market + '%' ])
        } else {
          subquery.push([ 'orWhere', 'city', 'like', '%' + market + '%' ])
        }

        subquery.push([ 'orWhere', 'city1', 'like', '%' + market + '%' ])
        subquery.push([ 'orWhere', 'city2', 'like', '%' + market + '%' ])
        subquery.push([ 'orWhere', 'city3', 'like', '%' + market + '%' ])
      })

      data.query.push([ 'where', subquery ])
    } else {
      data.query.push([ 'where', [
        [ 'where', 'city', '=', form.markets ],
        [ 'orWhere', 'city1', '=', form.markets ],
        [ 'orWhere', 'city2', '=', form.markets ],
        [ 'orWhere', 'city3', '=', form.markets ]
      ]
      ])
    }
  }

  if (parseInt(form.age_min)) {
    data.query.push([ 'where', 'dobyyyy', '<=', new Date().getFullYear() - parseInt(form.age_min) ])
  }

  if (parseInt(form.age_max)) {
    data.query.push([ 'where', 'dobyyyy', '>=', new Date().getFullYear() - parseInt(form.age_max) ])
  }

  if (form.sex) {
    data.query.push([ 'where', 'sex', '=', form.sex ])
  }

  if (form.has_photo) {
    data.query.push([ 'where', 'has_photos', '=', form.has_photo == 'true' ? 1 : 0 ])
  }

  if (form.search_text) {
    data.query.push([ 'where',
      [
        [ 'where', 'talentnum', '=', form.search_text ],
        [ 'orWhere', 'fname', 'LIKE', '%' + form.search_text + '%' ],
        [ 'orWhere', 'lname', 'LIKE', '%' + form.search_text + '%' ]
      ]
    ])
  }

  if (parseInt(form.height_min)) {
    data.query.push([ 'where', 'heightinches', '>=', form.height_min ])
  }

  if (parseInt(form.height_max)) {
    data.query.push([ 'where', 'heightinches', '<=', form.height_max ])
  }

  if (form.build) {
    if (form.build instanceof Array) {
      data.query.push([ 'whereIn', 'build', form.build ])
    } else {
      data.query.push([ 'where', 'build', '=', form.build ])
    }
  }

  if (form.ethnicity) {
    // African and African American are both searched if either is chosen
    if (form.ethnicity instanceof Array) {
      if (form.ethnicity.indexOf('African') > -1 && form.ethnicity.indexOf('African American') == -1) {
        form.ethnicity.push('African American')
      } else if (form.ethnicity.indexOf('African American') > -1 && form.ethnicity.indexOf('African') == -1) {
        form.ethnicity.push('African')
      }

      data.query.push([ 'whereIn', 'ethnicity', form.ethnicity ])
    } else {
      if (form.ethnicity == 'African') {
        data.query.push(['where', [
          [ 'where', 'ethnicity', '=', 'African' ],
          [ 'orWhere', 'ethnicity', '=', 'African American' ]
        ]
        ])
      } else if (form.ethnicity == 'African American') {
        data.query.push(['where', [
          [ 'where', 'ethnicity', '=', 'African American' ],
          [ 'orWhere', 'ethnicity', '=', 'African' ]
        ]
        ])
      } else {
        data.query.push([ 'where', 'ethnicity', '=', form.ethnicity ])
      }
    }
  }

  return data
}

handler.prototype.confirmCdInfo = function () {
  // no logic applied on this other than when contact talent is clicked,
  // user is gonna go through forms and verify/update information

  // hide the last form shown(assuming that user not skipping)
  $('#onboarding-congratulations').hide()

  // showing first modal
  $('#ghost-onboarding-modal').show()
  $('#onboarding-confirm-email').show()
  // modal settings
  $('#ghost-onboarding-modal').modal({ backdrop: 'static', keyboard: false })

  return self.core.service.databind('#ghost-onboarding', self.user.bam_cd_user)
}

handler.prototype.updateCdInfo = function (e) {
  let btn = $(this)

  let form = self.core.service.form.serializeObject('#ghost-onboarding-form')

  form.cdUserId = self.user.bam_cd_user_id
  form.pass = form.cdpass

  delete form.cdpass
  delete form.conf_cdpass

  form.phone1 = form.phone1.replace(/-/g, '')
  form.phone2 = form.phone2.replace(/-/g, '')

  // set CD to active
  form.status = 1

  // update information
  self.core.resource.cd_user.patch(form)
    .then(function (res) {
      // fire congratulations text if last detail to be saved (company)
      if (btn.hasClass('company-name')) {
        $('#onboarding-company-name').hide()
        $('#onboarding-congratulations').show()
      }
    }, function (err) {
      alert('errors while saving')
    })
}

module.exports = function (core, user, projectId, roleId) {
  return new handler(core, user, projectId, roleId)
}

},{}],506:[function(require,module,exports){
let _ = require('lodash')
'use strict'

function handler (core, user, projectId, roleId) {
  self = this
  self.core = core
  self.user = user
  self.projectId = projectId
  self.roleId = roleId
  self.page = 1
  self.first_load = true
  self.likeitlistTotal
  self.filter = 0

  self.xorigins = []

  if (self.user.user_apps.length > 0) {
    _.each(self.user.user_apps, function (app) {
      self.xorigins = _.union(self.xorigins, _.map(app.app.app_xorigins, function (xorigin) {
        return xorigin.x_origin
      }))
    })
  }

  self.xorigins = self.xorigins.length == 0 ? [-1] : self.xorigins

  self.getProjectInfo()
}

handler.prototype.getProjectInfo = function () {
  let current_timestamp = parseInt(new Date().getTime() / 1000)
  let data = {
    projectId: self.projectId,
    query: [
      [ 'with', 'bam_roles' ]
    ]
  }

  self.core.resource.project.get(data)
    .then(function (res) {
      self.project = res
      // console.log(self.project);
      self.core.service.databind('.page-header', self.project)
      self.core.service.databind('#project-details', self.project)
      self.core.service.databind('#roles-list', { data: self.project.bam_roles })
      $('#roles-list').val(self.roleId)

      self.project.role = { role_id: self.roleId, likeitlist: { total: '' }, submissions: { total: '' } }
      self.core.service.databind('.project-data', self.project)

      self.refreshRole()

      let asap = self.project.asap
      let roleExpiryTimestamp = self.project.role.expiration_timestamp

      // if role is expired
      if (current_timestamp >= asap || current_timestamp >= roleExpiryTimestamp) {
        $('#invitetoauditionbutton').hide()
        $('#role-active').hide()
      } else {
        $('#role-expiry-btn').hide()
        $('#role-expired').hide()
      }
    })
}

handler.prototype.refreshRole = function () {
  self.done = false
  self.refreshing = false
  self.first_load = true
  self.roleId = $('#roles-list').val()
  let role = _.find(self.project.bam_roles, function (r) {
    return r.role_id == $('#roles-list').val()
  })

  self.project.role = role
  self.project.role.bam_casting = self.project

  // change url
  window.history.pushState({}, '', '/projects/' + role.casting_id + '/roles/' + role.role_id + '/like-it-list')

  // update filter form
  self.core.service.databind('#role-filter-form', self.project.role)

  // submissions count
  self.project.role.getSubmissionsCount(self.xorigins)
    .then(function (count) {
      self.project.role.submissions = { total: count }

      self.core.service.databind('.project-data', self.project)
    })

  // share like it list
  let link = window.location.origin + '/login?' + $.param({ access_token: localStorage.getItem('access_token'), /* refresh_token : localStorage.getItem('refresh_token'), */ redirect: encodeURIComponent(window.location.href.replace(/like-it-list/, '')) + 'public-like-it-list' })
  $('#share-like-list-link').val(link)

  self.findMatches()
  self.refreshInvitation()
}

handler.prototype.findMatches = function (append) {
  let form = self.core.service.form.serializeObject('#role-filter-form')

  if (self.refreshing) {
    return
  }

  append = append === true

  if (append && self.done) {
    return
  }

  self.page = append ? self.page + 1 : 1
  self.refreshing = true

  let data = self.getFilters()

  if (append) {
    self.first_load = self.first_load ? self.first_load : false
  } else {
    self.first_load = false
  }

  $('#search-loader').show()
  $('#no-likeitlist-found').addClass('hide')

  if (!append) {
    $('#role-matches-result').hide()
  }

  let options = {
    bam_role_id: self.roleId
  }

  self.core.resource.schedule.get(data)
    .then(function (res) {
      self.likeitlistTotal = res.total
      self.done = (res.total < res.per_page)

      let talentnums = _.map(res.data, function (r) {
        if (r.invitee && r.invitee.bam_talentci) {
          return r.invitee.bam_talentci.talentnum
        } else {
          return 0
        }
      })

      talentnums.push(0)

      let data2 = {
        query: [
          [ 'whereIn', 'talentnum', talentnums ],
          [ 'whereIn', 'x_origin', self.xorigins ]
        ]
      }

      data2 = self.getFilters2(data2)

      return self.core.resource.talent.search(data2, options)
    })
    .then(function (talents) {
      _.each(talents.data, function (talent) {
        talent.talent_role_id = self.roleId
        talent.talent_project_id = self.projectId
      })

      try {
        self.core.service.databind('#role-matches-result', talents, append)
      } catch (e) { }

      self.refreshing = false

      $('#search-loader').hide()

      if (!append) {
        $('#role-matches-result').show()

        if (talents.total > 0) {
          $('.like-it-list-only').removeClass('hide')
        } else {
          $('.like-it-list-only').addClass('hide')
          $('#no-likeitlist-found').removeClass('hide')
          $('#no-likeitlist-found').show()
        }
      }
    })
}

handler.prototype.getFilters = function () {
  let data = {
    per_page: 24,
    page: self.page,
    query: [
      [ 'where', 'rating', '<>', 0 ],
      [ 'where', 'bam_role_id', '=', $('#roles-list').val() ],
      [ 'with', 'invitee.bam_talentci' ]
    ]
  }
  return data
}

handler.prototype.getFilters2 = function (data) {
  let form = self.core.service.form.serializeObject('#role-filter-form')

  if ($('#show_only_matched').is(':checked') == true) {
    let role = _.find(self.project.bam_roles, function (r) {
      return r.role_id == $('#roles-list').val()
    })

    self.project.role = role
    self.project.role.bam_casting = self.project

    // change url
    window.history.pushState({}, '', '/projects/' + role.casting_id + '/roles/' + role.role_id + '/like-it-list')

    // update filter form
    self.core.service.databind('#role-filter-form', self.project.role)
  }

  if (!self.first_load) {
    if (form.address_search == 0) { // market filter
      if (form.markets) {
        if (form.markets instanceof Array) {
          let subquery = []

          _.each(form.markets, function (market) {
            if (subquery.length == 0) {
              subquery.push([ 'where', 'city', 'like', '%' + market + '%' ])
            } else {
              subquery.push([ 'orWhere', 'city', 'like', '%' + market + '%' ])
            }

            subquery.push([ 'orWhere', 'city1', 'like', '%' + market + '%' ])
            subquery.push([ 'orWhere', 'city2', 'like', '%' + market + '%' ])
            subquery.push([ 'orWhere', 'city3', 'like', '%' + market + '%' ])
          })

          data.query.push([ 'where', subquery ])
        } else {
          data.query.push([ 'where', [
            [ 'where', 'city', '=', form.markets ],
            [ 'orWhere', 'city1', '=', form.markets ],
            [ 'orWhere', 'city2', '=', form.markets ],
            [ 'orWhere', 'city3', '=', form.markets ]
          ]
          ])
        }
      }
    } else if (form.address_search == 1) { // location filter
      let lngLat = JSON.parse(form.lng_lat)

      if (lngLat.length > 0) {
        data.query.push(['join', 'bam.laret_users', 'bam.laret_users.bam_talentnum', '=', 'talentnum'])
        data.query.push(['join', 'bam.laret_locations', 'bam.laret_locations.user_id', '=', 'bam.laret_users.id'])

        data.query.push(['where', 'bam.laret_locations.longitude', '>=', lngLat[0].lng.min - 0.3])
        data.query.push(['where', 'bam.laret_locations.longitude', '<=', lngLat[0].lng.max + 0.3])

        data.query.push(['where', 'bam.laret_locations.latitude', '>=', lngLat[0].lat.min - 0.3])
        data.query.push(['where', 'bam.laret_locations.latitude', '<=', lngLat[0].lat.max + 0.3])
      }
    }

    if (parseInt(form.age_min)) {
      data.query.push([ 'where', 'dobyyyy', '<=', new Date().getFullYear() - parseInt(form.age_min) ])
    }

    if (parseInt(form.age_max)) {
      data.query.push([ 'where', 'dobyyyy', '>=', new Date().getFullYear() - parseInt(form.age_max) ])
    }

    if (form.sex) {
      data.query.push([ 'where', 'sex', '=', form.sex ])
    }

    if (form.has_photo) {
      data.query.push([ 'where', 'has_photos', '=', form.has_photo == 'true' ? 1 : 0 ])
    }

    if (form.search_text) {
      data.query.push([ 'where',
        [
          [ 'where', 'talentnum', '=', form.search_text ],
          [ 'orWhere', 'fname', 'LIKE', '%' + form.search_text + '%' ],
          [ 'orWhere', 'lname', 'LIKE', '%' + form.search_text + '%' ]
        ]
      ])
    }

    if (parseInt(form.height_min)) {
      data.query.push([ 'where', 'heightinches', '>=', form.height_min ])
    }

    if (parseInt(form.height_max)) {
      data.query.push([ 'where', 'heightinches', '<=', form.height_max ])
    }

    if (form.build) {
      if (form.build instanceof Array) {
        data.query.push([ 'whereIn', 'build', form.build ])
      } else {
        data.query.push([ 'where', 'build', '=', form.build ])
      }
    }

    if (form.ethnicity) {
      // African and African American are both searched if either is chosen
      if (form.ethnicity instanceof Array) {
        if (form.ethnicity.indexOf('African') > -1 && form.ethnicity.indexOf('African American') == -1) {
          form.ethnicity.push('African American')
        } else if (form.ethnicity.indexOf('African American') > -1 && form.ethnicity.indexOf('African') == -1) {
          form.ethnicity.push('African')
        }

        data.query.push([ 'whereIn', 'ethnicity', form.ethnicity ])
      } else {
        if (form.ethnicity == 'African') {
          data.query.push(['where', [
            [ 'where', 'ethnicity', '=', 'African' ],
            [ 'orWhere', 'ethnicity', '=', 'African American' ]
          ]
          ])
        } else if (form.ethnicity == 'African American') {
          data.query.push(['where', [
            [ 'where', 'ethnicity', '=', 'African American' ],
            [ 'orWhere', 'ethnicity', '=', 'African' ]
          ]
          ])
        } else {
          data.query.push([ 'where', 'ethnicity', '=', form.ethnicity ])
        }
      }
    }

    if (form.last_access) {
      data.query.push([ 'where', 'last_access', '>', Math.floor(new Date().getTime() / 1000) - parseInt(form.last_access) ])
    }

    if (form.young_old) {
      data.query.push([ 'orderBy', 'dobyyyy', form.young_old ])
      data.query.push([ 'orderBy', 'dobmm', form.young_old ])
      data.query.push([ 'orderBy', 'dobdd', form.young_old ])
    }

    if (form.union) {
      if (form.union == '1') {
        data.query.push([ 'where', [
          [ 'where', 'union_aea', '=', 'Yes' ],
          [ 'orWhere', 'union_aftra', '=', 'Yes' ],
          [ 'orWhere', 'union_other', '=', 'Yes' ],
          [ 'orWhere', 'union_sag', '=', 'Yes' ]
        ]
        ])
      } else {
        data.query.push([ 'where', [
          [ 'where', 'union_aea', '=', 'No' ],
          [ 'orWhere', 'union_aftra', '=', 'No' ],
          [ 'orWhere', 'union_other', '=', 'No' ],
          [ 'orWhere', 'union_sag', '=', 'No' ]
        ]
        ])
      }
    }

    if (form.favorite_talent == '1') {
      data.query.push([ 'join', 'bam.laret_favorite_talents', 'bam.laret_favorite_talents.bam_talentnum', '=', 'search.talents.talentnum' ])
    }
  }

  return data
}

handler.prototype.refreshInvitation = function () {
  let data = {
    query: [
      [ 'where', 'bam_role_id', self.project.role.role_id ],
      [ 'orderBy', 'created_at', 'DESC' ]
    ],
    per_page: 1
  }

  self.core.resource.campaign.get(data)
    .then(function (res) {
      let campaign = _.first(res.data)
      if (campaign && (campaign.status > 0 || campaign.status == 0)) {
        $('#invitetoaudition-text')
          .html('<span class="text-muted">You have already sent an invitation on</span> ' + campaign.updated_at +
            '<a href="/projects/' + self.project.role.casting_id + '/roles/' + self.project.role.role_id + '/worksheet" class="btn-link margin-left-small"><i class="fa fa-pencil"></i> Manage Here</a>')

        $('#invitetoauditionbutton').attr('disabled', true)
      } else {
        let role = _.find(self.project.bam_roles, function (r) {
          return r.role_id == $('#roles-list').val()
        })

        role.getLikeItListCount(self.xorigins)
          .then(function (count) {
            role.likeitlist = { total: count }

            self.core.service.databind('#invite-to-audition-modal', role)
          })

        $('#invitetoaudition-text').text('')
        $('#invitetoauditionbutton').attr('disabled', false)
      }
    })
}

handler.prototype.sendInvites = function () {
  let form = self.core.service.form.serializeObject('#invite-to-audition-form')

  let data = [
    [ 'join', 'bam.laret_users', 'bam.laret_users.bam_talentnum', '=', 'bam.talentci.talentnum' ],
    [ 'join', 'bam.laret_schedules', 'bam.laret_schedules.invitee_id', '=', 'bam.laret_users.id' ],
    [ 'where', 'bam.laret_schedules.rating', '>', 0 ],
    [ 'where', 'bam.laret_schedules.bam_role_id', '=', self.project.role.role_id ]
  ]

  // let data = [
  //   [ 'where', 'rating', '<>', 0 ],
  //   [ 'where', 'bam_role_id', '=', self.project.role.role_id ],
  //   [ 'join', 'users', 'users.id', '=', 'invitee_id' ],
  //   [ 'select', 'bam_talentnum AS talentnum' ]
  // ];

  let campaignData = {
    campaign_type_id: self.core.resource.campaign_type.CD_INVITE,
    bam_cd_user_id: self.user.bam_cd_user_id,
    bam_role_id: self.project.role.role_id,
    when: form.when,
    where: form.where,
    name: 'CD Invite Role #' + self.project.role.role_id,
    description: form.message,
    query_model: 'Bam\\Talentci',
    query_model_raw: 'Bam\\Talentci',
    query_key_id: 'talentnum',
    query_key_cell: 'cell',
    query_key_email: 'email1',
    query: JSON.stringify(data),
    replies: form.replies,
    status: 0
  }

  self.core.resource.campaign.post(campaignData)
    .then(function (res) {
      alert('Invitations sent!')
      $('#invite-to-audition-modal').modal('toggle')

      self.refreshInvitation()
    })
}

handler.prototype.removeAllChecked = function () {
  if (confirm('Are you sure you want to remove checked talents from your Like it List?')) {
    let checkbox = $('.like-it-list-checkbox')
    let idArray = []

    $.each(checkbox, function (index, value) {
      if ($(this).hasClass('checked')) {
        let id = $(this).attr('id')

        if (id) {
          id = id.split('_')
          id = id[1]
          idArray.push(id)
        }
      }
    })

    $.each(idArray, function (index, value) {
      let data = {
        scheduleId: value,
        rating: 0
      }

      self.core.resource.schedule.put(data)
        .then(function (res) {
          self.getProjectInfo()
        })
    })
  }
}

handler.prototype.countCheckedTalents = function () {
  let checked_talents = []

  let all_checkboxes = $('.like-it-list-checkbox').length
  let checked = $('.like-it-list-checkbox.checked')

  $.each(checked, function (index, value) {
    checked_talents.push(value)
  })

  let length = checked_talents.length

  if (checked.length == self.likeitlistTotal) {
    $('#mark-all-talents-as-checked-btn').addClass('hide')
    $('#mark-all-talents-as-unchecked-btn').removeClass('hide')
  }

  $('#checked-talents-counter').text(length)
}

handler.prototype.removeAllLikeItList = function () {
  if (confirm('Are you sure you want to remove all Like It List entries?')) {
    self.project.role.deleteLikeItList()
      .then(function () {
        alert('Like It List entries removed.')
        self.getProjectInfo()
      })
  }
}

module.exports = function (core, user, projectId, roleId) {
  return new handler(core, user, projectId, roleId)
}

},{"lodash":429}],507:[function(require,module,exports){
let _ = require('lodash')
'use strict'

function handler (core, user, projectId, roleId) {
  self = this
  self.core = core
  self.user = user
  self.projectId = projectId
  self.roleId = roleId
  self.page = 1
  self.first_load = true
  self.filter = 0

  self.xorigins = []

  if (self.user.user_apps.length > 0) {
    _.each(self.user.user_apps, function (app) {
      self.xorigins = _.union(self.xorigins, _.map(app.app.app_xorigins, function (xorigin) {
        return xorigin.x_origin
      }))
    })
  }

  self.xorigins = self.xorigins.length == 0 ? [-1] : self.xorigins

  self.getDetails()
}

handler.prototype.getDetails = function () {
  let data = {
    projectId: self.projectId,
    jobId: self.roleId,
    query: [
      [ 'with', 'bam_casting.bam_cd_user' ]
    ]
  }

  self.core.resource.job.get(data)
    .then(function (res) {
      self.core.service.databind('#project-details', res)
      self.core.service.databind('#role-filter-form', res)
      self.filter = res
      self.findMatches()
    })
}

handler.prototype.findMatches = function (append) {
  let form = self.core.service.form.serializeObject('#role-filter-form')

  if (self.refreshing) {
    return
  }

  append = append === true

  if (append && self.done) {
    return
  }

  self.page = append ? self.page + 1 : 1
  self.refreshing = true

  let data = {
    per_page: 24,
    page: self.page,
    query: [
      [ 'where', 'rating', '<>', 0 ],
      [ 'where', 'bam_role_id', '=', self.roleId ],
      [ 'with', 'invitee.bam_talentci' ]
    ]
  }

  if (append) {
    self.first_load = self.first_load ? self.first_load : false
  } else {
    self.first_load = false
  }

  $('#search-loader').show()

  if (!append) {
    $('#role-matches-result').hide()
  }

  let options = {
    bam_role_id: self.roleId
  }

  self.core.resource.schedule.get(data)
    .then(function (res) {
      self.done = (res.total < res.per_page)
      let talentnums = _.map(res.data, function (r) {
        if (r.invitee && r.invitee.bam_talentci) {
          return r.invitee.bam_talentci.talentnum
        } else {
          return 0
        }
      })

      talentnums.push(0)

      let data2 = self.getFilters(talentnums)

      return self.core.resource.talent.search(data2, options)
    })
    .then(function (talents) {
      _.each(talents.data, function (talent) {
        talent.talent_role_id = self.roleId
        talent.talent_project_id = self.projectId
      })

      try {
        self.core.service.databind('#role-matches-result', talents, append)
      } catch (e) { }

      self.refreshing = false

      $('#search-loader').hide()

      if (!append) {
        $('#role-matches-result').show()

        if (talents.total > 0) {
          $('.like-it-list-only').removeClass('hide')
        } else {
          $('.like-it-list-only').addClass('hide')
        }
      }
    })
}

handler.prototype.getFilters = function (talentnums) {
  let form = self.core.service.form.serializeObject('#role-filter-form')
  let data = {
    per_page: 24,
    page: self.page,
    query: [
      [ 'whereIn', 'talentnum', talentnums ],
      [ 'whereIn', 'x_origin', self.xorigins ]
    ]
  }

  if ($('#show_only_matched').is(':checked') == true) {
    self.core.service.databind('#role-filter-form', self.filter)
  }

  if (!self.first_load) {
    if (form.address_search == 0) { // market filter
      if (form.markets) {
        if (form.markets instanceof Array) {
          let subquery = []

          _.each(form.markets, function (market) {
            if (subquery.length == 0) {
              subquery.push([ 'where', 'city', 'like', '%' + market + '%' ])
            } else {
              subquery.push([ 'orWhere', 'city', 'like', '%' + market + '%' ])
            }

            subquery.push([ 'orWhere', 'city1', 'like', '%' + market + '%' ])
            subquery.push([ 'orWhere', 'city2', 'like', '%' + market + '%' ])
            subquery.push([ 'orWhere', 'city3', 'like', '%' + market + '%' ])
          })

          data.query.push([ 'where', subquery ])
        } else {
          data.query.push([ 'where', [
            [ 'where', 'city', '=', form.markets ],
            [ 'orWhere', 'city1', '=', form.markets ],
            [ 'orWhere', 'city2', '=', form.markets ],
            [ 'orWhere', 'city3', '=', form.markets ]
          ]
          ])
        }
      }
    } else if (form.address_search == 1) { // location filter
      let lngLat = JSON.parse(form.lng_lat)

      if (lngLat.length > 0) {
        data.query.push(['join', 'bam.laret_users', 'bam.laret_users.bam_talentnum', '=', 'talentnum'])
        data.query.push(['join', 'bam.laret_locations', 'bam.laret_locations.user_id', '=', 'bam.laret_users.id'])

        data.query.push(['where', 'bam.laret_locations.longitude', '>=', lngLat[0].lng.min - 0.3])
        data.query.push(['where', 'bam.laret_locations.longitude', '<=', lngLat[0].lng.max + 0.3])

        data.query.push(['where', 'bam.laret_locations.latitude', '>=', lngLat[0].lat.min - 0.3])
        data.query.push(['where', 'bam.laret_locations.latitude', '<=', lngLat[0].lat.max + 0.3])
      }
    }

    if (parseInt(form.age_min)) {
      data.query.push([ 'where', 'dobyyyy', '<=', new Date().getFullYear() - parseInt(form.age_min) ])
    }

    if (parseInt(form.age_max)) {
      data.query.push([ 'where', 'dobyyyy', '>=', new Date().getFullYear() - parseInt(form.age_max) ])
    }

    if (form.sex) {
      data.query.push([ 'where', 'sex', '=', form.sex ])
    }

    if (form.has_photo) {
      data.query.push([ 'where', 'has_photos', '=', form.has_photo == 'true' ? 1 : 0 ])
    }

    if (form.search_text) {
      data.query.push([ 'where',
        [
          [ 'where', 'talentnum', '=', form.search_text ],
          [ 'orWhere', 'fname', 'LIKE', '%' + form.search_text + '%' ],
          [ 'orWhere', 'lname', 'LIKE', '%' + form.search_text + '%' ]
        ]
      ])
    }

    if (parseInt(form.height_min)) {
      data.query.push([ 'where', 'heightinches', '>=', form.height_min ])
    }

    if (parseInt(form.height_max)) {
      data.query.push([ 'where', 'heightinches', '<=', form.height_max ])
    }

    if (form.build) {
      if (form.build instanceof Array) {
        data.query.push([ 'whereIn', 'build', form.build ])
      } else {
        data.query.push([ 'where', 'build', '=', form.build ])
      }
    }

    if (form.ethnicity) {
      // African and African American are both searched if either is chosen
      if (form.ethnicity instanceof Array) {
        if (form.ethnicity.indexOf('African') > -1 && form.ethnicity.indexOf('African American') == -1) {
          form.ethnicity.push('African American')
        } else if (form.ethnicity.indexOf('African American') > -1 && form.ethnicity.indexOf('African') == -1) {
          form.ethnicity.push('African')
        }

        data.query.push([ 'whereIn', 'ethnicity', form.ethnicity ])
      } else {
        if (form.ethnicity == 'African') {
          data.query.push(['where', [
            [ 'where', 'ethnicity', '=', 'African' ],
            [ 'orWhere', 'ethnicity', '=', 'African American' ]
          ]
          ])
        } else if (form.ethnicity == 'African American') {
          data.query.push(['where', [
            [ 'where', 'ethnicity', '=', 'African American' ],
            [ 'orWhere', 'ethnicity', '=', 'African' ]
          ]
          ])
        } else {
          data.query.push([ 'where', 'ethnicity', '=', form.ethnicity ])
        }
      }
    }

    if (form.last_access) {
      data.query.push([ 'where', 'last_access', '>', Math.floor(new Date().getTime() / 1000) - parseInt(form.last_access) ])
    }

    if (form.young_old) {
      data.query.push([ 'orderBy', 'dobyyyy', form.young_old ])
      data.query.push([ 'orderBy', 'dobmm', form.young_old ])
      data.query.push([ 'orderBy', 'dobdd', form.young_old ])
    }

    if (form.union) {
      if (form.union == '1') {
        data.query.push([ 'where', [
          [ 'where', 'union_aea', '=', 'Yes' ],
          [ 'orWhere', 'union_aftra', '=', 'Yes' ],
          [ 'orWhere', 'union_other', '=', 'Yes' ],
          [ 'orWhere', 'union_sag', '=', 'Yes' ]
        ]
        ])
      } else {
        data.query.push([ 'where', [
          [ 'where', 'union_aea', '=', 'No' ],
          [ 'orWhere', 'union_aftra', '=', 'No' ],
          [ 'orWhere', 'union_other', '=', 'No' ],
          [ 'orWhere', 'union_sag', '=', 'No' ]
        ]
        ])
      }
    }

    if (form.favorite_talent == '1') {
      data.query.push([ 'join', 'bam.laret_favorite_talents', 'bam.laret_favorite_talents.bam_talentnum', '=', 'search.talents.talentnum' ])
    }
  }

  return data
}

handler.prototype.refreshInvitation = function () {
  let data = {
    query: [
      [ 'where', 'bam_role_id', self.project.role.role_id ],
      [ 'orderBy', 'created_at', 'DESC' ]
    ],
    per_page: 1
  }

  self.core.resource.campaign.get(data)
    .then(function (res) {
      let campaign = _.first(res.data)
      if (campaign && (campaign.status > 0 || campaign.status == 0)) {
        $('#invitetoaudition-text')
          .html('<span class="text-muted">You have already sent an invitation on</span> ' + campaign.updated_at +
            '<a href="/projects/' + self.project.role.casting_id + '/roles/' + self.project.role.role_id + '/worksheet" class="btn-link margin-left-small"><i class="fa fa-pencil"></i> Manage Here</a>')

        $('#invitetoauditionbutton').attr('disabled', true)
      } else {
        $('#invitetoaudition-text').text('')
        $('#invitetoauditionbutton').attr('disabled', false)
      }
    })
}

handler.prototype.sendInvites = function () {
  let form = self.core.service.form.serializeObject('#invite-to-audition-form')

  let data = [
    [ 'where', 'rating', '<>', 0 ],
    [ 'where', 'bam_role_id', '=', self.project.role.role_id ],
    [ 'join', 'users', 'users.id', '=', 'invitee_id' ],
    [ 'select', 'bam_talentnum AS talentnum' ]
  ]

  let campaignData = {
    campaign_type_id: self.core.resource.campaign_type.CD_INVITE,
    bam_cd_user_id: self.user.bam_cd_user_id,
    bam_role_id: self.project.role.role_id,
    when: form.when,
    where: form.where,
    name: 'CD Invite Role #' + self.project.role.role_id,
    description: form.message,
    query_model: 'Schedule',
    query_model_raw: 'Bam\\Talentci',
    query_key_id: 'talentnum',
    query_key_cell: 'cell',
    query_key_email: 'email1',
    query: JSON.stringify(data),
    replies: form.replies,
    status: 0
  }

  self.core.resource.campaign.post(campaignData)
    .then(function (res) {
      alert('Invitations sent!')
      $('#invite-to-audition-modal').modal('toggle')

      self.refreshInvitation()
    })
}

module.exports = function (core, user, projectId, roleId) {
  return new handler(core, user, projectId, roleId)
}

},{"lodash":429}],508:[function(require,module,exports){
'use strict'

function handler (core, user, projectId, roleId) {
  self = this
  self.core = core
  self.user = user
  self.projectId = projectId
  self.roleId = roleId
  self.page = 1
  self.first_load = true

  self.xorigins = []

  if (self.user.user_apps.length > 0) {
    _.each(self.user.user_apps, function (app) {
      self.xorigins = _.union(self.xorigins, _.map(app.app.app_xorigins, function (xorigin) {
        return xorigin.x_origin
      }))
    })
  }

  self.xorigins = self.xorigins.length == 0 ? [-1] : self.xorigins

  self.getProjectInfo()
}

handler.prototype.getProjectInfo = function () {
  let data = {
    projectId: self.projectId,
    query: [
      [ 'with', 'bam_roles' ]
    ]
  }

  self.core.resource.project.get(data)
    .then(function (res) {
      self.project = res

      self.core.service.databind('.page-header', self.project)
      self.core.service.databind('#project-details', self.project)
      self.core.service.databind('#roles-list', { data: self.project.bam_roles })
      $('#roles-list').val(self.roleId)

      self.project.role = { role_id: self.roleId, likeitlist: { total: '' }, submissions: { total: '' } }
      self.core.service.databind('#project-links', self.project)
      self.core.service.databind('#no-submission-div', self.project)

      // add active class on Find Talents nav
      $('#find-talents-list').addClass('active')

      self.refreshRole()
    })
}

handler.prototype.refreshRole = function () {
  self.done = false
  self.refreshing = false
  self.first_load = true
  self.roleId = $('#roles-list').val()
  let role = _.find(self.project.bam_roles, function (r) {
    return r.role_id == $('#roles-list').val()
  })

  window.history.pushState({}, '', '/projects/' + self.projectId + '/roles/' + role.role_id + '/submissions')

  role.bam_casting = self.project
  self.core.service.databind('#role-filter-form', role)
  $('#add-all-button span').text('Add All to Like it List')
  $('#add-all-button').removeClass('disabled')

  role.getLikeItListCount(self.xorigins)
    .then(function (count) {
      role.likeitlist = { total: count }

      self.core.service.databind('#add-all-total', role)
      return role.getSubmissionsCount(self.xorigins)
    })
    .then(function (count) {
      role.submissions = { total: count }
      self.project.role = role

      self.core.service.databind('#project-links', self.project)
    })

  self.findMatches()
}

handler.prototype.findMatches = function (append) {
  if (self.refreshing) {
    return
  }

  append = append === true

  if (append && self.done) {
    return
  }

  self.page = append ? self.page + 1 : 1
  self.refreshing = true
  let data = self.getFilters()

  console.log(append)

  if (append) {
    self.first_load = self.first_load ? self.first_load : false
  } else {
    self.first_load = false
  }

  $('#search-loader').show()

  if (!append) {
    $('#role-matches-result').hide()
  }

  let options = {
    bam_role_id: self.roleId
  }

  self.core.resource.talent.search(data, options)
    .then(function (talents) {
      self.done = (talents.total < talents.per_page)

      _.each(talents.data, function (talent) {
        talent.talent_role_id = self.roleId
        talent.talent_project_id = self.projectId
      })

      if (talents.total == 0) {
        $('#no-submission-div').removeClass('hide')
        $('#add-all-div').addClass('hide')
      } else {
        $('#no-submission-div').addClass('hide')
        $('#add-all-div').removeClass('hide')
      }

      // for total number of talent matches
      self.core.service.databind('#submission-total', talents)

      try {
        self.core.service.databind('#role-matches-result', talents, append)
      } catch (e) { }

      self.refreshing = false

      $('#search-loader').hide()
      if (!append) {
        $('#role-matches-result').show()
      }
    })
}

handler.prototype.getFilters = function () {
  let form = self.core.service.form.serializeObject('#role-filter-form')
  let data = {
    per_page: 24,
    page: self.page,
    query: [
      [ 'join', 'bam.laret_users', 'bam.laret_users.bam_talentnum', '=', 'search.talents.talentnum' ],
      [ 'leftJoin', 'bam.laret_schedules', 'bam.laret_schedules.invitee_id', '=', 'bam.laret_users.id' ],
      [ 'where', 'bam.laret_schedules.submission', '>', 0 ],
      [ 'where', 'bam.laret_schedules.bam_role_id', '=', $('#roles-list').val() ]
    ]
  }

  if ($('#show_only_matched').is(':checked') == true) {
    let role = _.find(self.project.bam_roles, function (r) {
      return r.role_id == $('#roles-list').val()
    })

    window.history.pushState({}, '', '/projects/' + self.projectId + '/roles/' + role.role_id + '/submissions')

    role.bam_casting = self.project
    self.core.service.databind('#role-filter-form', role)
  }

  // if (!self.first_load) {

  if (self.xorigins.length > 0) {
    data.query.push([ 'whereIn', 'x_origin', self.xorigins ])
  }

  if (form.address_search == 0) { // market filter
    if (form.markets) {
      if (form.markets instanceof Array) {
        let subquery = []

        _.each(form.markets, function (market) {
          if (subquery.length == 0) {
            subquery.push([ 'where', 'city', 'like', '%' + market + '%' ])
          } else {
            subquery.push([ 'orWhere', 'city', 'like', '%' + market + '%' ])
          }

          subquery.push([ 'orWhere', 'city1', 'like', '%' + market + '%' ])
          subquery.push([ 'orWhere', 'city2', 'like', '%' + market + '%' ])
          subquery.push([ 'orWhere', 'city3', 'like', '%' + market + '%' ])
        })

        data.query.push([ 'where', subquery ])
      } else {
        data.query.push([ 'where', [
          [ 'where', 'city', '=', form.markets ],
          [ 'orWhere', 'city1', '=', form.markets ],
          [ 'orWhere', 'city2', '=', form.markets ],
          [ 'orWhere', 'city3', '=', form.markets ]
        ]
        ])
      }
    }
  } else { // location filter
    let lngLat = JSON.parse(form.lng_lat)

    if (lngLat.length > 0) {
      // data.query.push(['join', 'bam.laret_users', 'bam.laret_users.bam_talentnum', '=', 'talentnum']);
      data.query.push(['join', 'bam.laret_locations', 'bam.laret_locations.user_id', '=', 'bam.laret_users.id'])

      data.query.push(['where', 'bam.laret_locations.longitude', '>=', lngLat[0].lng.min - 0.3])
      data.query.push(['where', 'bam.laret_locations.longitude', '<=', lngLat[0].lng.max + 0.3])

      data.query.push(['where', 'bam.laret_locations.latitude', '>=', lngLat[0].lat.min - 0.3])
      data.query.push(['where', 'bam.laret_locations.latitude', '<=', lngLat[0].lat.max + 0.3])
    }
  }

  if (parseInt(form.age_min)) {
    if (form.age_min <= 2) {
      data.query.push([ 'where', 'dobyyyy', '<=', new Date().getFullYear() - 2 ])
    } else {
      data.query.push([ 'where', 'dobyyyy', '<=', new Date().getFullYear() - parseInt(form.age_min) ])
    }
  }

  if (parseInt(form.age_max)) {
    if (form.age_max >= 71) {
      data.query.push([ 'where', 'dobyyyy', '>=', new Date().getFullYear() - 71 ])
    } else {
      data.query.push([ 'where', 'dobyyyy', '>=', new Date().getFullYear() - parseInt(form.age_max) ])
    }
  }

  if (form.sexMale && !form.sexFemale) {
    data.query.push([ 'where', 'sex', '=', form.sexMale ])
  }

  if (form.sexFemale && !form.sexMale) {
    data.query.push([ 'where', 'sex', '=', form.sexFemale ])
  }

  if (form.has_photo == 'true') {
    data.query.push([ 'where', 'has_photos', '=', form.has_photo == 'true' ? 1 : 0 ])
  }

  if (form.search_text) {
    data.query.push([ 'where',
      [
        [ 'where', 'talentnum', '=', form.search_text ],
        [ 'orWhere', 'fname', 'LIKE', '%' + form.search_text + '%' ],
        [ 'orWhere', 'lname', 'LIKE', '%' + form.search_text + '%' ]
      ]
    ])
  }

  if (parseInt(form.height_min)) {
    data.query.push([ 'where', 'heightinches', '>=', form.height_min ])
  }

  if (parseInt(form.height_max)) {
    data.query.push([ 'where', 'heightinches', '<=', form.height_max ])
  }

  if (form.build) {
    if (form.build instanceof Array) {
      data.query.push([ 'whereIn', 'build', form.build ])
    } else {
      data.query.push([ 'where', 'build', '=', form.build ])
    }
  }

  if (form.ethnicity) {
    // African and African American are both searched if either is chosen
    if (form.ethnicity instanceof Array) {
      if (form.ethnicity.indexOf('African') > -1 && form.ethnicity.indexOf('African American') == -1) {
        form.ethnicity.push('African American')
      } else if (form.ethnicity.indexOf('African American') > -1 && form.ethnicity.indexOf('African') == -1) {
        form.ethnicity.push('African')
      }

      data.query.push([ 'whereIn', 'ethnicity', form.ethnicity ])
    } else {
      if (form.ethnicity == 'African') {
        data.query.push(['where', [
          [ 'where', 'ethnicity', '=', 'African' ],
          [ 'orWhere', 'ethnicity', '=', 'African American' ]
        ]
        ])
      } else if (form.ethnicity == 'African American') {
        data.query.push(['where', [
          [ 'where', 'ethnicity', '=', 'African American' ],
          [ 'orWhere', 'ethnicity', '=', 'African' ]
        ]
        ])
      } else {
        data.query.push([ 'where', 'ethnicity', '=', form.ethnicity ])
      }
    }
  }

  if (form.last_access) {
    data.query.push([ 'where', 'last_access', '>', Math.floor(new Date().getTime() / 1000) - parseInt(form.last_access) ])
  }

  if (form.young_old) {
    data.query.push([ 'orderBy', 'dobyyyy', form.young_old ])
    data.query.push([ 'orderBy', 'dobmm', form.young_old ])
    data.query.push([ 'orderBy', 'dobdd', form.young_old ])
  }

  if (form.union) {
    if (form.union == '1') {
      data.query.push([ 'where', [
        [ 'where', 'union_aea', '=', 'Yes' ],
        [ 'orWhere', 'union_aftra', '=', 'Yes' ],
        [ 'orWhere', 'union_other', '=', 'Yes' ],
        [ 'orWhere', 'union_sag', '=', 'Yes' ]
      ]
      ])
    } else {
      data.query.push([ 'where', [
        [ 'where', 'union_aea', '=', 'No' ],
        [ 'orWhere', 'union_aftra', '=', 'No' ],
        [ 'orWhere', 'union_other', '=', 'No' ],
        [ 'orWhere', 'union_sag', '=', 'No' ]
      ]
      ])
    }
  }

  // }
  return data
}

handler.prototype.addAll = function () {
  let data = self.getFilters()

  self.core.service.rest.post(self.core.config.api.base + '/cd/talentci/import/' + self.roleId, data)
    .then(function () {
      $('#add-all-button span').text('Added to Like it List')
      $('#add-all-button').addClass('disabled')
    })
}

module.exports = function (core, user, projectId, roleId) {
  return new handler(core, user, projectId, roleId)
}

},{}],509:[function(require,module,exports){
'use strict'
let _ = require('lodash')

function handler (core, user, projectId, roleId) {
  self = this
  self.core = core
  self.user = user
  self.projectId = projectId
  self.roleId = roleId

  self.xorigins = []

  if (self.user.user_apps.length > 0) {
    _.each(self.user.user_apps, function (app) {
      self.xorigins = _.union(self.xorigins, _.map(app.app.app_xorigins, function (xorigin) {
        return xorigin.x_origin
      }))
    })
  }

  self.xorigins = self.xorigins.length == 0 ? [-1] : self.xorigins

  self.refresh()
}

handler.prototype.refresh = function () {
  self.core.service.databind('#schedules', { data: [] })
  $('#schedules').append('<div class="text-center"> <h1><i class="fa fa-spinner fa-spin"></i></h1> </div>')
  let promise = $.when()
  if (!self.campaign) {
    // get campaign object first
    let data = {
      query: [
        [ 'with', 'bam_role.bam_casting' ],
        [ 'where', 'bam_role_id', '=', self.roleId ],
        [ 'orderBy', 'created_at', 'DESC' ]
      ]
    }

    promise = self.core.resource.campaign.get(data)
      .then(function (res) {
        self.campaign = _.first(res.data)
        return $.when()
      })
  }

  promise.then(function () {
    if (self.campaign) { return self.getSchedules() } else { return $.when() }
  })
    .then(function (res) {
      if (res) {
        _.each(res.data, function (s) {
          s.campaign = self.campaign
          if (!s.conversation) {
            s.conversation = { messages: [] }
          }

          _.each(s.conversation.messages, function (val, ind) {
            s.conversation.messages[ind].created_at += ' GMT-0700'
          })
        })

        if (res.total == 0) {
          $('#no-result-found').removeClass('hide')
          self.core.service.databind('#no-result-found', self.campaign)
        }

        self.core.service.databind('#campaign-details', self.campaign)
        self.core.service.databind('#schedules', res)
        self.core.service.paginate('#worksheet-pagination', { total: res.total, class: 'pagination', name: 'page', per_page: res.per_page })
        self.core.service.paginate('#worksheet-pagination2', { total: res.total, class: 'pagination', name: 'page', per_page: res.per_page })
      } else {
        self.core.service.databind('#schedules', { data: [] })
        // alert('Worksheet not available. Create an invite first.');
      }
    })
}

handler.prototype.getSchedules = function () {
  let qs = self.core.service.query_string()

  let data = {
    query: [
      [ 'join', 'bam.laret_users', 'bam.laret_users.bam_talentnum', '=', 'search.talents.talentnum' ],
      [ 'join', 'bam.laret_schedules', 'bam.laret_schedules.invitee_id', '=', 'bam.laret_users.id' ],
      [ 'where', 'bam.laret_schedules.bam_role_id', '=', self.campaign.bam_role_id ],
      [ 'where', 'bam.laret_schedules.rating', '<>', 0 ],
      [ 'select', 'bam.laret_schedules.id AS schedule_id' ]
    ],
    page: qs.page || 1
  }

  let form = self.core.service.form.serializeObject('#filter-form')

  if (form.confirmation_status) {
    data.query.push([ 'where', 'bam.laret_schedules.invitee_status', '=', form.confirmation_status ])
  }

  if (form.callback_status) {
    data.query.push([ 'where', 'bam.laret_schedules.status', '=', form.callback_status ])
  }

  if (form.talentname) {
    data.query.push([ 'where',
      [
        [ 'where', 'fname', 'LIKE', '%' + form.talentname + '%' ],
        [ 'orWhere', 'lname', 'LIKE', '%' + form.talentname + '%' ],
        [ 'orWhere', 'talentlogin', 'LIKE', '%' + form.talentname + '%' ],
        [ 'orWhere', 'talentnum', 'LIKE', '%' + form.talentname + '%' ]
      ]
    ])
  }

  if (form.notes) {
    data.query.push([ 'join', 'bam.laret_schedule_notes', 'bam.laret_schedule_notes.schedule_id', '=', 'bam.laret_schedules.id' ])
    data.query.push([ 'where', 'bam.laret_schedule_notes.body', 'LIKE', '%' + form.notes + '%' ])
  }

  let talents

  if (self.xorigins.length > 0) {
    data.query.push([ 'whereIn', 'x_origin', self.xorigins ])
  }

  return self.core.resource.search_talent.get(data)
    .then(function (res) {
      talents = res
      let schedule_ids = _.map(res.data, function (talent) {
        return talent.schedule_id
      })

      schedule_ids.push(0)

      let data2 = {
        query: [
          [ 'whereIn', 'schedules.id', schedule_ids ],
          [ 'with', 'invitee.bam_talentci.bam_talentinfo1' ],
          [ 'with', 'invitee.bam_talentci.bam_talentinfo2' ],
          [ 'with', 'invitee.bam_talentci.bam_talent_media2' ],
          [ 'with', 'schedule_notes.user.bam_cd_user' ],
          [ 'with', 'conversation.messages.user.bam_talentci' ],
          [ 'with', 'bam_role' ],
          [ 'with', {
            'conversation.messages': [
              ['skip', 0],
              ['take', 5],
              [ 'orderBy', 'created_at', 'DESC' ]
            ]
          }]
        ],
        per_page: 25
      }

      return self.core.resource.schedule.get(data2)
    })
    .then(function (res) {
      res.total = talents.total
      console.log(res)
      return $.when(res)
    })
}

handler.prototype.updateScheduleStatus = function (e) {
  let $element = $(e.target)

  if (!$element.is('button')) {
    $element = $element.parents('button')
  }

  let status = 0
  if ($element.hasClass('accept-button')) {
    status = 2
  } else if ($element.hasClass('decline-button')) {
    status = 3
  }

  let data = {
    scheduleId: $element.parents('.schedule').attr('data-id'),
    invitee_status: status
  }

  self.core.resource.schedule.patch(data)
    .then(function (res) {
      // self.refresh();
      if ($element.hasClass('accept-button')) {
        $element.removeClass('btn-outline').addClass('btn-success')
        $element.siblings('.decline-button').removeClass('btn-danger')
      } else if ($element.hasClass('decline-button')) {
        $element.removeClass('btn-outline').addClass('btn-danger')
        $element.siblings('.accept-button').removeClass('btn-success')
      }
    })
}

handler.prototype.updateScheduleCDStatus = function (e) {
  e.preventDefault()
  let $element = $(e.target)

  if (!$element.is('button')) {
    $element = $element.parents('button')
  }

  let status = 0

  if ($element.hasClass('callback-button')) {
    if ($element.hasClass('btn-success')) {
      status = 1
    } else {
      status = 2
    }
  } else if ($element.hasClass('hired-button')) {
    if ($element.hasClass('btn-success')) {
      status = 1
    } else {
      status = 3
    }
  }

  let data = {
    scheduleId: $element.parents('.schedule').attr('data-id'),
    status: status
  }

  self.core.resource.schedule.patch(data)
    .then(function (res) {
      // self.refresh();

      if ($element.hasClass('callback-button')) {
        if ($element.hasClass('btn-success')) {
          $element.removeClass('btn-success')
          $element.addClass('btn-outline')
        } else {
          $element.removeClass('btn-outline')
          $element.addClass('btn-success')
          if ($element.parent('.actions-content').find('.hired-button').hasClass('btn-success')) {
            $element.parent('.actions-content').find('.hired-button').removeClass('btn-success')
            $element.parent('.actions-content').find('.hired-button').addClass('btn-outline')
          }
        }
      }
      if ($element.hasClass('hired-button')) {
        if ($element.hasClass('btn-success')) {
          $element.removeClass('btn-success')
          $element.addClass('btn-outline')
        } else {
          $element.removeClass('btn-outline')
          $element.addClass('btn-success')
          if ($element.parent('.actions-content').find('.callback-button').hasClass('btn-success')) {
            $element.parent('.actions-content').find('.callback-button').removeClass('btn-success')
            $element.parent('.actions-content').find('.callback-button').addClass('btn-outline')
          }
        }
      }
    })
}

handler.prototype.setScheduleId = function (e) {
  let $element = $(e.target)

  if (!$element.is('button')) {
    $element = $element.parents('button')
  }

  self.scheduleId = $element.parents('.schedule').attr('data-id')
}

handler.prototype.reschedule = function (e) {
  let data = {
    when: $('#reschedule-date').val(),
    scheduleId: self.scheduleId,
    invitee_status: 4
  }

  self.core.resource.schedule.patch(data)
    .then(function (res) {
      // get conversation
      let data = {
        query: [
          [ 'where', 'schedule_id', '=', self.scheduleId ]
        ]
      }

      return self.core.resource.conversation.get(data)
    })
    .then(function (res) {
      let conversation = _.first(res.data)
      // send reschedule message

      let data = {
        conversationId: conversation.id,
        user_id: self.user.id,
        body: 'Rescheduled to <span style="color:#ffa500;font-weight:bold;">' + $('#reschedule-date').val() + '</span>'
      }

      return self.core.resource.message.post(data)
    })
    .then(function (res) {
      self.refresh()
    })
}

handler.prototype.addNote = function () {
  let data = {
    user_id: self.user.id,
    scheduleId: self.scheduleId,
    body: $('#note-text').val()
  }

  self.core.resource.schedule_note.post(data)
    .then(function (res) {
      self.refresh()
    })
}

handler.prototype.showMessageModal = function (e) {
  let $element = $(e.target)

  if (!$element.is('button')) {
    $element = $element.parents('button')
  }

  // databind dummy to modal first
  let dummy = {
    schedule: {
      bam_role: { },
      invitee: {
        bam_talentci: {
          getPrimaryPhoto: function () { },
          getFullName: function () { },
          getLocation: function () { },
          getAge: function () { },
          heightText: function () { },
          bam_talentinfo1: { }
        }
      }
    },
    campaign: { },
    messages: [ ]
  }

  self.core.service.databind('#message-modal', dummy)

  let scheduleId = $element.parents('.schedule').attr('data-id')
  self.refreshMessages(scheduleId)
}

handler.prototype.refreshMessages = function (scheduleId) {
  let data = {
    query: [
      [ 'where', 'schedule_id', '=', scheduleId ],
      [ 'with', 'schedule.bam_role' ],
      [ 'with', 'schedule.invitee.bam_talentci.bam_talentinfo2' ],
      [ 'with', 'schedule.invitee.bam_talentci.bam_talentinfo1' ],
      [ 'with', 'schedule.invitee.bam_talentci.bam_talent_media2' ],
      [ 'with', 'messages.user.bam_talentci' ],
      [ 'with', 'messages.user.bam_cd_user' ]
    ]
  }

  let conversation

  self.core.resource.conversation.get(data)
    .then(function (res) {
      if (res.total) {
        return $.when(res)
      } else {
        return self.core.resource.schedule.get({ scheduleId: scheduleId })
          .then(function (res) {
            // create new conversation
            let data2 = {
              schedule_id: scheduleId,
              user_id: res.inviter_id,
              user_ids: [ res.inviter_id, res.invitee_id ]
            }

            return self.core.resource.conversation.post(data2)
          })
          .then(function () {
            return self.core.resource.conversation.get(data)
          })
      }
    })
    .then(function (res) {
      conversation = _.first(res.data)
      let data = {
        query: [
          [ 'where', 'bam_role_id', '=', conversation.schedule.bam_role_id ]
        ]
      }
      return self.core.resource.campaign.get(data)
    })
    .then(function (res) {
      conversation.campaign = _.first(res.data)
      _.each(conversation.messages, function (val, ind) {
        conversation.messages[ind].created_at += ' GMT-0700'

        // check if contains youtube video
        let regex = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/
        let path = val.body.match(regex)

        if (path && path.length >= 8 && path[7]) {
          let embed = '<br/><iframe style="border:0px" width="420" height="315" src="https://www.youtube.com/embed/' + path[7] + '"> </iframe>'
          val.body += embed
        }
      })

      $('#message-modal #messages .per-message:not([data-bind-template])').remove()
      self.core.service.databind('#message-modal', conversation)
      $('#message-modal #messages-container').animate({ scrollTop: $('#message-modal #messages').height() }, 1000)
      self.conversation = conversation
    })
}

handler.prototype.reply = function () {
  if ($('#message-text').val()) {
    let data = {
      conversationId: self.conversation.id,
      user_id: self.user.id,
      body: $('#message-text').val()
    }

    $('#message-text').val('')
    $('#reply-button').addClass('disabled')

    self.core.resource.message.post(data)
      .then(function () {
        self.refreshMessages(self.conversation.schedule.id)
        $('#reply-button').removeClass('disabled')
      })
  }
}

module.exports = function (core, user, projectId, roleId) {
  return new handler(core, user, projectId, roleId)
}

},{"lodash":429}],510:[function(require,module,exports){
'use strict'

function handler (core, user) {
  let self = this
  self.core = core
  self.user = user
  self.refresh()
  self.userOption()
}

handler.prototype.cdUserId = function () {
  return parseInt(this.user.bam_cd_user_id, 10) ||
    (this.user.bam_cd_user && parseInt(this.user.bam_cd_user.user_id, 10)) ||
    0
}

handler.prototype.normalizeCdUser = function (data) {
  if (!data) {
    return data
  }

  if (data.phone1) {
    var digits = String(data.phone1).replace(/\D/g, '')
    if (digits.length === 10) {
      data.phone1 = digits.substr(0, 3) + '-' + digits.substr(3, 3) + '-' + digits.substr(6)
    }
  }

  return data
}

handler.prototype.bindSettings = function (data) {
  if (!data) {
    return
  }

  data = this.normalizeCdUser($.extend(true, {}, data))
  this.core.service.databind('#settings', data)
  this.core.service.databind('#settings-form', data)
}

handler.prototype.userOption = function () {
  let self = this
  let data = {
    query: [
      ['where', 'user_id', '=', self.user.id]
    ]
  }

  self.core.resource.cd_user_campaign_subscription.get(data)
    .then(function (res) {
      if (!res.total) {
        let trnData = {
          campaign_id: 7078,
          OK: 1,
          user_id: self.user.id
        }
        self.core.resource.cd_user_campaign_subscription.post(trnData)
          .then(function () {
            let tsnData = {
              campaign_id: 7250,
              OK: 1,
              user_id: self.user.id
            }
            self.core.resource.cd_user_campaign_subscription.post(tsnData)
          })
      }
    })
    .catch(function () {})
}

handler.prototype.refresh = function () {
  let self = this

  if (self.user.bam_cd_user) {
    self.bindSettings(self.user.bam_cd_user)
  }

  let cdUserId = self.cdUserId()
  if (!cdUserId) {
    return
  }

  var load = function () {
    let user_subs = {
      cdUserId: cdUserId,
      query: [
        ['with', 'cd_user_subscription']
      ]
    }

    self.core.resource.cd_user.get(user_subs)
      .then(function (res) {
        self.bindSettings(res)

        let data = {
          query: [
            ['where', 'user_id', '=', self.user.id]
          ]
        }

        return self.core.resource.cd_user_campaign_subscription.get(data)
          .then(function (res2) {
            res.cd_user_campaign_subscription = res2 || { data: [] }
            self.bindSettings(res)
          })
          .catch(function () {
            res.cd_user_campaign_subscription = { data: [] }
            self.bindSettings(res)
          })
      })
      .catch(function () {
        if (self.user.bam_cd_user) {
          self.bindSettings(self.user.bam_cd_user)
        }
      })
  }

  if ($('#settings-form').length) {
    load()
  } else {
    setTimeout(load, 0)
  }
}

handler.prototype.updatePassword = function (e) {
  e.preventDefault()

  let self = this
  let form = self.core.service.form.serializeObject('#password-form')

  form.cdUserId = self.user.bam_cd_user_id
  form.pass = form.new_password

  let regEx = /^((?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+){5,})$/.test(form.new_password)

  if (!form.new_password && !form.conf_new_password) {
    alert('Please enter a new password.')
    return
  }

  if (regEx) {
    if (form.new_password == form.conf_new_password) {
      delete form.new_password
      delete form.conf_new_password

      self.core.resource.cd_user.patch(form)
        .then(function (res) {
          $('#update-password-success').removeClass('hide')

          $('input[name=\'new_password\']').val('')
          $('input[name=\'conf_new_password\']').val('')

          setTimeout(function () {
            $('#settings-modal').modal('hide')
            $('#update-password-success').addClass('hide')
          }, 500)
        }, function (err) {
        })
    } else {
      $('#update-password-fail').removeClass('hide')
    }
  } else {
    alert('Your password must contain atleast 5 alphanumeric characters.')
  }
}

handler.prototype.updateUser = function (e) {
  e.preventDefault()
  let self = this
  if (self.core.service.form.validate('#settings-form')) {
    let form = self.core.service.form.serializeObject('#settings-form')
    form.cdUserId = self.user.bam_cd_user_id

    self.core.resource.cd_user.patch(form)
      .then(function (res) {
        let subscription_form = {}
        self.core.resource.cd_user_subscription.get({ bam_cd_user_id: self.user.bam_cd_user_id })
          .then(function (res) {
            if (res.total > 0) {
              subscription_form.subscriptionId = res.data[0].id

              if ($('#emailok').is(':checked')) {
                subscription_form.email = 1
              } else {
                subscription_form.email = 0
              }
              if ($('#smsok').is(':checked')) {
                subscription_form.sms = 1
              } else {
                subscription_form.sms = 0
              }

              self.core.resource.cd_user_subscription.patch(subscription_form)
            } else {
              if ($('#emailok').is(':checked')) {
                subscription_form.email = 1
              } else {
                subscription_form.email = 0
              }
              if ($('#smsok').is(':checked')) {
                subscription_form.sms = 1
              } else {
                subscription_form.sms = 0
              }

              self.core.resource.cd_user_subscription.post(subscription_form)
            }
          })

        let userOption_trn_form = {}
        let userOption_tsn_form = {}

        if ($('#talentReply').is(':checked')) {
          userOption_trn_form.campaign_id = 7078
          userOption_trn_form.OK = 1
        } else {
          userOption_trn_form.campaign_id = 7078
          userOption_trn_form.OK = 0
        }

        if ($('#talentSubmitProject').is(':checked')) {
          userOption_tsn_form.campaign_id = 7250
          userOption_tsn_form.OK = 1
        } else {
          userOption_tsn_form.campaign_id = 7250
          userOption_tsn_form.OK = 0
        }

        self.core.resource.cd_user_campaign_subscription.get({ bam_cd_user_id: self.user.bam_cd_user_id })
          .then(function (res) {
            if (res.total > 0 && res.data[0]) {
              userOption_trn_form.id = res.data[0].id
            }
            if (res.total > 1 && res.data[1]) {
              userOption_tsn_form.id = res.data[1].id
            }

            if (res.total > 0) {
              if (userOption_trn_form.id) {
                self.core.resource.cd_user_campaign_subscription.patch(userOption_trn_form)
              }
              if (userOption_tsn_form.id) {
                self.core.resource.cd_user_campaign_subscription.patch(userOption_tsn_form)
              }
            } else {
              self.core.resource.cd_user_campaign_subscription.post(userOption_trn_form)
              self.core.resource.cd_user_campaign_subscription.post(userOption_tsn_form)
            }
          })

        $('#update-settings-success').fadeIn().delay(5000).fadeOut()
      }, function (err) {
        $('#update-settings-fail').fadeIn().delay(5000).fadeOut()
      })
  }
}

module.exports = function (core, user) {
  return new handler(core, user)
}

},{}],511:[function(require,module,exports){
function handler (core, user) {
  self = this
  self.core = core
  self.user = user
  self.talent = null
  self.filter = 0

  self.xorigins = []

  if (self.user.user_apps.length > 0) {
    _.each(self.user.user_apps, function (app) {
      self.xorigins = _.union(self.xorigins, _.map(app.app.app_xorigins, function (xorigin) {
        return xorigin.x_origin
      }))
    })
  }

  self.xorigins = self.xorigins.length == 0 ? [-1] : self.xorigins

  self.refresh()
}
handler.prototype.refresh = function (append) {
  if (self.refreshing) {
    return
  }

  append = append === true

  if (append && self.done) {
    return
  }

  self.page = append ? self.page + 1 : 1
  self.refreshing = true

  let talents

  $('#no-favorite-talent').addClass('hide')
  $('#search-loader').show()

  if (!append) {
    $('.talents-search-result').hide()
  }

  let data = self.getFilters()

  self.core.resource.talent.search(data)
    .then(function (res) {
      talents = res

      self.core.service.databind('#submission-total', res)

      let promises = []

      _.each(talents.data, function (talent) {
        talent.talent_role_id = 0
        talent.talent_project_id = 0
        promises.push(self.getTalentVideos(talent))
      })

      return $.when.apply($, promises)
    })
    .then(function () {
      self.done = (self.page == talents.last_page)

      try {
        // for total number of talent matches
        self.core.service.databind('#favorite-result', talents, append)
      } catch (e) {
        // console.log(e);
      }

      self.refreshing = false

      $('#search-loader').hide()

      if (!append) {
        $('.talents-search-result').show()
        if (talents.total == 0) {
          self.done = true
          $('.talents-search-result').hide()
          $('#no-favorite-talent').removeClass('hide')
          $('#no-favorite-talent').show()
        }
      }
    })
}

handler.prototype.getFilters = function () {
  let data = {
    query: [
      ['join', 'bam.laret_favorite_talents', 'bam.laret_favorite_talents.bam_talentnum', '=', 'talentnum'],
      ['where', 'bam.laret_favorite_talents.bam_cd_user_id', '=', self.user.bam_cd_user_id]
    ],
    per_page: 24,
    page: self.page
  }

  if (self.xorigins.length > 0) {
    data.query.push([ 'whereIn', 'x_origin', self.xorigins ])
  }

  let form = self.core.service.form.serializeObject('#talent-filter-form')

  console.log('FORM', form)

  if (form.address_search == 0) { // market filter
    if (form.markets) {
      if (form.markets instanceof Array) {
        let subquery = []

        _.each(form.markets, function (market) {
          if (subquery.length == 0) {
            subquery.push([ 'where', 'city', 'like', '%' + market + '%' ])
          } else {
            subquery.push([ 'orWhere', 'city', 'like', '%' + market + '%' ])
          }

          subquery.push([ 'orWhere', 'city1', 'like', '%' + market + '%' ])
          subquery.push([ 'orWhere', 'city2', 'like', '%' + market + '%' ])
          subquery.push([ 'orWhere', 'city3', 'like', '%' + market + '%' ])
        })

        data.query.push([ 'where', subquery ])
      } else {
        data.query.push([ 'where', [
          [ 'where', 'city', '=', form.markets ],
          [ 'orWhere', 'city1', '=', form.markets ],
          [ 'orWhere', 'city2', '=', form.markets ],
          [ 'orWhere', 'city3', '=', form.markets ]
        ]
        ])
      }
    }
  } else if (form.address_search == 1) { // location filter
    let lngLat = JSON.parse(form.lng_lat)

    if (lngLat.length > 0) {
      data.query.push(['join', 'bam.laret_users', 'bam.laret_users.bam_talentnum', '=', 'talentnum'])
      data.query.push(['join', 'bam.laret_locations', 'bam.laret_locations.user_id', '=', 'bam.laret_users.id'])

      data.query.push(['where', 'bam.laret_locations.longitude', '>=', lngLat[0].lng.min - 0.3])
      data.query.push(['where', 'bam.laret_locations.longitude', '<=', lngLat[0].lng.max + 0.3])

      data.query.push(['where', 'bam.laret_locations.latitude', '>=', lngLat[0].lat.min - 0.3])
      data.query.push(['where', 'bam.laret_locations.latitude', '<=', lngLat[0].lat.max + 0.3])
    }
  }

  if (parseInt(form.age_min)) {
    if (form.age_min <= 2) {
      data.query.push([ 'where', 'dobyyyy', '<=', new Date().getFullYear() - 2 ])
    } else {
      data.query.push([ 'where', 'dobyyyy', '<=', new Date().getFullYear() - parseInt(form.age_min) ])
    }
  }

  if (parseInt(form.age_max)) {
    if (form.age_max >= 71) {
      data.query.push([ 'where', 'dobyyyy', '>=', new Date().getFullYear() - 71 ])
    } else {
      data.query.push([ 'where', 'dobyyyy', '>=', new Date().getFullYear() - parseInt(form.age_max) ])
    }
  }

  if (form.sexMale && !form.sexFemale) {
    data.query.push([ 'where', 'sex', '=', form.sexMale ])
  }

  if (form.sexFemale && !form.sexMale) {
    data.query.push([ 'where', 'sex', '=', form.sexFemale ])
  }

  if (form.has_photo == 'true') {
    data.query.push([ 'where', 'has_photos', '=', form.has_photo == 'true' ? 1 : 0 ])
  }

  if (form.search_text) {
    data.query.push([ 'where',
      [
        [ 'where', 'talentnum', '=', form.search_text ],
        [ 'orWhere', 'fname', 'LIKE', '%' + form.search_text + '%' ],
        [ 'orWhere', 'lname', 'LIKE', '%' + form.search_text + '%' ]
      ]
    ])
  }

  if (parseInt(form.height_min)) {
    data.query.push([ 'where', 'heightinches', '>=', form.height_min ])
  }

  if (parseInt(form.height_max)) {
    data.query.push([ 'where', 'heightinches', '<=', form.height_max ])
  }

  if (form.build) {
    if (form.build instanceof Array) {
      data.query.push([ 'whereIn', 'build', form.build ])
    } else {
      data.query.push([ 'where', 'build', '=', form.build ])
    }
  }

  if (form.ethnicity) {
    // African and African American are both searched if either is chosen
    if (form.ethnicity instanceof Array) {
      if (form.ethnicity.indexOf('African') > -1 && form.ethnicity.indexOf('African American') == -1) {
        form.ethnicity.push('African American')
      } else if (form.ethnicity.indexOf('African American') > -1 && form.ethnicity.indexOf('African') == -1) {
        form.ethnicity.push('African')
      }

      data.query.push([ 'whereIn', 'ethnicity', form.ethnicity ])
    } else {
      if (form.ethnicity == 'African') {
        data.query.push(['where', [
          [ 'where', 'ethnicity', '=', 'African' ],
          [ 'orWhere', 'ethnicity', '=', 'African American' ]
        ]
        ])
      } else if (form.ethnicity == 'African American') {
        data.query.push(['where', [
          [ 'where', 'ethnicity', '=', 'African American' ],
          [ 'orWhere', 'ethnicity', '=', 'African' ]
        ]
        ])
      } else {
        data.query.push([ 'where', 'ethnicity', '=', form.ethnicity ])
      }
    }
  }

  if (form.last_access) {
    data.query.push([ 'where', 'last_access', '>', Math.floor(new Date().getTime() / 1000) - parseInt(form.last_access) ])
  }

  if (form.young_old) {
    data.query.push([ 'orderBy', 'dobyyyy', form.young_old ])
    data.query.push([ 'orderBy', 'dobmm', form.young_old ])
    data.query.push([ 'orderBy', 'dobdd', form.young_old ])
  }

  if (form.union) {
    if (form.union == '1') {
      data.query.push([ 'where', [
        [ 'where', 'union_aea', '=', 'Yes' ],
        [ 'orWhere', 'union_aftra', '=', 'Yes' ],
        [ 'orWhere', 'union_other', '=', 'Yes' ],
        [ 'orWhere', 'union_sag', '=', 'Yes' ]
      ]
      ])
    } else {
      data.query.push([ 'where', [
        [ 'where', 'union_aea', '=', 'No' ],
        [ 'orWhere', 'union_aftra', '=', 'No' ],
        [ 'orWhere', 'union_other', '=', 'No' ],
        [ 'orWhere', 'union_sag', '=', 'No' ]
      ]
      ])
    }
  }

  return data
}

handler.prototype.getTalentVideos = function (talent) {
  let deferred = $.Deferred()
  let data = {
    query: [
      [ 'where', 'talentnum', '=', talent.talentnum ],
      [ 'where', 'type', '=', '6' ]
    ]
  }

  self.core.resource.talent_videos.get(data)
    .then(function (video) {
      talent.video_id = (video.data.length > 0) ? video.data[0].video_id : ''
      deferred.resolve()
    })

  return deferred.promise()
}

module.exports = function (core, user) {
  return new handler(core, user)
}

},{}],512:[function(require,module,exports){
'use strict'
let _ = require('lodash')

function withTimeout (promise, ms, label) {
  return new Promise(function (resolve, reject) {
    var timer = setTimeout(function () {
      reject(new Error((label || 'request') + ' timed out'))
    }, ms)

    Promise.resolve(promise).then(function (result) {
      clearTimeout(timer)
      resolve(result)
    }).catch(function (err) {
      clearTimeout(timer)
      reject(err)
    })
  })
}

function handler (core, user) {
  self = this
  self.core = core
  self.user = user

  self.xorigins = []
  let userApps = (self.user && self.user.user_apps) || []

  if (userApps.length > 0) {
    _.each(userApps, function (app) {
      if (!app || !app.app || !app.app.app_xorigins) {
        return
      }

      self.xorigins = _.union(self.xorigins, _.map(app.app.app_xorigins, function (xorigin) {
        return xorigin.x_origin
      }))
    })
  }

  self.xorigins = self.xorigins.length == 0 ? [-1] : self.xorigins
  self.page = 1

  $('#talent-search-loader').hide()
}

handler.prototype.refresh = function (append) {
  if (self.refreshing) {
    return
  }

  append = append === true

  if (append && self.done) {
    return
  }

  self.page = append ? self.page + 1 : 1
  self.refreshing = true

  let talents
  let promises = []

  let data = self.getFilters()
  $('#talent-search-loader').show()

  if (!append) {
    $('#talent-search-result').hide()
    $('#no-talent-result').addClass('hidden')
    self.preloadTalents = null
  }

  self.getTalents().then(function (talents) {
    // check if talent has a greeting video
    _.each(talents.data, function (value, index) {
      promises.push(self.getTalentVideos(value))
    })

    var videoWait = $.when.apply($, promises.length ? promises : [{}])

    return withTimeout(videoWait, 20000, 'talent videos').then(function () {
      try {
        self.core.service.databind('#submission-total', talents)
        self.core.service.databind('#talent-search-result', talents, append)
      } catch (e) {
        console.log(e)
      }

      self.refreshing = false

      $('#talent-search-loader').hide()
      if (!append) {
        $('#talent-search-result').show()
        if (talents.total === 0) {
          $('#no-talent-result').removeClass('hidden')
        }
      }
    })
  }).catch(function () {
    self.refreshing = false
    $('#talent-search-loader').hide()
    $('#talent-search-result').show()
    $('#no-talent-result').removeClass('hidden')
  })
}

handler.prototype.getTalents = function () {
  let deferred = $.Deferred()

  if (self.preloadTalents) {
    let ret = self.preloadTalents
    self.searchTalents(true).then(function (res) {
      self.preloadTalents = res
    })
    deferred.resolve(ret)
  } else {
    self.searchTalents().then(function (res) {
      self.searchTalents(true).then(function (res) {
        self.preloadTalents = res
      })
      deferred.resolve(res)
    })
  }

  return deferred.promise()
}

handler.prototype.searchTalents = function (nextPage) {
  let deferred = $.Deferred()

  if (nextPage) {
    self.page = self.page + 1
  }

  let talents
  let promise

  let data = self.getFilters()
  let form = self.core.service.form.serializeObject('#talent-filter-form')
  if (form.recently_active == 'true') {
    data.query.push([ 'customOrderBy', 'recently_active' ])
  }

  if (form.search_text && !isNaN(form.search_text)) {
    if (nextPage) {
      promise = $.when({})
    } else {
      promise = withTimeout(
        self.core.resource.talent.get({ talentId: form.search_text, query: [[ 'with', 'bam_talent_media2' ], [ 'with', 'bam_talentinfo1' ]] }),
        45000,
        'talent lookup'
      )
    }
  } else {
    promise = withTimeout(self.core.resource.talent.search(data), 45000, 'talent search')
  }

  promise.then(function (talents) {
    console.log(talents)
    if (!talents.data) {
      talents.schedule = {}
      talents.favorite = null

      talents = _.assign(talents, talents.bam_talentinfo1)

      let ret = {
        data: [
          talents
        ],
        total: 1,
        per_page: 25
      }

      talents = ret
    }

    _.each(talents.data, function (talent) {
      talent.talent_role_id = 0
      talent.talent_project_id = 0
    })

    deferred.resolve(talents)
  }).catch(function (err) {
    console.error(err)
    deferred.reject(err)
  })

  return deferred.promise()
}

handler.prototype.getFilters = function () {
  let form = self.core.service.form.serializeObject('#talent-filter-form')
  let data = {
    query: [
    ],
    per_page: 24,
    page: self.page
  }

  if (self.xorigins.length > 0) {
    data.query.push([ 'whereIn', 'x_origin', self.xorigins ])
  }

  if (form.address_search == 0) { // market filter
    if (form.markets) {
      if (form.markets instanceof Array) {
        let subquery = []

        _.each(form.markets, function (market) {
          if (subquery.length == 0) {
            subquery.push([ 'where', 'city', 'like', '%' + market + '%' ])
          } else {
            subquery.push([ 'orWhere', 'city', 'like', '%' + market + '%' ])
          }

          subquery.push([ 'orWhere', 'city1', 'like', '%' + market + '%' ])
          subquery.push([ 'orWhere', 'city2', 'like', '%' + market + '%' ])
          subquery.push([ 'orWhere', 'city3', 'like', '%' + market + '%' ])
        })

        data.query.push([ 'where', subquery ])
      } else {
        data.query.push([ 'where', [
          [ 'where', 'city', '=', form.markets ],
          [ 'orWhere', 'city1', '=', form.markets ],
          [ 'orWhere', 'city2', '=', form.markets ],
          [ 'orWhere', 'city3', '=', form.markets ]
        ]
        ])
      }
    }
  } else if (form.address_search == 1) { // location filter
    let placeQuery = ($('#location-search-box').val() || '').trim()
    let usedPlaceFilter = false

    if (placeQuery) {
      let parts = placeQuery.split(',').map(function (part) { return part.trim() }).filter(Boolean)
      let city = parts[0] || ''
      let state = parts.length > 1 ? parts[1].replace(/[^A-Za-z]/g, '').substr(0, 2).toUpperCase() : ''

      if (city) {
        data.query.push(['where', 'city', 'like', city + '%'])
        usedPlaceFilter = true
      }

      if (state) {
        data.query.push(['where', 'state', '=', state])
      }
    }

    if (!usedPlaceFilter) {
      let lngLat = []

      try {
        lngLat = JSON.parse(form.lng_lat || '[]')
      } catch (e) {
        lngLat = []
      }

      if (lngLat.length > 0) {
        data.query.push(['join', 'bam.laret_users', 'bam.laret_users.bam_talentnum', '=', 'talentnum'])
        data.query.push(['join', 'bam.laret_locations', 'bam.laret_locations.user_id', '=', 'bam.laret_users.id'])

        data.query.push(['where', 'bam.laret_locations.longitude', '>=', lngLat[0].lng.min - 0.3])
        data.query.push(['where', 'bam.laret_locations.longitude', '<=', lngLat[0].lng.max + 0.3])

        data.query.push(['where', 'bam.laret_locations.latitude', '>=', lngLat[0].lat.min - 0.3])
        data.query.push(['where', 'bam.laret_locations.latitude', '<=', lngLat[0].lat.max + 0.3])
      }
    }
  }

  if (parseInt(form.age_min)) {
    if (form.age_min <= 2) {
      data.query.push([ 'where', 'dobyyyy', '<=', new Date().getFullYear() - 2 ])
    } else {
      data.query.push([ 'where', 'dobyyyy', '<=', new Date().getFullYear() - parseInt(form.age_min) ])
    }
  }

  if (parseInt(form.age_max)) {
    if (form.age_max >= 71) {
      data.query.push([ 'where', 'dobyyyy', '>=', new Date().getFullYear() - 71 ])
    } else {
      data.query.push([ 'where', 'dobyyyy', '>=', new Date().getFullYear() - parseInt(form.age_max) ])
    }
  }

  if (form.sexMale && !form.sexFemale) {
    data.query.push([ 'where', 'sex', '=', form.sexMale ])
  }

  if (form.sexFemale && !form.sexMale) {
    data.query.push([ 'where', 'sex', '=', form.sexFemale ])
  }

  if (form.has_photo == 'true') {
    data.query.push([ 'where', 'has_photos', '=', form.has_photo == 'true' ? 1 : 0 ])
  }

  if (form.search_text) {
    data.query.push([ 'where',
      [
        [ 'where', 'talentnum', '=', form.search_text ],
        [ 'orWhere', 'fname', 'LIKE', '%' + form.search_text + '%' ],
        [ 'orWhere', 'lname', 'LIKE', '%' + form.search_text + '%' ]
      ]
    ])
  }

  if (parseInt(form.height_min)) {
    data.query.push([ 'where', 'heightinches', '>=', form.height_min ])
  }

  if (parseInt(form.height_max)) {
    data.query.push([ 'where', 'heightinches', '<=', form.height_max ])
  }

  if (form.build) {
    if (form.build instanceof Array) {
      data.query.push([ 'whereIn', 'build', form.build ])
    } else {
      data.query.push([ 'where', 'build', '=', form.build ])
    }
  }

  if (form.ethnicity) {
    // African and African American are both searched if either is chosen
    if (form.ethnicity instanceof Array) {
      if (form.ethnicity.indexOf('African') > -1 && form.ethnicity.indexOf('African American') == -1) {
        form.ethnicity.push('African American')
      } else if (form.ethnicity.indexOf('African American') > -1 && form.ethnicity.indexOf('African') == -1) {
        form.ethnicity.push('African')
      }

      data.query.push([ 'whereIn', 'ethnicity', form.ethnicity ])
    } else {
      if (form.ethnicity == 'African') {
        data.query.push(['where', [
          [ 'where', 'ethnicity', '=', 'African' ],
          [ 'orWhere', 'ethnicity', '=', 'African American' ]
        ]
        ])
      } else if (form.ethnicity == 'African American') {
        data.query.push(['where', [
          [ 'where', 'ethnicity', '=', 'African American' ],
          [ 'orWhere', 'ethnicity', '=', 'African' ]
        ]
        ])
      } else {
        data.query.push([ 'where', 'ethnicity', '=', form.ethnicity ])
      }
    }
  }

  if (form.last_access) {
    data.query.push([ 'where', 'last_access', '>', Math.floor(new Date().getTime() / 1000) - parseInt(form.last_access) ])
  }

  if (form.young_old) {
    data.query.push([ 'orderBy', 'dobyyyy', form.young_old ])
    data.query.push([ 'orderBy', 'dobmm', form.young_old ])
    data.query.push([ 'orderBy', 'dobdd', form.young_old ])
  }

  if (form.union) {
    if (form.union == '1') {
      data.query.push([ 'where', [
        [ 'where', 'union_aea', '=', 'Yes' ],
        [ 'orWhere', 'union_aftra', '=', 'Yes' ],
        [ 'orWhere', 'union_other', '=', 'Yes' ],
        [ 'orWhere', 'union_sag', '=', 'Yes' ]
      ]
      ])
    } else {
      data.query.push([ 'where', [
        [ 'where', 'union_aea', '=', 'No' ],
        [ 'orWhere', 'union_aftra', '=', 'No' ],
        [ 'orWhere', 'union_other', '=', 'No' ],
        [ 'orWhere', 'union_sag', '=', 'No' ]
      ]
      ])
    }
  }

  return data
}

handler.prototype.getTalentVideos = function (talent) {
  let deferred = $.Deferred()
  let data = {
    query: [
      [ 'where', 'talentnum', '=', talent.talentnum ],
      [ 'where', 'type', '=', '6' ]
    ]
  }

  self.core.resource.talent_videos.get(data)
    .then(function (video) {
      talent.video_id = (video && video.data && video.data.length > 0) ? video.data[0].video_id : ''
      deferred.resolve()
    })
    .catch(function () {
      talent.video_id = ''
      deferred.resolve()
    })

  setTimeout(function () {
    if (deferred.state() === 'pending') {
      talent.video_id = ''
      deferred.resolve()
    }
  }, 10000)

  return deferred.promise()
}

module.exports = function (core, user) {
  return new handler(core, user)
}

},{"lodash":429}],513:[function(require,module,exports){
'use strict'
let _ = require('lodash')

function handler (core, user, talentnum) {
  self = this
  self.core = core
  self.user = user
  self.talentnum = talentnum
  self.refresh()
}

handler.prototype.refresh = function () {
  let data = {
    talentId: self.talentnum,
    query: [
      [ 'with', 'bam_talent_media2' ],
      [ 'with', 'bam_talentinfo1' ],
      [ 'with', 'bam_talentinfo2' ],
      [ 'with', 'bam_talent_music' ],
      [ 'with', 'bam_talent_dance' ], [ 'with', 'user' ]
    ]
  }
  self.core.resource.talent.get(data)
    .then(function (res) {
      self.talent = res
      console.log(self.talent.talentnum)

      let data = {
        q: [
          [ 'where', 'bam_talentnum', '=', self.talent.talentnum ]
        ]
      }

      return self.core.resource.favorite_talent.get(data)
    })
    .then(function (res) {
      self.talent.favorite = _.first(res.data)
      self.getRoleInfo()

      if (!self.talent.heightText() && !self.talent.bam_talentinfo2.ethnicity && !self.talent.bam_talentinfo1.weightpounds && !self.talent.bam_talentinfo1.haircolor && !self.talent.bam_talentinfo1.build && !self.talent.bam_talentinfo1.eyecolor && !self.talent.bam_talentinfo2.special_skills) {
        $('#acting-modeling-link, #acting-modeling').addClass('hide')
      }

      if (!self.talent.bam_talent_music && !self.talent.bam_talent_music[0].music_role && !self.talent.bam_talent_music[0].number_of_gigs && !self.talent.bam_talent_music[0].genre && !self.talent.bam_talent_music[0].music_instruments && !self.talent.bam_talent_music[0].des_1 && !self.talent.bam_talent_music[0].searching_gig_des && !self.talent.bam_talent_music[0].major_influence) {
        $('#musician-link, #musician').addClass('hide')
      }

      if (!self.talent.bam_talent_dance && !self.talent.bam_talent_dance[0].dance_style_1 && !self.talent.bam_talent_dance[0].num_of_perfom && !self.talent.bam_talent_dance[0].years_experience && !self.talent.bam_talent_dance[0].dancer_background && !self.talent.bam_talent_dance[0].influences && !self.talent.bam_talent_dance[0].searching_gig_des) {
        $('#dance-link, #dance').addClass('hide')
      }

      if (!self.talent.bam_talent_music.length) {
        $('#musician').addClass('hide')
      }

      if (!self.talent.bam_talent_dance.length) {
        $('#dance').addClass('hide')
      }

      self.core.service.databind('#talent-resume-info', self.talent)
      self.core.service.databind('#talent-primary-photo', self.talent)
      self.core.service.databind('#talent-resume-div', self.talent)
      self.core.service.databind('#talent-photo', self.talent)
      // self.core.service.databind('#talent-photo', self.talent);

      let photos = _.filter(self.talent.bam_talent_media2, function (val) {
        return val.type == 1
      })
      if (photos[0]) {
        let firstphoto = _.slice(photos, 0, 1)
        self.core.service.databind('#first-photo', firstphoto[0])
      }

      if (photos[1]) {
        let secondphoto = _.slice(photos, 1, 2)
        self.core.service.databind('#second-photo', secondphoto[0])
      }

      if (photos[2]) {
        let thirdphoto = _.slice(photos, 2, 3)
        self.core.service.databind('#third-photo', thirdphoto[0])
      }

      $('.talent-resume-wrapper').removeClass('hide')
    })
}

handler.prototype.getRoleInfo = function () {
  let qs = self.core.service.query_string()

  if (qs.casting_id != 0 && qs.role_id != 0) {
    let data = {
      projectId: qs.casting_id,
      jobId: qs.role_id,
      query: [
        [ 'with', 'bam_casting' ]
      ]
    }

    self.core.resource.job.get(data)
      .then(function (res) {
        res.talent = self.talent
        self.core.service.databind('#project-role-actions', res)
      })
  } else {
    self.core.service.databind('#add-to-like-it-list-bind', { talent: self.talent, role_id: 0 })
    self.core.service.databind('.favorite-button', { talent: self.talent, role_id: 0 })
  }
}

module.exports = function (core, user, talentnum) {
  return new handler(core, user, talentnum)
}

},{"lodash":429}],514:[function(require,module,exports){
'use strict'
let _ = require('lodash')

function handler (core, user) {
  self = this
  self.core = core
  self.user = user
  self.refresh()

  let data = {
    query: [
      ['where', 'user_id', '=', self.user.id]
    ]
  }
  self.core.resource.user_option.get(data)
    .then(function (res) {
      self.core.service.databind('#notifications', res)
    })
}

handler.prototype.refresh = function () {
  self.core.service.databind('#talent-email', self.user)
  self.core.resource.cd_user_subscription.get()
    .then(function (res) {
      if (res.data[0].email !== res.data[0].sms) {
        if (res.data[0].email == 1) {
          res.email = 1
        } else {
          res.email = 0
        }

        if (res.data[0].sms == 1) {
          res.sms = 1
        } else {
          res.sms = 0
        }
      } else {
        if (res.data[0].email == 1) {
          res.email = 0
        } else {
          res.email = 1
        }

        if (res.data[0].sms == 1) {
          res.sms = 0
        } else {
          res.sms = 1
        }
      }
      self.core.service.databind('#unsubscribe-emails', res)
    })
}

handler.prototype.saveChanges = function () {
  let data = {
    query: [
      ['where', 'bam_cd_user_id', self.user.bam_cd_user_id]
    ]
  }

  self.core.resource.cd_user_subscription.get(data)
    .then(function (res) {
      if (res.total == 0) {
        let data = {
          bam_cd_user_id: self.user.user_id,
          sms: $('#emailchck').is(':checked') ? 0 : 1,
          email: $('#smschck').is(':checked') ? 0 : 1
        }
        self.core.resource.cd_user_subscription.post(data)
          .then(function (res) {
            window.location = '/'
          })
      } else {
        let data = {
          subscriptionId: res.data[0].id,
          sms: $('#emailchck').is(':checked') ? 0 : 1,
          email: $('#smschck').is(':checked') ? 0 : 1
        }

        self.core.resource.cd_user_subscription.patch(data)
          .then(function (res) {
            window.location = '/'
          })
      }
    })

  let user_option_data = {
    query: [
      ['where', 'user_id', '=', self.user.id]
    ]
  }

  let talent_reply_data = {
    option: 'Talent Reply Notification',
    value: $('#talentReply').is(':checked') ? 1 : 0
  }

  let talent_submit_data = {
    option: 'Talent Submit Notification',
    value: $('#talentSubmit').is(':checked') ? 1 : 0
  }

  self.core.resource.user_option.get(user_option_data)
    .then(function (res) {
      if (res.total == 0) {
        self.core.resource.user_option.post(talent_reply_data)
        self.core.resource.user_option.post(talent_submit_data)
      } else {
        talent_reply_data.id = res.data[0].id
        talent_submit_data.id = res.data[1].id
        self.core.resource.user_option.patch(talent_reply_data)
        self.core.resource.user_option.patch(talent_submit_data)
      }
    })
}

module.exports = function (core, user) {
  return new handler(core, user)
}

},{"lodash":429}],515:[function(require,module,exports){
'use strict'

var CASTING_CATEGORIES = {
  0: '',
  1: 'Commercials',
  3: 'Dance - Ballet/Classic',
  4: 'Dance - Modern/Jazz',
  5: 'Episodic TV - Pilots',
  6: 'Episodic TV - SAG',
  7: 'Episodic TV - AFTRA',
  8: 'Episodic TV - Non-Union',
  9: 'Feature Film - SAG',
  10: 'Feature Film - Non-SAG',
  11: 'Feature Film - Student Films',
  12: 'Feature Film - Short Film',
  13: 'Feature Film - Documentaries',
  14: 'Feature Film - Inde/Low Budget',
  15: 'Infomercials',
  16: 'Crew - Assistants & Entry Level',
  17: 'Industrial/Training Films',
  18: 'Modeling - Runway',
  19: 'Modeling - Hair/Cosmetics',
  20: 'Modeling - Print',
  21: 'Music Videos',
  22: 'Theatre - Equity (Union)',
  23: 'Theatre - Non-Equity',
  24: 'Trade Shows/Live Events/Promo Model',
  25: 'Crew - Marketing/PR',
  26: 'Voice Over',
  27: 'Internet',
  28: 'Music - Vocals',
  29: 'Music - Strings',
  30: 'Music - Horns',
  31: 'Music - Keyboards',
  32: 'Music - Drums',
  33: 'Music - Other',
  34: 'Crew - Ligthing/Sound',
  35: 'Crew - Camera/Editor',
  36: 'Crew - Producer/Director',
  37: 'Crew - Make Up/Stylist',
  38: 'Crew - Other',
  39: 'Crew - Writing/Script/Edit',
  40: 'Crew - Showbiz Internship',
  41: 'Acting - Comedy/Clown',
  42: 'Variety - Variety Acts',
  43: 'Acting - Acrobatics/Stunts',
  44: 'Music - Band',
  45: 'Music - DJ/Sound',
  46: 'Music - Teacher',
  47: 'Crew - TV/Radio',
  48: 'Crew - Graphic/Web/Animate',
  49: 'Crew - Accounting/Payroll/HR',
  50: 'Crew - Technology/MIS',
  51: 'Crew - Management',
  52: 'Crew - Talent/Casting Mgmt',
  53: 'Dance - HipHop',
  54: 'Dance - Club/Gogo',
  55: 'Dance - Traditonal/Latin',
  56: 'Dance - Choreography',
  57: 'Dance - Teacher',
  58: 'Dance - Other/General',
  59: 'Reality TV',
  60: 'Extras',
  61: 'Acting - Other'
}

function decorateProjectList (res) {
  if (!res || !res.data) {
    return res
  }

  res.data.forEach(function (project) {
    if (!project.bam_roles) {
      project.bam_roles = []
    }

    if (typeof project.getCategory === 'function') {
      return
    }

    project.getCategory = function () {
      return CASTING_CATEGORIES[this.cat] || 'N/A'
    }
  })

  return res
}

module.exports = {
  decorateProjectList: decorateProjectList
}

},{}]},{},[1]);
